/* eslint-disable */
/**
 * Generated by orval 🍺
 * ThanksBen Django API
 * Internal API for ThanksBen
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  ACHCheckoutRequestRequest,
  ACHCheckoutSession,
  ACHMandateStatus,
  ACHMicroDepositCheckoutRequestRequest,
  ActivatePhysicalCardRequestRequest,
  AdminEnrolmentChangeDetailResponse,
  AirwallexAccountCreateErrorResponse,
  AirwallexFinancialReportDownloadResponse,
  AirwallexFinancialReportGenerateRequestRequest,
  AirwallexFinancialReportGenerateResponse,
  AllowanceBalanceDetailResponse,
  AllowanceEmployeeRetrieve200,
  AllowanceReceipt,
  AllowanceReceiptRequest,
  AllowanceResponse,
  AllowancesPartialUpdateBodyOne,
  AllowancesPartialUpdateBodyThree,
  AllowancesPartialUpdateBodyTwo,
  AllowancesPreviewCreateBodyOne,
  AllowancesPreviewCreateBodyThree,
  AllowancesPreviewCreateBodyTwo,
  ApiSchemaRetrieve200Four,
  ApiSchemaRetrieve200One,
  ApiSchemaRetrieve200Three,
  ApiSchemaRetrieve200Two,
  ApiSchemaRetrieveParams,
  ApiV10BenefitCategoriesRetrieveParams,
  ApiV10BenefitsFeaturesListParams,
  ApiV10EmployeeInterestsPartialUpdateParams,
  ApiV10EmployeesContactsEnrollmentsListParams,
  ApiV10EmployeesContactsListParams,
  ApiV10EmployeesTotalRewardsChartRetrieveParams,
  ApiV10EmployeesTotalRewardsPdfRetrieveParams,
  ApiV10EmployeesTotalRewardsRetrieveParams,
  ApiV10EmployeesTotalRewardsVestingScheduleRetrieveParams,
  ApiV10EnrollableBenefitsPartialUpdateParams,
  ApiV10EnrollableBenefitsRetrieve2Params,
  ApiV10EnrollableBenefitsRetrieveParams,
  ApiV10EnrollmentsListParams,
  ApiV10FullSearchRetrieveParams,
  ApiV10ProvidersListParams,
  ApiV10RecognitionsRewardPresetsRetrieveParams,
  ApiV10RecognitionsStatisticsRetrieveParams,
  ApiV10ResourcesArticlesRetrieveParams,
  ApiV10RewardsBudgetsRetrieveParams,
  ApiV10SearchRetrieveParams,
  ApprovalActionRequest,
  ApprovalProcessesListView,
  ApprovalRequestActionRequest,
  ApprovalRequestsActionResponse,
  ApprovalRequestsFundRequestsListParams,
  ApprovalRequestsReimbursementsListParams,
  ApprovalRequestsStepExecutionsListParams,
  ApprovalResponseAction,
  AreaOfInterest,
  AutoEnrolmentAssessmentReportExportResponse,
  AutoEnrolmentAssessmentReportGenerateResponse,
  AvailableCurrencies,
  BalanceTransferRequestRequest,
  BankAccountRequest,
  BaseAgentRequestRequest,
  BaseAgentRequestRequestRequest,
  BeneficiaryRequestRequest,
  BeneficiaryResponse,
  BenefitAllowancesResponse,
  BenefitBrokerResponse,
  BenefitCategory,
  BenefitCategoryListResponse,
  BenefitCategoryRequest,
  BenefitConfigurationChangeDetail,
  BenefitConfigurationChangePage,
  BenefitConfigurationRunCreateRequest,
  BenefitConfigurationV10ChangesListParams,
  BenefitContributions,
  BenefitDelaysListParams,
  BenefitDocumentCreateRequest,
  BenefitDocumentCreateRequestRequest,
  BenefitDocumentUpdateRequest,
  BenefitDocumentsListParams,
  BenefitEnrollmentSerializerWithInterests,
  BenefitEnrollmentUpdate,
  BenefitEnrolmentContributionSourceRequestRequest,
  BenefitEnrolmentDetailResponse,
  BenefitEnrolmentHistoryFilterResponse,
  BenefitHeroImage,
  BenefitHeroImageListParams,
  BenefitHeroImageRequest,
  BenefitImage,
  BenefitImageListParams,
  BenefitImageRequest,
  BenefitLifeEventResponse,
  BenefitManager,
  BenefitManagerRequest,
  BenefitManagerResponse,
  BenefitManagersListParams,
  BenefitOptOutRequestRequest,
  BenefitPaymentHistoryCorrectionResponse,
  BenefitPaymentHistoryDetailResponse,
  BenefitProduct,
  BenefitProductType,
  BenefitProductTypeRequest,
  BenefitProductTypesListParams,
  BenefitRequestCreateRequest,
  BenefitRequestGetResponse,
  BenefitRequestListResponse,
  BenefitTypeListResponse,
  BenefitWaiverReasonsGroupsListParams,
  BenefitsBrokersListParams,
  BenefitsChangesListParams,
  BenefitsEnrolmentsMinMaxFormulaFieldRecalculateCreateBodyOne,
  BenefitsEnrolmentsMinMaxFormulaFieldRecalculateCreateBodyThree,
  BenefitsEnrolmentsMinMaxFormulaFieldRecalculateCreateBodyTwo,
  BenefitsFeaturesListParams,
  BenefitsListParams,
  BillingAddress,
  BudgetDetailResponse,
  BudgetEmployeeResponse,
  BudgetMemberResponse,
  BudgetTopupRequest,
  BudgetTopupRequestRequest,
  BudgetsMembersListParams,
  BudgetsResponse,
  BudgetsRetrieveParams,
  CampaignDetailResponse,
  CardTopUpRequest,
  CardTopUpResponse,
  Carousel,
  CarouselRequest,
  ChangesEnrolmentsListParams,
  ChangesListParams,
  ChatChatsRetrieveParams,
  ClaimSigningStepResponse,
  CompanyValueCreateUpdateRequest,
  CompanyValueListResponse,
  ComponentKeysListParams,
  ContributionHolidaysExportResponse,
  ContributionHolidaysGenerateResponse,
  CorporateKYBRequestRequest,
  CorporateKYBResponse,
  CreateCampaignRequestRequest,
  CreateEnrollableBenefitRequest,
  CreationAssessmentRequestRequest,
  CreationAssessmentResponse,
  CreationRequestListResponse,
  CreationRequestRequest,
  CreationRequestResponse,
  DashboardBenefitsListResponse,
  DashboardRemindersRetrieveParams,
  DashboardRemindersSerializerResponse,
  DashboardYearlyCompensationResponse,
  DocumentSigningExportResponse,
  DocumentSigningGenerateResponse,
  EaHomepageLayoutResponse,
  EaRecognitionsListRequestRequest,
  EccChatCreateResponse,
  EccChatDetail,
  EccChatListPaginatedResponse,
  EccHandoffResponse,
  EccHomepageLayoutRequestRequest,
  EccHomepageLayoutResponse,
  EccPollTurnResponse,
  EccRecognitionsListRequestRequest,
  EccSubmitTurnConflict,
  EccSubmitTurnRequestRequest,
  EccSubmitTurnResponse,
  EccSuggestionsResponse,
  EligibilityResponse,
  EligibleEmployeesResponse,
  EmailPreviewRequestRequest,
  EmailPreviewResponse,
  EmployeeAddressRequest,
  EmployeeContact,
  EmployeeContactDetail,
  EmployeeContactDetailRequest,
  EmployeeContactRequest,
  EmployeeDependent,
  EmployeeInfoResponse,
  EmployeeMinimalDetailsResponse,
  EmployeeMobileDeviceRequestRequest,
  EmployeeNetPayEstimateResponse,
  EmployeeProfile,
  EmployeeProfileConfigResponse,
  EmployeeProfileRequest,
  EmployeeRequestRequest,
  EmployeeSalaryRequest,
  EmployeeSalaryResponse,
  EmployeeSegmentCreateRequestRequest,
  EmployeeSegmentList,
  EmployeeSegmentQueryRequestRequest,
  EmployeeSegmentsEmployeesCreateParams,
  EmployeeSegmentsListParams,
  EmployeeUpdateRequestRequest,
  EmployeeUrlResponse,
  EmployeeWeavrMFARequestRequest,
  EmployeeWeavrMFAResponse,
  EmployeesListParams,
  EmployerConfiguration,
  EmployerExternalLink,
  EmployerExternalLinkRequest,
  EmployerIntegrationResponse,
  EmployerOfflineWorkerForm,
  EmployerResponse,
  EmployerRolesResponse,
  EmployersListParams,
  EnrollableBenefit,
  EnrollableBenefitDetailResponse,
  EnrollableBenefitEmployeeFeatureUpdate,
  EnrollableBenefitFeatureCategoryResponse,
  EnrollableBenefitListResponse,
  EnrolmentUpdateRequestRequest,
  EnrolmentWindowChange,
  EnrolmentWindowChangeRequest,
  EquityModelerCalculateRequestRequest,
  EquityModelerCalculateResponse,
  EquityModelerEmployeeStateResponse,
  EquityModelerPageContextResponse,
  FeaturedProviderResponse,
  FilterGroupsResponse,
  FilteredEmployeesRequestRequest,
  FilteredEmployeesResponse,
  FullSearchResponse,
  FundRequestRequest,
  FundRequestResponse,
  Goal,
  HomeScreenCarouselResponse,
  HomepageBlockResponse,
  HomepageRegistryResponse,
  ImpersonationSessionResponse,
  IntegrationActionResponse,
  IntegrationResponse,
  IntentProfileResponse,
  InvoiceResponse,
  LifeEventRequest,
  LifeEventRequestRequest,
  LifeEventResponseDetail,
  LifeEventRetrieve200,
  LifeEventReviewErrorResponse,
  LifeEventReviewRequestRequest,
  LifeEventsListParams,
  LoginMetadataResponse,
  LoginRequestRequest,
  LoginResponse,
  LostPasscodeResumeRequestRequest,
  MSTeamsChannelsResponse,
  MSTeamsCompleteAuthRequestRequest,
  MSTeamsStartAuthResponse,
  MSTeamsTeamsResponse,
  ManagedAccount,
  ManagedAccountBalances,
  ManagedCardBreakdownResponse,
  ManagedCardConfigPreviewResponse,
  ManagedCardMinimal,
  ManagedCardsCategoriesEmployeesRetrieveParams,
  ManagedCardsTransactionResponse,
  Me,
  MeResponse,
  MessageFeedbackRequestRequest,
  MessagingIntegrationsV10MsTeamsAuthRedirectRetrieveParams,
  MessagingIntegrationsV10RetrieveParams,
  MessagingIntegrationsV10SlackAuthRedirectRetrieveParams,
  MessagingIntegrationsV10SlackAuthUsersRedirectRetrieveParams,
  Metabase,
  MobileLoginMetadataResponse,
  ModularBenefitListResponse,
  ModularBenefitListResponseRequest,
  ModularBenefitMinMaxFormulaFieldRecalculateCockpitResponse,
  ModularBenefitMinMaxFormulaFieldRecalculateHoustonResponse,
  ModularBenefitPayrollCycle,
  ModularBenefitPriceResponse,
  ModularBenefitStepComponentKeyList,
  ModularBenefitStepComponentKeyListRequest,
  ModularBenefitSubscriptionsResponse,
  ModularBenefitTag,
  ModularBenefitTagRequest,
  ModularBenefitUploadedFileRequestRequest,
  ModularBenefitUploadedFileResponse,
  ModularBenefitVersionsResponse,
  ModularBenefitsMinMaxFormulaFieldRecalculateCreateBodyOne,
  ModularBenefitsMinMaxFormulaFieldRecalculateCreateBodyThree,
  ModularBenefitsMinMaxFormulaFieldRecalculateCreateBodyTwo,
  ModularBenefitsSubscriptionsRetrieveParams,
  MomentGroup,
  Need,
  NmwCheckExportResponse,
  NmwCheckFilterOptionsResponse,
  NmwCheckGenerateResponse,
  NmwCheckReportResponse,
  NotificationDefinitionDetailResponse,
  NotificationDefinitionsResponse,
  NotificationEventsResponse,
  NotificationTemplatePreviewResponse,
  NotificationsV10CampaignsRetrieveParams,
  NotificationsV10EventsRetrieveParams,
  NotificationsV10NotificationDefinitionsEventsRetrieveParams,
  NotificationsV10NotificationDefinitionsRetrieveParams,
  NotificationsV10NotificationDefinitionsTemplatesRetrieveParams,
  OnboardingChecklistResponse,
  OnboardingResponse,
  OptOutReasonsGroup,
  OptOutReasonsGroupRequest,
  OptOutReasonsGroupsListParams,
  OrderPhysicalManagedCardRequestRequest,
  OutboundProvidersListParams,
  PaginatedAdminEnrolmentChangeListResponseList,
  PaginatedAirwallexFinancialReportListItemList,
  PaginatedApprovalRequestResponseList,
  PaginatedApprovalRequestStepExecutionResponseList,
  PaginatedBenefitBrokerList,
  PaginatedBenefitDelayList,
  PaginatedBenefitDocumentCreateRequestList,
  PaginatedBenefitEnrollmentList,
  PaginatedBenefitHeroImageList,
  PaginatedBenefitImageList,
  PaginatedBenefitManagerList,
  PaginatedBenefitProductTypeList,
  PaginatedCampaignListResponse,
  PaginatedContactEnrollmentListList,
  PaginatedEmployeeContactListList,
  PaginatedEmployeeSegmentEmployeeList,
  PaginatedEmployeeSegmentListList,
  PaginatedEmployerListResponseList,
  PaginatedEnrollableBenefitFeatureSerializerWithBenefitDetailsList,
  PaginatedEnrolmentChangeResponseList,
  PaginatedLifeEventResponseList,
  PaginatedModularBenefitListResponseList,
  PaginatedModularBenefitStepComponentKeyListList,
  PaginatedModularBenefitTagList,
  PaginatedOptOutReasonsGroupList,
  PaginatedOutboundProviderList,
  PaginatedPayrollCycleList,
  PaginatedPayrollInstructionConfigList,
  PaginatedPayrollInstructionOutputSchemaList,
  PaginatedPayrollInstructionSchemaCycleList,
  PaginatedProviderList,
  PaginatedProviderResponseList,
  PaginatedStatePensionAgeConfigList,
  PaginatedTestCaseListList,
  PanTokenResponse,
  PatchEmployerConfiguration,
  PatchedAllowanceReceiptUpdateRequestRequest,
  PatchedBeneficiaryRequestRequest,
  PatchedBenefitCategoryPartialUpdateRequest,
  PatchedBenefitDocumentUpdateRequestRequest,
  PatchedBenefitEnrollmentUpdateRequest,
  PatchedBenefitRequestPatchRequest,
  PatchedBudgetUpdateRequestRequest,
  PatchedCarouselRankRequest,
  PatchedCompanyValueCreateUpdateRequest,
  PatchedCompleteOnboardingRequestRequest,
  PatchedCreateEnrollableBenefitRequest,
  PatchedEmployeeInfoRequestRequest,
  PatchedEmployeeInterestsUpdateRequest,
  PatchedEmployeePatchRequestRequest,
  PatchedEmployeeProfileRequest,
  PatchedEmployeeRolesUpdateRequest,
  PatchedEmployerChangeRequestRequest,
  PatchedEmployerExternalLinkRankRequest,
  PatchedEnrollableBenefitEmployeeFeatureUpdateRequest,
  PatchedEnrollableBenefitFeatureUpdateRequestRequest,
  PatchedEnrolmentUpdateRequestRequest,
  PatchedIntentProfileRequest,
  PatchedKomboSetupActivateRequestRequest,
  PatchedMSTeamsUpdateEmployerConfigRequestRequest,
  PatchedMeRequestRequest,
  PatchedModularBenefitUnenrollRequestRequest,
  PatchedNotificationDefinitionUpdateRequestRequest,
  PatchedOnboardingChecklistRequestRequest,
  PatchedPatchEmployerConfigurationRequest,
  PatchedPayrollInstructionConfigCreateRequest,
  PatchedRankRequestRequest,
  PatchedReadEnrolmentChangeRequestRequest,
  PatchedReadNotificationRequestRequest,
  PatchedRecognitionConfigurationPatchRequestRequest,
  PatchedRewardPresetPatchRequestRequest,
  PatchedRewardPresetReorderRequestRequest,
  PatchedRewardsBudgetMembersBalanceRequestRequest,
  PatchedRewardsBudgetMembersUpdateRequestRequest,
  PatchedRewardsBudgetUpdateRequestRequest,
  PatchedSlackUpdateEmployerConfigRequestRequest,
  PatchedTestCaseUpdateRequest,
  PatchedUpdateCampaignRequestRequest,
  PatchedVerifyMobileVerificationCodeRequestRequest,
  PayrollConfigOption,
  PayrollCyclesListParams,
  PayrollInstructionConfig,
  PayrollInstructionConfigCreateRequest,
  PayrollInstructionConfigDuplicateRequest,
  PayrollInstructionConfigsListParams,
  PayrollInstructionOutputSchema,
  PayrollInstructionOutputSchemaGenerateRequestRequest,
  PayrollInstructionOutputSchemaGenerateResponse,
  PayrollInstructionOutputSchemaRequest,
  PayrollInstructionOutputSchemaUpdateRequest,
  PayrollInstructionReportDetail,
  PayrollInstructionReportRowsResponse,
  PayrollInstructionSchemasCyclesListParams,
  PayrollInstructionSchemasCyclesRowsListParams,
  PayrollInstructionSchemasListParams,
  PayrollInstructionSchemasTestCasesListParams,
  PayrollReportExportResponse,
  PrepareSigningRequestRequest,
  PrepareSigningResponse,
  PricingFormulaPreviewRequestRequest,
  ProductResponse,
  ProgrammeBenefitEnrolmentResponse,
  ProgrammeBulkEnrolmentRequestRequest,
  ProgrammeBulkEnrolmentResponse,
  ProgrammeCostPreviewRequestRequest,
  ProgrammeCostResponse,
  ProgrammeEnrollmentRequestRequest,
  ProgrammeEnrollmentResponse,
  ProgrammeListResponse,
  ProgrammePreviewResponse,
  Provider,
  ProviderPitchListResponse,
  ProviderRequest,
  ProviderResponse,
  ProvidersListParams,
  PublicEmployeeResponse,
  PurchaseResponse,
  QueryBuilderSchemaResponse,
  QuerySuggestion,
  RJSFFormConfigResponse,
  ReadEnrolmentChangeResponse,
  ReadNotificationResponse,
  Receipt,
  ReceiptDraftStatus,
  ReceiptExtractionCreateRequest,
  RecognitionConfigurationResponse,
  RecognitionCreateRequestRequest,
  RecognitionEmployeesResponse,
  RecognitionResponse,
  RecognitionStatisticsResponse,
  RecognitionSuggestionsRequestRequest,
  RecognitionSuggestionsResponse,
  RecognitionsEmployeesRetrieveParams,
  RecognitionsListResponse,
  ReimbursementRequestBase,
  ReimbursementRequestRequest,
  ReimbursementResponse,
  ReorderManagedCardRequestRequest,
  ReportsAirwallexListParams,
  ReportsNmwCheckExportRetrieveParams,
  ReportsNmwCheckListParams,
  ReportsPayrollExportRetrieveParams,
  RequirementGroupDetail,
  RequirementGroupPage,
  RequirementPage,
  RequirementsV10GroupsListParams,
  RequirementsV10GroupsRequirementsListParams,
  ResendInviteEmailRequestRequest,
  ResidencyType,
  ResourcesArticleDetailResponse,
  ResourcesArticleListResponse,
  ResourcesCategoriesListResponse,
  RewardPresetCreateRequestRequest,
  RewardPresetsResponse,
  RewardResponse,
  RewardResponseRequest,
  RewardsBudgetCreateRequestRequest,
  RewardsBudgetDetailResponse,
  RewardsBudgetMembersRequestRequest,
  RewardsBudgetMembersResponse,
  RewardsBudgetResponse,
  RewardsBudgetsResponse,
  RewardsListResponse,
  RewardsSpendingBalanceListResponse,
  RewardsSpendingBalancesRetrieveParams,
  RewardsSpendingBalancesTransactionsRetrieveParams,
  RewardsTransactionsResponse,
  RichTextImageUploadRequestRequest,
  RichTextImageUploadResponse,
  SalaryDeductionsResponse,
  ScaAuthorizeResponse,
  ScaRequiredResponse,
  SearchResponse,
  SendCampaignRequestRequest,
  SlackChannelsResponse,
  SlackCompleteAuthRequestRequest,
  SlackCompleteAuthResponse,
  SlackCompleteUsersAuthRequestRequest,
  SlackExternalMultiSelectOptionsResponse,
  SlackStartAuthResponse,
  SlackStartUsersAuthResponse,
  SlackTeamsResponse,
  SlackUsersResponse,
  StartImpersonationSessionRequestRequest,
  StartedRun,
  StatePensionAgeConfigsListParams,
  TagsListParams,
  TestCaseCreateRequest,
  TestCaseDetail,
  TestCaseDuplicateRequest,
  TopupEmployeesResponse,
  TotalRewardsChart,
  TotalRewardsStatementResponse,
  TotalRewardsVestingSchedule,
  TransactionResponse,
  UiConfigResponse,
  WeavrPasswordRequestRequest,
} from './codegen.schemas';

import { axiosOrvalCustomInstance } from '../axios';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * Configuration changes, filtered by employer, run, benefit or status.
 */
export const benefitConfigurationV10ChangesList = (
  params?: BenefitConfigurationV10ChangesListParams,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<BenefitConfigurationChangePage>({
    url: `/api/benefit-configuration/v1.0/changes/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getBenefitConfigurationV10ChangesListQueryKey = (
  params?: BenefitConfigurationV10ChangesListParams
) => {
  return [
    `/api/benefit-configuration/v1.0/changes/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getBenefitConfigurationV10ChangesListQueryOptions = <
  TData = Awaited<ReturnType<typeof benefitConfigurationV10ChangesList>>,
  TError = unknown,
>(
  params?: BenefitConfigurationV10ChangesListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof benefitConfigurationV10ChangesList>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getBenefitConfigurationV10ChangesListQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof benefitConfigurationV10ChangesList>>
  > = ({ signal }) => benefitConfigurationV10ChangesList(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof benefitConfigurationV10ChangesList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type BenefitConfigurationV10ChangesListQueryResult = NonNullable<
  Awaited<ReturnType<typeof benefitConfigurationV10ChangesList>>
>;
export type BenefitConfigurationV10ChangesListQueryError = unknown;

export function useBenefitConfigurationV10ChangesList<
  TData = Awaited<ReturnType<typeof benefitConfigurationV10ChangesList>>,
  TError = unknown,
>(
  params?: BenefitConfigurationV10ChangesListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof benefitConfigurationV10ChangesList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getBenefitConfigurationV10ChangesListQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * One change with its payload, staleness and requirement links.
 */
export const apiBenefitConfigurationV10ChangesRetrieve = (
  changeId: string,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<BenefitConfigurationChangeDetail>({
    url: `/api/benefit-configuration/v1.0/changes/${changeId}/`,
    method: 'GET',
    signal,
  });
};

export const getApiBenefitConfigurationV10ChangesRetrieveQueryKey = (
  changeId: string
) => {
  return [`/api/benefit-configuration/v1.0/changes/${changeId}/`] as const;
};

export const getApiBenefitConfigurationV10ChangesRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiBenefitConfigurationV10ChangesRetrieve>>,
  TError = unknown,
>(
  changeId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiBenefitConfigurationV10ChangesRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiBenefitConfigurationV10ChangesRetrieveQueryKey(changeId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiBenefitConfigurationV10ChangesRetrieve>>
  > = ({ signal }) =>
    apiBenefitConfigurationV10ChangesRetrieve(changeId, signal);

  return {
    queryKey,
    queryFn,
    enabled: changeId !== null && changeId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof apiBenefitConfigurationV10ChangesRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ApiBenefitConfigurationV10ChangesRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiBenefitConfigurationV10ChangesRetrieve>>
>;
export type ApiBenefitConfigurationV10ChangesRetrieveQueryError = unknown;

export function useApiBenefitConfigurationV10ChangesRetrieve<
  TData = Awaited<ReturnType<typeof apiBenefitConfigurationV10ChangesRetrieve>>,
  TError = unknown,
>(
  changeId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiBenefitConfigurationV10ChangesRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApiBenefitConfigurationV10ChangesRetrieveQueryOptions(
    changeId,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Approve a change: the workflow applies it and owns the status.
 */
export const apiBenefitConfigurationV10ChangesApproveCreate = (
  changeId: string,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<BenefitConfigurationChangeDetail>({
    url: `/api/benefit-configuration/v1.0/changes/${changeId}/approve/`,
    method: 'POST',
    signal,
  });
};

export const getApiBenefitConfigurationV10ChangesApproveCreateMutationKey =
  () => ['apiBenefitConfigurationV10ChangesApproveCreate'] as const;

export const getApiBenefitConfigurationV10ChangesApproveCreateMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof apiBenefitConfigurationV10ChangesApproveCreate>
      >,
      TError,
      ApiBenefitConfigurationV10ChangesApproveCreateMutationVariables,
      TContext
    >;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof apiBenefitConfigurationV10ChangesApproveCreate>>,
    TError,
    ApiBenefitConfigurationV10ChangesApproveCreateMutationVariables,
    TContext
  > => {
    const mutationKey =
      getApiBenefitConfigurationV10ChangesApproveCreateMutationKey();
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof apiBenefitConfigurationV10ChangesApproveCreate>
      >,
      ApiBenefitConfigurationV10ChangesApproveCreateMutationVariables
    > = (props) => {
      const { changeId } = props ?? {};

      return apiBenefitConfigurationV10ChangesApproveCreate(changeId);
    };

    return { mutationFn, ...mutationOptions };
  };

export type ApiBenefitConfigurationV10ChangesApproveCreateMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof apiBenefitConfigurationV10ChangesApproveCreate>>
  >;

export type ApiBenefitConfigurationV10ChangesApproveCreateMutationError =
  unknown;
export type ApiBenefitConfigurationV10ChangesApproveCreateMutationVariables = {
  changeId: string;
};

export const useApiBenefitConfigurationV10ChangesApproveCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiBenefitConfigurationV10ChangesApproveCreate>>,
    TError,
    ApiBenefitConfigurationV10ChangesApproveCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiBenefitConfigurationV10ChangesApproveCreate>>,
  TError,
  ApiBenefitConfigurationV10ChangesApproveCreateMutationVariables,
  TContext
> => {
  return useMutation(
    getApiBenefitConfigurationV10ChangesApproveCreateMutationOptions(options)
  );
};

/**
 * Reject a change: the workflow marks it rejected.
 */
export const apiBenefitConfigurationV10ChangesRejectCreate = (
  changeId: string,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<BenefitConfigurationChangeDetail>({
    url: `/api/benefit-configuration/v1.0/changes/${changeId}/reject/`,
    method: 'POST',
    signal,
  });
};

export const getApiBenefitConfigurationV10ChangesRejectCreateMutationKey = () =>
  ['apiBenefitConfigurationV10ChangesRejectCreate'] as const;

export const getApiBenefitConfigurationV10ChangesRejectCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiBenefitConfigurationV10ChangesRejectCreate>>,
    TError,
    ApiBenefitConfigurationV10ChangesRejectCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiBenefitConfigurationV10ChangesRejectCreate>>,
  TError,
  ApiBenefitConfigurationV10ChangesRejectCreateMutationVariables,
  TContext
> => {
  const mutationKey =
    getApiBenefitConfigurationV10ChangesRejectCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiBenefitConfigurationV10ChangesRejectCreate>>,
    ApiBenefitConfigurationV10ChangesRejectCreateMutationVariables
  > = (props) => {
    const { changeId } = props ?? {};

    return apiBenefitConfigurationV10ChangesRejectCreate(changeId);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiBenefitConfigurationV10ChangesRejectCreateMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof apiBenefitConfigurationV10ChangesRejectCreate>>
  >;

export type ApiBenefitConfigurationV10ChangesRejectCreateMutationError =
  unknown;
export type ApiBenefitConfigurationV10ChangesRejectCreateMutationVariables = {
  changeId: string;
};

export const useApiBenefitConfigurationV10ChangesRejectCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiBenefitConfigurationV10ChangesRejectCreate>>,
    TError,
    ApiBenefitConfigurationV10ChangesRejectCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiBenefitConfigurationV10ChangesRejectCreate>>,
  TError,
  ApiBenefitConfigurationV10ChangesRejectCreateMutationVariables,
  TContext
> => {
  return useMutation(
    getApiBenefitConfigurationV10ChangesRejectCreateMutationOptions(options)
  );
};

/**
 * Start a configuration run for a requirement group.
 */
export const apiBenefitConfigurationV10RunsCreate = (
  benefitConfigurationRunCreateRequest: BenefitConfigurationRunCreateRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<StartedRun>({
    url: `/api/benefit-configuration/v1.0/runs/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: benefitConfigurationRunCreateRequest,
    signal,
  });
};

export const getApiBenefitConfigurationV10RunsCreateMutationKey = () =>
  ['apiBenefitConfigurationV10RunsCreate'] as const;

export const getApiBenefitConfigurationV10RunsCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiBenefitConfigurationV10RunsCreate>>,
    TError,
    ApiBenefitConfigurationV10RunsCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiBenefitConfigurationV10RunsCreate>>,
  TError,
  ApiBenefitConfigurationV10RunsCreateMutationVariables,
  TContext
> => {
  const mutationKey = getApiBenefitConfigurationV10RunsCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiBenefitConfigurationV10RunsCreate>>,
    ApiBenefitConfigurationV10RunsCreateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return apiBenefitConfigurationV10RunsCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiBenefitConfigurationV10RunsCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiBenefitConfigurationV10RunsCreate>>
>;
export type ApiBenefitConfigurationV10RunsCreateMutationBody =
  BenefitConfigurationRunCreateRequest;
export type ApiBenefitConfigurationV10RunsCreateMutationError = unknown;
export type ApiBenefitConfigurationV10RunsCreateMutationVariables = {
  data: BenefitConfigurationRunCreateRequest;
};

export const useApiBenefitConfigurationV10RunsCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiBenefitConfigurationV10RunsCreate>>,
    TError,
    ApiBenefitConfigurationV10RunsCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiBenefitConfigurationV10RunsCreate>>,
  TError,
  ApiBenefitConfigurationV10RunsCreateMutationVariables,
  TContext
> => {
  return useMutation(
    getApiBenefitConfigurationV10RunsCreateMutationOptions(options)
  );
};

/**
 * Paginated requirement groups for one employer, filterable by classification.
 */
export const requirementsV10GroupsList = (
  params: RequirementsV10GroupsListParams,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<RequirementGroupPage>({
    url: `/api/requirements/v1.0/groups/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getRequirementsV10GroupsListQueryKey = (
  params?: RequirementsV10GroupsListParams
) => {
  return [
    `/api/requirements/v1.0/groups/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getRequirementsV10GroupsListQueryOptions = <
  TData = Awaited<ReturnType<typeof requirementsV10GroupsList>>,
  TError = unknown,
>(
  params: RequirementsV10GroupsListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof requirementsV10GroupsList>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getRequirementsV10GroupsListQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof requirementsV10GroupsList>>
  > = ({ signal }) => requirementsV10GroupsList(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof requirementsV10GroupsList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type RequirementsV10GroupsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof requirementsV10GroupsList>>
>;
export type RequirementsV10GroupsListQueryError = unknown;

export function useRequirementsV10GroupsList<
  TData = Awaited<ReturnType<typeof requirementsV10GroupsList>>,
  TError = unknown,
>(
  params: RequirementsV10GroupsListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof requirementsV10GroupsList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getRequirementsV10GroupsListQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * One requirement group with its direct children and run history.
 */
export const apiRequirementsV10GroupsRetrieve = (
  groupId: string,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<RequirementGroupDetail>({
    url: `/api/requirements/v1.0/groups/${groupId}/`,
    method: 'GET',
    signal,
  });
};

export const getApiRequirementsV10GroupsRetrieveQueryKey = (
  groupId: string
) => {
  return [`/api/requirements/v1.0/groups/${groupId}/`] as const;
};

export const getApiRequirementsV10GroupsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiRequirementsV10GroupsRetrieve>>,
  TError = unknown,
>(
  groupId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiRequirementsV10GroupsRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiRequirementsV10GroupsRetrieveQueryKey(groupId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiRequirementsV10GroupsRetrieve>>
  > = ({ signal }) => apiRequirementsV10GroupsRetrieve(groupId, signal);

  return {
    queryKey,
    queryFn,
    enabled: groupId !== null && groupId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof apiRequirementsV10GroupsRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ApiRequirementsV10GroupsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiRequirementsV10GroupsRetrieve>>
>;
export type ApiRequirementsV10GroupsRetrieveQueryError = unknown;

export function useApiRequirementsV10GroupsRetrieve<
  TData = Awaited<ReturnType<typeof apiRequirementsV10GroupsRetrieve>>,
  TError = unknown,
>(
  groupId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiRequirementsV10GroupsRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApiRequirementsV10GroupsRetrieveQueryOptions(
    groupId,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * A group's current requirements with their configuration status.
 *
 * On a root group this spans the whole tree; on a child, just that child.
 */
export const requirementsV10GroupsRequirementsList = (
  groupId: string,
  params?: RequirementsV10GroupsRequirementsListParams,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<RequirementPage>({
    url: `/api/requirements/v1.0/groups/${groupId}/requirements/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getRequirementsV10GroupsRequirementsListQueryKey = (
  groupId: string,
  params?: RequirementsV10GroupsRequirementsListParams
) => {
  return [
    `/api/requirements/v1.0/groups/${groupId}/requirements/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getRequirementsV10GroupsRequirementsListQueryOptions = <
  TData = Awaited<ReturnType<typeof requirementsV10GroupsRequirementsList>>,
  TError = unknown,
>(
  groupId: string,
  params?: RequirementsV10GroupsRequirementsListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof requirementsV10GroupsRequirementsList>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getRequirementsV10GroupsRequirementsListQueryKey(groupId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof requirementsV10GroupsRequirementsList>>
  > = ({ signal }) =>
    requirementsV10GroupsRequirementsList(groupId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: groupId !== null && groupId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof requirementsV10GroupsRequirementsList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type RequirementsV10GroupsRequirementsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof requirementsV10GroupsRequirementsList>>
>;
export type RequirementsV10GroupsRequirementsListQueryError = unknown;

export function useRequirementsV10GroupsRequirementsList<
  TData = Awaited<ReturnType<typeof requirementsV10GroupsRequirementsList>>,
  TError = unknown,
>(
  groupId: string,
  params?: RequirementsV10GroupsRequirementsListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof requirementsV10GroupsRequirementsList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getRequirementsV10GroupsRequirementsListQueryOptions(
    groupId,
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * OpenApi3 schema for this API. Format can be selected via content negotiation.
 *
 * - YAML: application/vnd.oai.openapi
 * - JSON: application/vnd.oai.openapi+json
 */
export const apiSchemaRetrieve = (
  params?: ApiSchemaRetrieveParams,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<
    | ApiSchemaRetrieve200One
    | ApiSchemaRetrieve200Two
    | ApiSchemaRetrieve200Three
    | ApiSchemaRetrieve200Four
  >({ url: `/api/schema/`, method: 'GET', params, signal });
};

export const getApiSchemaRetrieveQueryKey = (
  params?: ApiSchemaRetrieveParams
) => {
  return [`/api/schema/`, ...(params ? [params] : [])] as const;
};

export const getApiSchemaRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiSchemaRetrieve>>,
  TError = unknown,
>(
  params?: ApiSchemaRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiSchemaRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiSchemaRetrieveQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiSchemaRetrieve>>
  > = ({ signal }) => apiSchemaRetrieve(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiSchemaRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ApiSchemaRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiSchemaRetrieve>>
>;
export type ApiSchemaRetrieveQueryError = unknown;

export function useApiSchemaRetrieve<
  TData = Awaited<ReturnType<typeof apiSchemaRetrieve>>,
  TError = unknown,
>(
  params?: ApiSchemaRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiSchemaRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApiSchemaRetrieveQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Return the current mandate status for the employer
 */
export const apiV10AchMandatesRetrieve = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<ACHMandateStatus>({
    url: `/api/v1.0/ach-mandates/`,
    method: 'GET',
    signal,
  });
};

export const getApiV10AchMandatesRetrieveQueryKey = () => {
  return [`/api/v1.0/ach-mandates/`] as const;
};

export const getApiV10AchMandatesRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiV10AchMandatesRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiV10AchMandatesRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiV10AchMandatesRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiV10AchMandatesRetrieve>>
  > = ({ signal }) => apiV10AchMandatesRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiV10AchMandatesRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ApiV10AchMandatesRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiV10AchMandatesRetrieve>>
>;
export type ApiV10AchMandatesRetrieveQueryError = unknown;

export function useApiV10AchMandatesRetrieve<
  TData = Awaited<ReturnType<typeof apiV10AchMandatesRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiV10AchMandatesRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApiV10AchMandatesRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Create a new pending mandate for the employer
 */
export const apiV10AchMandatesCreate = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<void>({
    url: `/api/v1.0/ach-mandates/`,
    method: 'POST',
    signal,
  });
};

export const getApiV10AchMandatesCreateMutationKey = () =>
  ['apiV10AchMandatesCreate'] as const;

export const getApiV10AchMandatesCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10AchMandatesCreate>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiV10AchMandatesCreate>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = getApiV10AchMandatesCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiV10AchMandatesCreate>>,
    void
  > = () => {
    return apiV10AchMandatesCreate();
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiV10AchMandatesCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiV10AchMandatesCreate>>
>;

export type ApiV10AchMandatesCreateMutationError = unknown;

export const useApiV10AchMandatesCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10AchMandatesCreate>>,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiV10AchMandatesCreate>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getApiV10AchMandatesCreateMutationOptions(options));
};

/**
 * Activate mandate after successful verification.
 */
export const apiV10AchMandatesActivateCreate = (
  mandateId: number,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/api/v1.0/ach-mandates/${mandateId}/activate/`,
    method: 'POST',
    signal,
  });
};

export const getApiV10AchMandatesActivateCreateMutationKey = () =>
  ['apiV10AchMandatesActivateCreate'] as const;

export const getApiV10AchMandatesActivateCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10AchMandatesActivateCreate>>,
    TError,
    ApiV10AchMandatesActivateCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiV10AchMandatesActivateCreate>>,
  TError,
  ApiV10AchMandatesActivateCreateMutationVariables,
  TContext
> => {
  const mutationKey = getApiV10AchMandatesActivateCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiV10AchMandatesActivateCreate>>,
    ApiV10AchMandatesActivateCreateMutationVariables
  > = (props) => {
    const { mandateId } = props ?? {};

    return apiV10AchMandatesActivateCreate(mandateId);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiV10AchMandatesActivateCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiV10AchMandatesActivateCreate>>
>;

export type ApiV10AchMandatesActivateCreateMutationError = unknown;
export type ApiV10AchMandatesActivateCreateMutationVariables = {
  mandateId: number;
};

export const useApiV10AchMandatesActivateCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10AchMandatesActivateCreate>>,
    TError,
    ApiV10AchMandatesActivateCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiV10AchMandatesActivateCreate>>,
  TError,
  ApiV10AchMandatesActivateCreateMutationVariables,
  TContext
> => {
  return useMutation(
    getApiV10AchMandatesActivateCreateMutationOptions(options)
  );
};

/**
 * Create Airwallex checkout session for mandate setup
 */
export const apiV10AchMandatesCheckoutCreate = (
  mandateId: number,
  aCHCheckoutRequestRequest: ACHCheckoutRequestRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<ACHCheckoutSession>({
    url: `/api/v1.0/ach-mandates/${mandateId}/checkout/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: aCHCheckoutRequestRequest,
    signal,
  });
};

export const getApiV10AchMandatesCheckoutCreateMutationKey = () =>
  ['apiV10AchMandatesCheckoutCreate'] as const;

export const getApiV10AchMandatesCheckoutCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10AchMandatesCheckoutCreate>>,
    TError,
    ApiV10AchMandatesCheckoutCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiV10AchMandatesCheckoutCreate>>,
  TError,
  ApiV10AchMandatesCheckoutCreateMutationVariables,
  TContext
> => {
  const mutationKey = getApiV10AchMandatesCheckoutCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiV10AchMandatesCheckoutCreate>>,
    ApiV10AchMandatesCheckoutCreateMutationVariables
  > = (props) => {
    const { mandateId, data } = props ?? {};

    return apiV10AchMandatesCheckoutCreate(mandateId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiV10AchMandatesCheckoutCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiV10AchMandatesCheckoutCreate>>
>;
export type ApiV10AchMandatesCheckoutCreateMutationBody =
  ACHCheckoutRequestRequest;
export type ApiV10AchMandatesCheckoutCreateMutationError = unknown;
export type ApiV10AchMandatesCheckoutCreateMutationVariables = {
  mandateId: number;
  data: ACHCheckoutRequestRequest;
};

export const useApiV10AchMandatesCheckoutCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10AchMandatesCheckoutCreate>>,
    TError,
    ApiV10AchMandatesCheckoutCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiV10AchMandatesCheckoutCreate>>,
  TError,
  ApiV10AchMandatesCheckoutCreateMutationVariables,
  TContext
> => {
  return useMutation(
    getApiV10AchMandatesCheckoutCreateMutationOptions(options)
  );
};

/**
 * Initiate micro-deposit ACH mandate verification
 */
export const apiV10AchMandatesMicroDepositCheckoutCreate = (
  mandateId: number,
  aCHMicroDepositCheckoutRequestRequest: ACHMicroDepositCheckoutRequestRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/api/v1.0/ach-mandates/${mandateId}/micro-deposit-checkout/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: aCHMicroDepositCheckoutRequestRequest,
    signal,
  });
};

export const getApiV10AchMandatesMicroDepositCheckoutCreateMutationKey = () =>
  ['apiV10AchMandatesMicroDepositCheckoutCreate'] as const;

export const getApiV10AchMandatesMicroDepositCheckoutCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10AchMandatesMicroDepositCheckoutCreate>>,
    TError,
    ApiV10AchMandatesMicroDepositCheckoutCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiV10AchMandatesMicroDepositCheckoutCreate>>,
  TError,
  ApiV10AchMandatesMicroDepositCheckoutCreateMutationVariables,
  TContext
> => {
  const mutationKey =
    getApiV10AchMandatesMicroDepositCheckoutCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiV10AchMandatesMicroDepositCheckoutCreate>>,
    ApiV10AchMandatesMicroDepositCheckoutCreateMutationVariables
  > = (props) => {
    const { mandateId, data } = props ?? {};

    return apiV10AchMandatesMicroDepositCheckoutCreate(mandateId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiV10AchMandatesMicroDepositCheckoutCreateMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof apiV10AchMandatesMicroDepositCheckoutCreate>>
  >;
export type ApiV10AchMandatesMicroDepositCheckoutCreateMutationBody =
  ACHMicroDepositCheckoutRequestRequest;
export type ApiV10AchMandatesMicroDepositCheckoutCreateMutationError = unknown;
export type ApiV10AchMandatesMicroDepositCheckoutCreateMutationVariables = {
  mandateId: number;
  data: ACHMicroDepositCheckoutRequestRequest;
};

export const useApiV10AchMandatesMicroDepositCheckoutCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10AchMandatesMicroDepositCheckoutCreate>>,
    TError,
    ApiV10AchMandatesMicroDepositCheckoutCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiV10AchMandatesMicroDepositCheckoutCreate>>,
  TError,
  ApiV10AchMandatesMicroDepositCheckoutCreateMutationVariables,
  TContext
> => {
  return useMutation(
    getApiV10AchMandatesMicroDepositCheckoutCreateMutationOptions(options)
  );
};

export const apiV10AreasOfInterestList = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<AreaOfInterest[]>({
    url: `/api/v1.0/areas-of-interest/`,
    method: 'GET',
    signal,
  });
};

export const getApiV10AreasOfInterestListQueryKey = () => {
  return [`/api/v1.0/areas-of-interest/`] as const;
};

export const getApiV10AreasOfInterestListQueryOptions = <
  TData = Awaited<ReturnType<typeof apiV10AreasOfInterestList>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiV10AreasOfInterestList>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiV10AreasOfInterestListQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiV10AreasOfInterestList>>
  > = ({ signal }) => apiV10AreasOfInterestList(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiV10AreasOfInterestList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ApiV10AreasOfInterestListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiV10AreasOfInterestList>>
>;
export type ApiV10AreasOfInterestListQueryError = unknown;

export function useApiV10AreasOfInterestList<
  TData = Awaited<ReturnType<typeof apiV10AreasOfInterestList>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiV10AreasOfInterestList>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApiV10AreasOfInterestListQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const apiV10AssistantCreate = (
  baseAgentRequestRequestRequest: BaseAgentRequestRequestRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<BaseAgentRequestRequest>({
    url: `/api/v1.0/assistant/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: baseAgentRequestRequestRequest,
    signal,
  });
};

export const getApiV10AssistantCreateMutationKey = () =>
  ['apiV10AssistantCreate'] as const;

export const getApiV10AssistantCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10AssistantCreate>>,
    TError,
    ApiV10AssistantCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiV10AssistantCreate>>,
  TError,
  ApiV10AssistantCreateMutationVariables,
  TContext
> => {
  const mutationKey = getApiV10AssistantCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiV10AssistantCreate>>,
    ApiV10AssistantCreateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return apiV10AssistantCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiV10AssistantCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiV10AssistantCreate>>
>;
export type ApiV10AssistantCreateMutationBody = BaseAgentRequestRequestRequest;
export type ApiV10AssistantCreateMutationError = unknown;
export type ApiV10AssistantCreateMutationVariables = {
  data: BaseAgentRequestRequestRequest;
};

export const useApiV10AssistantCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10AssistantCreate>>,
    TError,
    ApiV10AssistantCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiV10AssistantCreate>>,
  TError,
  ApiV10AssistantCreateMutationVariables,
  TContext
> => {
  return useMutation(getApiV10AssistantCreateMutationOptions(options));
};

export const apiV10AutobenCreate = (
  baseAgentRequestRequestRequest: BaseAgentRequestRequestRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<BaseAgentRequestRequest>({
    url: `/api/v1.0/autoben/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: baseAgentRequestRequestRequest,
    signal,
  });
};

export const getApiV10AutobenCreateMutationKey = () =>
  ['apiV10AutobenCreate'] as const;

export const getApiV10AutobenCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10AutobenCreate>>,
    TError,
    ApiV10AutobenCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiV10AutobenCreate>>,
  TError,
  ApiV10AutobenCreateMutationVariables,
  TContext
> => {
  const mutationKey = getApiV10AutobenCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiV10AutobenCreate>>,
    ApiV10AutobenCreateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return apiV10AutobenCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiV10AutobenCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiV10AutobenCreate>>
>;
export type ApiV10AutobenCreateMutationBody = BaseAgentRequestRequestRequest;
export type ApiV10AutobenCreateMutationError = unknown;
export type ApiV10AutobenCreateMutationVariables = {
  data: BaseAgentRequestRequestRequest;
};

export const useApiV10AutobenCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10AutobenCreate>>,
    TError,
    ApiV10AutobenCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiV10AutobenCreate>>,
  TError,
  ApiV10AutobenCreateMutationVariables,
  TContext
> => {
  return useMutation(getApiV10AutobenCreateMutationOptions(options));
};

/**
 * Returns the RJSF form config for the beneficiary add/edit form.
 *
 * One shared config for everyone — not employee- or employer-scoped.
 */
export const apiV10BeneficiariesFormConfigRetrieve = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<RJSFFormConfigResponse>({
    url: `/api/v1.0/beneficiaries/form-config/`,
    method: 'GET',
    signal,
  });
};

export const getApiV10BeneficiariesFormConfigRetrieveQueryKey = () => {
  return [`/api/v1.0/beneficiaries/form-config/`] as const;
};

export const getApiV10BeneficiariesFormConfigRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiV10BeneficiariesFormConfigRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiV10BeneficiariesFormConfigRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiV10BeneficiariesFormConfigRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiV10BeneficiariesFormConfigRetrieve>>
  > = ({ signal }) => apiV10BeneficiariesFormConfigRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiV10BeneficiariesFormConfigRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ApiV10BeneficiariesFormConfigRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiV10BeneficiariesFormConfigRetrieve>>
>;
export type ApiV10BeneficiariesFormConfigRetrieveQueryError = unknown;

export function useApiV10BeneficiariesFormConfigRetrieve<
  TData = Awaited<ReturnType<typeof apiV10BeneficiariesFormConfigRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiV10BeneficiariesFormConfigRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getApiV10BeneficiariesFormConfigRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Return a list of all benefit categories for the given employer
 */
export const apiV10BenefitCategoriesRetrieve = (
  params?: ApiV10BenefitCategoriesRetrieveParams,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<BenefitCategoryListResponse>({
    url: `/api/v1.0/benefit-categories/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getApiV10BenefitCategoriesRetrieveQueryKey = (
  params?: ApiV10BenefitCategoriesRetrieveParams
) => {
  return [
    `/api/v1.0/benefit-categories/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getApiV10BenefitCategoriesRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiV10BenefitCategoriesRetrieve>>,
  TError = unknown,
>(
  params?: ApiV10BenefitCategoriesRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiV10BenefitCategoriesRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiV10BenefitCategoriesRetrieveQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiV10BenefitCategoriesRetrieve>>
  > = ({ signal }) => apiV10BenefitCategoriesRetrieve(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiV10BenefitCategoriesRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ApiV10BenefitCategoriesRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiV10BenefitCategoriesRetrieve>>
>;
export type ApiV10BenefitCategoriesRetrieveQueryError = unknown;

export function useApiV10BenefitCategoriesRetrieve<
  TData = Awaited<ReturnType<typeof apiV10BenefitCategoriesRetrieve>>,
  TError = unknown,
>(
  params?: ApiV10BenefitCategoriesRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiV10BenefitCategoriesRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApiV10BenefitCategoriesRetrieveQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Create a Benefit Category.
 */
export const apiV10BenefitCategoriesCreate = (
  benefitCategoryRequest: BenefitCategoryRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<BenefitCategory>({
    url: `/api/v1.0/benefit-categories/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: benefitCategoryRequest,
    signal,
  });
};

export const getApiV10BenefitCategoriesCreateMutationKey = () =>
  ['apiV10BenefitCategoriesCreate'] as const;

export const getApiV10BenefitCategoriesCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10BenefitCategoriesCreate>>,
    TError,
    ApiV10BenefitCategoriesCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiV10BenefitCategoriesCreate>>,
  TError,
  ApiV10BenefitCategoriesCreateMutationVariables,
  TContext
> => {
  const mutationKey = getApiV10BenefitCategoriesCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiV10BenefitCategoriesCreate>>,
    ApiV10BenefitCategoriesCreateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return apiV10BenefitCategoriesCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiV10BenefitCategoriesCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiV10BenefitCategoriesCreate>>
>;
export type ApiV10BenefitCategoriesCreateMutationBody = BenefitCategoryRequest;
export type ApiV10BenefitCategoriesCreateMutationError = unknown;
export type ApiV10BenefitCategoriesCreateMutationVariables = {
  data: BenefitCategoryRequest;
};

export const useApiV10BenefitCategoriesCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10BenefitCategoriesCreate>>,
    TError,
    ApiV10BenefitCategoriesCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiV10BenefitCategoriesCreate>>,
  TError,
  ApiV10BenefitCategoriesCreateMutationVariables,
  TContext
> => {
  return useMutation(getApiV10BenefitCategoriesCreateMutationOptions(options));
};

/**
 * Partially update a Benefit Category.
 */
export const apiV10BenefitCategoriesPartialUpdate = (
  patchedBenefitCategoryPartialUpdateRequest: PatchedBenefitCategoryPartialUpdateRequest[],
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/api/v1.0/benefit-categories/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchedBenefitCategoryPartialUpdateRequest,
    signal,
  });
};

export const getApiV10BenefitCategoriesPartialUpdateMutationKey = () =>
  ['apiV10BenefitCategoriesPartialUpdate'] as const;

export const getApiV10BenefitCategoriesPartialUpdateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10BenefitCategoriesPartialUpdate>>,
    TError,
    ApiV10BenefitCategoriesPartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiV10BenefitCategoriesPartialUpdate>>,
  TError,
  ApiV10BenefitCategoriesPartialUpdateMutationVariables,
  TContext
> => {
  const mutationKey = getApiV10BenefitCategoriesPartialUpdateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiV10BenefitCategoriesPartialUpdate>>,
    ApiV10BenefitCategoriesPartialUpdateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return apiV10BenefitCategoriesPartialUpdate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiV10BenefitCategoriesPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiV10BenefitCategoriesPartialUpdate>>
>;
export type ApiV10BenefitCategoriesPartialUpdateMutationBody =
  PatchedBenefitCategoryPartialUpdateRequest[];
export type ApiV10BenefitCategoriesPartialUpdateMutationError = unknown;
export type ApiV10BenefitCategoriesPartialUpdateMutationVariables = {
  data: PatchedBenefitCategoryPartialUpdateRequest[];
};

export const useApiV10BenefitCategoriesPartialUpdate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10BenefitCategoriesPartialUpdate>>,
    TError,
    ApiV10BenefitCategoriesPartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiV10BenefitCategoriesPartialUpdate>>,
  TError,
  ApiV10BenefitCategoriesPartialUpdateMutationVariables,
  TContext
> => {
  return useMutation(
    getApiV10BenefitCategoriesPartialUpdateMutationOptions(options)
  );
};

export const apiV10BenefitRequestsRetrieve = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<BenefitRequestListResponse>({
    url: `/api/v1.0/benefit-requests/`,
    method: 'GET',
    signal,
  });
};

export const getApiV10BenefitRequestsRetrieveQueryKey = () => {
  return [`/api/v1.0/benefit-requests/`] as const;
};

export const getApiV10BenefitRequestsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiV10BenefitRequestsRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiV10BenefitRequestsRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiV10BenefitRequestsRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiV10BenefitRequestsRetrieve>>
  > = ({ signal }) => apiV10BenefitRequestsRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiV10BenefitRequestsRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ApiV10BenefitRequestsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiV10BenefitRequestsRetrieve>>
>;
export type ApiV10BenefitRequestsRetrieveQueryError = unknown;

export function useApiV10BenefitRequestsRetrieve<
  TData = Awaited<ReturnType<typeof apiV10BenefitRequestsRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiV10BenefitRequestsRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApiV10BenefitRequestsRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const apiV10BenefitRequestsCreate = (
  benefitRequestCreateRequest: BenefitRequestCreateRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/api/v1.0/benefit-requests/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: benefitRequestCreateRequest,
    signal,
  });
};

export const getApiV10BenefitRequestsCreateMutationKey = () =>
  ['apiV10BenefitRequestsCreate'] as const;

export const getApiV10BenefitRequestsCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10BenefitRequestsCreate>>,
    TError,
    ApiV10BenefitRequestsCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiV10BenefitRequestsCreate>>,
  TError,
  ApiV10BenefitRequestsCreateMutationVariables,
  TContext
> => {
  const mutationKey = getApiV10BenefitRequestsCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiV10BenefitRequestsCreate>>,
    ApiV10BenefitRequestsCreateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return apiV10BenefitRequestsCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiV10BenefitRequestsCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiV10BenefitRequestsCreate>>
>;
export type ApiV10BenefitRequestsCreateMutationBody =
  BenefitRequestCreateRequest;
export type ApiV10BenefitRequestsCreateMutationError = unknown;
export type ApiV10BenefitRequestsCreateMutationVariables = {
  data: BenefitRequestCreateRequest;
};

export const useApiV10BenefitRequestsCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10BenefitRequestsCreate>>,
    TError,
    ApiV10BenefitRequestsCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiV10BenefitRequestsCreate>>,
  TError,
  ApiV10BenefitRequestsCreateMutationVariables,
  TContext
> => {
  return useMutation(getApiV10BenefitRequestsCreateMutationOptions(options));
};

export const apiV10BenefitRequestsRetrieve2 = (
  benefitRequestId: number,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<BenefitRequestGetResponse>({
    url: `/api/v1.0/benefit-requests/${benefitRequestId}/`,
    method: 'GET',
    signal,
  });
};

export const getApiV10BenefitRequestsRetrieve2QueryKey = (
  benefitRequestId: number
) => {
  return [`/api/v1.0/benefit-requests/${benefitRequestId}/`] as const;
};

export const getApiV10BenefitRequestsRetrieve2QueryOptions = <
  TData = Awaited<ReturnType<typeof apiV10BenefitRequestsRetrieve2>>,
  TError = unknown,
>(
  benefitRequestId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiV10BenefitRequestsRetrieve2>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiV10BenefitRequestsRetrieve2QueryKey(benefitRequestId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiV10BenefitRequestsRetrieve2>>
  > = ({ signal }) => apiV10BenefitRequestsRetrieve2(benefitRequestId, signal);

  return {
    queryKey,
    queryFn,
    enabled: benefitRequestId !== null && benefitRequestId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof apiV10BenefitRequestsRetrieve2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ApiV10BenefitRequestsRetrieve2QueryResult = NonNullable<
  Awaited<ReturnType<typeof apiV10BenefitRequestsRetrieve2>>
>;
export type ApiV10BenefitRequestsRetrieve2QueryError = unknown;

export function useApiV10BenefitRequestsRetrieve2<
  TData = Awaited<ReturnType<typeof apiV10BenefitRequestsRetrieve2>>,
  TError = unknown,
>(
  benefitRequestId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiV10BenefitRequestsRetrieve2>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApiV10BenefitRequestsRetrieve2QueryOptions(
    benefitRequestId,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Patch the request.
 *
 * Patching resets the approval process no matter whether the request
 * is updated or not. This is for data consistency to ensure admins review the
 * actual version of the request.
 *
 * The implementation of the approval process should ensure that the
 * request data hasn't changed during the review. To facilitate this
 * check, the version counter of the |BenefitRequest| is incremented
 * when employees patch their requests.
 */
export const apiV10BenefitRequestsPartialUpdate = (
  benefitRequestId: number,
  patchedBenefitRequestPatchRequest?: PatchedBenefitRequestPatchRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/api/v1.0/benefit-requests/${benefitRequestId}/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchedBenefitRequestPatchRequest,
    signal,
  });
};

export const getApiV10BenefitRequestsPartialUpdateMutationKey = () =>
  ['apiV10BenefitRequestsPartialUpdate'] as const;

export const getApiV10BenefitRequestsPartialUpdateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10BenefitRequestsPartialUpdate>>,
    TError,
    ApiV10BenefitRequestsPartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiV10BenefitRequestsPartialUpdate>>,
  TError,
  ApiV10BenefitRequestsPartialUpdateMutationVariables,
  TContext
> => {
  const mutationKey = getApiV10BenefitRequestsPartialUpdateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiV10BenefitRequestsPartialUpdate>>,
    ApiV10BenefitRequestsPartialUpdateMutationVariables
  > = (props) => {
    const { benefitRequestId, data } = props ?? {};

    return apiV10BenefitRequestsPartialUpdate(benefitRequestId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiV10BenefitRequestsPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiV10BenefitRequestsPartialUpdate>>
>;
export type ApiV10BenefitRequestsPartialUpdateMutationBody =
  | PatchedBenefitRequestPatchRequest
  | undefined;
export type ApiV10BenefitRequestsPartialUpdateMutationError = unknown;
export type ApiV10BenefitRequestsPartialUpdateMutationVariables = {
  benefitRequestId: number;
  data?: PatchedBenefitRequestPatchRequest;
};

export const useApiV10BenefitRequestsPartialUpdate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10BenefitRequestsPartialUpdate>>,
    TError,
    ApiV10BenefitRequestsPartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiV10BenefitRequestsPartialUpdate>>,
  TError,
  ApiV10BenefitRequestsPartialUpdateMutationVariables,
  TContext
> => {
  return useMutation(
    getApiV10BenefitRequestsPartialUpdateMutationOptions(options)
  );
};

export const apiV10BenefitRequestsDestroy = (
  benefitRequestId: number,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/api/v1.0/benefit-requests/${benefitRequestId}/`,
    method: 'DELETE',
    signal,
  });
};

export const getApiV10BenefitRequestsDestroyMutationKey = () =>
  ['apiV10BenefitRequestsDestroy'] as const;

export const getApiV10BenefitRequestsDestroyMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10BenefitRequestsDestroy>>,
    TError,
    ApiV10BenefitRequestsDestroyMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiV10BenefitRequestsDestroy>>,
  TError,
  ApiV10BenefitRequestsDestroyMutationVariables,
  TContext
> => {
  const mutationKey = getApiV10BenefitRequestsDestroyMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiV10BenefitRequestsDestroy>>,
    ApiV10BenefitRequestsDestroyMutationVariables
  > = (props) => {
    const { benefitRequestId } = props ?? {};

    return apiV10BenefitRequestsDestroy(benefitRequestId);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiV10BenefitRequestsDestroyMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiV10BenefitRequestsDestroy>>
>;

export type ApiV10BenefitRequestsDestroyMutationError = unknown;
export type ApiV10BenefitRequestsDestroyMutationVariables = {
  benefitRequestId: number;
};

export const useApiV10BenefitRequestsDestroy = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10BenefitRequestsDestroy>>,
    TError,
    ApiV10BenefitRequestsDestroyMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiV10BenefitRequestsDestroy>>,
  TError,
  ApiV10BenefitRequestsDestroyMutationVariables,
  TContext
> => {
  return useMutation(getApiV10BenefitRequestsDestroyMutationOptions(options));
};

/**
 * Return a list of all BenefitType objects
 */
export const apiV10BenefitTypesRetrieve = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<BenefitTypeListResponse>({
    url: `/api/v1.0/benefit-types/`,
    method: 'GET',
    signal,
  });
};

export const getApiV10BenefitTypesRetrieveQueryKey = () => {
  return [`/api/v1.0/benefit-types/`] as const;
};

export const getApiV10BenefitTypesRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiV10BenefitTypesRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiV10BenefitTypesRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiV10BenefitTypesRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiV10BenefitTypesRetrieve>>
  > = ({ signal }) => apiV10BenefitTypesRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiV10BenefitTypesRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ApiV10BenefitTypesRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiV10BenefitTypesRetrieve>>
>;
export type ApiV10BenefitTypesRetrieveQueryError = unknown;

export function useApiV10BenefitTypesRetrieve<
  TData = Awaited<ReturnType<typeof apiV10BenefitTypesRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiV10BenefitTypesRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApiV10BenefitTypesRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const apiV10BenefitsEnrollmentsPartialUpdate = (
  benefitId: number,
  patchedBenefitEnrollmentUpdateRequest?: PatchedBenefitEnrollmentUpdateRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<BenefitEnrollmentUpdate>({
    url: `/api/v1.0/benefits/${benefitId}/enrollments/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchedBenefitEnrollmentUpdateRequest,
    signal,
  });
};

export const getApiV10BenefitsEnrollmentsPartialUpdateMutationKey = () =>
  ['apiV10BenefitsEnrollmentsPartialUpdate'] as const;

export const getApiV10BenefitsEnrollmentsPartialUpdateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10BenefitsEnrollmentsPartialUpdate>>,
    TError,
    ApiV10BenefitsEnrollmentsPartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiV10BenefitsEnrollmentsPartialUpdate>>,
  TError,
  ApiV10BenefitsEnrollmentsPartialUpdateMutationVariables,
  TContext
> => {
  const mutationKey = getApiV10BenefitsEnrollmentsPartialUpdateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiV10BenefitsEnrollmentsPartialUpdate>>,
    ApiV10BenefitsEnrollmentsPartialUpdateMutationVariables
  > = (props) => {
    const { benefitId, data } = props ?? {};

    return apiV10BenefitsEnrollmentsPartialUpdate(benefitId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiV10BenefitsEnrollmentsPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiV10BenefitsEnrollmentsPartialUpdate>>
>;
export type ApiV10BenefitsEnrollmentsPartialUpdateMutationBody =
  | PatchedBenefitEnrollmentUpdateRequest
  | undefined;
export type ApiV10BenefitsEnrollmentsPartialUpdateMutationError = unknown;
export type ApiV10BenefitsEnrollmentsPartialUpdateMutationVariables = {
  benefitId: number;
  data?: PatchedBenefitEnrollmentUpdateRequest;
};

export const useApiV10BenefitsEnrollmentsPartialUpdate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10BenefitsEnrollmentsPartialUpdate>>,
    TError,
    ApiV10BenefitsEnrollmentsPartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiV10BenefitsEnrollmentsPartialUpdate>>,
  TError,
  ApiV10BenefitsEnrollmentsPartialUpdateMutationVariables,
  TContext
> => {
  return useMutation(
    getApiV10BenefitsEnrollmentsPartialUpdateMutationOptions(options)
  );
};

export const apiV10BenefitsFeaturesGenerateRetrieve = (
  benefitId: number,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/api/v1.0/benefits/${benefitId}/features/generate/`,
    method: 'GET',
    signal,
  });
};

export const getApiV10BenefitsFeaturesGenerateRetrieveQueryKey = (
  benefitId: number
) => {
  return [`/api/v1.0/benefits/${benefitId}/features/generate/`] as const;
};

export const getApiV10BenefitsFeaturesGenerateRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiV10BenefitsFeaturesGenerateRetrieve>>,
  TError = unknown,
>(
  benefitId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiV10BenefitsFeaturesGenerateRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiV10BenefitsFeaturesGenerateRetrieveQueryKey(benefitId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiV10BenefitsFeaturesGenerateRetrieve>>
  > = ({ signal }) => apiV10BenefitsFeaturesGenerateRetrieve(benefitId, signal);

  return {
    queryKey,
    queryFn,
    enabled: benefitId !== null && benefitId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof apiV10BenefitsFeaturesGenerateRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ApiV10BenefitsFeaturesGenerateRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiV10BenefitsFeaturesGenerateRetrieve>>
>;
export type ApiV10BenefitsFeaturesGenerateRetrieveQueryError = unknown;

export function useApiV10BenefitsFeaturesGenerateRetrieve<
  TData = Awaited<ReturnType<typeof apiV10BenefitsFeaturesGenerateRetrieve>>,
  TError = unknown,
>(
  benefitId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiV10BenefitsFeaturesGenerateRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApiV10BenefitsFeaturesGenerateRetrieveQueryOptions(
    benefitId,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const apiV10BenefitsFeaturesList = (
  params?: ApiV10BenefitsFeaturesListParams,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<PaginatedEnrollableBenefitFeatureSerializerWithBenefitDetailsList>(
    { url: `/api/v1.0/benefits/features/`, method: 'GET', params, signal }
  );
};

export const getApiV10BenefitsFeaturesListQueryKey = (
  params?: ApiV10BenefitsFeaturesListParams
) => {
  return [`/api/v1.0/benefits/features/`, ...(params ? [params] : [])] as const;
};

export const getApiV10BenefitsFeaturesListQueryOptions = <
  TData = Awaited<ReturnType<typeof apiV10BenefitsFeaturesList>>,
  TError = unknown,
>(
  params?: ApiV10BenefitsFeaturesListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiV10BenefitsFeaturesList>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiV10BenefitsFeaturesListQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiV10BenefitsFeaturesList>>
  > = ({ signal }) => apiV10BenefitsFeaturesList(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiV10BenefitsFeaturesList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ApiV10BenefitsFeaturesListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiV10BenefitsFeaturesList>>
>;
export type ApiV10BenefitsFeaturesListQueryError = unknown;

export function useApiV10BenefitsFeaturesList<
  TData = Awaited<ReturnType<typeof apiV10BenefitsFeaturesList>>,
  TError = unknown,
>(
  params?: ApiV10BenefitsFeaturesListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiV10BenefitsFeaturesList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApiV10BenefitsFeaturesListQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const apiV10BenefitsFeaturesPartialUpdate = (
  patchedEnrollableBenefitFeatureUpdateRequestRequest: PatchedEnrollableBenefitFeatureUpdateRequestRequest[],
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/api/v1.0/benefits/features/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchedEnrollableBenefitFeatureUpdateRequestRequest,
    signal,
  });
};

export const getApiV10BenefitsFeaturesPartialUpdateMutationKey = () =>
  ['apiV10BenefitsFeaturesPartialUpdate'] as const;

export const getApiV10BenefitsFeaturesPartialUpdateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10BenefitsFeaturesPartialUpdate>>,
    TError,
    ApiV10BenefitsFeaturesPartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiV10BenefitsFeaturesPartialUpdate>>,
  TError,
  ApiV10BenefitsFeaturesPartialUpdateMutationVariables,
  TContext
> => {
  const mutationKey = getApiV10BenefitsFeaturesPartialUpdateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiV10BenefitsFeaturesPartialUpdate>>,
    ApiV10BenefitsFeaturesPartialUpdateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return apiV10BenefitsFeaturesPartialUpdate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiV10BenefitsFeaturesPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiV10BenefitsFeaturesPartialUpdate>>
>;
export type ApiV10BenefitsFeaturesPartialUpdateMutationBody =
  PatchedEnrollableBenefitFeatureUpdateRequestRequest[];
export type ApiV10BenefitsFeaturesPartialUpdateMutationError = unknown;
export type ApiV10BenefitsFeaturesPartialUpdateMutationVariables = {
  data: PatchedEnrollableBenefitFeatureUpdateRequestRequest[];
};

export const useApiV10BenefitsFeaturesPartialUpdate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10BenefitsFeaturesPartialUpdate>>,
    TError,
    ApiV10BenefitsFeaturesPartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiV10BenefitsFeaturesPartialUpdate>>,
  TError,
  ApiV10BenefitsFeaturesPartialUpdateMutationVariables,
  TContext
> => {
  return useMutation(
    getApiV10BenefitsFeaturesPartialUpdateMutationOptions(options)
  );
};

export const apiV10BenefitsFeaturesCategoriesRetrieve = (
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<EnrollableBenefitFeatureCategoryResponse>({
    url: `/api/v1.0/benefits/features/categories/`,
    method: 'GET',
    signal,
  });
};

export const getApiV10BenefitsFeaturesCategoriesRetrieveQueryKey = () => {
  return [`/api/v1.0/benefits/features/categories/`] as const;
};

export const getApiV10BenefitsFeaturesCategoriesRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiV10BenefitsFeaturesCategoriesRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiV10BenefitsFeaturesCategoriesRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiV10BenefitsFeaturesCategoriesRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiV10BenefitsFeaturesCategoriesRetrieve>>
  > = ({ signal }) => apiV10BenefitsFeaturesCategoriesRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiV10BenefitsFeaturesCategoriesRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ApiV10BenefitsFeaturesCategoriesRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiV10BenefitsFeaturesCategoriesRetrieve>>
>;
export type ApiV10BenefitsFeaturesCategoriesRetrieveQueryError = unknown;

export function useApiV10BenefitsFeaturesCategoriesRetrieve<
  TData = Awaited<ReturnType<typeof apiV10BenefitsFeaturesCategoriesRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiV10BenefitsFeaturesCategoriesRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getApiV10BenefitsFeaturesCategoriesRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Updates the rank of the EnrollableBenefitFeatures provided
 */
export const apiV10BenefitsFeaturesRankPartialUpdate = (
  patchedRankRequestRequest?: PatchedRankRequestRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/api/v1.0/benefits/features/rank/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchedRankRequestRequest,
    signal,
  });
};

export const getApiV10BenefitsFeaturesRankPartialUpdateMutationKey = () =>
  ['apiV10BenefitsFeaturesRankPartialUpdate'] as const;

export const getApiV10BenefitsFeaturesRankPartialUpdateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10BenefitsFeaturesRankPartialUpdate>>,
    TError,
    ApiV10BenefitsFeaturesRankPartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiV10BenefitsFeaturesRankPartialUpdate>>,
  TError,
  ApiV10BenefitsFeaturesRankPartialUpdateMutationVariables,
  TContext
> => {
  const mutationKey = getApiV10BenefitsFeaturesRankPartialUpdateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiV10BenefitsFeaturesRankPartialUpdate>>,
    ApiV10BenefitsFeaturesRankPartialUpdateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return apiV10BenefitsFeaturesRankPartialUpdate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiV10BenefitsFeaturesRankPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiV10BenefitsFeaturesRankPartialUpdate>>
>;
export type ApiV10BenefitsFeaturesRankPartialUpdateMutationBody =
  | PatchedRankRequestRequest
  | undefined;
export type ApiV10BenefitsFeaturesRankPartialUpdateMutationError = unknown;
export type ApiV10BenefitsFeaturesRankPartialUpdateMutationVariables = {
  data?: PatchedRankRequestRequest;
};

export const useApiV10BenefitsFeaturesRankPartialUpdate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10BenefitsFeaturesRankPartialUpdate>>,
    TError,
    ApiV10BenefitsFeaturesRankPartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiV10BenefitsFeaturesRankPartialUpdate>>,
  TError,
  ApiV10BenefitsFeaturesRankPartialUpdateMutationVariables,
  TContext
> => {
  return useMutation(
    getApiV10BenefitsFeaturesRankPartialUpdateMutationOptions(options)
  );
};

export const apiV10CarouselsList = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<Carousel[]>({
    url: `/api/v1.0/carousels/`,
    method: 'GET',
    signal,
  });
};

export const getApiV10CarouselsListQueryKey = () => {
  return [`/api/v1.0/carousels/`] as const;
};

export const getApiV10CarouselsListQueryOptions = <
  TData = Awaited<ReturnType<typeof apiV10CarouselsList>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiV10CarouselsList>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiV10CarouselsListQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiV10CarouselsList>>
  > = ({ signal }) => apiV10CarouselsList(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiV10CarouselsList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ApiV10CarouselsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiV10CarouselsList>>
>;
export type ApiV10CarouselsListQueryError = unknown;

export function useApiV10CarouselsList<
  TData = Awaited<ReturnType<typeof apiV10CarouselsList>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiV10CarouselsList>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApiV10CarouselsListQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const apiV10CarouselsCreate = (
  carouselRequest: CarouselRequest,
  signal?: AbortSignal
) => {
  const formData = new FormData();
  formData.append(`title`, carouselRequest.title);
  formData.append(`description`, carouselRequest.description);
  if (
    carouselRequest.cta_link !== undefined &&
    carouselRequest.cta_link !== null
  ) {
    formData.append(`cta_link`, carouselRequest.cta_link);
  }
  if (
    carouselRequest.cta_text !== undefined &&
    carouselRequest.cta_text !== null
  ) {
    formData.append(`cta_text`, carouselRequest.cta_text);
  }
  formData.append(`image_alt_text`, carouselRequest.image_alt_text);
  if (carouselRequest.image !== undefined) {
    formData.append(`image`, carouselRequest.image);
  }
  if (carouselRequest.status !== undefined) {
    formData.append(`status`, carouselRequest.status);
  }
  if (carouselRequest.audience !== undefined) {
    formData.append(`audience`, carouselRequest.audience);
  }
  if (carouselRequest.segment_ids !== undefined) {
    carouselRequest.segment_ids.forEach((value) =>
      formData.append(`segment_ids`, value.toString())
    );
  }

  return axiosOrvalCustomInstance<Carousel>({
    url: `/api/v1.0/carousels/`,
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
    signal,
  });
};

export const getApiV10CarouselsCreateMutationKey = () =>
  ['apiV10CarouselsCreate'] as const;

export const getApiV10CarouselsCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10CarouselsCreate>>,
    TError,
    ApiV10CarouselsCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiV10CarouselsCreate>>,
  TError,
  ApiV10CarouselsCreateMutationVariables,
  TContext
> => {
  const mutationKey = getApiV10CarouselsCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiV10CarouselsCreate>>,
    ApiV10CarouselsCreateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return apiV10CarouselsCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiV10CarouselsCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiV10CarouselsCreate>>
>;
export type ApiV10CarouselsCreateMutationBody = CarouselRequest;
export type ApiV10CarouselsCreateMutationError = unknown;
export type ApiV10CarouselsCreateMutationVariables = { data: CarouselRequest };

export const useApiV10CarouselsCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10CarouselsCreate>>,
    TError,
    ApiV10CarouselsCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiV10CarouselsCreate>>,
  TError,
  ApiV10CarouselsCreateMutationVariables,
  TContext
> => {
  return useMutation(getApiV10CarouselsCreateMutationOptions(options));
};

export const apiV10CarouselsUpdate = (
  carouselId: number,
  carouselRequest: CarouselRequest,
  signal?: AbortSignal
) => {
  const formData = new FormData();
  formData.append(`title`, carouselRequest.title);
  formData.append(`description`, carouselRequest.description);
  if (
    carouselRequest.cta_link !== undefined &&
    carouselRequest.cta_link !== null
  ) {
    formData.append(`cta_link`, carouselRequest.cta_link);
  }
  if (
    carouselRequest.cta_text !== undefined &&
    carouselRequest.cta_text !== null
  ) {
    formData.append(`cta_text`, carouselRequest.cta_text);
  }
  formData.append(`image_alt_text`, carouselRequest.image_alt_text);
  if (carouselRequest.image !== undefined) {
    formData.append(`image`, carouselRequest.image);
  }
  if (carouselRequest.status !== undefined) {
    formData.append(`status`, carouselRequest.status);
  }
  if (carouselRequest.audience !== undefined) {
    formData.append(`audience`, carouselRequest.audience);
  }
  if (carouselRequest.segment_ids !== undefined) {
    carouselRequest.segment_ids.forEach((value) =>
      formData.append(`segment_ids`, value.toString())
    );
  }

  return axiosOrvalCustomInstance<Carousel>({
    url: `/api/v1.0/carousels/${carouselId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
    signal,
  });
};

export const getApiV10CarouselsUpdateMutationKey = () =>
  ['apiV10CarouselsUpdate'] as const;

export const getApiV10CarouselsUpdateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10CarouselsUpdate>>,
    TError,
    ApiV10CarouselsUpdateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiV10CarouselsUpdate>>,
  TError,
  ApiV10CarouselsUpdateMutationVariables,
  TContext
> => {
  const mutationKey = getApiV10CarouselsUpdateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiV10CarouselsUpdate>>,
    ApiV10CarouselsUpdateMutationVariables
  > = (props) => {
    const { carouselId, data } = props ?? {};

    return apiV10CarouselsUpdate(carouselId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiV10CarouselsUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiV10CarouselsUpdate>>
>;
export type ApiV10CarouselsUpdateMutationBody = CarouselRequest;
export type ApiV10CarouselsUpdateMutationError = unknown;
export type ApiV10CarouselsUpdateMutationVariables = {
  carouselId: number;
  data: CarouselRequest;
};

export const useApiV10CarouselsUpdate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10CarouselsUpdate>>,
    TError,
    ApiV10CarouselsUpdateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiV10CarouselsUpdate>>,
  TError,
  ApiV10CarouselsUpdateMutationVariables,
  TContext
> => {
  return useMutation(getApiV10CarouselsUpdateMutationOptions(options));
};

export const apiV10CarouselsPartialUpdate = (
  carouselId: number,
  patchedCarouselRankRequest?: PatchedCarouselRankRequest,
  signal?: AbortSignal
) => {
  const formData = new FormData();
  if (patchedCarouselRankRequest?.new_index !== undefined) {
    formData.append(
      `new_index`,
      patchedCarouselRankRequest.new_index.toString()
    );
  }

  return axiosOrvalCustomInstance<void>({
    url: `/api/v1.0/carousels/${carouselId}`,
    method: 'PATCH',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
    signal,
  });
};

export const getApiV10CarouselsPartialUpdateMutationKey = () =>
  ['apiV10CarouselsPartialUpdate'] as const;

export const getApiV10CarouselsPartialUpdateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10CarouselsPartialUpdate>>,
    TError,
    ApiV10CarouselsPartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiV10CarouselsPartialUpdate>>,
  TError,
  ApiV10CarouselsPartialUpdateMutationVariables,
  TContext
> => {
  const mutationKey = getApiV10CarouselsPartialUpdateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiV10CarouselsPartialUpdate>>,
    ApiV10CarouselsPartialUpdateMutationVariables
  > = (props) => {
    const { carouselId, data } = props ?? {};

    return apiV10CarouselsPartialUpdate(carouselId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiV10CarouselsPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiV10CarouselsPartialUpdate>>
>;
export type ApiV10CarouselsPartialUpdateMutationBody =
  | PatchedCarouselRankRequest
  | undefined;
export type ApiV10CarouselsPartialUpdateMutationError = unknown;
export type ApiV10CarouselsPartialUpdateMutationVariables = {
  carouselId: number;
  data?: PatchedCarouselRankRequest;
};

export const useApiV10CarouselsPartialUpdate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10CarouselsPartialUpdate>>,
    TError,
    ApiV10CarouselsPartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiV10CarouselsPartialUpdate>>,
  TError,
  ApiV10CarouselsPartialUpdateMutationVariables,
  TContext
> => {
  return useMutation(getApiV10CarouselsPartialUpdateMutationOptions(options));
};

export const apiV10CarouselsDestroy = (
  carouselId: number,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/api/v1.0/carousels/${carouselId}`,
    method: 'DELETE',
    signal,
  });
};

export const getApiV10CarouselsDestroyMutationKey = () =>
  ['apiV10CarouselsDestroy'] as const;

export const getApiV10CarouselsDestroyMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10CarouselsDestroy>>,
    TError,
    ApiV10CarouselsDestroyMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiV10CarouselsDestroy>>,
  TError,
  ApiV10CarouselsDestroyMutationVariables,
  TContext
> => {
  const mutationKey = getApiV10CarouselsDestroyMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiV10CarouselsDestroy>>,
    ApiV10CarouselsDestroyMutationVariables
  > = (props) => {
    const { carouselId } = props ?? {};

    return apiV10CarouselsDestroy(carouselId);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiV10CarouselsDestroyMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiV10CarouselsDestroy>>
>;

export type ApiV10CarouselsDestroyMutationError = unknown;
export type ApiV10CarouselsDestroyMutationVariables = { carouselId: number };

export const useApiV10CarouselsDestroy = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10CarouselsDestroy>>,
    TError,
    ApiV10CarouselsDestroyMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiV10CarouselsDestroy>>,
  TError,
  ApiV10CarouselsDestroyMutationVariables,
  TContext
> => {
  return useMutation(getApiV10CarouselsDestroyMutationOptions(options));
};

export const apiV10CompanyValuesRetrieve = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<CompanyValueListResponse>({
    url: `/api/v1.0/company-values/`,
    method: 'GET',
    signal,
  });
};

export const getApiV10CompanyValuesRetrieveQueryKey = () => {
  return [`/api/v1.0/company-values/`] as const;
};

export const getApiV10CompanyValuesRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiV10CompanyValuesRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiV10CompanyValuesRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiV10CompanyValuesRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiV10CompanyValuesRetrieve>>
  > = ({ signal }) => apiV10CompanyValuesRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiV10CompanyValuesRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ApiV10CompanyValuesRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiV10CompanyValuesRetrieve>>
>;
export type ApiV10CompanyValuesRetrieveQueryError = unknown;

export function useApiV10CompanyValuesRetrieve<
  TData = Awaited<ReturnType<typeof apiV10CompanyValuesRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiV10CompanyValuesRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApiV10CompanyValuesRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const apiV10CompanyValuesCreate = (
  companyValueCreateUpdateRequest: CompanyValueCreateUpdateRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/api/v1.0/company-values/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: companyValueCreateUpdateRequest,
    signal,
  });
};

export const getApiV10CompanyValuesCreateMutationKey = () =>
  ['apiV10CompanyValuesCreate'] as const;

export const getApiV10CompanyValuesCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10CompanyValuesCreate>>,
    TError,
    ApiV10CompanyValuesCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiV10CompanyValuesCreate>>,
  TError,
  ApiV10CompanyValuesCreateMutationVariables,
  TContext
> => {
  const mutationKey = getApiV10CompanyValuesCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiV10CompanyValuesCreate>>,
    ApiV10CompanyValuesCreateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return apiV10CompanyValuesCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiV10CompanyValuesCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiV10CompanyValuesCreate>>
>;
export type ApiV10CompanyValuesCreateMutationBody =
  CompanyValueCreateUpdateRequest;
export type ApiV10CompanyValuesCreateMutationError = unknown;
export type ApiV10CompanyValuesCreateMutationVariables = {
  data: CompanyValueCreateUpdateRequest;
};

export const useApiV10CompanyValuesCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10CompanyValuesCreate>>,
    TError,
    ApiV10CompanyValuesCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiV10CompanyValuesCreate>>,
  TError,
  ApiV10CompanyValuesCreateMutationVariables,
  TContext
> => {
  return useMutation(getApiV10CompanyValuesCreateMutationOptions(options));
};

export const apiV10CompanyValuesPartialUpdate = (
  companyValueId: number,
  patchedCompanyValueCreateUpdateRequest?: PatchedCompanyValueCreateUpdateRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/api/v1.0/company-values/${companyValueId}/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchedCompanyValueCreateUpdateRequest,
    signal,
  });
};

export const getApiV10CompanyValuesPartialUpdateMutationKey = () =>
  ['apiV10CompanyValuesPartialUpdate'] as const;

export const getApiV10CompanyValuesPartialUpdateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10CompanyValuesPartialUpdate>>,
    TError,
    ApiV10CompanyValuesPartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiV10CompanyValuesPartialUpdate>>,
  TError,
  ApiV10CompanyValuesPartialUpdateMutationVariables,
  TContext
> => {
  const mutationKey = getApiV10CompanyValuesPartialUpdateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiV10CompanyValuesPartialUpdate>>,
    ApiV10CompanyValuesPartialUpdateMutationVariables
  > = (props) => {
    const { companyValueId, data } = props ?? {};

    return apiV10CompanyValuesPartialUpdate(companyValueId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiV10CompanyValuesPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiV10CompanyValuesPartialUpdate>>
>;
export type ApiV10CompanyValuesPartialUpdateMutationBody =
  | PatchedCompanyValueCreateUpdateRequest
  | undefined;
export type ApiV10CompanyValuesPartialUpdateMutationError = unknown;
export type ApiV10CompanyValuesPartialUpdateMutationVariables = {
  companyValueId: number;
  data?: PatchedCompanyValueCreateUpdateRequest;
};

export const useApiV10CompanyValuesPartialUpdate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10CompanyValuesPartialUpdate>>,
    TError,
    ApiV10CompanyValuesPartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiV10CompanyValuesPartialUpdate>>,
  TError,
  ApiV10CompanyValuesPartialUpdateMutationVariables,
  TContext
> => {
  return useMutation(
    getApiV10CompanyValuesPartialUpdateMutationOptions(options)
  );
};

export const apiV10CompanyValuesDestroy = (
  companyValueId: number,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/api/v1.0/company-values/${companyValueId}/`,
    method: 'DELETE',
    signal,
  });
};

export const getApiV10CompanyValuesDestroyMutationKey = () =>
  ['apiV10CompanyValuesDestroy'] as const;

export const getApiV10CompanyValuesDestroyMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10CompanyValuesDestroy>>,
    TError,
    ApiV10CompanyValuesDestroyMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiV10CompanyValuesDestroy>>,
  TError,
  ApiV10CompanyValuesDestroyMutationVariables,
  TContext
> => {
  const mutationKey = getApiV10CompanyValuesDestroyMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiV10CompanyValuesDestroy>>,
    ApiV10CompanyValuesDestroyMutationVariables
  > = (props) => {
    const { companyValueId } = props ?? {};

    return apiV10CompanyValuesDestroy(companyValueId);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiV10CompanyValuesDestroyMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiV10CompanyValuesDestroy>>
>;

export type ApiV10CompanyValuesDestroyMutationError = unknown;
export type ApiV10CompanyValuesDestroyMutationVariables = {
  companyValueId: number;
};

export const useApiV10CompanyValuesDestroy = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10CompanyValuesDestroy>>,
    TError,
    ApiV10CompanyValuesDestroyMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiV10CompanyValuesDestroy>>,
  TError,
  ApiV10CompanyValuesDestroyMutationVariables,
  TContext
> => {
  return useMutation(getApiV10CompanyValuesDestroyMutationOptions(options));
};

/**
 * Return a list of all CreationRequests for the given employer
 */
export const apiV10CreationRequestsRetrieve = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<CreationRequestListResponse>({
    url: `/api/v1.0/creation-requests/`,
    method: 'GET',
    signal,
  });
};

export const getApiV10CreationRequestsRetrieveQueryKey = () => {
  return [`/api/v1.0/creation-requests/`] as const;
};

export const getApiV10CreationRequestsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiV10CreationRequestsRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiV10CreationRequestsRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiV10CreationRequestsRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiV10CreationRequestsRetrieve>>
  > = ({ signal }) => apiV10CreationRequestsRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiV10CreationRequestsRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ApiV10CreationRequestsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiV10CreationRequestsRetrieve>>
>;
export type ApiV10CreationRequestsRetrieveQueryError = unknown;

export function useApiV10CreationRequestsRetrieve<
  TData = Awaited<ReturnType<typeof apiV10CreationRequestsRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiV10CreationRequestsRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApiV10CreationRequestsRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Create a CreationRequest for the given benefit type.
 */
export const apiV10CreationRequestsCreate = (
  creationRequestRequest: CreationRequestRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<CreationRequestResponse>({
    url: `/api/v1.0/creation-requests/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: creationRequestRequest,
    signal,
  });
};

export const getApiV10CreationRequestsCreateMutationKey = () =>
  ['apiV10CreationRequestsCreate'] as const;

export const getApiV10CreationRequestsCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10CreationRequestsCreate>>,
    TError,
    ApiV10CreationRequestsCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiV10CreationRequestsCreate>>,
  TError,
  ApiV10CreationRequestsCreateMutationVariables,
  TContext
> => {
  const mutationKey = getApiV10CreationRequestsCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiV10CreationRequestsCreate>>,
    ApiV10CreationRequestsCreateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return apiV10CreationRequestsCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiV10CreationRequestsCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiV10CreationRequestsCreate>>
>;
export type ApiV10CreationRequestsCreateMutationBody = CreationRequestRequest;
export type ApiV10CreationRequestsCreateMutationError = unknown;
export type ApiV10CreationRequestsCreateMutationVariables = {
  data: CreationRequestRequest;
};

export const useApiV10CreationRequestsCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10CreationRequestsCreate>>,
    TError,
    ApiV10CreationRequestsCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiV10CreationRequestsCreate>>,
  TError,
  ApiV10CreationRequestsCreateMutationVariables,
  TContext
> => {
  return useMutation(getApiV10CreationRequestsCreateMutationOptions(options));
};

export const apiV10EmployeeInterestsPartialUpdate = (
  patchedEmployeeInterestsUpdateRequest?: PatchedEmployeeInterestsUpdateRequest,
  params?: ApiV10EmployeeInterestsPartialUpdateParams,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/api/v1.0/employee/interests/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchedEmployeeInterestsUpdateRequest,
    params,
    signal,
  });
};

export const getApiV10EmployeeInterestsPartialUpdateMutationKey = () =>
  ['apiV10EmployeeInterestsPartialUpdate'] as const;

export const getApiV10EmployeeInterestsPartialUpdateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10EmployeeInterestsPartialUpdate>>,
    TError,
    ApiV10EmployeeInterestsPartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiV10EmployeeInterestsPartialUpdate>>,
  TError,
  ApiV10EmployeeInterestsPartialUpdateMutationVariables,
  TContext
> => {
  const mutationKey = getApiV10EmployeeInterestsPartialUpdateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiV10EmployeeInterestsPartialUpdate>>,
    ApiV10EmployeeInterestsPartialUpdateMutationVariables
  > = (props) => {
    const { data, params } = props ?? {};

    return apiV10EmployeeInterestsPartialUpdate(data, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiV10EmployeeInterestsPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiV10EmployeeInterestsPartialUpdate>>
>;
export type ApiV10EmployeeInterestsPartialUpdateMutationBody =
  | PatchedEmployeeInterestsUpdateRequest
  | undefined;
export type ApiV10EmployeeInterestsPartialUpdateMutationError = unknown;
export type ApiV10EmployeeInterestsPartialUpdateMutationVariables = {
  data?: PatchedEmployeeInterestsUpdateRequest;
  params?: ApiV10EmployeeInterestsPartialUpdateParams;
};

export const useApiV10EmployeeInterestsPartialUpdate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10EmployeeInterestsPartialUpdate>>,
    TError,
    ApiV10EmployeeInterestsPartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiV10EmployeeInterestsPartialUpdate>>,
  TError,
  ApiV10EmployeeInterestsPartialUpdateMutationVariables,
  TContext
> => {
  return useMutation(
    getApiV10EmployeeInterestsPartialUpdateMutationOptions(options)
  );
};

export const apiV10EmployeesBeneficiariesCreate = (
  employeeId: number,
  beneficiaryRequestRequest: BeneficiaryRequestRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<BeneficiaryResponse>({
    url: `/api/v1.0/employees/${employeeId}/beneficiaries/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: beneficiaryRequestRequest,
    signal,
  });
};

export const getApiV10EmployeesBeneficiariesCreateMutationKey = () =>
  ['apiV10EmployeesBeneficiariesCreate'] as const;

export const getApiV10EmployeesBeneficiariesCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10EmployeesBeneficiariesCreate>>,
    TError,
    ApiV10EmployeesBeneficiariesCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiV10EmployeesBeneficiariesCreate>>,
  TError,
  ApiV10EmployeesBeneficiariesCreateMutationVariables,
  TContext
> => {
  const mutationKey = getApiV10EmployeesBeneficiariesCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiV10EmployeesBeneficiariesCreate>>,
    ApiV10EmployeesBeneficiariesCreateMutationVariables
  > = (props) => {
    const { employeeId, data } = props ?? {};

    return apiV10EmployeesBeneficiariesCreate(employeeId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiV10EmployeesBeneficiariesCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiV10EmployeesBeneficiariesCreate>>
>;
export type ApiV10EmployeesBeneficiariesCreateMutationBody =
  BeneficiaryRequestRequest;
export type ApiV10EmployeesBeneficiariesCreateMutationError = unknown;
export type ApiV10EmployeesBeneficiariesCreateMutationVariables = {
  employeeId: number;
  data: BeneficiaryRequestRequest;
};

export const useApiV10EmployeesBeneficiariesCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10EmployeesBeneficiariesCreate>>,
    TError,
    ApiV10EmployeesBeneficiariesCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiV10EmployeesBeneficiariesCreate>>,
  TError,
  ApiV10EmployeesBeneficiariesCreateMutationVariables,
  TContext
> => {
  return useMutation(
    getApiV10EmployeesBeneficiariesCreateMutationOptions(options)
  );
};

export const apiV10EmployeesBeneficiariesRetrieve = (
  employeeId: number,
  beneficiaryId: string,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<BeneficiaryResponse>({
    url: `/api/v1.0/employees/${employeeId}/beneficiaries/${beneficiaryId}/`,
    method: 'GET',
    signal,
  });
};

export const getApiV10EmployeesBeneficiariesRetrieveQueryKey = (
  employeeId: number,
  beneficiaryId: string
) => {
  return [
    `/api/v1.0/employees/${employeeId}/beneficiaries/${beneficiaryId}/`,
  ] as const;
};

export const getApiV10EmployeesBeneficiariesRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiV10EmployeesBeneficiariesRetrieve>>,
  TError = unknown,
>(
  employeeId: number,
  beneficiaryId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiV10EmployeesBeneficiariesRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiV10EmployeesBeneficiariesRetrieveQueryKey(employeeId, beneficiaryId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiV10EmployeesBeneficiariesRetrieve>>
  > = ({ signal }) =>
    apiV10EmployeesBeneficiariesRetrieve(employeeId, beneficiaryId, signal);

  return {
    queryKey,
    queryFn,
    enabled:
      employeeId !== null &&
      employeeId !== undefined &&
      beneficiaryId !== null &&
      beneficiaryId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof apiV10EmployeesBeneficiariesRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ApiV10EmployeesBeneficiariesRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiV10EmployeesBeneficiariesRetrieve>>
>;
export type ApiV10EmployeesBeneficiariesRetrieveQueryError = unknown;

export function useApiV10EmployeesBeneficiariesRetrieve<
  TData = Awaited<ReturnType<typeof apiV10EmployeesBeneficiariesRetrieve>>,
  TError = unknown,
>(
  employeeId: number,
  beneficiaryId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiV10EmployeesBeneficiariesRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApiV10EmployeesBeneficiariesRetrieveQueryOptions(
    employeeId,
    beneficiaryId,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const apiV10EmployeesBeneficiariesPartialUpdate = (
  employeeId: number,
  beneficiaryId: string,
  patchedBeneficiaryRequestRequest?: PatchedBeneficiaryRequestRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<BeneficiaryResponse>({
    url: `/api/v1.0/employees/${employeeId}/beneficiaries/${beneficiaryId}/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchedBeneficiaryRequestRequest,
    signal,
  });
};

export const getApiV10EmployeesBeneficiariesPartialUpdateMutationKey = () =>
  ['apiV10EmployeesBeneficiariesPartialUpdate'] as const;

export const getApiV10EmployeesBeneficiariesPartialUpdateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10EmployeesBeneficiariesPartialUpdate>>,
    TError,
    ApiV10EmployeesBeneficiariesPartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiV10EmployeesBeneficiariesPartialUpdate>>,
  TError,
  ApiV10EmployeesBeneficiariesPartialUpdateMutationVariables,
  TContext
> => {
  const mutationKey = getApiV10EmployeesBeneficiariesPartialUpdateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiV10EmployeesBeneficiariesPartialUpdate>>,
    ApiV10EmployeesBeneficiariesPartialUpdateMutationVariables
  > = (props) => {
    const { employeeId, beneficiaryId, data } = props ?? {};

    return apiV10EmployeesBeneficiariesPartialUpdate(
      employeeId,
      beneficiaryId,
      data
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiV10EmployeesBeneficiariesPartialUpdateMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof apiV10EmployeesBeneficiariesPartialUpdate>>
  >;
export type ApiV10EmployeesBeneficiariesPartialUpdateMutationBody =
  | PatchedBeneficiaryRequestRequest
  | undefined;
export type ApiV10EmployeesBeneficiariesPartialUpdateMutationError = unknown;
export type ApiV10EmployeesBeneficiariesPartialUpdateMutationVariables = {
  employeeId: number;
  beneficiaryId: string;
  data?: PatchedBeneficiaryRequestRequest;
};

export const useApiV10EmployeesBeneficiariesPartialUpdate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10EmployeesBeneficiariesPartialUpdate>>,
    TError,
    ApiV10EmployeesBeneficiariesPartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiV10EmployeesBeneficiariesPartialUpdate>>,
  TError,
  ApiV10EmployeesBeneficiariesPartialUpdateMutationVariables,
  TContext
> => {
  return useMutation(
    getApiV10EmployeesBeneficiariesPartialUpdateMutationOptions(options)
  );
};

export const apiV10EmployeesContactsList = (
  employeeId: number,
  params?: ApiV10EmployeesContactsListParams,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<PaginatedEmployeeContactListList>({
    url: `/api/v1.0/employees/${employeeId}/contacts/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getApiV10EmployeesContactsListQueryKey = (
  employeeId: number,
  params?: ApiV10EmployeesContactsListParams
) => {
  return [
    `/api/v1.0/employees/${employeeId}/contacts/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getApiV10EmployeesContactsListQueryOptions = <
  TData = Awaited<ReturnType<typeof apiV10EmployeesContactsList>>,
  TError = unknown,
>(
  employeeId: number,
  params?: ApiV10EmployeesContactsListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiV10EmployeesContactsList>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiV10EmployeesContactsListQueryKey(employeeId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiV10EmployeesContactsList>>
  > = ({ signal }) => apiV10EmployeesContactsList(employeeId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: employeeId !== null && employeeId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof apiV10EmployeesContactsList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ApiV10EmployeesContactsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiV10EmployeesContactsList>>
>;
export type ApiV10EmployeesContactsListQueryError = unknown;

export function useApiV10EmployeesContactsList<
  TData = Awaited<ReturnType<typeof apiV10EmployeesContactsList>>,
  TError = unknown,
>(
  employeeId: number,
  params?: ApiV10EmployeesContactsListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiV10EmployeesContactsList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApiV10EmployeesContactsListQueryOptions(
    employeeId,
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const apiV10EmployeesContactsCreate = (
  employeeId: number,
  employeeContactDetailRequest: EmployeeContactDetailRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<EmployeeContactDetail>({
    url: `/api/v1.0/employees/${employeeId}/contacts/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: employeeContactDetailRequest,
    signal,
  });
};

export const getApiV10EmployeesContactsCreateMutationKey = () =>
  ['apiV10EmployeesContactsCreate'] as const;

export const getApiV10EmployeesContactsCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10EmployeesContactsCreate>>,
    TError,
    ApiV10EmployeesContactsCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiV10EmployeesContactsCreate>>,
  TError,
  ApiV10EmployeesContactsCreateMutationVariables,
  TContext
> => {
  const mutationKey = getApiV10EmployeesContactsCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiV10EmployeesContactsCreate>>,
    ApiV10EmployeesContactsCreateMutationVariables
  > = (props) => {
    const { employeeId, data } = props ?? {};

    return apiV10EmployeesContactsCreate(employeeId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiV10EmployeesContactsCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiV10EmployeesContactsCreate>>
>;
export type ApiV10EmployeesContactsCreateMutationBody =
  EmployeeContactDetailRequest;
export type ApiV10EmployeesContactsCreateMutationError = unknown;
export type ApiV10EmployeesContactsCreateMutationVariables = {
  employeeId: number;
  data: EmployeeContactDetailRequest;
};

export const useApiV10EmployeesContactsCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10EmployeesContactsCreate>>,
    TError,
    ApiV10EmployeesContactsCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiV10EmployeesContactsCreate>>,
  TError,
  ApiV10EmployeesContactsCreateMutationVariables,
  TContext
> => {
  return useMutation(getApiV10EmployeesContactsCreateMutationOptions(options));
};

export const apiV10EmployeesContactsRetrieve = (
  employeeId: number,
  contactId: number,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<EmployeeContactDetail>({
    url: `/api/v1.0/employees/${employeeId}/contacts/${contactId}/`,
    method: 'GET',
    signal,
  });
};

export const getApiV10EmployeesContactsRetrieveQueryKey = (
  employeeId: number,
  contactId: number
) => {
  return [`/api/v1.0/employees/${employeeId}/contacts/${contactId}/`] as const;
};

export const getApiV10EmployeesContactsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiV10EmployeesContactsRetrieve>>,
  TError = unknown,
>(
  employeeId: number,
  contactId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiV10EmployeesContactsRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiV10EmployeesContactsRetrieveQueryKey(employeeId, contactId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiV10EmployeesContactsRetrieve>>
  > = ({ signal }) =>
    apiV10EmployeesContactsRetrieve(employeeId, contactId, signal);

  return {
    queryKey,
    queryFn,
    enabled:
      employeeId !== null &&
      employeeId !== undefined &&
      contactId !== null &&
      contactId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof apiV10EmployeesContactsRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ApiV10EmployeesContactsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiV10EmployeesContactsRetrieve>>
>;
export type ApiV10EmployeesContactsRetrieveQueryError = unknown;

export function useApiV10EmployeesContactsRetrieve<
  TData = Awaited<ReturnType<typeof apiV10EmployeesContactsRetrieve>>,
  TError = unknown,
>(
  employeeId: number,
  contactId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiV10EmployeesContactsRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApiV10EmployeesContactsRetrieveQueryOptions(
    employeeId,
    contactId,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const apiV10EmployeesContactsUpdate = (
  employeeId: number,
  contactId: number,
  employeeContactDetailRequest: EmployeeContactDetailRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<EmployeeContactDetail>({
    url: `/api/v1.0/employees/${employeeId}/contacts/${contactId}/`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: employeeContactDetailRequest,
    signal,
  });
};

export const getApiV10EmployeesContactsUpdateMutationKey = () =>
  ['apiV10EmployeesContactsUpdate'] as const;

export const getApiV10EmployeesContactsUpdateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10EmployeesContactsUpdate>>,
    TError,
    ApiV10EmployeesContactsUpdateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiV10EmployeesContactsUpdate>>,
  TError,
  ApiV10EmployeesContactsUpdateMutationVariables,
  TContext
> => {
  const mutationKey = getApiV10EmployeesContactsUpdateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiV10EmployeesContactsUpdate>>,
    ApiV10EmployeesContactsUpdateMutationVariables
  > = (props) => {
    const { employeeId, contactId, data } = props ?? {};

    return apiV10EmployeesContactsUpdate(employeeId, contactId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiV10EmployeesContactsUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiV10EmployeesContactsUpdate>>
>;
export type ApiV10EmployeesContactsUpdateMutationBody =
  EmployeeContactDetailRequest;
export type ApiV10EmployeesContactsUpdateMutationError = unknown;
export type ApiV10EmployeesContactsUpdateMutationVariables = {
  employeeId: number;
  contactId: number;
  data: EmployeeContactDetailRequest;
};

export const useApiV10EmployeesContactsUpdate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10EmployeesContactsUpdate>>,
    TError,
    ApiV10EmployeesContactsUpdateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiV10EmployeesContactsUpdate>>,
  TError,
  ApiV10EmployeesContactsUpdateMutationVariables,
  TContext
> => {
  return useMutation(getApiV10EmployeesContactsUpdateMutationOptions(options));
};

export const apiV10EmployeesContactsDestroy = (
  employeeId: number,
  contactId: number,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/api/v1.0/employees/${employeeId}/contacts/${contactId}/`,
    method: 'DELETE',
    signal,
  });
};

export const getApiV10EmployeesContactsDestroyMutationKey = () =>
  ['apiV10EmployeesContactsDestroy'] as const;

export const getApiV10EmployeesContactsDestroyMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10EmployeesContactsDestroy>>,
    TError,
    ApiV10EmployeesContactsDestroyMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiV10EmployeesContactsDestroy>>,
  TError,
  ApiV10EmployeesContactsDestroyMutationVariables,
  TContext
> => {
  const mutationKey = getApiV10EmployeesContactsDestroyMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiV10EmployeesContactsDestroy>>,
    ApiV10EmployeesContactsDestroyMutationVariables
  > = (props) => {
    const { employeeId, contactId } = props ?? {};

    return apiV10EmployeesContactsDestroy(employeeId, contactId);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiV10EmployeesContactsDestroyMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiV10EmployeesContactsDestroy>>
>;

export type ApiV10EmployeesContactsDestroyMutationError = unknown;
export type ApiV10EmployeesContactsDestroyMutationVariables = {
  employeeId: number;
  contactId: number;
};

export const useApiV10EmployeesContactsDestroy = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10EmployeesContactsDestroy>>,
    TError,
    ApiV10EmployeesContactsDestroyMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiV10EmployeesContactsDestroy>>,
  TError,
  ApiV10EmployeesContactsDestroyMutationVariables,
  TContext
> => {
  return useMutation(getApiV10EmployeesContactsDestroyMutationOptions(options));
};

export const apiV10EmployeesContactsEnrollmentsList = (
  employeeId: number,
  contactId: number,
  params?: ApiV10EmployeesContactsEnrollmentsListParams,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<PaginatedContactEnrollmentListList>({
    url: `/api/v1.0/employees/${employeeId}/contacts/${contactId}/enrollments/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getApiV10EmployeesContactsEnrollmentsListQueryKey = (
  employeeId: number,
  contactId: number,
  params?: ApiV10EmployeesContactsEnrollmentsListParams
) => {
  return [
    `/api/v1.0/employees/${employeeId}/contacts/${contactId}/enrollments/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getApiV10EmployeesContactsEnrollmentsListQueryOptions = <
  TData = Awaited<ReturnType<typeof apiV10EmployeesContactsEnrollmentsList>>,
  TError = unknown,
>(
  employeeId: number,
  contactId: number,
  params?: ApiV10EmployeesContactsEnrollmentsListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiV10EmployeesContactsEnrollmentsList>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiV10EmployeesContactsEnrollmentsListQueryKey(
      employeeId,
      contactId,
      params
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiV10EmployeesContactsEnrollmentsList>>
  > = ({ signal }) =>
    apiV10EmployeesContactsEnrollmentsList(
      employeeId,
      contactId,
      params,
      signal
    );

  return {
    queryKey,
    queryFn,
    enabled:
      employeeId !== null &&
      employeeId !== undefined &&
      contactId !== null &&
      contactId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof apiV10EmployeesContactsEnrollmentsList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ApiV10EmployeesContactsEnrollmentsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiV10EmployeesContactsEnrollmentsList>>
>;
export type ApiV10EmployeesContactsEnrollmentsListQueryError = unknown;

export function useApiV10EmployeesContactsEnrollmentsList<
  TData = Awaited<ReturnType<typeof apiV10EmployeesContactsEnrollmentsList>>,
  TError = unknown,
>(
  employeeId: number,
  contactId: number,
  params?: ApiV10EmployeesContactsEnrollmentsListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiV10EmployeesContactsEnrollmentsList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApiV10EmployeesContactsEnrollmentsListQueryOptions(
    employeeId,
    contactId,
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const apiV10EmployeesEquityModelerCalculateCreate = (
  employeeId: number,
  equityModelerCalculateRequestRequest: EquityModelerCalculateRequestRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<EquityModelerCalculateResponse>({
    url: `/api/v1.0/employees/${employeeId}/equity-modeler/calculate/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: equityModelerCalculateRequestRequest,
    signal,
  });
};

export const getApiV10EmployeesEquityModelerCalculateCreateMutationKey = () =>
  ['apiV10EmployeesEquityModelerCalculateCreate'] as const;

export const getApiV10EmployeesEquityModelerCalculateCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10EmployeesEquityModelerCalculateCreate>>,
    TError,
    ApiV10EmployeesEquityModelerCalculateCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiV10EmployeesEquityModelerCalculateCreate>>,
  TError,
  ApiV10EmployeesEquityModelerCalculateCreateMutationVariables,
  TContext
> => {
  const mutationKey =
    getApiV10EmployeesEquityModelerCalculateCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiV10EmployeesEquityModelerCalculateCreate>>,
    ApiV10EmployeesEquityModelerCalculateCreateMutationVariables
  > = (props) => {
    const { employeeId, data } = props ?? {};

    return apiV10EmployeesEquityModelerCalculateCreate(employeeId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiV10EmployeesEquityModelerCalculateCreateMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof apiV10EmployeesEquityModelerCalculateCreate>>
  >;
export type ApiV10EmployeesEquityModelerCalculateCreateMutationBody =
  EquityModelerCalculateRequestRequest;
export type ApiV10EmployeesEquityModelerCalculateCreateMutationError = unknown;
export type ApiV10EmployeesEquityModelerCalculateCreateMutationVariables = {
  employeeId: number;
  data: EquityModelerCalculateRequestRequest;
};

export const useApiV10EmployeesEquityModelerCalculateCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10EmployeesEquityModelerCalculateCreate>>,
    TError,
    ApiV10EmployeesEquityModelerCalculateCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiV10EmployeesEquityModelerCalculateCreate>>,
  TError,
  ApiV10EmployeesEquityModelerCalculateCreateMutationVariables,
  TContext
> => {
  return useMutation(
    getApiV10EmployeesEquityModelerCalculateCreateMutationOptions(options)
  );
};

export const apiV10EmployeesEquityModelerEmployeeStateRetrieve = (
  employeeId: number,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<EquityModelerEmployeeStateResponse>({
    url: `/api/v1.0/employees/${employeeId}/equity-modeler/employee-state/`,
    method: 'GET',
    signal,
  });
};

export const getApiV10EmployeesEquityModelerEmployeeStateRetrieveQueryKey = (
  employeeId: number
) => {
  return [
    `/api/v1.0/employees/${employeeId}/equity-modeler/employee-state/`,
  ] as const;
};

export const getApiV10EmployeesEquityModelerEmployeeStateRetrieveQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof apiV10EmployeesEquityModelerEmployeeStateRetrieve>
    >,
    TError = unknown,
  >(
    employeeId: number,
    options?: {
      query?: UseQueryOptions<
        Awaited<
          ReturnType<typeof apiV10EmployeesEquityModelerEmployeeStateRetrieve>
        >,
        TError,
        TData
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getApiV10EmployeesEquityModelerEmployeeStateRetrieveQueryKey(employeeId);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof apiV10EmployeesEquityModelerEmployeeStateRetrieve>
      >
    > = ({ signal }) =>
      apiV10EmployeesEquityModelerEmployeeStateRetrieve(employeeId, signal);

    return {
      queryKey,
      queryFn,
      enabled: employeeId !== null && employeeId !== undefined,
      ...queryOptions,
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof apiV10EmployeesEquityModelerEmployeeStateRetrieve>
      >,
      TError,
      TData
    > & { queryKey: QueryKey };
  };

export type ApiV10EmployeesEquityModelerEmployeeStateRetrieveQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof apiV10EmployeesEquityModelerEmployeeStateRetrieve>
    >
  >;
export type ApiV10EmployeesEquityModelerEmployeeStateRetrieveQueryError =
  unknown;

export function useApiV10EmployeesEquityModelerEmployeeStateRetrieve<
  TData = Awaited<
    ReturnType<typeof apiV10EmployeesEquityModelerEmployeeStateRetrieve>
  >,
  TError = unknown,
>(
  employeeId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<typeof apiV10EmployeesEquityModelerEmployeeStateRetrieve>
      >,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getApiV10EmployeesEquityModelerEmployeeStateRetrieveQueryOptions(
      employeeId,
      options
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const apiV10EmployeesEquityModelerPageContextRetrieve = (
  employeeId: number,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<EquityModelerPageContextResponse>({
    url: `/api/v1.0/employees/${employeeId}/equity-modeler/page-context/`,
    method: 'GET',
    signal,
  });
};

export const getApiV10EmployeesEquityModelerPageContextRetrieveQueryKey = (
  employeeId: number
) => {
  return [
    `/api/v1.0/employees/${employeeId}/equity-modeler/page-context/`,
  ] as const;
};

export const getApiV10EmployeesEquityModelerPageContextRetrieveQueryOptions = <
  TData = Awaited<
    ReturnType<typeof apiV10EmployeesEquityModelerPageContextRetrieve>
  >,
  TError = unknown,
>(
  employeeId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<typeof apiV10EmployeesEquityModelerPageContextRetrieve>
      >,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiV10EmployeesEquityModelerPageContextRetrieveQueryKey(employeeId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiV10EmployeesEquityModelerPageContextRetrieve>>
  > = ({ signal }) =>
    apiV10EmployeesEquityModelerPageContextRetrieve(employeeId, signal);

  return {
    queryKey,
    queryFn,
    enabled: employeeId !== null && employeeId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof apiV10EmployeesEquityModelerPageContextRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ApiV10EmployeesEquityModelerPageContextRetrieveQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof apiV10EmployeesEquityModelerPageContextRetrieve>>
  >;
export type ApiV10EmployeesEquityModelerPageContextRetrieveQueryError = unknown;

export function useApiV10EmployeesEquityModelerPageContextRetrieve<
  TData = Awaited<
    ReturnType<typeof apiV10EmployeesEquityModelerPageContextRetrieve>
  >,
  TError = unknown,
>(
  employeeId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<typeof apiV10EmployeesEquityModelerPageContextRetrieve>
      >,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getApiV10EmployeesEquityModelerPageContextRetrieveQueryOptions(
      employeeId,
      options
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const apiV10EmployeesTotalRewardsRetrieve = (
  employeeId: number,
  params?: ApiV10EmployeesTotalRewardsRetrieveParams,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<TotalRewardsStatementResponse>({
    url: `/api/v1.0/employees/${employeeId}/total-rewards/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getApiV10EmployeesTotalRewardsRetrieveQueryKey = (
  employeeId: number,
  params?: ApiV10EmployeesTotalRewardsRetrieveParams
) => {
  return [
    `/api/v1.0/employees/${employeeId}/total-rewards/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getApiV10EmployeesTotalRewardsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiV10EmployeesTotalRewardsRetrieve>>,
  TError = unknown,
>(
  employeeId: number,
  params?: ApiV10EmployeesTotalRewardsRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiV10EmployeesTotalRewardsRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiV10EmployeesTotalRewardsRetrieveQueryKey(employeeId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiV10EmployeesTotalRewardsRetrieve>>
  > = ({ signal }) =>
    apiV10EmployeesTotalRewardsRetrieve(employeeId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: employeeId !== null && employeeId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof apiV10EmployeesTotalRewardsRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ApiV10EmployeesTotalRewardsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiV10EmployeesTotalRewardsRetrieve>>
>;
export type ApiV10EmployeesTotalRewardsRetrieveQueryError = unknown;

export function useApiV10EmployeesTotalRewardsRetrieve<
  TData = Awaited<ReturnType<typeof apiV10EmployeesTotalRewardsRetrieve>>,
  TError = unknown,
>(
  employeeId: number,
  params?: ApiV10EmployeesTotalRewardsRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiV10EmployeesTotalRewardsRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApiV10EmployeesTotalRewardsRetrieveQueryOptions(
    employeeId,
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const apiV10EmployeesTotalRewardsChartRetrieve = (
  employeeId: number,
  params?: ApiV10EmployeesTotalRewardsChartRetrieveParams,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<TotalRewardsChart>({
    url: `/api/v1.0/employees/${employeeId}/total-rewards/chart/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getApiV10EmployeesTotalRewardsChartRetrieveQueryKey = (
  employeeId: number,
  params?: ApiV10EmployeesTotalRewardsChartRetrieveParams
) => {
  return [
    `/api/v1.0/employees/${employeeId}/total-rewards/chart/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getApiV10EmployeesTotalRewardsChartRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiV10EmployeesTotalRewardsChartRetrieve>>,
  TError = unknown,
>(
  employeeId: number,
  params?: ApiV10EmployeesTotalRewardsChartRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiV10EmployeesTotalRewardsChartRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiV10EmployeesTotalRewardsChartRetrieveQueryKey(employeeId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiV10EmployeesTotalRewardsChartRetrieve>>
  > = ({ signal }) =>
    apiV10EmployeesTotalRewardsChartRetrieve(employeeId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: employeeId !== null && employeeId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof apiV10EmployeesTotalRewardsChartRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ApiV10EmployeesTotalRewardsChartRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiV10EmployeesTotalRewardsChartRetrieve>>
>;
export type ApiV10EmployeesTotalRewardsChartRetrieveQueryError = unknown;

export function useApiV10EmployeesTotalRewardsChartRetrieve<
  TData = Awaited<ReturnType<typeof apiV10EmployeesTotalRewardsChartRetrieve>>,
  TError = unknown,
>(
  employeeId: number,
  params?: ApiV10EmployeesTotalRewardsChartRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiV10EmployeesTotalRewardsChartRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApiV10EmployeesTotalRewardsChartRetrieveQueryOptions(
    employeeId,
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const apiV10EmployeesTotalRewardsPdfRetrieve = (
  employeeId: number,
  params?: ApiV10EmployeesTotalRewardsPdfRetrieveParams,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<Blob>({
    url: `/api/v1.0/employees/${employeeId}/total-rewards/pdf/`,
    method: 'GET',
    params,
    responseType: 'blob',
    signal,
  });
};

export const getApiV10EmployeesTotalRewardsPdfRetrieveQueryKey = (
  employeeId: number,
  params?: ApiV10EmployeesTotalRewardsPdfRetrieveParams
) => {
  return [
    `/api/v1.0/employees/${employeeId}/total-rewards/pdf/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getApiV10EmployeesTotalRewardsPdfRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiV10EmployeesTotalRewardsPdfRetrieve>>,
  TError = unknown,
>(
  employeeId: number,
  params?: ApiV10EmployeesTotalRewardsPdfRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiV10EmployeesTotalRewardsPdfRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiV10EmployeesTotalRewardsPdfRetrieveQueryKey(employeeId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiV10EmployeesTotalRewardsPdfRetrieve>>
  > = ({ signal }) =>
    apiV10EmployeesTotalRewardsPdfRetrieve(employeeId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: employeeId !== null && employeeId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof apiV10EmployeesTotalRewardsPdfRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ApiV10EmployeesTotalRewardsPdfRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiV10EmployeesTotalRewardsPdfRetrieve>>
>;
export type ApiV10EmployeesTotalRewardsPdfRetrieveQueryError = unknown;

export function useApiV10EmployeesTotalRewardsPdfRetrieve<
  TData = Awaited<ReturnType<typeof apiV10EmployeesTotalRewardsPdfRetrieve>>,
  TError = unknown,
>(
  employeeId: number,
  params?: ApiV10EmployeesTotalRewardsPdfRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiV10EmployeesTotalRewardsPdfRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApiV10EmployeesTotalRewardsPdfRetrieveQueryOptions(
    employeeId,
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const apiV10EmployeesTotalRewardsVestingScheduleRetrieve = (
  employeeId: number,
  params: ApiV10EmployeesTotalRewardsVestingScheduleRetrieveParams,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<TotalRewardsVestingSchedule>({
    url: `/api/v1.0/employees/${employeeId}/total-rewards/vesting-schedule/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getApiV10EmployeesTotalRewardsVestingScheduleRetrieveQueryKey = (
  employeeId: number,
  params?: ApiV10EmployeesTotalRewardsVestingScheduleRetrieveParams
) => {
  return [
    `/api/v1.0/employees/${employeeId}/total-rewards/vesting-schedule/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getApiV10EmployeesTotalRewardsVestingScheduleRetrieveQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof apiV10EmployeesTotalRewardsVestingScheduleRetrieve>
    >,
    TError = unknown,
  >(
    employeeId: number,
    params: ApiV10EmployeesTotalRewardsVestingScheduleRetrieveParams,
    options?: {
      query?: UseQueryOptions<
        Awaited<
          ReturnType<typeof apiV10EmployeesTotalRewardsVestingScheduleRetrieve>
        >,
        TError,
        TData
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getApiV10EmployeesTotalRewardsVestingScheduleRetrieveQueryKey(
        employeeId,
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof apiV10EmployeesTotalRewardsVestingScheduleRetrieve>
      >
    > = ({ signal }) =>
      apiV10EmployeesTotalRewardsVestingScheduleRetrieve(
        employeeId,
        params,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: employeeId !== null && employeeId !== undefined,
      ...queryOptions,
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof apiV10EmployeesTotalRewardsVestingScheduleRetrieve>
      >,
      TError,
      TData
    > & { queryKey: QueryKey };
  };

export type ApiV10EmployeesTotalRewardsVestingScheduleRetrieveQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof apiV10EmployeesTotalRewardsVestingScheduleRetrieve>
    >
  >;
export type ApiV10EmployeesTotalRewardsVestingScheduleRetrieveQueryError =
  unknown;

export function useApiV10EmployeesTotalRewardsVestingScheduleRetrieve<
  TData = Awaited<
    ReturnType<typeof apiV10EmployeesTotalRewardsVestingScheduleRetrieve>
  >,
  TError = unknown,
>(
  employeeId: number,
  params: ApiV10EmployeesTotalRewardsVestingScheduleRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<typeof apiV10EmployeesTotalRewardsVestingScheduleRetrieve>
      >,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getApiV10EmployeesTotalRewardsVestingScheduleRetrieveQueryOptions(
      employeeId,
      params,
      options
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const apiV10EmployerAirwallexBillingAddressRetrieve = (
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<BillingAddress>({
    url: `/api/v1.0/employer/airwallex/billing-address/`,
    method: 'GET',
    signal,
  });
};

export const getApiV10EmployerAirwallexBillingAddressRetrieveQueryKey = () => {
  return [`/api/v1.0/employer/airwallex/billing-address/`] as const;
};

export const getApiV10EmployerAirwallexBillingAddressRetrieveQueryOptions = <
  TData = Awaited<
    ReturnType<typeof apiV10EmployerAirwallexBillingAddressRetrieve>
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiV10EmployerAirwallexBillingAddressRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiV10EmployerAirwallexBillingAddressRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiV10EmployerAirwallexBillingAddressRetrieve>>
  > = ({ signal }) => apiV10EmployerAirwallexBillingAddressRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiV10EmployerAirwallexBillingAddressRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ApiV10EmployerAirwallexBillingAddressRetrieveQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof apiV10EmployerAirwallexBillingAddressRetrieve>>
  >;
export type ApiV10EmployerAirwallexBillingAddressRetrieveQueryError = unknown;

export function useApiV10EmployerAirwallexBillingAddressRetrieve<
  TData = Awaited<
    ReturnType<typeof apiV10EmployerAirwallexBillingAddressRetrieve>
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiV10EmployerAirwallexBillingAddressRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getApiV10EmployerAirwallexBillingAddressRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Updates the given Employer
 */
export const apiV10EmployersConfigurationPartialUpdate = (
  employerId: number,
  patchedPatchEmployerConfigurationRequest?: PatchedPatchEmployerConfigurationRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<PatchEmployerConfiguration>({
    url: `/api/v1.0/employers/${employerId}/configuration`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchedPatchEmployerConfigurationRequest,
    signal,
  });
};

export const getApiV10EmployersConfigurationPartialUpdateMutationKey = () =>
  ['apiV10EmployersConfigurationPartialUpdate'] as const;

export const getApiV10EmployersConfigurationPartialUpdateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10EmployersConfigurationPartialUpdate>>,
    TError,
    ApiV10EmployersConfigurationPartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiV10EmployersConfigurationPartialUpdate>>,
  TError,
  ApiV10EmployersConfigurationPartialUpdateMutationVariables,
  TContext
> => {
  const mutationKey = getApiV10EmployersConfigurationPartialUpdateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiV10EmployersConfigurationPartialUpdate>>,
    ApiV10EmployersConfigurationPartialUpdateMutationVariables
  > = (props) => {
    const { employerId, data } = props ?? {};

    return apiV10EmployersConfigurationPartialUpdate(employerId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiV10EmployersConfigurationPartialUpdateMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof apiV10EmployersConfigurationPartialUpdate>>
  >;
export type ApiV10EmployersConfigurationPartialUpdateMutationBody =
  | PatchedPatchEmployerConfigurationRequest
  | undefined;
export type ApiV10EmployersConfigurationPartialUpdateMutationError = unknown;
export type ApiV10EmployersConfigurationPartialUpdateMutationVariables = {
  employerId: number;
  data?: PatchedPatchEmployerConfigurationRequest;
};

export const useApiV10EmployersConfigurationPartialUpdate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10EmployersConfigurationPartialUpdate>>,
    TError,
    ApiV10EmployersConfigurationPartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiV10EmployersConfigurationPartialUpdate>>,
  TError,
  ApiV10EmployersConfigurationPartialUpdateMutationVariables,
  TContext
> => {
  return useMutation(
    getApiV10EmployersConfigurationPartialUpdateMutationOptions(options)
  );
};

export const apiV10EmployersRolesRetrieve = (
  employerId: number,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<EmployerRolesResponse>({
    url: `/api/v1.0/employers/${employerId}/roles/`,
    method: 'GET',
    signal,
  });
};

export const getApiV10EmployersRolesRetrieveQueryKey = (employerId: number) => {
  return [`/api/v1.0/employers/${employerId}/roles/`] as const;
};

export const getApiV10EmployersRolesRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiV10EmployersRolesRetrieve>>,
  TError = unknown,
>(
  employerId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiV10EmployersRolesRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiV10EmployersRolesRetrieveQueryKey(employerId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiV10EmployersRolesRetrieve>>
  > = ({ signal }) => apiV10EmployersRolesRetrieve(employerId, signal);

  return {
    queryKey,
    queryFn,
    enabled: employerId !== null && employerId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof apiV10EmployersRolesRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ApiV10EmployersRolesRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiV10EmployersRolesRetrieve>>
>;
export type ApiV10EmployersRolesRetrieveQueryError = unknown;

export function useApiV10EmployersRolesRetrieve<
  TData = Awaited<ReturnType<typeof apiV10EmployersRolesRetrieve>>,
  TError = unknown,
>(
  employerId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiV10EmployersRolesRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApiV10EmployersRolesRetrieveQueryOptions(
    employerId,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Return a list of all enrollable benefits for the given employer
 */
export const apiV10EnrollableBenefitsRetrieve = (
  params?: ApiV10EnrollableBenefitsRetrieveParams,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<EnrollableBenefitListResponse>({
    url: `/api/v1.0/enrollable-benefits/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getApiV10EnrollableBenefitsRetrieveQueryKey = (
  params?: ApiV10EnrollableBenefitsRetrieveParams
) => {
  return [
    `/api/v1.0/enrollable-benefits/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getApiV10EnrollableBenefitsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiV10EnrollableBenefitsRetrieve>>,
  TError = unknown,
>(
  params?: ApiV10EnrollableBenefitsRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiV10EnrollableBenefitsRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiV10EnrollableBenefitsRetrieveQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiV10EnrollableBenefitsRetrieve>>
  > = ({ signal }) => apiV10EnrollableBenefitsRetrieve(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiV10EnrollableBenefitsRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ApiV10EnrollableBenefitsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiV10EnrollableBenefitsRetrieve>>
>;
export type ApiV10EnrollableBenefitsRetrieveQueryError = unknown;

export function useApiV10EnrollableBenefitsRetrieve<
  TData = Awaited<ReturnType<typeof apiV10EnrollableBenefitsRetrieve>>,
  TError = unknown,
>(
  params?: ApiV10EnrollableBenefitsRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiV10EnrollableBenefitsRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApiV10EnrollableBenefitsRetrieveQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Creates the given EnrollableBenefit
 */
export const apiV10EnrollableBenefitsCreate = (
  createEnrollableBenefitRequest?: CreateEnrollableBenefitRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<EnrollableBenefit>({
    url: `/api/v1.0/enrollable-benefits/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createEnrollableBenefitRequest,
    signal,
  });
};

export const getApiV10EnrollableBenefitsCreateMutationKey = () =>
  ['apiV10EnrollableBenefitsCreate'] as const;

export const getApiV10EnrollableBenefitsCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10EnrollableBenefitsCreate>>,
    TError,
    ApiV10EnrollableBenefitsCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiV10EnrollableBenefitsCreate>>,
  TError,
  ApiV10EnrollableBenefitsCreateMutationVariables,
  TContext
> => {
  const mutationKey = getApiV10EnrollableBenefitsCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiV10EnrollableBenefitsCreate>>,
    ApiV10EnrollableBenefitsCreateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return apiV10EnrollableBenefitsCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiV10EnrollableBenefitsCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiV10EnrollableBenefitsCreate>>
>;
export type ApiV10EnrollableBenefitsCreateMutationBody =
  | CreateEnrollableBenefitRequest
  | undefined;
export type ApiV10EnrollableBenefitsCreateMutationError = unknown;
export type ApiV10EnrollableBenefitsCreateMutationVariables = {
  data?: CreateEnrollableBenefitRequest;
};

export const useApiV10EnrollableBenefitsCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10EnrollableBenefitsCreate>>,
    TError,
    ApiV10EnrollableBenefitsCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiV10EnrollableBenefitsCreate>>,
  TError,
  ApiV10EnrollableBenefitsCreateMutationVariables,
  TContext
> => {
  return useMutation(getApiV10EnrollableBenefitsCreateMutationOptions(options));
};

/**
 * Returns the given EnrollableBenefit
 */
export const apiV10EnrollableBenefitsRetrieve2 = (
  benefitId: number,
  params?: ApiV10EnrollableBenefitsRetrieve2Params,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<EnrollableBenefit>({
    url: `/api/v1.0/enrollable-benefits/${benefitId}/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getApiV10EnrollableBenefitsRetrieve2QueryKey = (
  benefitId: number,
  params?: ApiV10EnrollableBenefitsRetrieve2Params
) => {
  return [
    `/api/v1.0/enrollable-benefits/${benefitId}/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getApiV10EnrollableBenefitsRetrieve2QueryOptions = <
  TData = Awaited<ReturnType<typeof apiV10EnrollableBenefitsRetrieve2>>,
  TError = unknown,
>(
  benefitId: number,
  params?: ApiV10EnrollableBenefitsRetrieve2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiV10EnrollableBenefitsRetrieve2>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiV10EnrollableBenefitsRetrieve2QueryKey(benefitId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiV10EnrollableBenefitsRetrieve2>>
  > = ({ signal }) =>
    apiV10EnrollableBenefitsRetrieve2(benefitId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: benefitId !== null && benefitId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof apiV10EnrollableBenefitsRetrieve2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ApiV10EnrollableBenefitsRetrieve2QueryResult = NonNullable<
  Awaited<ReturnType<typeof apiV10EnrollableBenefitsRetrieve2>>
>;
export type ApiV10EnrollableBenefitsRetrieve2QueryError = unknown;

export function useApiV10EnrollableBenefitsRetrieve2<
  TData = Awaited<ReturnType<typeof apiV10EnrollableBenefitsRetrieve2>>,
  TError = unknown,
>(
  benefitId: number,
  params?: ApiV10EnrollableBenefitsRetrieve2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiV10EnrollableBenefitsRetrieve2>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApiV10EnrollableBenefitsRetrieve2QueryOptions(
    benefitId,
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Update the given EnrollableBenefit.
 */
export const apiV10EnrollableBenefitsPartialUpdate = (
  benefitId: number,
  patchedCreateEnrollableBenefitRequest?: PatchedCreateEnrollableBenefitRequest,
  params?: ApiV10EnrollableBenefitsPartialUpdateParams,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<EnrollableBenefit>({
    url: `/api/v1.0/enrollable-benefits/${benefitId}/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchedCreateEnrollableBenefitRequest,
    params,
    signal,
  });
};

export const getApiV10EnrollableBenefitsPartialUpdateMutationKey = () =>
  ['apiV10EnrollableBenefitsPartialUpdate'] as const;

export const getApiV10EnrollableBenefitsPartialUpdateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10EnrollableBenefitsPartialUpdate>>,
    TError,
    ApiV10EnrollableBenefitsPartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiV10EnrollableBenefitsPartialUpdate>>,
  TError,
  ApiV10EnrollableBenefitsPartialUpdateMutationVariables,
  TContext
> => {
  const mutationKey = getApiV10EnrollableBenefitsPartialUpdateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiV10EnrollableBenefitsPartialUpdate>>,
    ApiV10EnrollableBenefitsPartialUpdateMutationVariables
  > = (props) => {
    const { benefitId, data, params } = props ?? {};

    return apiV10EnrollableBenefitsPartialUpdate(benefitId, data, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiV10EnrollableBenefitsPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiV10EnrollableBenefitsPartialUpdate>>
>;
export type ApiV10EnrollableBenefitsPartialUpdateMutationBody =
  | PatchedCreateEnrollableBenefitRequest
  | undefined;
export type ApiV10EnrollableBenefitsPartialUpdateMutationError = unknown;
export type ApiV10EnrollableBenefitsPartialUpdateMutationVariables = {
  benefitId: number;
  data?: PatchedCreateEnrollableBenefitRequest;
  params?: ApiV10EnrollableBenefitsPartialUpdateParams;
};

export const useApiV10EnrollableBenefitsPartialUpdate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10EnrollableBenefitsPartialUpdate>>,
    TError,
    ApiV10EnrollableBenefitsPartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiV10EnrollableBenefitsPartialUpdate>>,
  TError,
  ApiV10EnrollableBenefitsPartialUpdateMutationVariables,
  TContext
> => {
  return useMutation(
    getApiV10EnrollableBenefitsPartialUpdateMutationOptions(options)
  );
};

export const apiV10EnrollableBenefitsEligibilityRetrieve = (
  benefitId: number,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<EligibilityResponse>({
    url: `/api/v1.0/enrollable-benefits/${benefitId}/eligibility/`,
    method: 'GET',
    signal,
  });
};

export const getApiV10EnrollableBenefitsEligibilityRetrieveQueryKey = (
  benefitId: number
) => {
  return [`/api/v1.0/enrollable-benefits/${benefitId}/eligibility/`] as const;
};

export const getApiV10EnrollableBenefitsEligibilityRetrieveQueryOptions = <
  TData = Awaited<
    ReturnType<typeof apiV10EnrollableBenefitsEligibilityRetrieve>
  >,
  TError = unknown,
>(
  benefitId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiV10EnrollableBenefitsEligibilityRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiV10EnrollableBenefitsEligibilityRetrieveQueryKey(benefitId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiV10EnrollableBenefitsEligibilityRetrieve>>
  > = ({ signal }) =>
    apiV10EnrollableBenefitsEligibilityRetrieve(benefitId, signal);

  return {
    queryKey,
    queryFn,
    enabled: benefitId !== null && benefitId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof apiV10EnrollableBenefitsEligibilityRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ApiV10EnrollableBenefitsEligibilityRetrieveQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof apiV10EnrollableBenefitsEligibilityRetrieve>>
  >;
export type ApiV10EnrollableBenefitsEligibilityRetrieveQueryError = unknown;

export function useApiV10EnrollableBenefitsEligibilityRetrieve<
  TData = Awaited<
    ReturnType<typeof apiV10EnrollableBenefitsEligibilityRetrieve>
  >,
  TError = unknown,
>(
  benefitId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiV10EnrollableBenefitsEligibilityRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getApiV10EnrollableBenefitsEligibilityRetrieveQueryOptions(
      benefitId,
      options
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const apiV10EnrollableBenefitsEligibilityCsvRetrieve = (
  benefitId: number,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/api/v1.0/enrollable-benefits/${benefitId}/eligibility/csv/`,
    method: 'GET',
    signal,
  });
};

export const getApiV10EnrollableBenefitsEligibilityCsvRetrieveQueryKey = (
  benefitId: number
) => {
  return [
    `/api/v1.0/enrollable-benefits/${benefitId}/eligibility/csv/`,
  ] as const;
};

export const getApiV10EnrollableBenefitsEligibilityCsvRetrieveQueryOptions = <
  TData = Awaited<
    ReturnType<typeof apiV10EnrollableBenefitsEligibilityCsvRetrieve>
  >,
  TError = unknown,
>(
  benefitId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<typeof apiV10EnrollableBenefitsEligibilityCsvRetrieve>
      >,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiV10EnrollableBenefitsEligibilityCsvRetrieveQueryKey(benefitId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiV10EnrollableBenefitsEligibilityCsvRetrieve>>
  > = ({ signal }) =>
    apiV10EnrollableBenefitsEligibilityCsvRetrieve(benefitId, signal);

  return {
    queryKey,
    queryFn,
    enabled: benefitId !== null && benefitId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof apiV10EnrollableBenefitsEligibilityCsvRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ApiV10EnrollableBenefitsEligibilityCsvRetrieveQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof apiV10EnrollableBenefitsEligibilityCsvRetrieve>>
  >;
export type ApiV10EnrollableBenefitsEligibilityCsvRetrieveQueryError = unknown;

export function useApiV10EnrollableBenefitsEligibilityCsvRetrieve<
  TData = Awaited<
    ReturnType<typeof apiV10EnrollableBenefitsEligibilityCsvRetrieve>
  >,
  TError = unknown,
>(
  benefitId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<typeof apiV10EnrollableBenefitsEligibilityCsvRetrieve>
      >,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getApiV10EnrollableBenefitsEligibilityCsvRetrieveQueryOptions(
      benefitId,
      options
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const apiV10EnrollableBenefitsEligibilityEmployeesRetrieve = (
  benefitId: number,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<EligibleEmployeesResponse>({
    url: `/api/v1.0/enrollable-benefits/${benefitId}/eligibility/employees/`,
    method: 'GET',
    signal,
  });
};

export const getApiV10EnrollableBenefitsEligibilityEmployeesRetrieveQueryKey = (
  benefitId: number
) => {
  return [
    `/api/v1.0/enrollable-benefits/${benefitId}/eligibility/employees/`,
  ] as const;
};

export const getApiV10EnrollableBenefitsEligibilityEmployeesRetrieveQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof apiV10EnrollableBenefitsEligibilityEmployeesRetrieve>
    >,
    TError = unknown,
  >(
    benefitId: number,
    options?: {
      query?: UseQueryOptions<
        Awaited<
          ReturnType<
            typeof apiV10EnrollableBenefitsEligibilityEmployeesRetrieve
          >
        >,
        TError,
        TData
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getApiV10EnrollableBenefitsEligibilityEmployeesRetrieveQueryKey(
        benefitId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof apiV10EnrollableBenefitsEligibilityEmployeesRetrieve>
      >
    > = ({ signal }) =>
      apiV10EnrollableBenefitsEligibilityEmployeesRetrieve(benefitId, signal);

    return {
      queryKey,
      queryFn,
      enabled: benefitId !== null && benefitId !== undefined,
      ...queryOptions,
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof apiV10EnrollableBenefitsEligibilityEmployeesRetrieve>
      >,
      TError,
      TData
    > & { queryKey: QueryKey };
  };

export type ApiV10EnrollableBenefitsEligibilityEmployeesRetrieveQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof apiV10EnrollableBenefitsEligibilityEmployeesRetrieve>
    >
  >;
export type ApiV10EnrollableBenefitsEligibilityEmployeesRetrieveQueryError =
  unknown;

export function useApiV10EnrollableBenefitsEligibilityEmployeesRetrieve<
  TData = Awaited<
    ReturnType<typeof apiV10EnrollableBenefitsEligibilityEmployeesRetrieve>
  >,
  TError = unknown,
>(
  benefitId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<typeof apiV10EnrollableBenefitsEligibilityEmployeesRetrieve>
      >,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getApiV10EnrollableBenefitsEligibilityEmployeesRetrieveQueryOptions(
      benefitId,
      options
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Preview pricing formula changes for all enrolments of a benefit.
 *
 * Returns a CSV file with old vs new pricing information.
 */
export const apiV10EnrollableBenefitsPricingFormulasTestCreate = (
  benefitId: number,
  pricingFormulaPreviewRequestRequest?: PricingFormulaPreviewRequestRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<Blob>({
    url: `/api/v1.0/enrollable-benefits/${benefitId}/pricing-formulas/test/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: pricingFormulaPreviewRequestRequest,
    responseType: 'blob',
    signal,
  });
};

export const getApiV10EnrollableBenefitsPricingFormulasTestCreateMutationKey =
  () => ['apiV10EnrollableBenefitsPricingFormulasTestCreate'] as const;

export const getApiV10EnrollableBenefitsPricingFormulasTestCreateMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof apiV10EnrollableBenefitsPricingFormulasTestCreate>
      >,
      TError,
      ApiV10EnrollableBenefitsPricingFormulasTestCreateMutationVariables,
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof apiV10EnrollableBenefitsPricingFormulasTestCreate>
    >,
    TError,
    ApiV10EnrollableBenefitsPricingFormulasTestCreateMutationVariables,
    TContext
  > => {
    const mutationKey =
      getApiV10EnrollableBenefitsPricingFormulasTestCreateMutationKey();
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof apiV10EnrollableBenefitsPricingFormulasTestCreate>
      >,
      ApiV10EnrollableBenefitsPricingFormulasTestCreateMutationVariables
    > = (props) => {
      const { benefitId, data } = props ?? {};

      return apiV10EnrollableBenefitsPricingFormulasTestCreate(benefitId, data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type ApiV10EnrollableBenefitsPricingFormulasTestCreateMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof apiV10EnrollableBenefitsPricingFormulasTestCreate>
    >
  >;
export type ApiV10EnrollableBenefitsPricingFormulasTestCreateMutationBody =
  | PricingFormulaPreviewRequestRequest
  | undefined;
export type ApiV10EnrollableBenefitsPricingFormulasTestCreateMutationError =
  unknown;
export type ApiV10EnrollableBenefitsPricingFormulasTestCreateMutationVariables =
  { benefitId: number; data?: PricingFormulaPreviewRequestRequest };

export const useApiV10EnrollableBenefitsPricingFormulasTestCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<typeof apiV10EnrollableBenefitsPricingFormulasTestCreate>
    >,
    TError,
    ApiV10EnrollableBenefitsPricingFormulasTestCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiV10EnrollableBenefitsPricingFormulasTestCreate>>,
  TError,
  ApiV10EnrollableBenefitsPricingFormulasTestCreateMutationVariables,
  TContext
> => {
  return useMutation(
    getApiV10EnrollableBenefitsPricingFormulasTestCreateMutationOptions(options)
  );
};

export const apiV10EnrollableBenefitsCreationAssessmentUpdate = (
  creationAssessmentRequestRequest: CreationAssessmentRequestRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<CreationAssessmentResponse>({
    url: `/api/v1.0/enrollable-benefits/creation-assessment/`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: creationAssessmentRequestRequest,
    signal,
  });
};

export const getApiV10EnrollableBenefitsCreationAssessmentUpdateMutationKey =
  () => ['apiV10EnrollableBenefitsCreationAssessmentUpdate'] as const;

export const getApiV10EnrollableBenefitsCreationAssessmentUpdateMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof apiV10EnrollableBenefitsCreationAssessmentUpdate>
      >,
      TError,
      ApiV10EnrollableBenefitsCreationAssessmentUpdateMutationVariables,
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof apiV10EnrollableBenefitsCreationAssessmentUpdate>
    >,
    TError,
    ApiV10EnrollableBenefitsCreationAssessmentUpdateMutationVariables,
    TContext
  > => {
    const mutationKey =
      getApiV10EnrollableBenefitsCreationAssessmentUpdateMutationKey();
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof apiV10EnrollableBenefitsCreationAssessmentUpdate>
      >,
      ApiV10EnrollableBenefitsCreationAssessmentUpdateMutationVariables
    > = (props) => {
      const { data } = props ?? {};

      return apiV10EnrollableBenefitsCreationAssessmentUpdate(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type ApiV10EnrollableBenefitsCreationAssessmentUpdateMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof apiV10EnrollableBenefitsCreationAssessmentUpdate>>
  >;
export type ApiV10EnrollableBenefitsCreationAssessmentUpdateMutationBody =
  CreationAssessmentRequestRequest;
export type ApiV10EnrollableBenefitsCreationAssessmentUpdateMutationError =
  unknown;
export type ApiV10EnrollableBenefitsCreationAssessmentUpdateMutationVariables =
  { data: CreationAssessmentRequestRequest };

export const useApiV10EnrollableBenefitsCreationAssessmentUpdate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<typeof apiV10EnrollableBenefitsCreationAssessmentUpdate>
    >,
    TError,
    ApiV10EnrollableBenefitsCreationAssessmentUpdateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiV10EnrollableBenefitsCreationAssessmentUpdate>>,
  TError,
  ApiV10EnrollableBenefitsCreationAssessmentUpdateMutationVariables,
  TContext
> => {
  return useMutation(
    getApiV10EnrollableBenefitsCreationAssessmentUpdateMutationOptions(options)
  );
};

/**
 * Return managers available to be used as EnrollableBenefit `managed_by`.
 */
export const apiV10EnrollableBenefitsManagersRetrieve = (
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<BenefitManagerResponse>({
    url: `/api/v1.0/enrollable-benefits/managers/`,
    method: 'GET',
    signal,
  });
};

export const getApiV10EnrollableBenefitsManagersRetrieveQueryKey = () => {
  return [`/api/v1.0/enrollable-benefits/managers/`] as const;
};

export const getApiV10EnrollableBenefitsManagersRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiV10EnrollableBenefitsManagersRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiV10EnrollableBenefitsManagersRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiV10EnrollableBenefitsManagersRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiV10EnrollableBenefitsManagersRetrieve>>
  > = ({ signal }) => apiV10EnrollableBenefitsManagersRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiV10EnrollableBenefitsManagersRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ApiV10EnrollableBenefitsManagersRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiV10EnrollableBenefitsManagersRetrieve>>
>;
export type ApiV10EnrollableBenefitsManagersRetrieveQueryError = unknown;

export function useApiV10EnrollableBenefitsManagersRetrieve<
  TData = Awaited<ReturnType<typeof apiV10EnrollableBenefitsManagersRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiV10EnrollableBenefitsManagersRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getApiV10EnrollableBenefitsManagersRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Updates the rank of the EnrollableBenefits provided
 */
export const apiV10EnrollableBenefitsRankPartialUpdate = (
  patchedRankRequestRequest?: PatchedRankRequestRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/api/v1.0/enrollable-benefits/rank/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchedRankRequestRequest,
    signal,
  });
};

export const getApiV10EnrollableBenefitsRankPartialUpdateMutationKey = () =>
  ['apiV10EnrollableBenefitsRankPartialUpdate'] as const;

export const getApiV10EnrollableBenefitsRankPartialUpdateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10EnrollableBenefitsRankPartialUpdate>>,
    TError,
    ApiV10EnrollableBenefitsRankPartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiV10EnrollableBenefitsRankPartialUpdate>>,
  TError,
  ApiV10EnrollableBenefitsRankPartialUpdateMutationVariables,
  TContext
> => {
  const mutationKey = getApiV10EnrollableBenefitsRankPartialUpdateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiV10EnrollableBenefitsRankPartialUpdate>>,
    ApiV10EnrollableBenefitsRankPartialUpdateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return apiV10EnrollableBenefitsRankPartialUpdate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiV10EnrollableBenefitsRankPartialUpdateMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof apiV10EnrollableBenefitsRankPartialUpdate>>
  >;
export type ApiV10EnrollableBenefitsRankPartialUpdateMutationBody =
  | PatchedRankRequestRequest
  | undefined;
export type ApiV10EnrollableBenefitsRankPartialUpdateMutationError = unknown;
export type ApiV10EnrollableBenefitsRankPartialUpdateMutationVariables = {
  data?: PatchedRankRequestRequest;
};

export const useApiV10EnrollableBenefitsRankPartialUpdate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10EnrollableBenefitsRankPartialUpdate>>,
    TError,
    ApiV10EnrollableBenefitsRankPartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiV10EnrollableBenefitsRankPartialUpdate>>,
  TError,
  ApiV10EnrollableBenefitsRankPartialUpdateMutationVariables,
  TContext
> => {
  return useMutation(
    getApiV10EnrollableBenefitsRankPartialUpdateMutationOptions(options)
  );
};

export const apiV10EnrollableBenefitsRecommendedList = (
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<BenefitEnrollmentSerializerWithInterests[]>({
    url: `/api/v1.0/enrollable-benefits/recommended/`,
    method: 'GET',
    signal,
  });
};

export const getApiV10EnrollableBenefitsRecommendedListQueryKey = () => {
  return [`/api/v1.0/enrollable-benefits/recommended/`] as const;
};

export const getApiV10EnrollableBenefitsRecommendedListQueryOptions = <
  TData = Awaited<ReturnType<typeof apiV10EnrollableBenefitsRecommendedList>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiV10EnrollableBenefitsRecommendedList>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiV10EnrollableBenefitsRecommendedListQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiV10EnrollableBenefitsRecommendedList>>
  > = ({ signal }) => apiV10EnrollableBenefitsRecommendedList(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiV10EnrollableBenefitsRecommendedList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ApiV10EnrollableBenefitsRecommendedListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiV10EnrollableBenefitsRecommendedList>>
>;
export type ApiV10EnrollableBenefitsRecommendedListQueryError = unknown;

export function useApiV10EnrollableBenefitsRecommendedList<
  TData = Awaited<ReturnType<typeof apiV10EnrollableBenefitsRecommendedList>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiV10EnrollableBenefitsRecommendedList>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getApiV10EnrollableBenefitsRecommendedListQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const apiV10EnrollmentsList = (
  params?: ApiV10EnrollmentsListParams,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<PaginatedBenefitEnrollmentList>({
    url: `/api/v1.0/enrollments/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getApiV10EnrollmentsListQueryKey = (
  params?: ApiV10EnrollmentsListParams
) => {
  return [`/api/v1.0/enrollments/`, ...(params ? [params] : [])] as const;
};

export const getApiV10EnrollmentsListQueryOptions = <
  TData = Awaited<ReturnType<typeof apiV10EnrollmentsList>>,
  TError = unknown,
>(
  params?: ApiV10EnrollmentsListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiV10EnrollmentsList>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiV10EnrollmentsListQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiV10EnrollmentsList>>
  > = ({ signal }) => apiV10EnrollmentsList(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiV10EnrollmentsList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ApiV10EnrollmentsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiV10EnrollmentsList>>
>;
export type ApiV10EnrollmentsListQueryError = unknown;

export function useApiV10EnrollmentsList<
  TData = Awaited<ReturnType<typeof apiV10EnrollmentsList>>,
  TError = unknown,
>(
  params?: ApiV10EnrollmentsListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiV10EnrollmentsList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApiV10EnrollmentsListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Full semantic search using LLM
 */
export const apiV10FullSearchRetrieve = (
  params?: ApiV10FullSearchRetrieveParams,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<FullSearchResponse>({
    url: `/api/v1.0/full-search/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getApiV10FullSearchRetrieveQueryKey = (
  params?: ApiV10FullSearchRetrieveParams
) => {
  return [`/api/v1.0/full-search/`, ...(params ? [params] : [])] as const;
};

export const getApiV10FullSearchRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiV10FullSearchRetrieve>>,
  TError = unknown,
>(
  params?: ApiV10FullSearchRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiV10FullSearchRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiV10FullSearchRetrieveQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiV10FullSearchRetrieve>>
  > = ({ signal }) => apiV10FullSearchRetrieve(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiV10FullSearchRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ApiV10FullSearchRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiV10FullSearchRetrieve>>
>;
export type ApiV10FullSearchRetrieveQueryError = unknown;

export function useApiV10FullSearchRetrieve<
  TData = Awaited<ReturnType<typeof apiV10FullSearchRetrieve>>,
  TError = unknown,
>(
  params?: ApiV10FullSearchRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiV10FullSearchRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApiV10FullSearchRetrieveQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Returns the given ManagedCardConfig
 */
export const apiV10ManagedCardConfigsRetrieve = (
  managedCardConfigId: number,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<ManagedCardConfigPreviewResponse>({
    url: `/api/v1.0/managed-card-configs/${managedCardConfigId}/`,
    method: 'GET',
    signal,
  });
};

export const getApiV10ManagedCardConfigsRetrieveQueryKey = (
  managedCardConfigId: number
) => {
  return [`/api/v1.0/managed-card-configs/${managedCardConfigId}/`] as const;
};

export const getApiV10ManagedCardConfigsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiV10ManagedCardConfigsRetrieve>>,
  TError = unknown,
>(
  managedCardConfigId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiV10ManagedCardConfigsRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiV10ManagedCardConfigsRetrieveQueryKey(managedCardConfigId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiV10ManagedCardConfigsRetrieve>>
  > = ({ signal }) =>
    apiV10ManagedCardConfigsRetrieve(managedCardConfigId, signal);

  return {
    queryKey,
    queryFn,
    enabled: managedCardConfigId !== null && managedCardConfigId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof apiV10ManagedCardConfigsRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ApiV10ManagedCardConfigsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiV10ManagedCardConfigsRetrieve>>
>;
export type ApiV10ManagedCardConfigsRetrieveQueryError = unknown;

export function useApiV10ManagedCardConfigsRetrieve<
  TData = Awaited<ReturnType<typeof apiV10ManagedCardConfigsRetrieve>>,
  TError = unknown,
>(
  managedCardConfigId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiV10ManagedCardConfigsRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApiV10ManagedCardConfigsRetrieveQueryOptions(
    managedCardConfigId,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const apiV10ManagedCardsBreakdownRetrieve = (
  externalCardId: string,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<ManagedCardBreakdownResponse>({
    url: `/api/v1.0/managed-cards/${externalCardId}/breakdown`,
    method: 'GET',
    signal,
  });
};

export const getApiV10ManagedCardsBreakdownRetrieveQueryKey = (
  externalCardId: string
) => {
  return [`/api/v1.0/managed-cards/${externalCardId}/breakdown`] as const;
};

export const getApiV10ManagedCardsBreakdownRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiV10ManagedCardsBreakdownRetrieve>>,
  TError = unknown,
>(
  externalCardId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiV10ManagedCardsBreakdownRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiV10ManagedCardsBreakdownRetrieveQueryKey(externalCardId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiV10ManagedCardsBreakdownRetrieve>>
  > = ({ signal }) =>
    apiV10ManagedCardsBreakdownRetrieve(externalCardId, signal);

  return {
    queryKey,
    queryFn,
    enabled: externalCardId !== null && externalCardId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof apiV10ManagedCardsBreakdownRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ApiV10ManagedCardsBreakdownRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiV10ManagedCardsBreakdownRetrieve>>
>;
export type ApiV10ManagedCardsBreakdownRetrieveQueryError = unknown;

export function useApiV10ManagedCardsBreakdownRetrieve<
  TData = Awaited<ReturnType<typeof apiV10ManagedCardsBreakdownRetrieve>>,
  TError = unknown,
>(
  externalCardId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiV10ManagedCardsBreakdownRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApiV10ManagedCardsBreakdownRetrieveQueryOptions(
    externalCardId,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const apiV10MediaRichTextImagesCreate = (
  richTextImageUploadRequestRequest: RichTextImageUploadRequestRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<RichTextImageUploadResponse>({
    url: `/api/v1.0/media/rich-text-images/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: richTextImageUploadRequestRequest,
    signal,
  });
};

export const getApiV10MediaRichTextImagesCreateMutationKey = () =>
  ['apiV10MediaRichTextImagesCreate'] as const;

export const getApiV10MediaRichTextImagesCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10MediaRichTextImagesCreate>>,
    TError,
    ApiV10MediaRichTextImagesCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiV10MediaRichTextImagesCreate>>,
  TError,
  ApiV10MediaRichTextImagesCreateMutationVariables,
  TContext
> => {
  const mutationKey = getApiV10MediaRichTextImagesCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiV10MediaRichTextImagesCreate>>,
    ApiV10MediaRichTextImagesCreateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return apiV10MediaRichTextImagesCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiV10MediaRichTextImagesCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiV10MediaRichTextImagesCreate>>
>;
export type ApiV10MediaRichTextImagesCreateMutationBody =
  RichTextImageUploadRequestRequest;
export type ApiV10MediaRichTextImagesCreateMutationError = unknown;
export type ApiV10MediaRichTextImagesCreateMutationVariables = {
  data: RichTextImageUploadRequestRequest;
};

export const useApiV10MediaRichTextImagesCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10MediaRichTextImagesCreate>>,
    TError,
    ApiV10MediaRichTextImagesCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiV10MediaRichTextImagesCreate>>,
  TError,
  ApiV10MediaRichTextImagesCreateMutationVariables,
  TContext
> => {
  return useMutation(
    getApiV10MediaRichTextImagesCreateMutationOptions(options)
  );
};

/**
 * Provide feedback on a message
 */
export const apiV10MessageFeedbackCreate = (
  messageId: string,
  messageFeedbackRequestRequest: MessageFeedbackRequestRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/api/v1.0/message/${messageId}/feedback`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: messageFeedbackRequestRequest,
    signal,
  });
};

export const getApiV10MessageFeedbackCreateMutationKey = () =>
  ['apiV10MessageFeedbackCreate'] as const;

export const getApiV10MessageFeedbackCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10MessageFeedbackCreate>>,
    TError,
    ApiV10MessageFeedbackCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiV10MessageFeedbackCreate>>,
  TError,
  ApiV10MessageFeedbackCreateMutationVariables,
  TContext
> => {
  const mutationKey = getApiV10MessageFeedbackCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiV10MessageFeedbackCreate>>,
    ApiV10MessageFeedbackCreateMutationVariables
  > = (props) => {
    const { messageId, data } = props ?? {};

    return apiV10MessageFeedbackCreate(messageId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiV10MessageFeedbackCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiV10MessageFeedbackCreate>>
>;
export type ApiV10MessageFeedbackCreateMutationBody =
  MessageFeedbackRequestRequest;
export type ApiV10MessageFeedbackCreateMutationError = unknown;
export type ApiV10MessageFeedbackCreateMutationVariables = {
  messageId: string;
  data: MessageFeedbackRequestRequest;
};

export const useApiV10MessageFeedbackCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10MessageFeedbackCreate>>,
    TError,
    ApiV10MessageFeedbackCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiV10MessageFeedbackCreate>>,
  TError,
  ApiV10MessageFeedbackCreateMutationVariables,
  TContext
> => {
  return useMutation(getApiV10MessageFeedbackCreateMutationOptions(options));
};

/**
 * Return a list of all Programmes for the given employer
 */
export const apiV10ProgrammesRetrieve = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<ProgrammeListResponse>({
    url: `/api/v1.0/programmes/`,
    method: 'GET',
    signal,
  });
};

export const getApiV10ProgrammesRetrieveQueryKey = () => {
  return [`/api/v1.0/programmes/`] as const;
};

export const getApiV10ProgrammesRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiV10ProgrammesRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiV10ProgrammesRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiV10ProgrammesRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiV10ProgrammesRetrieve>>
  > = ({ signal }) => apiV10ProgrammesRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiV10ProgrammesRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ApiV10ProgrammesRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiV10ProgrammesRetrieve>>
>;
export type ApiV10ProgrammesRetrieveQueryError = unknown;

export function useApiV10ProgrammesRetrieve<
  TData = Awaited<ReturnType<typeof apiV10ProgrammesRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiV10ProgrammesRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApiV10ProgrammesRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Returns the given Programme
 */
export const apiV10ProgrammesRetrieve2 = (
  programmeId: number,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<ProgrammePreviewResponse>({
    url: `/api/v1.0/programmes/${programmeId}/`,
    method: 'GET',
    signal,
  });
};

export const getApiV10ProgrammesRetrieve2QueryKey = (programmeId: number) => {
  return [`/api/v1.0/programmes/${programmeId}/`] as const;
};

export const getApiV10ProgrammesRetrieve2QueryOptions = <
  TData = Awaited<ReturnType<typeof apiV10ProgrammesRetrieve2>>,
  TError = unknown,
>(
  programmeId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiV10ProgrammesRetrieve2>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiV10ProgrammesRetrieve2QueryKey(programmeId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiV10ProgrammesRetrieve2>>
  > = ({ signal }) => apiV10ProgrammesRetrieve2(programmeId, signal);

  return {
    queryKey,
    queryFn,
    enabled: programmeId !== null && programmeId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof apiV10ProgrammesRetrieve2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ApiV10ProgrammesRetrieve2QueryResult = NonNullable<
  Awaited<ReturnType<typeof apiV10ProgrammesRetrieve2>>
>;
export type ApiV10ProgrammesRetrieve2QueryError = unknown;

export function useApiV10ProgrammesRetrieve2<
  TData = Awaited<ReturnType<typeof apiV10ProgrammesRetrieve2>>,
  TError = unknown,
>(
  programmeId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiV10ProgrammesRetrieve2>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApiV10ProgrammesRetrieve2QueryOptions(
    programmeId,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Return a list of all ProviderPitch objects
 */
export const apiV10ProviderPitchesRetrieve = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<ProviderPitchListResponse>({
    url: `/api/v1.0/provider-pitches/`,
    method: 'GET',
    signal,
  });
};

export const getApiV10ProviderPitchesRetrieveQueryKey = () => {
  return [`/api/v1.0/provider-pitches/`] as const;
};

export const getApiV10ProviderPitchesRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiV10ProviderPitchesRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiV10ProviderPitchesRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiV10ProviderPitchesRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiV10ProviderPitchesRetrieve>>
  > = ({ signal }) => apiV10ProviderPitchesRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiV10ProviderPitchesRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ApiV10ProviderPitchesRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiV10ProviderPitchesRetrieve>>
>;
export type ApiV10ProviderPitchesRetrieveQueryError = unknown;

export function useApiV10ProviderPitchesRetrieve<
  TData = Awaited<ReturnType<typeof apiV10ProviderPitchesRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiV10ProviderPitchesRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApiV10ProviderPitchesRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Sends two emails, one to the internal implementation team alerting
 * them to the fact a customer has requested information,
 * and the second to the requesting employee letting them know
 * to await an email from the internal implemenation team.
 */
export const apiV10ProviderPitchesRequestInfoUpdate = (
  providerPitchId: number,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/api/v1.0/provider-pitches/${providerPitchId}/request-info/`,
    method: 'PUT',
    signal,
  });
};

export const getApiV10ProviderPitchesRequestInfoUpdateMutationKey = () =>
  ['apiV10ProviderPitchesRequestInfoUpdate'] as const;

export const getApiV10ProviderPitchesRequestInfoUpdateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10ProviderPitchesRequestInfoUpdate>>,
    TError,
    ApiV10ProviderPitchesRequestInfoUpdateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiV10ProviderPitchesRequestInfoUpdate>>,
  TError,
  ApiV10ProviderPitchesRequestInfoUpdateMutationVariables,
  TContext
> => {
  const mutationKey = getApiV10ProviderPitchesRequestInfoUpdateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiV10ProviderPitchesRequestInfoUpdate>>,
    ApiV10ProviderPitchesRequestInfoUpdateMutationVariables
  > = (props) => {
    const { providerPitchId } = props ?? {};

    return apiV10ProviderPitchesRequestInfoUpdate(providerPitchId);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiV10ProviderPitchesRequestInfoUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiV10ProviderPitchesRequestInfoUpdate>>
>;

export type ApiV10ProviderPitchesRequestInfoUpdateMutationError = unknown;
export type ApiV10ProviderPitchesRequestInfoUpdateMutationVariables = {
  providerPitchId: number;
};

export const useApiV10ProviderPitchesRequestInfoUpdate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10ProviderPitchesRequestInfoUpdate>>,
    TError,
    ApiV10ProviderPitchesRequestInfoUpdateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiV10ProviderPitchesRequestInfoUpdate>>,
  TError,
  ApiV10ProviderPitchesRequestInfoUpdateMutationVariables,
  TContext
> => {
  return useMutation(
    getApiV10ProviderPitchesRequestInfoUpdateMutationOptions(options)
  );
};

export const apiV10ProvidersList = (
  params?: ApiV10ProvidersListParams,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<PaginatedProviderResponseList>({
    url: `/api/v1.0/providers/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getApiV10ProvidersListQueryKey = (
  params?: ApiV10ProvidersListParams
) => {
  return [`/api/v1.0/providers/`, ...(params ? [params] : [])] as const;
};

export const getApiV10ProvidersListQueryOptions = <
  TData = Awaited<ReturnType<typeof apiV10ProvidersList>>,
  TError = unknown,
>(
  params?: ApiV10ProvidersListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiV10ProvidersList>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiV10ProvidersListQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiV10ProvidersList>>
  > = ({ signal }) => apiV10ProvidersList(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiV10ProvidersList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ApiV10ProvidersListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiV10ProvidersList>>
>;
export type ApiV10ProvidersListQueryError = unknown;

export function useApiV10ProvidersList<
  TData = Awaited<ReturnType<typeof apiV10ProvidersList>>,
  TError = unknown,
>(
  params?: ApiV10ProvidersListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiV10ProvidersList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApiV10ProvidersListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Returns a specific recognition.
 */
export const apiV10RecognitionRetrieve = (
  recognitionId: number,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<RecognitionResponse>({
    url: `/api/v1.0/recognitions/${recognitionId}/`,
    method: 'GET',
    signal,
  });
};

export const getApiV10RecognitionRetrieveQueryKey = (recognitionId: number) => {
  return [`/api/v1.0/recognitions/${recognitionId}/`] as const;
};

export const getApiV10RecognitionRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiV10RecognitionRetrieve>>,
  TError = unknown,
>(
  recognitionId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiV10RecognitionRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiV10RecognitionRetrieveQueryKey(recognitionId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiV10RecognitionRetrieve>>
  > = ({ signal }) => apiV10RecognitionRetrieve(recognitionId, signal);

  return {
    queryKey,
    queryFn,
    enabled: recognitionId !== null && recognitionId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof apiV10RecognitionRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ApiV10RecognitionRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiV10RecognitionRetrieve>>
>;
export type ApiV10RecognitionRetrieveQueryError = unknown;

export function useApiV10RecognitionRetrieve<
  TData = Awaited<ReturnType<typeof apiV10RecognitionRetrieve>>,
  TError = unknown,
>(
  recognitionId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiV10RecognitionRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApiV10RecognitionRetrieveQueryOptions(
    recognitionId,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Returns the recognition configuration for the current employer.
 */
export const apiV10RecognitionsConfigurationRetrieve = (
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<RecognitionConfigurationResponse>({
    url: `/api/v1.0/recognitions/configuration/`,
    method: 'GET',
    signal,
  });
};

export const getApiV10RecognitionsConfigurationRetrieveQueryKey = () => {
  return [`/api/v1.0/recognitions/configuration/`] as const;
};

export const getApiV10RecognitionsConfigurationRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiV10RecognitionsConfigurationRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiV10RecognitionsConfigurationRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiV10RecognitionsConfigurationRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiV10RecognitionsConfigurationRetrieve>>
  > = ({ signal }) => apiV10RecognitionsConfigurationRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiV10RecognitionsConfigurationRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ApiV10RecognitionsConfigurationRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiV10RecognitionsConfigurationRetrieve>>
>;
export type ApiV10RecognitionsConfigurationRetrieveQueryError = unknown;

export function useApiV10RecognitionsConfigurationRetrieve<
  TData = Awaited<ReturnType<typeof apiV10RecognitionsConfigurationRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiV10RecognitionsConfigurationRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getApiV10RecognitionsConfigurationRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Updates the recognition configuration for the current employer.
 */
export const apiV10RecognitionsConfigurationPartialUpdate = (
  patchedRecognitionConfigurationPatchRequestRequest?: PatchedRecognitionConfigurationPatchRequestRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/api/v1.0/recognitions/configuration/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchedRecognitionConfigurationPatchRequestRequest,
    signal,
  });
};

export const getApiV10RecognitionsConfigurationPartialUpdateMutationKey = () =>
  ['apiV10RecognitionsConfigurationPartialUpdate'] as const;

export const getApiV10RecognitionsConfigurationPartialUpdateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10RecognitionsConfigurationPartialUpdate>>,
    TError,
    ApiV10RecognitionsConfigurationPartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiV10RecognitionsConfigurationPartialUpdate>>,
  TError,
  ApiV10RecognitionsConfigurationPartialUpdateMutationVariables,
  TContext
> => {
  const mutationKey =
    getApiV10RecognitionsConfigurationPartialUpdateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiV10RecognitionsConfigurationPartialUpdate>>,
    ApiV10RecognitionsConfigurationPartialUpdateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return apiV10RecognitionsConfigurationPartialUpdate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiV10RecognitionsConfigurationPartialUpdateMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof apiV10RecognitionsConfigurationPartialUpdate>>
  >;
export type ApiV10RecognitionsConfigurationPartialUpdateMutationBody =
  | PatchedRecognitionConfigurationPatchRequestRequest
  | undefined;
export type ApiV10RecognitionsConfigurationPartialUpdateMutationError = unknown;
export type ApiV10RecognitionsConfigurationPartialUpdateMutationVariables = {
  data?: PatchedRecognitionConfigurationPatchRequestRequest;
};

export const useApiV10RecognitionsConfigurationPartialUpdate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10RecognitionsConfigurationPartialUpdate>>,
    TError,
    ApiV10RecognitionsConfigurationPartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiV10RecognitionsConfigurationPartialUpdate>>,
  TError,
  ApiV10RecognitionsConfigurationPartialUpdateMutationVariables,
  TContext
> => {
  return useMutation(
    getApiV10RecognitionsConfigurationPartialUpdateMutationOptions(options)
  );
};

/**
 * Returns a list of filters for recognitions.
 */
export const apiV10RecognitionsFiltersRetrieve = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<FilterGroupsResponse>({
    url: `/api/v1.0/recognitions/filters/`,
    method: 'GET',
    signal,
  });
};

export const getApiV10RecognitionsFiltersRetrieveQueryKey = () => {
  return [`/api/v1.0/recognitions/filters/`] as const;
};

export const getApiV10RecognitionsFiltersRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiV10RecognitionsFiltersRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiV10RecognitionsFiltersRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiV10RecognitionsFiltersRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiV10RecognitionsFiltersRetrieve>>
  > = ({ signal }) => apiV10RecognitionsFiltersRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiV10RecognitionsFiltersRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ApiV10RecognitionsFiltersRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiV10RecognitionsFiltersRetrieve>>
>;
export type ApiV10RecognitionsFiltersRetrieveQueryError = unknown;

export function useApiV10RecognitionsFiltersRetrieve<
  TData = Awaited<ReturnType<typeof apiV10RecognitionsFiltersRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiV10RecognitionsFiltersRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getApiV10RecognitionsFiltersRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Returns a list of reward presets for the current employer.
 */
export const apiV10RecognitionsRewardPresetsRetrieve = (
  params: ApiV10RecognitionsRewardPresetsRetrieveParams,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<RewardPresetsResponse>({
    url: `/api/v1.0/recognitions/reward-presets/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getApiV10RecognitionsRewardPresetsRetrieveQueryKey = (
  params?: ApiV10RecognitionsRewardPresetsRetrieveParams
) => {
  return [
    `/api/v1.0/recognitions/reward-presets/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getApiV10RecognitionsRewardPresetsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiV10RecognitionsRewardPresetsRetrieve>>,
  TError = unknown,
>(
  params: ApiV10RecognitionsRewardPresetsRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiV10RecognitionsRewardPresetsRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiV10RecognitionsRewardPresetsRetrieveQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiV10RecognitionsRewardPresetsRetrieve>>
  > = ({ signal }) => apiV10RecognitionsRewardPresetsRetrieve(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiV10RecognitionsRewardPresetsRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ApiV10RecognitionsRewardPresetsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiV10RecognitionsRewardPresetsRetrieve>>
>;
export type ApiV10RecognitionsRewardPresetsRetrieveQueryError = unknown;

export function useApiV10RecognitionsRewardPresetsRetrieve<
  TData = Awaited<ReturnType<typeof apiV10RecognitionsRewardPresetsRetrieve>>,
  TError = unknown,
>(
  params: ApiV10RecognitionsRewardPresetsRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiV10RecognitionsRewardPresetsRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApiV10RecognitionsRewardPresetsRetrieveQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Creates a reward preset for the current employer.
 */
export const apiV10RecognitionsRewardPresetsCreate = (
  rewardPresetCreateRequestRequest: RewardPresetCreateRequestRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/api/v1.0/recognitions/reward-presets/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: rewardPresetCreateRequestRequest,
    signal,
  });
};

export const getApiV10RecognitionsRewardPresetsCreateMutationKey = () =>
  ['apiV10RecognitionsRewardPresetsCreate'] as const;

export const getApiV10RecognitionsRewardPresetsCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10RecognitionsRewardPresetsCreate>>,
    TError,
    ApiV10RecognitionsRewardPresetsCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiV10RecognitionsRewardPresetsCreate>>,
  TError,
  ApiV10RecognitionsRewardPresetsCreateMutationVariables,
  TContext
> => {
  const mutationKey = getApiV10RecognitionsRewardPresetsCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiV10RecognitionsRewardPresetsCreate>>,
    ApiV10RecognitionsRewardPresetsCreateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return apiV10RecognitionsRewardPresetsCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiV10RecognitionsRewardPresetsCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiV10RecognitionsRewardPresetsCreate>>
>;
export type ApiV10RecognitionsRewardPresetsCreateMutationBody =
  RewardPresetCreateRequestRequest;
export type ApiV10RecognitionsRewardPresetsCreateMutationError = unknown;
export type ApiV10RecognitionsRewardPresetsCreateMutationVariables = {
  data: RewardPresetCreateRequestRequest;
};

export const useApiV10RecognitionsRewardPresetsCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10RecognitionsRewardPresetsCreate>>,
    TError,
    ApiV10RecognitionsRewardPresetsCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiV10RecognitionsRewardPresetsCreate>>,
  TError,
  ApiV10RecognitionsRewardPresetsCreateMutationVariables,
  TContext
> => {
  return useMutation(
    getApiV10RecognitionsRewardPresetsCreateMutationOptions(options)
  );
};

/**
 * Updates a specific employer's reward preset
 */
export const apiV10RecognitionsRewardPresetsPartialUpdate = (
  rewardPresetId: number,
  patchedRewardPresetPatchRequestRequest?: PatchedRewardPresetPatchRequestRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/api/v1.0/recognitions/reward-presets/${rewardPresetId}/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchedRewardPresetPatchRequestRequest,
    signal,
  });
};

export const getApiV10RecognitionsRewardPresetsPartialUpdateMutationKey = () =>
  ['apiV10RecognitionsRewardPresetsPartialUpdate'] as const;

export const getApiV10RecognitionsRewardPresetsPartialUpdateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10RecognitionsRewardPresetsPartialUpdate>>,
    TError,
    ApiV10RecognitionsRewardPresetsPartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiV10RecognitionsRewardPresetsPartialUpdate>>,
  TError,
  ApiV10RecognitionsRewardPresetsPartialUpdateMutationVariables,
  TContext
> => {
  const mutationKey =
    getApiV10RecognitionsRewardPresetsPartialUpdateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiV10RecognitionsRewardPresetsPartialUpdate>>,
    ApiV10RecognitionsRewardPresetsPartialUpdateMutationVariables
  > = (props) => {
    const { rewardPresetId, data } = props ?? {};

    return apiV10RecognitionsRewardPresetsPartialUpdate(rewardPresetId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiV10RecognitionsRewardPresetsPartialUpdateMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof apiV10RecognitionsRewardPresetsPartialUpdate>>
  >;
export type ApiV10RecognitionsRewardPresetsPartialUpdateMutationBody =
  | PatchedRewardPresetPatchRequestRequest
  | undefined;
export type ApiV10RecognitionsRewardPresetsPartialUpdateMutationError = unknown;
export type ApiV10RecognitionsRewardPresetsPartialUpdateMutationVariables = {
  rewardPresetId: number;
  data?: PatchedRewardPresetPatchRequestRequest;
};

export const useApiV10RecognitionsRewardPresetsPartialUpdate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10RecognitionsRewardPresetsPartialUpdate>>,
    TError,
    ApiV10RecognitionsRewardPresetsPartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiV10RecognitionsRewardPresetsPartialUpdate>>,
  TError,
  ApiV10RecognitionsRewardPresetsPartialUpdateMutationVariables,
  TContext
> => {
  return useMutation(
    getApiV10RecognitionsRewardPresetsPartialUpdateMutationOptions(options)
  );
};

/**
 * Deletes a specific employer's reward preset
 */
export const apiV10RecognitionsRewardPresetsDestroy = (
  rewardPresetId: number,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/api/v1.0/recognitions/reward-presets/${rewardPresetId}/`,
    method: 'DELETE',
    signal,
  });
};

export const getApiV10RecognitionsRewardPresetsDestroyMutationKey = () =>
  ['apiV10RecognitionsRewardPresetsDestroy'] as const;

export const getApiV10RecognitionsRewardPresetsDestroyMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10RecognitionsRewardPresetsDestroy>>,
    TError,
    ApiV10RecognitionsRewardPresetsDestroyMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiV10RecognitionsRewardPresetsDestroy>>,
  TError,
  ApiV10RecognitionsRewardPresetsDestroyMutationVariables,
  TContext
> => {
  const mutationKey = getApiV10RecognitionsRewardPresetsDestroyMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiV10RecognitionsRewardPresetsDestroy>>,
    ApiV10RecognitionsRewardPresetsDestroyMutationVariables
  > = (props) => {
    const { rewardPresetId } = props ?? {};

    return apiV10RecognitionsRewardPresetsDestroy(rewardPresetId);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiV10RecognitionsRewardPresetsDestroyMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiV10RecognitionsRewardPresetsDestroy>>
>;

export type ApiV10RecognitionsRewardPresetsDestroyMutationError = unknown;
export type ApiV10RecognitionsRewardPresetsDestroyMutationVariables = {
  rewardPresetId: number;
};

export const useApiV10RecognitionsRewardPresetsDestroy = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10RecognitionsRewardPresetsDestroy>>,
    TError,
    ApiV10RecognitionsRewardPresetsDestroyMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiV10RecognitionsRewardPresetsDestroy>>,
  TError,
  ApiV10RecognitionsRewardPresetsDestroyMutationVariables,
  TContext
> => {
  return useMutation(
    getApiV10RecognitionsRewardPresetsDestroyMutationOptions(options)
  );
};

/**
 * Reorders multiple reward presets in a single request.
 */
export const apiV10RecognitionsRewardPresetsOrderPartialUpdate = (
  patchedRewardPresetReorderRequestRequest?: PatchedRewardPresetReorderRequestRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/api/v1.0/recognitions/reward-presets/order/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchedRewardPresetReorderRequestRequest,
    signal,
  });
};

export const getApiV10RecognitionsRewardPresetsOrderPartialUpdateMutationKey =
  () => ['apiV10RecognitionsRewardPresetsOrderPartialUpdate'] as const;

export const getApiV10RecognitionsRewardPresetsOrderPartialUpdateMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof apiV10RecognitionsRewardPresetsOrderPartialUpdate>
      >,
      TError,
      ApiV10RecognitionsRewardPresetsOrderPartialUpdateMutationVariables,
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof apiV10RecognitionsRewardPresetsOrderPartialUpdate>
    >,
    TError,
    ApiV10RecognitionsRewardPresetsOrderPartialUpdateMutationVariables,
    TContext
  > => {
    const mutationKey =
      getApiV10RecognitionsRewardPresetsOrderPartialUpdateMutationKey();
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof apiV10RecognitionsRewardPresetsOrderPartialUpdate>
      >,
      ApiV10RecognitionsRewardPresetsOrderPartialUpdateMutationVariables
    > = (props) => {
      const { data } = props ?? {};

      return apiV10RecognitionsRewardPresetsOrderPartialUpdate(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type ApiV10RecognitionsRewardPresetsOrderPartialUpdateMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof apiV10RecognitionsRewardPresetsOrderPartialUpdate>
    >
  >;
export type ApiV10RecognitionsRewardPresetsOrderPartialUpdateMutationBody =
  | PatchedRewardPresetReorderRequestRequest
  | undefined;
export type ApiV10RecognitionsRewardPresetsOrderPartialUpdateMutationError =
  unknown;
export type ApiV10RecognitionsRewardPresetsOrderPartialUpdateMutationVariables =
  { data?: PatchedRewardPresetReorderRequestRequest };

export const useApiV10RecognitionsRewardPresetsOrderPartialUpdate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<typeof apiV10RecognitionsRewardPresetsOrderPartialUpdate>
    >,
    TError,
    ApiV10RecognitionsRewardPresetsOrderPartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiV10RecognitionsRewardPresetsOrderPartialUpdate>>,
  TError,
  ApiV10RecognitionsRewardPresetsOrderPartialUpdateMutationVariables,
  TContext
> => {
  return useMutation(
    getApiV10RecognitionsRewardPresetsOrderPartialUpdateMutationOptions(options)
  );
};

/**
 * Returns statistics for recognitions.
 */
export const apiV10RecognitionsStatisticsRetrieve = (
  params?: ApiV10RecognitionsStatisticsRetrieveParams,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<RecognitionStatisticsResponse>({
    url: `/api/v1.0/recognitions/statistics/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getApiV10RecognitionsStatisticsRetrieveQueryKey = (
  params?: ApiV10RecognitionsStatisticsRetrieveParams
) => {
  return [
    `/api/v1.0/recognitions/statistics/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getApiV10RecognitionsStatisticsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiV10RecognitionsStatisticsRetrieve>>,
  TError = unknown,
>(
  params?: ApiV10RecognitionsStatisticsRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiV10RecognitionsStatisticsRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiV10RecognitionsStatisticsRetrieveQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiV10RecognitionsStatisticsRetrieve>>
  > = ({ signal }) => apiV10RecognitionsStatisticsRetrieve(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiV10RecognitionsStatisticsRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ApiV10RecognitionsStatisticsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiV10RecognitionsStatisticsRetrieve>>
>;
export type ApiV10RecognitionsStatisticsRetrieveQueryError = unknown;

export function useApiV10RecognitionsStatisticsRetrieve<
  TData = Awaited<ReturnType<typeof apiV10RecognitionsStatisticsRetrieve>>,
  TError = unknown,
>(
  params?: ApiV10RecognitionsStatisticsRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiV10RecognitionsStatisticsRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApiV10RecognitionsStatisticsRetrieveQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const apiV10RefineCreate = (
  baseAgentRequestRequestRequest: BaseAgentRequestRequestRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<BaseAgentRequestRequest>({
    url: `/api/v1.0/refine/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: baseAgentRequestRequestRequest,
    signal,
  });
};

export const getApiV10RefineCreateMutationKey = () =>
  ['apiV10RefineCreate'] as const;

export const getApiV10RefineCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10RefineCreate>>,
    TError,
    ApiV10RefineCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiV10RefineCreate>>,
  TError,
  ApiV10RefineCreateMutationVariables,
  TContext
> => {
  const mutationKey = getApiV10RefineCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiV10RefineCreate>>,
    ApiV10RefineCreateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return apiV10RefineCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiV10RefineCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiV10RefineCreate>>
>;
export type ApiV10RefineCreateMutationBody = BaseAgentRequestRequestRequest;
export type ApiV10RefineCreateMutationError = unknown;
export type ApiV10RefineCreateMutationVariables = {
  data: BaseAgentRequestRequestRequest;
};

export const useApiV10RefineCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10RefineCreate>>,
    TError,
    ApiV10RefineCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiV10RefineCreate>>,
  TError,
  ApiV10RefineCreateMutationVariables,
  TContext
> => {
  return useMutation(getApiV10RefineCreateMutationOptions(options));
};

/**
 * Return a list of all resources articles for the given employer.
 */
export const apiV10ResourcesArticlesRetrieve = (
  params?: ApiV10ResourcesArticlesRetrieveParams,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<ResourcesArticleListResponse>({
    url: `/api/v1.0/resources/articles/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getApiV10ResourcesArticlesRetrieveQueryKey = (
  params?: ApiV10ResourcesArticlesRetrieveParams
) => {
  return [
    `/api/v1.0/resources/articles/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getApiV10ResourcesArticlesRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiV10ResourcesArticlesRetrieve>>,
  TError = unknown,
>(
  params?: ApiV10ResourcesArticlesRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiV10ResourcesArticlesRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiV10ResourcesArticlesRetrieveQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiV10ResourcesArticlesRetrieve>>
  > = ({ signal }) => apiV10ResourcesArticlesRetrieve(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiV10ResourcesArticlesRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ApiV10ResourcesArticlesRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiV10ResourcesArticlesRetrieve>>
>;
export type ApiV10ResourcesArticlesRetrieveQueryError = unknown;

export function useApiV10ResourcesArticlesRetrieve<
  TData = Awaited<ReturnType<typeof apiV10ResourcesArticlesRetrieve>>,
  TError = unknown,
>(
  params?: ApiV10ResourcesArticlesRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiV10ResourcesArticlesRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApiV10ResourcesArticlesRetrieveQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Returns the given resources article.
 */
export const apiV10ResourcesArticlesRetrieve2 = (
  articleId: number,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<ResourcesArticleDetailResponse>({
    url: `/api/v1.0/resources/articles/${articleId}/`,
    method: 'GET',
    signal,
  });
};

export const getApiV10ResourcesArticlesRetrieve2QueryKey = (
  articleId: number
) => {
  return [`/api/v1.0/resources/articles/${articleId}/`] as const;
};

export const getApiV10ResourcesArticlesRetrieve2QueryOptions = <
  TData = Awaited<ReturnType<typeof apiV10ResourcesArticlesRetrieve2>>,
  TError = unknown,
>(
  articleId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiV10ResourcesArticlesRetrieve2>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiV10ResourcesArticlesRetrieve2QueryKey(articleId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiV10ResourcesArticlesRetrieve2>>
  > = ({ signal }) => apiV10ResourcesArticlesRetrieve2(articleId, signal);

  return {
    queryKey,
    queryFn,
    enabled: articleId !== null && articleId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof apiV10ResourcesArticlesRetrieve2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ApiV10ResourcesArticlesRetrieve2QueryResult = NonNullable<
  Awaited<ReturnType<typeof apiV10ResourcesArticlesRetrieve2>>
>;
export type ApiV10ResourcesArticlesRetrieve2QueryError = unknown;

export function useApiV10ResourcesArticlesRetrieve2<
  TData = Awaited<ReturnType<typeof apiV10ResourcesArticlesRetrieve2>>,
  TError = unknown,
>(
  articleId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiV10ResourcesArticlesRetrieve2>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApiV10ResourcesArticlesRetrieve2QueryOptions(
    articleId,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Return resource categories for the logged-in employee's employer.
 */
export const apiV10ResourcesCategoriesRetrieve = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<ResourcesCategoriesListResponse>({
    url: `/api/v1.0/resources/categories/`,
    method: 'GET',
    signal,
  });
};

export const getApiV10ResourcesCategoriesRetrieveQueryKey = () => {
  return [`/api/v1.0/resources/categories/`] as const;
};

export const getApiV10ResourcesCategoriesRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiV10ResourcesCategoriesRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiV10ResourcesCategoriesRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiV10ResourcesCategoriesRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiV10ResourcesCategoriesRetrieve>>
  > = ({ signal }) => apiV10ResourcesCategoriesRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiV10ResourcesCategoriesRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ApiV10ResourcesCategoriesRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiV10ResourcesCategoriesRetrieve>>
>;
export type ApiV10ResourcesCategoriesRetrieveQueryError = unknown;

export function useApiV10ResourcesCategoriesRetrieve<
  TData = Awaited<ReturnType<typeof apiV10ResourcesCategoriesRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiV10ResourcesCategoriesRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getApiV10ResourcesCategoriesRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Returns a paginated list of all rewards budgets available to the employee
 * on the selected employer.
 */
export const apiV10RewardsBudgetsRetrieve = (
  params?: ApiV10RewardsBudgetsRetrieveParams,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<RewardsBudgetsResponse>({
    url: `/api/v1.0/rewards-budgets/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getApiV10RewardsBudgetsRetrieveQueryKey = (
  params?: ApiV10RewardsBudgetsRetrieveParams
) => {
  return [`/api/v1.0/rewards-budgets/`, ...(params ? [params] : [])] as const;
};

export const getApiV10RewardsBudgetsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiV10RewardsBudgetsRetrieve>>,
  TError = unknown,
>(
  params?: ApiV10RewardsBudgetsRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiV10RewardsBudgetsRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiV10RewardsBudgetsRetrieveQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiV10RewardsBudgetsRetrieve>>
  > = ({ signal }) => apiV10RewardsBudgetsRetrieve(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiV10RewardsBudgetsRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ApiV10RewardsBudgetsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiV10RewardsBudgetsRetrieve>>
>;
export type ApiV10RewardsBudgetsRetrieveQueryError = unknown;

export function useApiV10RewardsBudgetsRetrieve<
  TData = Awaited<ReturnType<typeof apiV10RewardsBudgetsRetrieve>>,
  TError = unknown,
>(
  params?: ApiV10RewardsBudgetsRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiV10RewardsBudgetsRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApiV10RewardsBudgetsRetrieveQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Creates a new rewards budget.
 */
export const apiV10RewardsBudgetsCreate = (
  rewardsBudgetCreateRequestRequest: RewardsBudgetCreateRequestRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<RewardsBudgetResponse>({
    url: `/api/v1.0/rewards-budgets/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: rewardsBudgetCreateRequestRequest,
    signal,
  });
};

export const getApiV10RewardsBudgetsCreateMutationKey = () =>
  ['apiV10RewardsBudgetsCreate'] as const;

export const getApiV10RewardsBudgetsCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10RewardsBudgetsCreate>>,
    TError,
    ApiV10RewardsBudgetsCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiV10RewardsBudgetsCreate>>,
  TError,
  ApiV10RewardsBudgetsCreateMutationVariables,
  TContext
> => {
  const mutationKey = getApiV10RewardsBudgetsCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiV10RewardsBudgetsCreate>>,
    ApiV10RewardsBudgetsCreateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return apiV10RewardsBudgetsCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiV10RewardsBudgetsCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiV10RewardsBudgetsCreate>>
>;
export type ApiV10RewardsBudgetsCreateMutationBody =
  RewardsBudgetCreateRequestRequest;
export type ApiV10RewardsBudgetsCreateMutationError = unknown;
export type ApiV10RewardsBudgetsCreateMutationVariables = {
  data: RewardsBudgetCreateRequestRequest;
};

export const useApiV10RewardsBudgetsCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10RewardsBudgetsCreate>>,
    TError,
    ApiV10RewardsBudgetsCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiV10RewardsBudgetsCreate>>,
  TError,
  ApiV10RewardsBudgetsCreateMutationVariables,
  TContext
> => {
  return useMutation(getApiV10RewardsBudgetsCreateMutationOptions(options));
};

/**
 * Returns details of a specific rewards budget.
 */
export const apiV10RewardsBudgetsRetrieve2 = (
  rewardsBudgetId: number,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<RewardsBudgetDetailResponse>({
    url: `/api/v1.0/rewards-budgets/${rewardsBudgetId}/`,
    method: 'GET',
    signal,
  });
};

export const getApiV10RewardsBudgetsRetrieve2QueryKey = (
  rewardsBudgetId: number
) => {
  return [`/api/v1.0/rewards-budgets/${rewardsBudgetId}/`] as const;
};

export const getApiV10RewardsBudgetsRetrieve2QueryOptions = <
  TData = Awaited<ReturnType<typeof apiV10RewardsBudgetsRetrieve2>>,
  TError = unknown,
>(
  rewardsBudgetId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiV10RewardsBudgetsRetrieve2>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiV10RewardsBudgetsRetrieve2QueryKey(rewardsBudgetId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiV10RewardsBudgetsRetrieve2>>
  > = ({ signal }) => apiV10RewardsBudgetsRetrieve2(rewardsBudgetId, signal);

  return {
    queryKey,
    queryFn,
    enabled: rewardsBudgetId !== null && rewardsBudgetId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof apiV10RewardsBudgetsRetrieve2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ApiV10RewardsBudgetsRetrieve2QueryResult = NonNullable<
  Awaited<ReturnType<typeof apiV10RewardsBudgetsRetrieve2>>
>;
export type ApiV10RewardsBudgetsRetrieve2QueryError = unknown;

export function useApiV10RewardsBudgetsRetrieve2<
  TData = Awaited<ReturnType<typeof apiV10RewardsBudgetsRetrieve2>>,
  TError = unknown,
>(
  rewardsBudgetId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiV10RewardsBudgetsRetrieve2>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApiV10RewardsBudgetsRetrieve2QueryOptions(
    rewardsBudgetId,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Updates fields on a specific rewards budget.
 */
export const apiV10RewardsBudgetsPartialUpdate = (
  rewardsBudgetId: number,
  patchedRewardsBudgetUpdateRequestRequest?: PatchedRewardsBudgetUpdateRequestRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/api/v1.0/rewards-budgets/${rewardsBudgetId}/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchedRewardsBudgetUpdateRequestRequest,
    signal,
  });
};

export const getApiV10RewardsBudgetsPartialUpdateMutationKey = () =>
  ['apiV10RewardsBudgetsPartialUpdate'] as const;

export const getApiV10RewardsBudgetsPartialUpdateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10RewardsBudgetsPartialUpdate>>,
    TError,
    ApiV10RewardsBudgetsPartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiV10RewardsBudgetsPartialUpdate>>,
  TError,
  ApiV10RewardsBudgetsPartialUpdateMutationVariables,
  TContext
> => {
  const mutationKey = getApiV10RewardsBudgetsPartialUpdateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiV10RewardsBudgetsPartialUpdate>>,
    ApiV10RewardsBudgetsPartialUpdateMutationVariables
  > = (props) => {
    const { rewardsBudgetId, data } = props ?? {};

    return apiV10RewardsBudgetsPartialUpdate(rewardsBudgetId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiV10RewardsBudgetsPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiV10RewardsBudgetsPartialUpdate>>
>;
export type ApiV10RewardsBudgetsPartialUpdateMutationBody =
  | PatchedRewardsBudgetUpdateRequestRequest
  | undefined;
export type ApiV10RewardsBudgetsPartialUpdateMutationError = unknown;
export type ApiV10RewardsBudgetsPartialUpdateMutationVariables = {
  rewardsBudgetId: number;
  data?: PatchedRewardsBudgetUpdateRequestRequest;
};

export const useApiV10RewardsBudgetsPartialUpdate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10RewardsBudgetsPartialUpdate>>,
    TError,
    ApiV10RewardsBudgetsPartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiV10RewardsBudgetsPartialUpdate>>,
  TError,
  ApiV10RewardsBudgetsPartialUpdateMutationVariables,
  TContext
> => {
  return useMutation(
    getApiV10RewardsBudgetsPartialUpdateMutationOptions(options)
  );
};

/**
 * Returns a paginated list of all members in the specified rewards budget.
 *
 * Note: Although this endpoint uses POST to support complex filter parameters
 * in the request body it is read-only and behaves like a GET request.
 */
export const apiV10RewardsBudgetsMembersCreate = (
  rewardsBudgetId: number,
  rewardsBudgetMembersRequestRequest?: RewardsBudgetMembersRequestRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<RewardsBudgetMembersResponse>({
    url: `/api/v1.0/rewards-budgets/${rewardsBudgetId}/members/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: rewardsBudgetMembersRequestRequest,
    signal,
  });
};

export const getApiV10RewardsBudgetsMembersCreateMutationKey = () =>
  ['apiV10RewardsBudgetsMembersCreate'] as const;

export const getApiV10RewardsBudgetsMembersCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10RewardsBudgetsMembersCreate>>,
    TError,
    ApiV10RewardsBudgetsMembersCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiV10RewardsBudgetsMembersCreate>>,
  TError,
  ApiV10RewardsBudgetsMembersCreateMutationVariables,
  TContext
> => {
  const mutationKey = getApiV10RewardsBudgetsMembersCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiV10RewardsBudgetsMembersCreate>>,
    ApiV10RewardsBudgetsMembersCreateMutationVariables
  > = (props) => {
    const { rewardsBudgetId, data } = props ?? {};

    return apiV10RewardsBudgetsMembersCreate(rewardsBudgetId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiV10RewardsBudgetsMembersCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiV10RewardsBudgetsMembersCreate>>
>;
export type ApiV10RewardsBudgetsMembersCreateMutationBody =
  | RewardsBudgetMembersRequestRequest
  | undefined;
export type ApiV10RewardsBudgetsMembersCreateMutationError = unknown;
export type ApiV10RewardsBudgetsMembersCreateMutationVariables = {
  rewardsBudgetId: number;
  data?: RewardsBudgetMembersRequestRequest;
};

export const useApiV10RewardsBudgetsMembersCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10RewardsBudgetsMembersCreate>>,
    TError,
    ApiV10RewardsBudgetsMembersCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiV10RewardsBudgetsMembersCreate>>,
  TError,
  ApiV10RewardsBudgetsMembersCreateMutationVariables,
  TContext
> => {
  return useMutation(
    getApiV10RewardsBudgetsMembersCreateMutationOptions(options)
  );
};

/**
 * Adds or removes members from a specific rewards budget
 */
export const apiV10RewardsBudgetsMembersPartialUpdate = (
  rewardsBudgetId: number,
  patchedRewardsBudgetMembersUpdateRequestRequest?: PatchedRewardsBudgetMembersUpdateRequestRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/api/v1.0/rewards-budgets/${rewardsBudgetId}/members/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchedRewardsBudgetMembersUpdateRequestRequest,
    signal,
  });
};

export const getApiV10RewardsBudgetsMembersPartialUpdateMutationKey = () =>
  ['apiV10RewardsBudgetsMembersPartialUpdate'] as const;

export const getApiV10RewardsBudgetsMembersPartialUpdateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10RewardsBudgetsMembersPartialUpdate>>,
    TError,
    ApiV10RewardsBudgetsMembersPartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiV10RewardsBudgetsMembersPartialUpdate>>,
  TError,
  ApiV10RewardsBudgetsMembersPartialUpdateMutationVariables,
  TContext
> => {
  const mutationKey = getApiV10RewardsBudgetsMembersPartialUpdateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiV10RewardsBudgetsMembersPartialUpdate>>,
    ApiV10RewardsBudgetsMembersPartialUpdateMutationVariables
  > = (props) => {
    const { rewardsBudgetId, data } = props ?? {};

    return apiV10RewardsBudgetsMembersPartialUpdate(rewardsBudgetId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiV10RewardsBudgetsMembersPartialUpdateMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof apiV10RewardsBudgetsMembersPartialUpdate>>
  >;
export type ApiV10RewardsBudgetsMembersPartialUpdateMutationBody =
  | PatchedRewardsBudgetMembersUpdateRequestRequest
  | undefined;
export type ApiV10RewardsBudgetsMembersPartialUpdateMutationError = unknown;
export type ApiV10RewardsBudgetsMembersPartialUpdateMutationVariables = {
  rewardsBudgetId: number;
  data?: PatchedRewardsBudgetMembersUpdateRequestRequest;
};

export const useApiV10RewardsBudgetsMembersPartialUpdate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10RewardsBudgetsMembersPartialUpdate>>,
    TError,
    ApiV10RewardsBudgetsMembersPartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiV10RewardsBudgetsMembersPartialUpdate>>,
  TError,
  ApiV10RewardsBudgetsMembersPartialUpdateMutationVariables,
  TContext
> => {
  return useMutation(
    getApiV10RewardsBudgetsMembersPartialUpdateMutationOptions(options)
  );
};

/**
 * Allocates funds to a specified set of employees,
 * either as an addition or deduction.
 */
export const apiV10RewardsBudgetsMembersBalancePartialUpdate = (
  rewardsBudgetId: number,
  patchedRewardsBudgetMembersBalanceRequestRequest?: PatchedRewardsBudgetMembersBalanceRequestRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/api/v1.0/rewards-budgets/${rewardsBudgetId}/members/balance/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchedRewardsBudgetMembersBalanceRequestRequest,
    signal,
  });
};

export const getApiV10RewardsBudgetsMembersBalancePartialUpdateMutationKey =
  () => ['apiV10RewardsBudgetsMembersBalancePartialUpdate'] as const;

export const getApiV10RewardsBudgetsMembersBalancePartialUpdateMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof apiV10RewardsBudgetsMembersBalancePartialUpdate>
      >,
      TError,
      ApiV10RewardsBudgetsMembersBalancePartialUpdateMutationVariables,
      TContext
    >;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof apiV10RewardsBudgetsMembersBalancePartialUpdate>>,
    TError,
    ApiV10RewardsBudgetsMembersBalancePartialUpdateMutationVariables,
    TContext
  > => {
    const mutationKey =
      getApiV10RewardsBudgetsMembersBalancePartialUpdateMutationKey();
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof apiV10RewardsBudgetsMembersBalancePartialUpdate>
      >,
      ApiV10RewardsBudgetsMembersBalancePartialUpdateMutationVariables
    > = (props) => {
      const { rewardsBudgetId, data } = props ?? {};

      return apiV10RewardsBudgetsMembersBalancePartialUpdate(
        rewardsBudgetId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ApiV10RewardsBudgetsMembersBalancePartialUpdateMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof apiV10RewardsBudgetsMembersBalancePartialUpdate>>
  >;
export type ApiV10RewardsBudgetsMembersBalancePartialUpdateMutationBody =
  | PatchedRewardsBudgetMembersBalanceRequestRequest
  | undefined;
export type ApiV10RewardsBudgetsMembersBalancePartialUpdateMutationError =
  unknown;
export type ApiV10RewardsBudgetsMembersBalancePartialUpdateMutationVariables = {
  rewardsBudgetId: number;
  data?: PatchedRewardsBudgetMembersBalanceRequestRequest;
};

export const useApiV10RewardsBudgetsMembersBalancePartialUpdate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiV10RewardsBudgetsMembersBalancePartialUpdate>>,
    TError,
    ApiV10RewardsBudgetsMembersBalancePartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiV10RewardsBudgetsMembersBalancePartialUpdate>>,
  TError,
  ApiV10RewardsBudgetsMembersBalancePartialUpdateMutationVariables,
  TContext
> => {
  return useMutation(
    getApiV10RewardsBudgetsMembersBalancePartialUpdateMutationOptions(options)
  );
};

/**
 * Search for benefits, features and predefined queries
 */
export const apiV10SearchRetrieve = (
  params: ApiV10SearchRetrieveParams,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<SearchResponse>({
    url: `/api/v1.0/search/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getApiV10SearchRetrieveQueryKey = (
  params?: ApiV10SearchRetrieveParams
) => {
  return [`/api/v1.0/search/`, ...(params ? [params] : [])] as const;
};

export const getApiV10SearchRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiV10SearchRetrieve>>,
  TError = unknown,
>(
  params: ApiV10SearchRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiV10SearchRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiV10SearchRetrieveQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiV10SearchRetrieve>>
  > = ({ signal }) => apiV10SearchRetrieve(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiV10SearchRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ApiV10SearchRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiV10SearchRetrieve>>
>;
export type ApiV10SearchRetrieveQueryError = unknown;

export function useApiV10SearchRetrieve<
  TData = Awaited<ReturnType<typeof apiV10SearchRetrieve>>,
  TError = unknown,
>(
  params: ApiV10SearchRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiV10SearchRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApiV10SearchRetrieveQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Get AI search query suggestions
 */
export const apiV10SearchSuggestionsList = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<QuerySuggestion[]>({
    url: `/api/v1.0/search/suggestions/`,
    method: 'GET',
    signal,
  });
};

export const getApiV10SearchSuggestionsListQueryKey = () => {
  return [`/api/v1.0/search/suggestions/`] as const;
};

export const getApiV10SearchSuggestionsListQueryOptions = <
  TData = Awaited<ReturnType<typeof apiV10SearchSuggestionsList>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiV10SearchSuggestionsList>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiV10SearchSuggestionsListQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiV10SearchSuggestionsList>>
  > = ({ signal }) => apiV10SearchSuggestionsList(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof apiV10SearchSuggestionsList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ApiV10SearchSuggestionsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiV10SearchSuggestionsList>>
>;
export type ApiV10SearchSuggestionsListQueryError = unknown;

export function useApiV10SearchSuggestionsList<
  TData = Awaited<ReturnType<typeof apiV10SearchSuggestionsList>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiV10SearchSuggestionsList>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApiV10SearchSuggestionsListQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const allowanceReceiptUpdate = (
  allowanceReceiptRequest: AllowanceReceiptRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<AllowanceReceipt>({
    url: `/cockpit/v1.0/allowance-receipt/`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: allowanceReceiptRequest,
    signal,
  });
};

export const getAllowanceReceiptUpdateMutationKey = () =>
  ['allowanceReceiptUpdate'] as const;

export const getAllowanceReceiptUpdateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allowanceReceiptUpdate>>,
    TError,
    AllowanceReceiptUpdateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof allowanceReceiptUpdate>>,
  TError,
  AllowanceReceiptUpdateMutationVariables,
  TContext
> => {
  const mutationKey = getAllowanceReceiptUpdateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof allowanceReceiptUpdate>>,
    AllowanceReceiptUpdateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return allowanceReceiptUpdate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AllowanceReceiptUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof allowanceReceiptUpdate>>
>;
export type AllowanceReceiptUpdateMutationBody = AllowanceReceiptRequest;
export type AllowanceReceiptUpdateMutationError = unknown;
export type AllowanceReceiptUpdateMutationVariables = {
  data: AllowanceReceiptRequest;
};

export const useAllowanceReceiptUpdate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allowanceReceiptUpdate>>,
    TError,
    AllowanceReceiptUpdateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof allowanceReceiptUpdate>>,
  TError,
  AllowanceReceiptUpdateMutationVariables,
  TContext
> => {
  return useMutation(getAllowanceReceiptUpdateMutationOptions(options));
};

export const allowanceReceiptPartialUpdate = (
  patchedAllowanceReceiptUpdateRequestRequest?: PatchedAllowanceReceiptUpdateRequestRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<AllowanceReceipt>({
    url: `/cockpit/v1.0/allowance-receipt/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchedAllowanceReceiptUpdateRequestRequest,
    signal,
  });
};

export const getAllowanceReceiptPartialUpdateMutationKey = () =>
  ['allowanceReceiptPartialUpdate'] as const;

export const getAllowanceReceiptPartialUpdateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allowanceReceiptPartialUpdate>>,
    TError,
    AllowanceReceiptPartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof allowanceReceiptPartialUpdate>>,
  TError,
  AllowanceReceiptPartialUpdateMutationVariables,
  TContext
> => {
  const mutationKey = getAllowanceReceiptPartialUpdateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof allowanceReceiptPartialUpdate>>,
    AllowanceReceiptPartialUpdateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return allowanceReceiptPartialUpdate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AllowanceReceiptPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof allowanceReceiptPartialUpdate>>
>;
export type AllowanceReceiptPartialUpdateMutationBody =
  | PatchedAllowanceReceiptUpdateRequestRequest
  | undefined;
export type AllowanceReceiptPartialUpdateMutationError = unknown;
export type AllowanceReceiptPartialUpdateMutationVariables = {
  data?: PatchedAllowanceReceiptUpdateRequestRequest;
};

export const useAllowanceReceiptPartialUpdate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allowanceReceiptPartialUpdate>>,
    TError,
    AllowanceReceiptPartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof allowanceReceiptPartialUpdate>>,
  TError,
  AllowanceReceiptPartialUpdateMutationVariables,
  TContext
> => {
  return useMutation(getAllowanceReceiptPartialUpdateMutationOptions(options));
};

export const allowanceReceiptUpdate2 = (
  receiptUuid: string,
  allowanceReceiptRequest: AllowanceReceiptRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<AllowanceReceipt>({
    url: `/cockpit/v1.0/allowance-receipt/${receiptUuid}/`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: allowanceReceiptRequest,
    signal,
  });
};

export const getAllowanceReceiptUpdate2MutationKey = () =>
  ['allowanceReceiptUpdate2'] as const;

export const getAllowanceReceiptUpdate2MutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allowanceReceiptUpdate2>>,
    TError,
    AllowanceReceiptUpdate2MutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof allowanceReceiptUpdate2>>,
  TError,
  AllowanceReceiptUpdate2MutationVariables,
  TContext
> => {
  const mutationKey = getAllowanceReceiptUpdate2MutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof allowanceReceiptUpdate2>>,
    AllowanceReceiptUpdate2MutationVariables
  > = (props) => {
    const { receiptUuid, data } = props ?? {};

    return allowanceReceiptUpdate2(receiptUuid, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AllowanceReceiptUpdate2MutationResult = NonNullable<
  Awaited<ReturnType<typeof allowanceReceiptUpdate2>>
>;
export type AllowanceReceiptUpdate2MutationBody = AllowanceReceiptRequest;
export type AllowanceReceiptUpdate2MutationError = unknown;
export type AllowanceReceiptUpdate2MutationVariables = {
  receiptUuid: string;
  data: AllowanceReceiptRequest;
};

export const useAllowanceReceiptUpdate2 = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allowanceReceiptUpdate2>>,
    TError,
    AllowanceReceiptUpdate2MutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof allowanceReceiptUpdate2>>,
  TError,
  AllowanceReceiptUpdate2MutationVariables,
  TContext
> => {
  return useMutation(getAllowanceReceiptUpdate2MutationOptions(options));
};

export const allowanceReceiptPartialUpdate2 = (
  receiptUuid: string,
  patchedAllowanceReceiptUpdateRequestRequest?: PatchedAllowanceReceiptUpdateRequestRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<AllowanceReceipt>({
    url: `/cockpit/v1.0/allowance-receipt/${receiptUuid}/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchedAllowanceReceiptUpdateRequestRequest,
    signal,
  });
};

export const getAllowanceReceiptPartialUpdate2MutationKey = () =>
  ['allowanceReceiptPartialUpdate2'] as const;

export const getAllowanceReceiptPartialUpdate2MutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allowanceReceiptPartialUpdate2>>,
    TError,
    AllowanceReceiptPartialUpdate2MutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof allowanceReceiptPartialUpdate2>>,
  TError,
  AllowanceReceiptPartialUpdate2MutationVariables,
  TContext
> => {
  const mutationKey = getAllowanceReceiptPartialUpdate2MutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof allowanceReceiptPartialUpdate2>>,
    AllowanceReceiptPartialUpdate2MutationVariables
  > = (props) => {
    const { receiptUuid, data } = props ?? {};

    return allowanceReceiptPartialUpdate2(receiptUuid, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AllowanceReceiptPartialUpdate2MutationResult = NonNullable<
  Awaited<ReturnType<typeof allowanceReceiptPartialUpdate2>>
>;
export type AllowanceReceiptPartialUpdate2MutationBody =
  | PatchedAllowanceReceiptUpdateRequestRequest
  | undefined;
export type AllowanceReceiptPartialUpdate2MutationError = unknown;
export type AllowanceReceiptPartialUpdate2MutationVariables = {
  receiptUuid: string;
  data?: PatchedAllowanceReceiptUpdateRequestRequest;
};

export const useAllowanceReceiptPartialUpdate2 = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allowanceReceiptPartialUpdate2>>,
    TError,
    AllowanceReceiptPartialUpdate2MutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof allowanceReceiptPartialUpdate2>>,
  TError,
  AllowanceReceiptPartialUpdate2MutationVariables,
  TContext
> => {
  return useMutation(getAllowanceReceiptPartialUpdate2MutationOptions(options));
};

/**
 * Get allowance balance details including selection form config.
 */
export const allowancesRetrieve = (
  allowanceId: number,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<AllowanceBalanceDetailResponse>({
    url: `/cockpit/v1.0/allowances/${allowanceId}/`,
    method: 'GET',
    signal,
  });
};

export const getAllowancesRetrieveQueryKey = (allowanceId: number) => {
  return [`/cockpit/v1.0/allowances/${allowanceId}/`] as const;
};

export const getAllowancesRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof allowancesRetrieve>>,
  TError = unknown,
>(
  allowanceId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof allowancesRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAllowancesRetrieveQueryKey(allowanceId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof allowancesRetrieve>>
  > = ({ signal }) => allowancesRetrieve(allowanceId, signal);

  return {
    queryKey,
    queryFn,
    enabled: allowanceId !== null && allowanceId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof allowancesRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AllowancesRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof allowancesRetrieve>>
>;
export type AllowancesRetrieveQueryError = unknown;

export function useAllowancesRetrieve<
  TData = Awaited<ReturnType<typeof allowancesRetrieve>>,
  TError = unknown,
>(
  allowanceId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof allowancesRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAllowancesRetrieveQueryOptions(allowanceId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Update user selection for allowance balance.
 */
export const allowancesPartialUpdate = (
  allowanceId: number,
  allowancesPartialUpdateBody?:
    | AllowancesPartialUpdateBodyOne
    | AllowancesPartialUpdateBodyTwo
    | AllowancesPartialUpdateBodyThree,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<AllowanceBalanceDetailResponse>({
    url: `/cockpit/v1.0/allowances/${allowanceId}/`,
    method: 'PATCH',
    data: allowancesPartialUpdateBody,
    signal,
  });
};

export const getAllowancesPartialUpdateMutationKey = () =>
  ['allowancesPartialUpdate'] as const;

export const getAllowancesPartialUpdateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allowancesPartialUpdate>>,
    TError,
    AllowancesPartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof allowancesPartialUpdate>>,
  TError,
  AllowancesPartialUpdateMutationVariables,
  TContext
> => {
  const mutationKey = getAllowancesPartialUpdateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof allowancesPartialUpdate>>,
    AllowancesPartialUpdateMutationVariables
  > = (props) => {
    const { allowanceId, data } = props ?? {};

    return allowancesPartialUpdate(allowanceId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AllowancesPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof allowancesPartialUpdate>>
>;
export type AllowancesPartialUpdateMutationBody =
  | AllowancesPartialUpdateBodyOne
  | AllowancesPartialUpdateBodyTwo
  | AllowancesPartialUpdateBodyThree
  | undefined;
export type AllowancesPartialUpdateMutationError = unknown;
export type AllowancesPartialUpdateMutationVariables = {
  allowanceId: number;
  data?:
    | AllowancesPartialUpdateBodyOne
    | AllowancesPartialUpdateBodyTwo
    | AllowancesPartialUpdateBodyThree;
};

export const useAllowancesPartialUpdate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allowancesPartialUpdate>>,
    TError,
    AllowancesPartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof allowancesPartialUpdate>>,
  TError,
  AllowancesPartialUpdateMutationVariables,
  TContext
> => {
  return useMutation(getAllowancesPartialUpdateMutationOptions(options));
};

/**
 * Preview allowance balance evaluation without persisting changes.
 */
export const allowancesPreviewCreate = (
  allowanceId: number,
  allowancesPreviewCreateBody?:
    | AllowancesPreviewCreateBodyOne
    | AllowancesPreviewCreateBodyTwo
    | AllowancesPreviewCreateBodyThree,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<AllowanceBalanceDetailResponse>({
    url: `/cockpit/v1.0/allowances/${allowanceId}/preview/`,
    method: 'POST',
    data: allowancesPreviewCreateBody,
    signal,
  });
};

export const getAllowancesPreviewCreateMutationKey = () =>
  ['allowancesPreviewCreate'] as const;

export const getAllowancesPreviewCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allowancesPreviewCreate>>,
    TError,
    AllowancesPreviewCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof allowancesPreviewCreate>>,
  TError,
  AllowancesPreviewCreateMutationVariables,
  TContext
> => {
  const mutationKey = getAllowancesPreviewCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof allowancesPreviewCreate>>,
    AllowancesPreviewCreateMutationVariables
  > = (props) => {
    const { allowanceId, data } = props ?? {};

    return allowancesPreviewCreate(allowanceId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AllowancesPreviewCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof allowancesPreviewCreate>>
>;
export type AllowancesPreviewCreateMutationBody =
  | AllowancesPreviewCreateBodyOne
  | AllowancesPreviewCreateBodyTwo
  | AllowancesPreviewCreateBodyThree
  | undefined;
export type AllowancesPreviewCreateMutationError = unknown;
export type AllowancesPreviewCreateMutationVariables = {
  allowanceId: number;
  data?:
    | AllowancesPreviewCreateBodyOne
    | AllowancesPreviewCreateBodyTwo
    | AllowancesPreviewCreateBodyThree;
};

export const useAllowancesPreviewCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof allowancesPreviewCreate>>,
    TError,
    AllowancesPreviewCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof allowancesPreviewCreate>>,
  TError,
  AllowancesPreviewCreateMutationVariables,
  TContext
> => {
  return useMutation(getAllowancesPreviewCreateMutationOptions(options));
};

export const allowancesTransactionsList = (
  allowancePk: number,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<TransactionResponse[]>({
    url: `/cockpit/v1.0/allowances/${allowancePk}/transactions/`,
    method: 'GET',
    signal,
  });
};

export const getAllowancesTransactionsListQueryKey = (allowancePk: number) => {
  return [`/cockpit/v1.0/allowances/${allowancePk}/transactions/`] as const;
};

export const getAllowancesTransactionsListQueryOptions = <
  TData = Awaited<ReturnType<typeof allowancesTransactionsList>>,
  TError = unknown,
>(
  allowancePk: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof allowancesTransactionsList>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getAllowancesTransactionsListQueryKey(allowancePk);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof allowancesTransactionsList>>
  > = ({ signal }) => allowancesTransactionsList(allowancePk, signal);

  return {
    queryKey,
    queryFn,
    enabled: allowancePk !== null && allowancePk !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof allowancesTransactionsList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AllowancesTransactionsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof allowancesTransactionsList>>
>;
export type AllowancesTransactionsListQueryError = unknown;

export function useAllowancesTransactionsList<
  TData = Awaited<ReturnType<typeof allowancesTransactionsList>>,
  TError = unknown,
>(
  allowancePk: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof allowancesTransactionsList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAllowancesTransactionsListQueryOptions(
    allowancePk,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const bankAccountRetrieve = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<void>({
    url: `/cockpit/v1.0/bank-account/`,
    method: 'GET',
    signal,
  });
};

export const getBankAccountRetrieveQueryKey = () => {
  return [`/cockpit/v1.0/bank-account/`] as const;
};

export const getBankAccountRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof bankAccountRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof bankAccountRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getBankAccountRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof bankAccountRetrieve>>
  > = ({ signal }) => bankAccountRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof bankAccountRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type BankAccountRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof bankAccountRetrieve>>
>;
export type BankAccountRetrieveQueryError = unknown;

export function useBankAccountRetrieve<
  TData = Awaited<ReturnType<typeof bankAccountRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof bankAccountRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getBankAccountRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const bankAccountUpdate = (
  bankAccountRequest?: BankAccountRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/cockpit/v1.0/bank-account/`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: bankAccountRequest,
    signal,
  });
};

export const getBankAccountUpdateMutationKey = () =>
  ['bankAccountUpdate'] as const;

export const getBankAccountUpdateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bankAccountUpdate>>,
    TError,
    BankAccountUpdateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bankAccountUpdate>>,
  TError,
  BankAccountUpdateMutationVariables,
  TContext
> => {
  const mutationKey = getBankAccountUpdateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bankAccountUpdate>>,
    BankAccountUpdateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return bankAccountUpdate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type BankAccountUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof bankAccountUpdate>>
>;
export type BankAccountUpdateMutationBody = BankAccountRequest | undefined;
export type BankAccountUpdateMutationError = unknown;
export type BankAccountUpdateMutationVariables = { data?: BankAccountRequest };

export const useBankAccountUpdate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bankAccountUpdate>>,
    TError,
    BankAccountUpdateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof bankAccountUpdate>>,
  TError,
  BankAccountUpdateMutationVariables,
  TContext
> => {
  return useMutation(getBankAccountUpdateMutationOptions(options));
};

export const benefitAllowancesRetrieve = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<BenefitAllowancesResponse>({
    url: `/cockpit/v1.0/benefit-allowances/`,
    method: 'GET',
    signal,
  });
};

export const getBenefitAllowancesRetrieveQueryKey = () => {
  return [`/cockpit/v1.0/benefit-allowances/`] as const;
};

export const getBenefitAllowancesRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof benefitAllowancesRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof benefitAllowancesRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getBenefitAllowancesRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof benefitAllowancesRetrieve>>
  > = ({ signal }) => benefitAllowancesRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof benefitAllowancesRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type BenefitAllowancesRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof benefitAllowancesRetrieve>>
>;
export type BenefitAllowancesRetrieveQueryError = unknown;

export function useBenefitAllowancesRetrieve<
  TData = Awaited<ReturnType<typeof benefitAllowancesRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof benefitAllowancesRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getBenefitAllowancesRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const benefitsEnrolmentContributionSourcesCreate = (
  benefitPk: number,
  benefitEnrolmentContributionSourceRequestRequest: BenefitEnrolmentContributionSourceRequestRequest[],
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/cockpit/v1.0/benefits-enrolment/${benefitPk}/contribution-sources/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: benefitEnrolmentContributionSourceRequestRequest,
    signal,
  });
};

export const getBenefitsEnrolmentContributionSourcesCreateMutationKey = () =>
  ['benefitsEnrolmentContributionSourcesCreate'] as const;

export const getBenefitsEnrolmentContributionSourcesCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof benefitsEnrolmentContributionSourcesCreate>>,
    TError,
    BenefitsEnrolmentContributionSourcesCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof benefitsEnrolmentContributionSourcesCreate>>,
  TError,
  BenefitsEnrolmentContributionSourcesCreateMutationVariables,
  TContext
> => {
  const mutationKey =
    getBenefitsEnrolmentContributionSourcesCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof benefitsEnrolmentContributionSourcesCreate>>,
    BenefitsEnrolmentContributionSourcesCreateMutationVariables
  > = (props) => {
    const { benefitPk, data } = props ?? {};

    return benefitsEnrolmentContributionSourcesCreate(benefitPk, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type BenefitsEnrolmentContributionSourcesCreateMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof benefitsEnrolmentContributionSourcesCreate>>
  >;
export type BenefitsEnrolmentContributionSourcesCreateMutationBody =
  BenefitEnrolmentContributionSourceRequestRequest[];
export type BenefitsEnrolmentContributionSourcesCreateMutationError = unknown;
export type BenefitsEnrolmentContributionSourcesCreateMutationVariables = {
  benefitPk: number;
  data: BenefitEnrolmentContributionSourceRequestRequest[];
};

export const useBenefitsEnrolmentContributionSourcesCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof benefitsEnrolmentContributionSourcesCreate>>,
    TError,
    BenefitsEnrolmentContributionSourcesCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof benefitsEnrolmentContributionSourcesCreate>>,
  TError,
  BenefitsEnrolmentContributionSourcesCreateMutationVariables,
  TContext
> => {
  return useMutation(
    getBenefitsEnrolmentContributionSourcesCreateMutationOptions(options)
  );
};

export const benefitsChangesList = (
  benefitPk: number,
  params?: BenefitsChangesListParams,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<PaginatedEnrolmentChangeResponseList>({
    url: `/cockpit/v1.0/benefits/${benefitPk}/changes/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getBenefitsChangesListQueryKey = (
  benefitPk: number,
  params?: BenefitsChangesListParams
) => {
  return [
    `/cockpit/v1.0/benefits/${benefitPk}/changes/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getBenefitsChangesListQueryOptions = <
  TData = Awaited<ReturnType<typeof benefitsChangesList>>,
  TError = unknown,
>(
  benefitPk: number,
  params?: BenefitsChangesListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof benefitsChangesList>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getBenefitsChangesListQueryKey(benefitPk, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof benefitsChangesList>>
  > = ({ signal }) => benefitsChangesList(benefitPk, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: benefitPk !== null && benefitPk !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof benefitsChangesList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type BenefitsChangesListQueryResult = NonNullable<
  Awaited<ReturnType<typeof benefitsChangesList>>
>;
export type BenefitsChangesListQueryError = unknown;

export function useBenefitsChangesList<
  TData = Awaited<ReturnType<typeof benefitsChangesList>>,
  TError = unknown,
>(
  benefitPk: number,
  params?: BenefitsChangesListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof benefitsChangesList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getBenefitsChangesListQueryOptions(
    benefitPk,
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const benefitsChangesReadPartialUpdate = (
  benefitPk: number,
  patchedReadEnrolmentChangeRequestRequest?: PatchedReadEnrolmentChangeRequestRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<ReadEnrolmentChangeResponse>({
    url: `/cockpit/v1.0/benefits/${benefitPk}/changes/read/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchedReadEnrolmentChangeRequestRequest,
    signal,
  });
};

export const getBenefitsChangesReadPartialUpdateMutationKey = () =>
  ['benefitsChangesReadPartialUpdate'] as const;

export const getBenefitsChangesReadPartialUpdateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof benefitsChangesReadPartialUpdate>>,
    TError,
    BenefitsChangesReadPartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof benefitsChangesReadPartialUpdate>>,
  TError,
  BenefitsChangesReadPartialUpdateMutationVariables,
  TContext
> => {
  const mutationKey = getBenefitsChangesReadPartialUpdateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof benefitsChangesReadPartialUpdate>>,
    BenefitsChangesReadPartialUpdateMutationVariables
  > = (props) => {
    const { benefitPk, data } = props ?? {};

    return benefitsChangesReadPartialUpdate(benefitPk, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type BenefitsChangesReadPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof benefitsChangesReadPartialUpdate>>
>;
export type BenefitsChangesReadPartialUpdateMutationBody =
  | PatchedReadEnrolmentChangeRequestRequest
  | undefined;
export type BenefitsChangesReadPartialUpdateMutationError = unknown;
export type BenefitsChangesReadPartialUpdateMutationVariables = {
  benefitPk: number;
  data?: PatchedReadEnrolmentChangeRequestRequest;
};

export const useBenefitsChangesReadPartialUpdate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof benefitsChangesReadPartialUpdate>>,
    TError,
    BenefitsChangesReadPartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof benefitsChangesReadPartialUpdate>>,
  TError,
  BenefitsChangesReadPartialUpdateMutationVariables,
  TContext
> => {
  return useMutation(
    getBenefitsChangesReadPartialUpdateMutationOptions(options)
  );
};

export const benefitsFeaturesList = (
  params?: BenefitsFeaturesListParams,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<PaginatedEnrollableBenefitFeatureSerializerWithBenefitDetailsList>(
    { url: `/cockpit/v1.0/benefits/features/`, method: 'GET', params, signal }
  );
};

export const getBenefitsFeaturesListQueryKey = (
  params?: BenefitsFeaturesListParams
) => {
  return [
    `/cockpit/v1.0/benefits/features/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getBenefitsFeaturesListQueryOptions = <
  TData = Awaited<ReturnType<typeof benefitsFeaturesList>>,
  TError = unknown,
>(
  params?: BenefitsFeaturesListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof benefitsFeaturesList>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getBenefitsFeaturesListQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof benefitsFeaturesList>>
  > = ({ signal }) => benefitsFeaturesList(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof benefitsFeaturesList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type BenefitsFeaturesListQueryResult = NonNullable<
  Awaited<ReturnType<typeof benefitsFeaturesList>>
>;
export type BenefitsFeaturesListQueryError = unknown;

export function useBenefitsFeaturesList<
  TData = Awaited<ReturnType<typeof benefitsFeaturesList>>,
  TError = unknown,
>(
  params?: BenefitsFeaturesListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof benefitsFeaturesList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getBenefitsFeaturesListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const benefitsFeaturesPartialUpdate = (
  featureId: number,
  patchedEnrollableBenefitEmployeeFeatureUpdateRequest?: PatchedEnrollableBenefitEmployeeFeatureUpdateRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<EnrollableBenefitEmployeeFeatureUpdate>({
    url: `/cockpit/v1.0/benefits/features/${featureId}/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchedEnrollableBenefitEmployeeFeatureUpdateRequest,
    signal,
  });
};

export const getBenefitsFeaturesPartialUpdateMutationKey = () =>
  ['benefitsFeaturesPartialUpdate'] as const;

export const getBenefitsFeaturesPartialUpdateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof benefitsFeaturesPartialUpdate>>,
    TError,
    BenefitsFeaturesPartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof benefitsFeaturesPartialUpdate>>,
  TError,
  BenefitsFeaturesPartialUpdateMutationVariables,
  TContext
> => {
  const mutationKey = getBenefitsFeaturesPartialUpdateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof benefitsFeaturesPartialUpdate>>,
    BenefitsFeaturesPartialUpdateMutationVariables
  > = (props) => {
    const { featureId, data } = props ?? {};

    return benefitsFeaturesPartialUpdate(featureId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type BenefitsFeaturesPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof benefitsFeaturesPartialUpdate>>
>;
export type BenefitsFeaturesPartialUpdateMutationBody =
  | PatchedEnrollableBenefitEmployeeFeatureUpdateRequest
  | undefined;
export type BenefitsFeaturesPartialUpdateMutationError = unknown;
export type BenefitsFeaturesPartialUpdateMutationVariables = {
  featureId: number;
  data?: PatchedEnrollableBenefitEmployeeFeatureUpdateRequest;
};

export const useBenefitsFeaturesPartialUpdate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof benefitsFeaturesPartialUpdate>>,
    TError,
    BenefitsFeaturesPartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof benefitsFeaturesPartialUpdate>>,
  TError,
  BenefitsFeaturesPartialUpdateMutationVariables,
  TContext
> => {
  return useMutation(getBenefitsFeaturesPartialUpdateMutationOptions(options));
};

export const categorisedBenefitsRetrieve = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<ProgrammeBenefitEnrolmentResponse>({
    url: `/cockpit/v1.0/categorised-benefits/`,
    method: 'GET',
    signal,
  });
};

export const getCategorisedBenefitsRetrieveQueryKey = () => {
  return [`/cockpit/v1.0/categorised-benefits/`] as const;
};

export const getCategorisedBenefitsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof categorisedBenefitsRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof categorisedBenefitsRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getCategorisedBenefitsRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof categorisedBenefitsRetrieve>>
  > = ({ signal }) => categorisedBenefitsRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof categorisedBenefitsRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CategorisedBenefitsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof categorisedBenefitsRetrieve>>
>;
export type CategorisedBenefitsRetrieveQueryError = unknown;

export function useCategorisedBenefitsRetrieve<
  TData = Awaited<ReturnType<typeof categorisedBenefitsRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof categorisedBenefitsRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getCategorisedBenefitsRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const dashboardBenefitContributionsRetrieve = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<BenefitContributions>({
    url: `/cockpit/v1.0/dashboard/benefit-contributions/`,
    method: 'GET',
    signal,
  });
};

export const getDashboardBenefitContributionsRetrieveQueryKey = () => {
  return [`/cockpit/v1.0/dashboard/benefit-contributions/`] as const;
};

export const getDashboardBenefitContributionsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardBenefitContributionsRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof dashboardBenefitContributionsRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getDashboardBenefitContributionsRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof dashboardBenefitContributionsRetrieve>>
  > = ({ signal }) => dashboardBenefitContributionsRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardBenefitContributionsRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type DashboardBenefitContributionsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardBenefitContributionsRetrieve>>
>;
export type DashboardBenefitContributionsRetrieveQueryError = unknown;

export function useDashboardBenefitContributionsRetrieve<
  TData = Awaited<ReturnType<typeof dashboardBenefitContributionsRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof dashboardBenefitContributionsRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getDashboardBenefitContributionsRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const dashboardBenefitsRetrieve = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<DashboardBenefitsListResponse>({
    url: `/cockpit/v1.0/dashboard/benefits/`,
    method: 'GET',
    signal,
  });
};

export const getDashboardBenefitsRetrieveQueryKey = () => {
  return [`/cockpit/v1.0/dashboard/benefits/`] as const;
};

export const getDashboardBenefitsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardBenefitsRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof dashboardBenefitsRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDashboardBenefitsRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof dashboardBenefitsRetrieve>>
  > = ({ signal }) => dashboardBenefitsRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardBenefitsRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type DashboardBenefitsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardBenefitsRetrieve>>
>;
export type DashboardBenefitsRetrieveQueryError = unknown;

export function useDashboardBenefitsRetrieve<
  TData = Awaited<ReturnType<typeof dashboardBenefitsRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof dashboardBenefitsRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getDashboardBenefitsRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const dashboardRemindersRetrieve = (
  params?: DashboardRemindersRetrieveParams,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<DashboardRemindersSerializerResponse>({
    url: `/cockpit/v1.0/dashboard/reminders/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getDashboardRemindersRetrieveQueryKey = (
  params?: DashboardRemindersRetrieveParams
) => {
  return [
    `/cockpit/v1.0/dashboard/reminders/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getDashboardRemindersRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardRemindersRetrieve>>,
  TError = unknown,
>(
  params?: DashboardRemindersRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof dashboardRemindersRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDashboardRemindersRetrieveQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof dashboardRemindersRetrieve>>
  > = ({ signal }) => dashboardRemindersRetrieve(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardRemindersRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type DashboardRemindersRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardRemindersRetrieve>>
>;
export type DashboardRemindersRetrieveQueryError = unknown;

export function useDashboardRemindersRetrieve<
  TData = Awaited<ReturnType<typeof dashboardRemindersRetrieve>>,
  TError = unknown,
>(
  params?: DashboardRemindersRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof dashboardRemindersRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getDashboardRemindersRetrieveQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const dashboardYearlyCompensationRetrieve = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<DashboardYearlyCompensationResponse>({
    url: `/cockpit/v1.0/dashboard/yearly-compensation/`,
    method: 'GET',
    signal,
  });
};

export const getDashboardYearlyCompensationRetrieveQueryKey = () => {
  return [`/cockpit/v1.0/dashboard/yearly-compensation/`] as const;
};

export const getDashboardYearlyCompensationRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardYearlyCompensationRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof dashboardYearlyCompensationRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDashboardYearlyCompensationRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof dashboardYearlyCompensationRetrieve>>
  > = ({ signal }) => dashboardYearlyCompensationRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardYearlyCompensationRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type DashboardYearlyCompensationRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardYearlyCompensationRetrieve>>
>;
export type DashboardYearlyCompensationRetrieveQueryError = unknown;

export function useDashboardYearlyCompensationRetrieve<
  TData = Awaited<ReturnType<typeof dashboardYearlyCompensationRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof dashboardYearlyCompensationRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getDashboardYearlyCompensationRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const employeeAddressUpdate = (
  employeeAddressRequest: EmployeeAddressRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/cockpit/v1.0/employee-address/`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: employeeAddressRequest,
    signal,
  });
};

export const getEmployeeAddressUpdateMutationKey = () =>
  ['employeeAddressUpdate'] as const;

export const getEmployeeAddressUpdateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof employeeAddressUpdate>>,
    TError,
    EmployeeAddressUpdateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof employeeAddressUpdate>>,
  TError,
  EmployeeAddressUpdateMutationVariables,
  TContext
> => {
  const mutationKey = getEmployeeAddressUpdateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof employeeAddressUpdate>>,
    EmployeeAddressUpdateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return employeeAddressUpdate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type EmployeeAddressUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof employeeAddressUpdate>>
>;
export type EmployeeAddressUpdateMutationBody = EmployeeAddressRequest;
export type EmployeeAddressUpdateMutationError = unknown;
export type EmployeeAddressUpdateMutationVariables = {
  data: EmployeeAddressRequest;
};

export const useEmployeeAddressUpdate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof employeeAddressUpdate>>,
    TError,
    EmployeeAddressUpdateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof employeeAddressUpdate>>,
  TError,
  EmployeeAddressUpdateMutationVariables,
  TContext
> => {
  return useMutation(getEmployeeAddressUpdateMutationOptions(options));
};

export const cockpitEmployeeAndDependentsRetrieve = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<EmployeeDependent>({
    url: `/cockpit/v1.0/employee-and-dependents/`,
    method: 'GET',
    signal,
  });
};

export const getCockpitEmployeeAndDependentsRetrieveQueryKey = () => {
  return [`/cockpit/v1.0/employee-and-dependents/`] as const;
};

export const getCockpitEmployeeAndDependentsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof cockpitEmployeeAndDependentsRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof cockpitEmployeeAndDependentsRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getCockpitEmployeeAndDependentsRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof cockpitEmployeeAndDependentsRetrieve>>
  > = ({ signal }) => cockpitEmployeeAndDependentsRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof cockpitEmployeeAndDependentsRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CockpitEmployeeAndDependentsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof cockpitEmployeeAndDependentsRetrieve>>
>;
export type CockpitEmployeeAndDependentsRetrieveQueryError = unknown;

export function useCockpitEmployeeAndDependentsRetrieve<
  TData = Awaited<ReturnType<typeof cockpitEmployeeAndDependentsRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof cockpitEmployeeAndDependentsRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getCockpitEmployeeAndDependentsRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const employeeConfigPartialUpdate = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<void>({
    url: `/cockpit/v1.0/employee-config/`,
    method: 'PATCH',
    signal,
  });
};

export const getEmployeeConfigPartialUpdateMutationKey = () =>
  ['employeeConfigPartialUpdate'] as const;

export const getEmployeeConfigPartialUpdateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof employeeConfigPartialUpdate>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof employeeConfigPartialUpdate>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = getEmployeeConfigPartialUpdateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof employeeConfigPartialUpdate>>,
    void
  > = () => {
    return employeeConfigPartialUpdate();
  };

  return { mutationFn, ...mutationOptions };
};

export type EmployeeConfigPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof employeeConfigPartialUpdate>>
>;

export type EmployeeConfigPartialUpdateMutationError = unknown;

export const useEmployeeConfigPartialUpdate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof employeeConfigPartialUpdate>>,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof employeeConfigPartialUpdate>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getEmployeeConfigPartialUpdateMutationOptions(options));
};

export const employeeContactsRetrieve = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<EmployeeContact>({
    url: `/cockpit/v1.0/employee-contacts/`,
    method: 'GET',
    signal,
  });
};

export const getEmployeeContactsRetrieveQueryKey = () => {
  return [`/cockpit/v1.0/employee-contacts/`] as const;
};

export const getEmployeeContactsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof employeeContactsRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof employeeContactsRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getEmployeeContactsRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof employeeContactsRetrieve>>
  > = ({ signal }) => employeeContactsRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof employeeContactsRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type EmployeeContactsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof employeeContactsRetrieve>>
>;
export type EmployeeContactsRetrieveQueryError = unknown;

export function useEmployeeContactsRetrieve<
  TData = Awaited<ReturnType<typeof employeeContactsRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof employeeContactsRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getEmployeeContactsRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const employeeContactsCreate = (
  employeeContactRequest: EmployeeContactRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/cockpit/v1.0/employee-contacts/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: employeeContactRequest,
    signal,
  });
};

export const getEmployeeContactsCreateMutationKey = () =>
  ['employeeContactsCreate'] as const;

export const getEmployeeContactsCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof employeeContactsCreate>>,
    TError,
    EmployeeContactsCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof employeeContactsCreate>>,
  TError,
  EmployeeContactsCreateMutationVariables,
  TContext
> => {
  const mutationKey = getEmployeeContactsCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof employeeContactsCreate>>,
    EmployeeContactsCreateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return employeeContactsCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type EmployeeContactsCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof employeeContactsCreate>>
>;
export type EmployeeContactsCreateMutationBody = EmployeeContactRequest;
export type EmployeeContactsCreateMutationError = unknown;
export type EmployeeContactsCreateMutationVariables = {
  data: EmployeeContactRequest;
};

export const useEmployeeContactsCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof employeeContactsCreate>>,
    TError,
    EmployeeContactsCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof employeeContactsCreate>>,
  TError,
  EmployeeContactsCreateMutationVariables,
  TContext
> => {
  return useMutation(getEmployeeContactsCreateMutationOptions(options));
};

export const employeeContactsRetrieve2 = (id: number, signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<void>({
    url: `/cockpit/v1.0/employee-contacts/${id}/`,
    method: 'GET',
    signal,
  });
};

export const getEmployeeContactsRetrieve2QueryKey = (id: number) => {
  return [`/cockpit/v1.0/employee-contacts/${id}/`] as const;
};

export const getEmployeeContactsRetrieve2QueryOptions = <
  TData = Awaited<ReturnType<typeof employeeContactsRetrieve2>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof employeeContactsRetrieve2>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getEmployeeContactsRetrieve2QueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof employeeContactsRetrieve2>>
  > = ({ signal }) => employeeContactsRetrieve2(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof employeeContactsRetrieve2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type EmployeeContactsRetrieve2QueryResult = NonNullable<
  Awaited<ReturnType<typeof employeeContactsRetrieve2>>
>;
export type EmployeeContactsRetrieve2QueryError = unknown;

export function useEmployeeContactsRetrieve2<
  TData = Awaited<ReturnType<typeof employeeContactsRetrieve2>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof employeeContactsRetrieve2>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getEmployeeContactsRetrieve2QueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const employeeContactsUpdate = (
  id: number,
  employeeContactRequest: EmployeeContactRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/cockpit/v1.0/employee-contacts/${id}/`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: employeeContactRequest,
    signal,
  });
};

export const getEmployeeContactsUpdateMutationKey = () =>
  ['employeeContactsUpdate'] as const;

export const getEmployeeContactsUpdateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof employeeContactsUpdate>>,
    TError,
    EmployeeContactsUpdateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof employeeContactsUpdate>>,
  TError,
  EmployeeContactsUpdateMutationVariables,
  TContext
> => {
  const mutationKey = getEmployeeContactsUpdateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof employeeContactsUpdate>>,
    EmployeeContactsUpdateMutationVariables
  > = (props) => {
    const { id, data } = props ?? {};

    return employeeContactsUpdate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type EmployeeContactsUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof employeeContactsUpdate>>
>;
export type EmployeeContactsUpdateMutationBody = EmployeeContactRequest;
export type EmployeeContactsUpdateMutationError = unknown;
export type EmployeeContactsUpdateMutationVariables = {
  id: number;
  data: EmployeeContactRequest;
};

export const useEmployeeContactsUpdate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof employeeContactsUpdate>>,
    TError,
    EmployeeContactsUpdateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof employeeContactsUpdate>>,
  TError,
  EmployeeContactsUpdateMutationVariables,
  TContext
> => {
  return useMutation(getEmployeeContactsUpdateMutationOptions(options));
};

export const employeeContactsDestroy = (id: number, signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<void>({
    url: `/cockpit/v1.0/employee-contacts/${id}/`,
    method: 'DELETE',
    signal,
  });
};

export const getEmployeeContactsDestroyMutationKey = () =>
  ['employeeContactsDestroy'] as const;

export const getEmployeeContactsDestroyMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof employeeContactsDestroy>>,
    TError,
    EmployeeContactsDestroyMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof employeeContactsDestroy>>,
  TError,
  EmployeeContactsDestroyMutationVariables,
  TContext
> => {
  const mutationKey = getEmployeeContactsDestroyMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof employeeContactsDestroy>>,
    EmployeeContactsDestroyMutationVariables
  > = (props) => {
    const { id } = props ?? {};

    return employeeContactsDestroy(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type EmployeeContactsDestroyMutationResult = NonNullable<
  Awaited<ReturnType<typeof employeeContactsDestroy>>
>;

export type EmployeeContactsDestroyMutationError = unknown;
export type EmployeeContactsDestroyMutationVariables = { id: number };

export const useEmployeeContactsDestroy = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof employeeContactsDestroy>>,
    TError,
    EmployeeContactsDestroyMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof employeeContactsDestroy>>,
  TError,
  EmployeeContactsDestroyMutationVariables,
  TContext
> => {
  return useMutation(getEmployeeContactsDestroyMutationOptions(options));
};

export const employeeProfileRetrieve = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<EmployeeProfile>({
    url: `/cockpit/v1.0/employee-profile/`,
    method: 'GET',
    signal,
  });
};

export const getEmployeeProfileRetrieveQueryKey = () => {
  return [`/cockpit/v1.0/employee-profile/`] as const;
};

export const getEmployeeProfileRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof employeeProfileRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof employeeProfileRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getEmployeeProfileRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof employeeProfileRetrieve>>
  > = ({ signal }) => employeeProfileRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof employeeProfileRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type EmployeeProfileRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof employeeProfileRetrieve>>
>;
export type EmployeeProfileRetrieveQueryError = unknown;

export function useEmployeeProfileRetrieve<
  TData = Awaited<ReturnType<typeof employeeProfileRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof employeeProfileRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getEmployeeProfileRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Used for welcome flow, triggered by first login or by missing profile data
 * required for benefit enrolment
 */
export const employeeProfileUpdate = (
  employeeProfileRequest?: EmployeeProfileRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<EmployeeProfile>({
    url: `/cockpit/v1.0/employee-profile/`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: employeeProfileRequest,
    signal,
  });
};

export const getEmployeeProfileUpdateMutationKey = () =>
  ['employeeProfileUpdate'] as const;

export const getEmployeeProfileUpdateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof employeeProfileUpdate>>,
    TError,
    EmployeeProfileUpdateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof employeeProfileUpdate>>,
  TError,
  EmployeeProfileUpdateMutationVariables,
  TContext
> => {
  const mutationKey = getEmployeeProfileUpdateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof employeeProfileUpdate>>,
    EmployeeProfileUpdateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return employeeProfileUpdate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type EmployeeProfileUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof employeeProfileUpdate>>
>;
export type EmployeeProfileUpdateMutationBody =
  | EmployeeProfileRequest
  | undefined;
export type EmployeeProfileUpdateMutationError = unknown;
export type EmployeeProfileUpdateMutationVariables = {
  data?: EmployeeProfileRequest;
};

export const useEmployeeProfileUpdate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof employeeProfileUpdate>>,
    TError,
    EmployeeProfileUpdateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof employeeProfileUpdate>>,
  TError,
  EmployeeProfileUpdateMutationVariables,
  TContext
> => {
  return useMutation(getEmployeeProfileUpdateMutationOptions(options));
};

export const employeeProfilePartialUpdate = (
  patchedEmployeeProfileRequest?: PatchedEmployeeProfileRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<EmployeeProfile>({
    url: `/cockpit/v1.0/employee-profile/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchedEmployeeProfileRequest,
    signal,
  });
};

export const getEmployeeProfilePartialUpdateMutationKey = () =>
  ['employeeProfilePartialUpdate'] as const;

export const getEmployeeProfilePartialUpdateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof employeeProfilePartialUpdate>>,
    TError,
    EmployeeProfilePartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof employeeProfilePartialUpdate>>,
  TError,
  EmployeeProfilePartialUpdateMutationVariables,
  TContext
> => {
  const mutationKey = getEmployeeProfilePartialUpdateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof employeeProfilePartialUpdate>>,
    EmployeeProfilePartialUpdateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return employeeProfilePartialUpdate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type EmployeeProfilePartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof employeeProfilePartialUpdate>>
>;
export type EmployeeProfilePartialUpdateMutationBody =
  | PatchedEmployeeProfileRequest
  | undefined;
export type EmployeeProfilePartialUpdateMutationError = unknown;
export type EmployeeProfilePartialUpdateMutationVariables = {
  data?: PatchedEmployeeProfileRequest;
};

export const useEmployeeProfilePartialUpdate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof employeeProfilePartialUpdate>>,
    TError,
    EmployeeProfilePartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof employeeProfilePartialUpdate>>,
  TError,
  EmployeeProfilePartialUpdateMutationVariables,
  TContext
> => {
  return useMutation(getEmployeeProfilePartialUpdateMutationOptions(options));
};

export const employeeProfileConfigRetrieve = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<EmployeeProfileConfigResponse>({
    url: `/cockpit/v1.0/employee-profile/config`,
    method: 'GET',
    signal,
  });
};

export const getEmployeeProfileConfigRetrieveQueryKey = () => {
  return [`/cockpit/v1.0/employee-profile/config`] as const;
};

export const getEmployeeProfileConfigRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof employeeProfileConfigRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof employeeProfileConfigRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getEmployeeProfileConfigRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof employeeProfileConfigRetrieve>>
  > = ({ signal }) => employeeProfileConfigRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof employeeProfileConfigRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type EmployeeProfileConfigRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof employeeProfileConfigRetrieve>>
>;
export type EmployeeProfileConfigRetrieveQueryError = unknown;

export function useEmployeeProfileConfigRetrieve<
  TData = Awaited<ReturnType<typeof employeeProfileConfigRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof employeeProfileConfigRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getEmployeeProfileConfigRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const employeeIntentProfilePartialUpdate = (
  patchedIntentProfileRequest?: PatchedIntentProfileRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<IntentProfileResponse>({
    url: `/cockpit/v1.0/employee/intent-profile/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchedIntentProfileRequest,
    signal,
  });
};

export const getEmployeeIntentProfilePartialUpdateMutationKey = () =>
  ['employeeIntentProfilePartialUpdate'] as const;

export const getEmployeeIntentProfilePartialUpdateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof employeeIntentProfilePartialUpdate>>,
    TError,
    EmployeeIntentProfilePartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof employeeIntentProfilePartialUpdate>>,
  TError,
  EmployeeIntentProfilePartialUpdateMutationVariables,
  TContext
> => {
  const mutationKey = getEmployeeIntentProfilePartialUpdateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof employeeIntentProfilePartialUpdate>>,
    EmployeeIntentProfilePartialUpdateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return employeeIntentProfilePartialUpdate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type EmployeeIntentProfilePartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof employeeIntentProfilePartialUpdate>>
>;
export type EmployeeIntentProfilePartialUpdateMutationBody =
  | PatchedIntentProfileRequest
  | undefined;
export type EmployeeIntentProfilePartialUpdateMutationError = unknown;
export type EmployeeIntentProfilePartialUpdateMutationVariables = {
  data?: PatchedIntentProfileRequest;
};

export const useEmployeeIntentProfilePartialUpdate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof employeeIntentProfilePartialUpdate>>,
    TError,
    EmployeeIntentProfilePartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof employeeIntentProfilePartialUpdate>>,
  TError,
  EmployeeIntentProfilePartialUpdateMutationVariables,
  TContext
> => {
  return useMutation(
    getEmployeeIntentProfilePartialUpdateMutationOptions(options)
  );
};

export const employeeNetPayEstimateRetrieve = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<EmployeeNetPayEstimateResponse>({
    url: `/cockpit/v1.0/employee/net-pay-estimate/`,
    method: 'GET',
    signal,
  });
};

export const getEmployeeNetPayEstimateRetrieveQueryKey = () => {
  return [`/cockpit/v1.0/employee/net-pay-estimate/`] as const;
};

export const getEmployeeNetPayEstimateRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof employeeNetPayEstimateRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof employeeNetPayEstimateRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getEmployeeNetPayEstimateRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof employeeNetPayEstimateRetrieve>>
  > = ({ signal }) => employeeNetPayEstimateRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof employeeNetPayEstimateRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type EmployeeNetPayEstimateRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof employeeNetPayEstimateRetrieve>>
>;
export type EmployeeNetPayEstimateRetrieveQueryError = unknown;

export function useEmployeeNetPayEstimateRetrieve<
  TData = Awaited<ReturnType<typeof employeeNetPayEstimateRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof employeeNetPayEstimateRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getEmployeeNetPayEstimateRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Returns a list of all employees for the given employer.
 */
export const employeesRetrieve = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<PublicEmployeeResponse>({
    url: `/cockpit/v1.0/employees/`,
    method: 'GET',
    signal,
  });
};

export const getEmployeesRetrieveQueryKey = () => {
  return [`/cockpit/v1.0/employees/`] as const;
};

export const getEmployeesRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof employeesRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof employeesRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getEmployeesRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof employeesRetrieve>>
  > = ({ signal }) => employeesRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof employeesRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type EmployeesRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof employeesRetrieve>>
>;
export type EmployeesRetrieveQueryError = unknown;

export function useEmployeesRetrieve<
  TData = Awaited<ReturnType<typeof employeesRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof employeesRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getEmployeesRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const employerExternalLinksList = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<EmployerExternalLink[]>({
    url: `/cockpit/v1.0/employer-external-links/`,
    method: 'GET',
    signal,
  });
};

export const getEmployerExternalLinksListQueryKey = () => {
  return [`/cockpit/v1.0/employer-external-links/`] as const;
};

export const getEmployerExternalLinksListQueryOptions = <
  TData = Awaited<ReturnType<typeof employerExternalLinksList>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof employerExternalLinksList>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getEmployerExternalLinksListQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof employerExternalLinksList>>
  > = ({ signal }) => employerExternalLinksList(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof employerExternalLinksList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type EmployerExternalLinksListQueryResult = NonNullable<
  Awaited<ReturnType<typeof employerExternalLinksList>>
>;
export type EmployerExternalLinksListQueryError = unknown;

export function useEmployerExternalLinksList<
  TData = Awaited<ReturnType<typeof employerExternalLinksList>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof employerExternalLinksList>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getEmployerExternalLinksListQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const employerRetrieve = (hostname: string, signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<LoginMetadataResponse>({
    url: `/cockpit/v1.0/employer/${hostname}/`,
    method: 'GET',
    signal,
  });
};

export const getEmployerRetrieveQueryKey = (hostname: string) => {
  return [`/cockpit/v1.0/employer/${hostname}/`] as const;
};

export const getEmployerRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof employerRetrieve>>,
  TError = unknown,
>(
  hostname: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof employerRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getEmployerRetrieveQueryKey(hostname);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof employerRetrieve>>
  > = ({ signal }) => employerRetrieve(hostname, signal);

  return {
    queryKey,
    queryFn,
    enabled: hostname !== null && hostname !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof employerRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type EmployerRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof employerRetrieve>>
>;
export type EmployerRetrieveQueryError = unknown;

export function useEmployerRetrieve<
  TData = Awaited<ReturnType<typeof employerRetrieve>>,
  TError = unknown,
>(
  hostname: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof employerRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getEmployerRetrieveQueryOptions(hostname, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const equityModelerCalculateCreate = (
  equityModelerCalculateRequestRequest: EquityModelerCalculateRequestRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<EquityModelerCalculateResponse>({
    url: `/cockpit/v1.0/equity-modeler/calculate/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: equityModelerCalculateRequestRequest,
    signal,
  });
};

export const getEquityModelerCalculateCreateMutationKey = () =>
  ['equityModelerCalculateCreate'] as const;

export const getEquityModelerCalculateCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof equityModelerCalculateCreate>>,
    TError,
    EquityModelerCalculateCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof equityModelerCalculateCreate>>,
  TError,
  EquityModelerCalculateCreateMutationVariables,
  TContext
> => {
  const mutationKey = getEquityModelerCalculateCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof equityModelerCalculateCreate>>,
    EquityModelerCalculateCreateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return equityModelerCalculateCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type EquityModelerCalculateCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof equityModelerCalculateCreate>>
>;
export type EquityModelerCalculateCreateMutationBody =
  EquityModelerCalculateRequestRequest;
export type EquityModelerCalculateCreateMutationError = unknown;
export type EquityModelerCalculateCreateMutationVariables = {
  data: EquityModelerCalculateRequestRequest;
};

export const useEquityModelerCalculateCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof equityModelerCalculateCreate>>,
    TError,
    EquityModelerCalculateCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof equityModelerCalculateCreate>>,
  TError,
  EquityModelerCalculateCreateMutationVariables,
  TContext
> => {
  return useMutation(getEquityModelerCalculateCreateMutationOptions(options));
};

export const equityModelerEmployeeStateRetrieve = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<EquityModelerEmployeeStateResponse>({
    url: `/cockpit/v1.0/equity-modeler/employee-state/`,
    method: 'GET',
    signal,
  });
};

export const getEquityModelerEmployeeStateRetrieveQueryKey = () => {
  return [`/cockpit/v1.0/equity-modeler/employee-state/`] as const;
};

export const getEquityModelerEmployeeStateRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof equityModelerEmployeeStateRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof equityModelerEmployeeStateRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getEquityModelerEmployeeStateRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof equityModelerEmployeeStateRetrieve>>
  > = ({ signal }) => equityModelerEmployeeStateRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof equityModelerEmployeeStateRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type EquityModelerEmployeeStateRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof equityModelerEmployeeStateRetrieve>>
>;
export type EquityModelerEmployeeStateRetrieveQueryError = unknown;

export function useEquityModelerEmployeeStateRetrieve<
  TData = Awaited<ReturnType<typeof equityModelerEmployeeStateRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof equityModelerEmployeeStateRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getEquityModelerEmployeeStateRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const equityModelerPageContextRetrieve = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<EquityModelerPageContextResponse>({
    url: `/cockpit/v1.0/equity-modeler/page-context/`,
    method: 'GET',
    signal,
  });
};

export const getEquityModelerPageContextRetrieveQueryKey = () => {
  return [`/cockpit/v1.0/equity-modeler/page-context/`] as const;
};

export const getEquityModelerPageContextRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof equityModelerPageContextRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof equityModelerPageContextRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getEquityModelerPageContextRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof equityModelerPageContextRetrieve>>
  > = ({ signal }) => equityModelerPageContextRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof equityModelerPageContextRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type EquityModelerPageContextRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof equityModelerPageContextRetrieve>>
>;
export type EquityModelerPageContextRetrieveQueryError = unknown;

export function useEquityModelerPageContextRetrieve<
  TData = Awaited<ReturnType<typeof equityModelerPageContextRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof equityModelerPageContextRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getEquityModelerPageContextRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const featuredProvidersRetrieve = (id: number, signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<FeaturedProviderResponse>({
    url: `/cockpit/v1.0/featured-providers/${id}/`,
    method: 'GET',
    signal,
  });
};

export const getFeaturedProvidersRetrieveQueryKey = (id: number) => {
  return [`/cockpit/v1.0/featured-providers/${id}/`] as const;
};

export const getFeaturedProvidersRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof featuredProvidersRetrieve>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof featuredProvidersRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getFeaturedProvidersRetrieveQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof featuredProvidersRetrieve>>
  > = ({ signal }) => featuredProvidersRetrieve(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof featuredProvidersRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type FeaturedProvidersRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof featuredProvidersRetrieve>>
>;
export type FeaturedProvidersRetrieveQueryError = unknown;

export function useFeaturedProvidersRetrieve<
  TData = Awaited<ReturnType<typeof featuredProvidersRetrieve>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof featuredProvidersRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getFeaturedProvidersRetrieveQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Returns a paginated list of recognitions for the given employee and visibility.
 * The list can be sorted, searched and filtered.
 */
export const filteredRecognitionsCreate = (
  eaRecognitionsListRequestRequest: EaRecognitionsListRequestRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<RecognitionsListResponse>({
    url: `/cockpit/v1.0/filtered-recognitions/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: eaRecognitionsListRequestRequest,
    signal,
  });
};

export const getFilteredRecognitionsCreateMutationKey = () =>
  ['filteredRecognitionsCreate'] as const;

export const getFilteredRecognitionsCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof filteredRecognitionsCreate>>,
    TError,
    FilteredRecognitionsCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof filteredRecognitionsCreate>>,
  TError,
  FilteredRecognitionsCreateMutationVariables,
  TContext
> => {
  const mutationKey = getFilteredRecognitionsCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof filteredRecognitionsCreate>>,
    FilteredRecognitionsCreateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return filteredRecognitionsCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type FilteredRecognitionsCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof filteredRecognitionsCreate>>
>;
export type FilteredRecognitionsCreateMutationBody =
  EaRecognitionsListRequestRequest;
export type FilteredRecognitionsCreateMutationError = unknown;
export type FilteredRecognitionsCreateMutationVariables = {
  data: EaRecognitionsListRequestRequest;
};

export const useFilteredRecognitionsCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof filteredRecognitionsCreate>>,
    TError,
    FilteredRecognitionsCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof filteredRecognitionsCreate>>,
  TError,
  FilteredRecognitionsCreateMutationVariables,
  TContext
> => {
  return useMutation(getFilteredRecognitionsCreateMutationOptions(options));
};

export const fundRequestUpdate = (
  fundRequestRequest: FundRequestRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/cockpit/v1.0/fund-request/`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: fundRequestRequest,
    signal,
  });
};

export const getFundRequestUpdateMutationKey = () =>
  ['fundRequestUpdate'] as const;

export const getFundRequestUpdateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof fundRequestUpdate>>,
    TError,
    FundRequestUpdateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof fundRequestUpdate>>,
  TError,
  FundRequestUpdateMutationVariables,
  TContext
> => {
  const mutationKey = getFundRequestUpdateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof fundRequestUpdate>>,
    FundRequestUpdateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return fundRequestUpdate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type FundRequestUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof fundRequestUpdate>>
>;
export type FundRequestUpdateMutationBody = FundRequestRequest;
export type FundRequestUpdateMutationError = unknown;
export type FundRequestUpdateMutationVariables = { data: FundRequestRequest };

export const useFundRequestUpdate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof fundRequestUpdate>>,
    TError,
    FundRequestUpdateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof fundRequestUpdate>>,
  TError,
  FundRequestUpdateMutationVariables,
  TContext
> => {
  return useMutation(getFundRequestUpdateMutationOptions(options));
};

export const fundRequestDetailRetrieve = (
  fundRequestUuid: string,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<FundRequestResponse>({
    url: `/cockpit/v1.0/fund-request/${fundRequestUuid}/detail/`,
    method: 'GET',
    signal,
  });
};

export const getFundRequestDetailRetrieveQueryKey = (
  fundRequestUuid: string
) => {
  return [`/cockpit/v1.0/fund-request/${fundRequestUuid}/detail/`] as const;
};

export const getFundRequestDetailRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof fundRequestDetailRetrieve>>,
  TError = unknown,
>(
  fundRequestUuid: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof fundRequestDetailRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getFundRequestDetailRetrieveQueryKey(fundRequestUuid);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof fundRequestDetailRetrieve>>
  > = ({ signal }) => fundRequestDetailRetrieve(fundRequestUuid, signal);

  return {
    queryKey,
    queryFn,
    enabled: fundRequestUuid !== null && fundRequestUuid !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof fundRequestDetailRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type FundRequestDetailRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof fundRequestDetailRetrieve>>
>;
export type FundRequestDetailRetrieveQueryError = unknown;

export function useFundRequestDetailRetrieve<
  TData = Awaited<ReturnType<typeof fundRequestDetailRetrieve>>,
  TError = unknown,
>(
  fundRequestUuid: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof fundRequestDetailRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getFundRequestDetailRetrieveQueryOptions(
    fundRequestUuid,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const goalsList = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<Goal[]>({
    url: `/cockpit/v1.0/goals/`,
    method: 'GET',
    signal,
  });
};

export const getGoalsListQueryKey = () => {
  return [`/cockpit/v1.0/goals/`] as const;
};

export const getGoalsListQueryOptions = <
  TData = Awaited<ReturnType<typeof goalsList>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof goalsList>>, TError, TData>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGoalsListQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof goalsList>>> = ({
    signal,
  }) => goalsList(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof goalsList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GoalsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof goalsList>>
>;
export type GoalsListQueryError = unknown;

export function useGoalsList<
  TData = Awaited<ReturnType<typeof goalsList>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof goalsList>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGoalsListQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const goalsNeedsList = (slug: string, signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<Need[]>({
    url: `/cockpit/v1.0/goals/${slug}/needs/`,
    method: 'GET',
    signal,
  });
};

export const getGoalsNeedsListQueryKey = (slug: string) => {
  return [`/cockpit/v1.0/goals/${slug}/needs/`] as const;
};

export const getGoalsNeedsListQueryOptions = <
  TData = Awaited<ReturnType<typeof goalsNeedsList>>,
  TError = unknown,
>(
  slug: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof goalsNeedsList>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGoalsNeedsListQueryKey(slug);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof goalsNeedsList>>> = ({
    signal,
  }) => goalsNeedsList(slug, signal);

  return {
    queryKey,
    queryFn,
    enabled: slug !== null && slug !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof goalsNeedsList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GoalsNeedsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof goalsNeedsList>>
>;
export type GoalsNeedsListQueryError = unknown;

export function useGoalsNeedsList<
  TData = Awaited<ReturnType<typeof goalsNeedsList>>,
  TError = unknown,
>(
  slug: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof goalsNeedsList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGoalsNeedsListQueryOptions(slug, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const homeScreenCarouselList = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<HomeScreenCarouselResponse[]>({
    url: `/cockpit/v1.0/home-screen-carousel/`,
    method: 'GET',
    signal,
  });
};

export const getHomeScreenCarouselListQueryKey = () => {
  return [`/cockpit/v1.0/home-screen-carousel/`] as const;
};

export const getHomeScreenCarouselListQueryOptions = <
  TData = Awaited<ReturnType<typeof homeScreenCarouselList>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof homeScreenCarouselList>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getHomeScreenCarouselListQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof homeScreenCarouselList>>
  > = ({ signal }) => homeScreenCarouselList(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof homeScreenCarouselList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HomeScreenCarouselListQueryResult = NonNullable<
  Awaited<ReturnType<typeof homeScreenCarouselList>>
>;
export type HomeScreenCarouselListQueryError = unknown;

export function useHomeScreenCarouselList<
  TData = Awaited<ReturnType<typeof homeScreenCarouselList>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof homeScreenCarouselList>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHomeScreenCarouselListQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const homepageBlocksRetrieve = (
  blockId: string,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<HomepageBlockResponse>({
    url: `/cockpit/v1.0/homepage/blocks/${blockId}/`,
    method: 'GET',
    signal,
  });
};

export const getHomepageBlocksRetrieveQueryKey = (blockId: string) => {
  return [`/cockpit/v1.0/homepage/blocks/${blockId}/`] as const;
};

export const getHomepageBlocksRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof homepageBlocksRetrieve>>,
  TError = unknown,
>(
  blockId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof homepageBlocksRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getHomepageBlocksRetrieveQueryKey(blockId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof homepageBlocksRetrieve>>
  > = ({ signal }) => homepageBlocksRetrieve(blockId, signal);

  return {
    queryKey,
    queryFn,
    enabled: blockId !== null && blockId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof homepageBlocksRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HomepageBlocksRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof homepageBlocksRetrieve>>
>;
export type HomepageBlocksRetrieveQueryError = unknown;

export function useHomepageBlocksRetrieve<
  TData = Awaited<ReturnType<typeof homepageBlocksRetrieve>>,
  TError = unknown,
>(
  blockId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof homepageBlocksRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHomepageBlocksRetrieveQueryOptions(blockId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const homepageLayoutRetrieve = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<EaHomepageLayoutResponse>({
    url: `/cockpit/v1.0/homepage/layout/`,
    method: 'GET',
    signal,
  });
};

export const getHomepageLayoutRetrieveQueryKey = () => {
  return [`/cockpit/v1.0/homepage/layout/`] as const;
};

export const getHomepageLayoutRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof homepageLayoutRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof homepageLayoutRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getHomepageLayoutRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof homepageLayoutRetrieve>>
  > = ({ signal }) => homepageLayoutRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof homepageLayoutRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HomepageLayoutRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof homepageLayoutRetrieve>>
>;
export type HomepageLayoutRetrieveQueryError = unknown;

export function useHomepageLayoutRetrieve<
  TData = Awaited<ReturnType<typeof homepageLayoutRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof homepageLayoutRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHomepageLayoutRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const homepageMomentsList = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<MomentGroup[]>({
    url: `/cockpit/v1.0/homepage/moments/`,
    method: 'GET',
    signal,
  });
};

export const getHomepageMomentsListQueryKey = () => {
  return [`/cockpit/v1.0/homepage/moments/`] as const;
};

export const getHomepageMomentsListQueryOptions = <
  TData = Awaited<ReturnType<typeof homepageMomentsList>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof homepageMomentsList>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getHomepageMomentsListQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof homepageMomentsList>>
  > = ({ signal }) => homepageMomentsList(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof homepageMomentsList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HomepageMomentsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof homepageMomentsList>>
>;
export type HomepageMomentsListQueryError = unknown;

export function useHomepageMomentsList<
  TData = Awaited<ReturnType<typeof homepageMomentsList>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof homepageMomentsList>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHomepageMomentsListQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const lifeEventRetrieve = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<LifeEventRetrieve200>({
    url: `/cockpit/v1.0/life-event/`,
    method: 'GET',
    signal,
  });
};

export const getLifeEventRetrieveQueryKey = () => {
  return [`/cockpit/v1.0/life-event/`] as const;
};

export const getLifeEventRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof lifeEventRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof lifeEventRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getLifeEventRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof lifeEventRetrieve>>
  > = ({ signal }) => lifeEventRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof lifeEventRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type LifeEventRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof lifeEventRetrieve>>
>;
export type LifeEventRetrieveQueryError = unknown;

export function useLifeEventRetrieve<
  TData = Awaited<ReturnType<typeof lifeEventRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof lifeEventRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getLifeEventRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const lifeEventCreate = (
  lifeEventRequestRequest: LifeEventRequestRequest,
  signal?: AbortSignal
) => {
  const formData = new FormData();
  formData.append(`life_event_type`, lifeEventRequestRequest.life_event_type);
  if (lifeEventRequestRequest.custom_life_event !== undefined) {
    formData.append(
      `custom_life_event`,
      lifeEventRequestRequest.custom_life_event
    );
  }
  if (
    lifeEventRequestRequest.event_date !== undefined &&
    lifeEventRequestRequest.event_date !== null
  ) {
    formData.append(`event_date`, lifeEventRequestRequest.event_date);
  }
  if (
    lifeEventRequestRequest.document !== undefined &&
    lifeEventRequestRequest.document !== null
  ) {
    formData.append(`document`, lifeEventRequestRequest.document);
  }

  return axiosOrvalCustomInstance<LifeEventRequest>({
    url: `/cockpit/v1.0/life-event/`,
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
    signal,
  });
};

export const getLifeEventCreateMutationKey = () => ['lifeEventCreate'] as const;

export const getLifeEventCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof lifeEventCreate>>,
    TError,
    LifeEventCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof lifeEventCreate>>,
  TError,
  LifeEventCreateMutationVariables,
  TContext
> => {
  const mutationKey = getLifeEventCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof lifeEventCreate>>,
    LifeEventCreateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return lifeEventCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type LifeEventCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof lifeEventCreate>>
>;
export type LifeEventCreateMutationBody = LifeEventRequestRequest;
export type LifeEventCreateMutationError = unknown;
export type LifeEventCreateMutationVariables = {
  data: LifeEventRequestRequest;
};

export const useLifeEventCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof lifeEventCreate>>,
    TError,
    LifeEventCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof lifeEventCreate>>,
  TError,
  LifeEventCreateMutationVariables,
  TContext
> => {
  return useMutation(getLifeEventCreateMutationOptions(options));
};

export const lifeEventBenefitsList = (
  lifeEvent: string,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<BenefitLifeEventResponse[]>({
    url: `/cockpit/v1.0/life-event/${lifeEvent}/benefits/`,
    method: 'GET',
    signal,
  });
};

export const getLifeEventBenefitsListQueryKey = (lifeEvent: string) => {
  return [`/cockpit/v1.0/life-event/${lifeEvent}/benefits/`] as const;
};

export const getLifeEventBenefitsListQueryOptions = <
  TData = Awaited<ReturnType<typeof lifeEventBenefitsList>>,
  TError = unknown,
>(
  lifeEvent: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof lifeEventBenefitsList>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getLifeEventBenefitsListQueryKey(lifeEvent);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof lifeEventBenefitsList>>
  > = ({ signal }) => lifeEventBenefitsList(lifeEvent, signal);

  return {
    queryKey,
    queryFn,
    enabled: lifeEvent !== null && lifeEvent !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof lifeEventBenefitsList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type LifeEventBenefitsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof lifeEventBenefitsList>>
>;
export type LifeEventBenefitsListQueryError = unknown;

export function useLifeEventBenefitsList<
  TData = Awaited<ReturnType<typeof lifeEventBenefitsList>>,
  TError = unknown,
>(
  lifeEvent: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof lifeEventBenefitsList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getLifeEventBenefitsListQueryOptions(lifeEvent, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const loginWithPasswordCreate = (
  loginRequestRequest: LoginRequestRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<LoginResponse>({
    url: `/cockpit/v1.0/login-with-password/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: loginRequestRequest,
    signal,
  });
};

export const getLoginWithPasswordCreateMutationKey = () =>
  ['loginWithPasswordCreate'] as const;

export const getLoginWithPasswordCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof loginWithPasswordCreate>>,
    TError,
    LoginWithPasswordCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof loginWithPasswordCreate>>,
  TError,
  LoginWithPasswordCreateMutationVariables,
  TContext
> => {
  const mutationKey = getLoginWithPasswordCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof loginWithPasswordCreate>>,
    LoginWithPasswordCreateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return loginWithPasswordCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type LoginWithPasswordCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof loginWithPasswordCreate>>
>;
export type LoginWithPasswordCreateMutationBody = LoginRequestRequest;
export type LoginWithPasswordCreateMutationError = unknown;
export type LoginWithPasswordCreateMutationVariables = {
  data: LoginRequestRequest;
};

export const useLoginWithPasswordCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof loginWithPasswordCreate>>,
    TError,
    LoginWithPasswordCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof loginWithPasswordCreate>>,
  TError,
  LoginWithPasswordCreateMutationVariables,
  TContext
> => {
  return useMutation(getLoginWithPasswordCreateMutationOptions(options));
};

export const lostPasscodeResumeCreate = (
  lostPasscodeResumeRequestRequest: LostPasscodeResumeRequestRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/cockpit/v1.0/lost-passcode-resume/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: lostPasscodeResumeRequestRequest,
    signal,
  });
};

export const getLostPasscodeResumeCreateMutationKey = () =>
  ['lostPasscodeResumeCreate'] as const;

export const getLostPasscodeResumeCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof lostPasscodeResumeCreate>>,
    TError,
    LostPasscodeResumeCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof lostPasscodeResumeCreate>>,
  TError,
  LostPasscodeResumeCreateMutationVariables,
  TContext
> => {
  const mutationKey = getLostPasscodeResumeCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof lostPasscodeResumeCreate>>,
    LostPasscodeResumeCreateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return lostPasscodeResumeCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type LostPasscodeResumeCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof lostPasscodeResumeCreate>>
>;
export type LostPasscodeResumeCreateMutationBody =
  LostPasscodeResumeRequestRequest;
export type LostPasscodeResumeCreateMutationError = unknown;
export type LostPasscodeResumeCreateMutationVariables = {
  data: LostPasscodeResumeRequestRequest;
};

export const useLostPasscodeResumeCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof lostPasscodeResumeCreate>>,
    TError,
    LostPasscodeResumeCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof lostPasscodeResumeCreate>>,
  TError,
  LostPasscodeResumeCreateMutationVariables,
  TContext
> => {
  return useMutation(getLostPasscodeResumeCreateMutationOptions(options));
};

export const lostPasscodeStartCreate = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<void>({
    url: `/cockpit/v1.0/lost-passcode-start/`,
    method: 'POST',
    signal,
  });
};

export const getLostPasscodeStartCreateMutationKey = () =>
  ['lostPasscodeStartCreate'] as const;

export const getLostPasscodeStartCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof lostPasscodeStartCreate>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof lostPasscodeStartCreate>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = getLostPasscodeStartCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof lostPasscodeStartCreate>>,
    void
  > = () => {
    return lostPasscodeStartCreate();
  };

  return { mutationFn, ...mutationOptions };
};

export type LostPasscodeStartCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof lostPasscodeStartCreate>>
>;

export type LostPasscodeStartCreateMutationError = unknown;

export const useLostPasscodeStartCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof lostPasscodeStartCreate>>,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof lostPasscodeStartCreate>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getLostPasscodeStartCreateMutationOptions(options));
};

export const managedCardDetailsListRetrieve = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<void>({
    url: `/cockpit/v1.0/managed-card-details-list/`,
    method: 'GET',
    signal,
  });
};

export const getManagedCardDetailsListRetrieveQueryKey = () => {
  return [`/cockpit/v1.0/managed-card-details-list/`] as const;
};

export const getManagedCardDetailsListRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof managedCardDetailsListRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof managedCardDetailsListRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getManagedCardDetailsListRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof managedCardDetailsListRetrieve>>
  > = ({ signal }) => managedCardDetailsListRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof managedCardDetailsListRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ManagedCardDetailsListRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof managedCardDetailsListRetrieve>>
>;
export type ManagedCardDetailsListRetrieveQueryError = unknown;

export function useManagedCardDetailsListRetrieve<
  TData = Awaited<ReturnType<typeof managedCardDetailsListRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof managedCardDetailsListRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getManagedCardDetailsListRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const managedCardsRetrieve = (
  managedCardExternalId: string,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/cockpit/v1.0/managed-cards/${managedCardExternalId}/`,
    method: 'GET',
    signal,
  });
};

export const getManagedCardsRetrieveQueryKey = (
  managedCardExternalId: string
) => {
  return [`/cockpit/v1.0/managed-cards/${managedCardExternalId}/`] as const;
};

export const getManagedCardsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof managedCardsRetrieve>>,
  TError = unknown,
>(
  managedCardExternalId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof managedCardsRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getManagedCardsRetrieveQueryKey(managedCardExternalId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof managedCardsRetrieve>>
  > = ({ signal }) => managedCardsRetrieve(managedCardExternalId, signal);

  return {
    queryKey,
    queryFn,
    enabled:
      managedCardExternalId !== null && managedCardExternalId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof managedCardsRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ManagedCardsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof managedCardsRetrieve>>
>;
export type ManagedCardsRetrieveQueryError = unknown;

export function useManagedCardsRetrieve<
  TData = Awaited<ReturnType<typeof managedCardsRetrieve>>,
  TError = unknown,
>(
  managedCardExternalId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof managedCardsRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getManagedCardsRetrieveQueryOptions(
    managedCardExternalId,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const managedCardsUpdate = (
  managedCardExternalId: string,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/cockpit/v1.0/managed-cards/${managedCardExternalId}/`,
    method: 'PUT',
    signal,
  });
};

export const getManagedCardsUpdateMutationKey = () =>
  ['managedCardsUpdate'] as const;

export const getManagedCardsUpdateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof managedCardsUpdate>>,
    TError,
    ManagedCardsUpdateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof managedCardsUpdate>>,
  TError,
  ManagedCardsUpdateMutationVariables,
  TContext
> => {
  const mutationKey = getManagedCardsUpdateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof managedCardsUpdate>>,
    ManagedCardsUpdateMutationVariables
  > = (props) => {
    const { managedCardExternalId } = props ?? {};

    return managedCardsUpdate(managedCardExternalId);
  };

  return { mutationFn, ...mutationOptions };
};

export type ManagedCardsUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof managedCardsUpdate>>
>;

export type ManagedCardsUpdateMutationError = unknown;
export type ManagedCardsUpdateMutationVariables = {
  managedCardExternalId: string;
};

export const useManagedCardsUpdate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof managedCardsUpdate>>,
    TError,
    ManagedCardsUpdateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof managedCardsUpdate>>,
  TError,
  ManagedCardsUpdateMutationVariables,
  TContext
> => {
  return useMutation(getManagedCardsUpdateMutationOptions(options));
};

export const managedCardsDestroy = (
  managedCardExternalId: string,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/cockpit/v1.0/managed-cards/${managedCardExternalId}/`,
    method: 'DELETE',
    signal,
  });
};

export const getManagedCardsDestroyMutationKey = () =>
  ['managedCardsDestroy'] as const;

export const getManagedCardsDestroyMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof managedCardsDestroy>>,
    TError,
    ManagedCardsDestroyMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof managedCardsDestroy>>,
  TError,
  ManagedCardsDestroyMutationVariables,
  TContext
> => {
  const mutationKey = getManagedCardsDestroyMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof managedCardsDestroy>>,
    ManagedCardsDestroyMutationVariables
  > = (props) => {
    const { managedCardExternalId } = props ?? {};

    return managedCardsDestroy(managedCardExternalId);
  };

  return { mutationFn, ...mutationOptions };
};

export type ManagedCardsDestroyMutationResult = NonNullable<
  Awaited<ReturnType<typeof managedCardsDestroy>>
>;

export type ManagedCardsDestroyMutationError = unknown;
export type ManagedCardsDestroyMutationVariables = {
  managedCardExternalId: string;
};

export const useManagedCardsDestroy = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof managedCardsDestroy>>,
    TError,
    ManagedCardsDestroyMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof managedCardsDestroy>>,
  TError,
  ManagedCardsDestroyMutationVariables,
  TContext
> => {
  return useMutation(getManagedCardsDestroyMutationOptions(options));
};

export const managedCardsPanRetrieve = (
  managedCardExternalId: string,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<PanTokenResponse>({
    url: `/cockpit/v1.0/managed-cards/${managedCardExternalId}/pan`,
    method: 'GET',
    signal,
  });
};

export const getManagedCardsPanRetrieveQueryKey = (
  managedCardExternalId: string
) => {
  return [`/cockpit/v1.0/managed-cards/${managedCardExternalId}/pan`] as const;
};

export const getManagedCardsPanRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof managedCardsPanRetrieve>>,
  TError = ScaRequiredResponse,
>(
  managedCardExternalId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof managedCardsPanRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getManagedCardsPanRetrieveQueryKey(managedCardExternalId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof managedCardsPanRetrieve>>
  > = ({ signal }) => managedCardsPanRetrieve(managedCardExternalId, signal);

  return {
    queryKey,
    queryFn,
    enabled:
      managedCardExternalId !== null && managedCardExternalId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof managedCardsPanRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ManagedCardsPanRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof managedCardsPanRetrieve>>
>;
export type ManagedCardsPanRetrieveQueryError = ScaRequiredResponse;

export function useManagedCardsPanRetrieve<
  TData = Awaited<ReturnType<typeof managedCardsPanRetrieve>>,
  TError = ScaRequiredResponse,
>(
  managedCardExternalId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof managedCardsPanRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getManagedCardsPanRetrieveQueryOptions(
    managedCardExternalId,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const managedCardsPhysicalPinRetrieve = (
  managedCardExternalId: string,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/cockpit/v1.0/managed-cards/${managedCardExternalId}/physical/pin`,
    method: 'GET',
    signal,
  });
};

export const getManagedCardsPhysicalPinRetrieveQueryKey = (
  managedCardExternalId: string
) => {
  return [
    `/cockpit/v1.0/managed-cards/${managedCardExternalId}/physical/pin`,
  ] as const;
};

export const getManagedCardsPhysicalPinRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof managedCardsPhysicalPinRetrieve>>,
  TError = unknown,
>(
  managedCardExternalId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof managedCardsPhysicalPinRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getManagedCardsPhysicalPinRetrieveQueryKey(managedCardExternalId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof managedCardsPhysicalPinRetrieve>>
  > = ({ signal }) =>
    managedCardsPhysicalPinRetrieve(managedCardExternalId, signal);

  return {
    queryKey,
    queryFn,
    enabled:
      managedCardExternalId !== null && managedCardExternalId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof managedCardsPhysicalPinRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ManagedCardsPhysicalPinRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof managedCardsPhysicalPinRetrieve>>
>;
export type ManagedCardsPhysicalPinRetrieveQueryError = unknown;

export function useManagedCardsPhysicalPinRetrieve<
  TData = Awaited<ReturnType<typeof managedCardsPhysicalPinRetrieve>>,
  TError = unknown,
>(
  managedCardExternalId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof managedCardsPhysicalPinRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getManagedCardsPhysicalPinRetrieveQueryOptions(
    managedCardExternalId,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const managedCardsTransactionsRetrieve = (
  managedCardExternalId: string,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<TransactionResponse>({
    url: `/cockpit/v1.0/managed-cards/${managedCardExternalId}/transactions/`,
    method: 'GET',
    signal,
  });
};

export const getManagedCardsTransactionsRetrieveQueryKey = (
  managedCardExternalId: string
) => {
  return [
    `/cockpit/v1.0/managed-cards/${managedCardExternalId}/transactions/`,
  ] as const;
};

export const getManagedCardsTransactionsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof managedCardsTransactionsRetrieve>>,
  TError = unknown,
>(
  managedCardExternalId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof managedCardsTransactionsRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getManagedCardsTransactionsRetrieveQueryKey(managedCardExternalId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof managedCardsTransactionsRetrieve>>
  > = ({ signal }) =>
    managedCardsTransactionsRetrieve(managedCardExternalId, signal);

  return {
    queryKey,
    queryFn,
    enabled:
      managedCardExternalId !== null && managedCardExternalId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof managedCardsTransactionsRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ManagedCardsTransactionsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof managedCardsTransactionsRetrieve>>
>;
export type ManagedCardsTransactionsRetrieveQueryError = unknown;

export function useManagedCardsTransactionsRetrieve<
  TData = Awaited<ReturnType<typeof managedCardsTransactionsRetrieve>>,
  TError = unknown,
>(
  managedCardExternalId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof managedCardsTransactionsRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getManagedCardsTransactionsRetrieveQueryOptions(
    managedCardExternalId,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const managedCardsPhysicalStatusRetrieve = (
  managedCardPk: number,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/cockpit/v1.0/managed-cards/${managedCardPk}/physical/status`,
    method: 'GET',
    signal,
  });
};

export const getManagedCardsPhysicalStatusRetrieveQueryKey = (
  managedCardPk: number
) => {
  return [
    `/cockpit/v1.0/managed-cards/${managedCardPk}/physical/status`,
  ] as const;
};

export const getManagedCardsPhysicalStatusRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof managedCardsPhysicalStatusRetrieve>>,
  TError = unknown,
>(
  managedCardPk: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof managedCardsPhysicalStatusRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getManagedCardsPhysicalStatusRetrieveQueryKey(managedCardPk);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof managedCardsPhysicalStatusRetrieve>>
  > = ({ signal }) => managedCardsPhysicalStatusRetrieve(managedCardPk, signal);

  return {
    queryKey,
    queryFn,
    enabled: managedCardPk !== null && managedCardPk !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof managedCardsPhysicalStatusRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ManagedCardsPhysicalStatusRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof managedCardsPhysicalStatusRetrieve>>
>;
export type ManagedCardsPhysicalStatusRetrieveQueryError = unknown;

export function useManagedCardsPhysicalStatusRetrieve<
  TData = Awaited<ReturnType<typeof managedCardsPhysicalStatusRetrieve>>,
  TError = unknown,
>(
  managedCardPk: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof managedCardsPhysicalStatusRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getManagedCardsPhysicalStatusRetrieveQueryOptions(
    managedCardPk,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const managedCardsPhysicalActivateCreate = (
  activatePhysicalCardRequestRequest: ActivatePhysicalCardRequestRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/cockpit/v1.0/managed-cards/physical/activate`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: activatePhysicalCardRequestRequest,
    signal,
  });
};

export const getManagedCardsPhysicalActivateCreateMutationKey = () =>
  ['managedCardsPhysicalActivateCreate'] as const;

export const getManagedCardsPhysicalActivateCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof managedCardsPhysicalActivateCreate>>,
    TError,
    ManagedCardsPhysicalActivateCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof managedCardsPhysicalActivateCreate>>,
  TError,
  ManagedCardsPhysicalActivateCreateMutationVariables,
  TContext
> => {
  const mutationKey = getManagedCardsPhysicalActivateCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof managedCardsPhysicalActivateCreate>>,
    ManagedCardsPhysicalActivateCreateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return managedCardsPhysicalActivateCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ManagedCardsPhysicalActivateCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof managedCardsPhysicalActivateCreate>>
>;
export type ManagedCardsPhysicalActivateCreateMutationBody =
  ActivatePhysicalCardRequestRequest;
export type ManagedCardsPhysicalActivateCreateMutationError = unknown;
export type ManagedCardsPhysicalActivateCreateMutationVariables = {
  data: ActivatePhysicalCardRequestRequest;
};

export const useManagedCardsPhysicalActivateCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof managedCardsPhysicalActivateCreate>>,
    TError,
    ManagedCardsPhysicalActivateCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof managedCardsPhysicalActivateCreate>>,
  TError,
  ManagedCardsPhysicalActivateCreateMutationVariables,
  TContext
> => {
  return useMutation(
    getManagedCardsPhysicalActivateCreateMutationOptions(options)
  );
};

export const managedCardsPhysicalOrderCreate = (
  orderPhysicalManagedCardRequestRequest: OrderPhysicalManagedCardRequestRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/cockpit/v1.0/managed-cards/physical/order`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: orderPhysicalManagedCardRequestRequest,
    signal,
  });
};

export const getManagedCardsPhysicalOrderCreateMutationKey = () =>
  ['managedCardsPhysicalOrderCreate'] as const;

export const getManagedCardsPhysicalOrderCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof managedCardsPhysicalOrderCreate>>,
    TError,
    ManagedCardsPhysicalOrderCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof managedCardsPhysicalOrderCreate>>,
  TError,
  ManagedCardsPhysicalOrderCreateMutationVariables,
  TContext
> => {
  const mutationKey = getManagedCardsPhysicalOrderCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof managedCardsPhysicalOrderCreate>>,
    ManagedCardsPhysicalOrderCreateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return managedCardsPhysicalOrderCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ManagedCardsPhysicalOrderCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof managedCardsPhysicalOrderCreate>>
>;
export type ManagedCardsPhysicalOrderCreateMutationBody =
  OrderPhysicalManagedCardRequestRequest;
export type ManagedCardsPhysicalOrderCreateMutationError = unknown;
export type ManagedCardsPhysicalOrderCreateMutationVariables = {
  data: OrderPhysicalManagedCardRequestRequest;
};

export const useManagedCardsPhysicalOrderCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof managedCardsPhysicalOrderCreate>>,
    TError,
    ManagedCardsPhysicalOrderCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof managedCardsPhysicalOrderCreate>>,
  TError,
  ManagedCardsPhysicalOrderCreateMutationVariables,
  TContext
> => {
  return useMutation(
    getManagedCardsPhysicalOrderCreateMutationOptions(options)
  );
};

export const managedCardsReorderCreate = (
  reorderManagedCardRequestRequest: ReorderManagedCardRequestRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/cockpit/v1.0/managed-cards/reorder`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: reorderManagedCardRequestRequest,
    signal,
  });
};

export const getManagedCardsReorderCreateMutationKey = () =>
  ['managedCardsReorderCreate'] as const;

export const getManagedCardsReorderCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof managedCardsReorderCreate>>,
    TError,
    ManagedCardsReorderCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof managedCardsReorderCreate>>,
  TError,
  ManagedCardsReorderCreateMutationVariables,
  TContext
> => {
  const mutationKey = getManagedCardsReorderCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof managedCardsReorderCreate>>,
    ManagedCardsReorderCreateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return managedCardsReorderCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ManagedCardsReorderCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof managedCardsReorderCreate>>
>;
export type ManagedCardsReorderCreateMutationBody =
  ReorderManagedCardRequestRequest;
export type ManagedCardsReorderCreateMutationError = unknown;
export type ManagedCardsReorderCreateMutationVariables = {
  data: ReorderManagedCardRequestRequest;
};

export const useManagedCardsReorderCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof managedCardsReorderCreate>>,
    TError,
    ManagedCardsReorderCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof managedCardsReorderCreate>>,
  TError,
  ManagedCardsReorderCreateMutationVariables,
  TContext
> => {
  return useMutation(getManagedCardsReorderCreateMutationOptions(options));
};

export const managedCardsTransferCreate = (
  balanceTransferRequestRequest: BalanceTransferRequestRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/cockpit/v1.0/managed-cards/transfer/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: balanceTransferRequestRequest,
    signal,
  });
};

export const getManagedCardsTransferCreateMutationKey = () =>
  ['managedCardsTransferCreate'] as const;

export const getManagedCardsTransferCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof managedCardsTransferCreate>>,
    TError,
    ManagedCardsTransferCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof managedCardsTransferCreate>>,
  TError,
  ManagedCardsTransferCreateMutationVariables,
  TContext
> => {
  const mutationKey = getManagedCardsTransferCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof managedCardsTransferCreate>>,
    ManagedCardsTransferCreateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return managedCardsTransferCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ManagedCardsTransferCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof managedCardsTransferCreate>>
>;
export type ManagedCardsTransferCreateMutationBody =
  BalanceTransferRequestRequest;
export type ManagedCardsTransferCreateMutationError = unknown;
export type ManagedCardsTransferCreateMutationVariables = {
  data: BalanceTransferRequestRequest;
};

export const useManagedCardsTransferCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof managedCardsTransferCreate>>,
    TError,
    ManagedCardsTransferCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof managedCardsTransferCreate>>,
  TError,
  ManagedCardsTransferCreateMutationVariables,
  TContext
> => {
  return useMutation(getManagedCardsTransferCreateMutationOptions(options));
};

export const managedCardsTransferDestinationsRetrieve = (
  managedCardExternalId: string,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<ManagedCardMinimal>({
    url: `/cockpit/v1.0/managed-cards/transfer/${managedCardExternalId}/destinations/`,
    method: 'GET',
    signal,
  });
};

export const getManagedCardsTransferDestinationsRetrieveQueryKey = (
  managedCardExternalId: string
) => {
  return [
    `/cockpit/v1.0/managed-cards/transfer/${managedCardExternalId}/destinations/`,
  ] as const;
};

export const getManagedCardsTransferDestinationsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof managedCardsTransferDestinationsRetrieve>>,
  TError = unknown,
>(
  managedCardExternalId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof managedCardsTransferDestinationsRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getManagedCardsTransferDestinationsRetrieveQueryKey(managedCardExternalId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof managedCardsTransferDestinationsRetrieve>>
  > = ({ signal }) =>
    managedCardsTransferDestinationsRetrieve(managedCardExternalId, signal);

  return {
    queryKey,
    queryFn,
    enabled:
      managedCardExternalId !== null && managedCardExternalId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof managedCardsTransferDestinationsRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ManagedCardsTransferDestinationsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof managedCardsTransferDestinationsRetrieve>>
>;
export type ManagedCardsTransferDestinationsRetrieveQueryError = unknown;

export function useManagedCardsTransferDestinationsRetrieve<
  TData = Awaited<ReturnType<typeof managedCardsTransferDestinationsRetrieve>>,
  TError = unknown,
>(
  managedCardExternalId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof managedCardsTransferDestinationsRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getManagedCardsTransferDestinationsRetrieveQueryOptions(
    managedCardExternalId,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const cockpitMeRetrieve = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<MeResponse>({
    url: `/cockpit/v1.0/me/`,
    method: 'GET',
    signal,
  });
};

export const getCockpitMeRetrieveQueryKey = () => {
  return [`/cockpit/v1.0/me/`] as const;
};

export const getCockpitMeRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof cockpitMeRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof cockpitMeRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCockpitMeRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof cockpitMeRetrieve>>
  > = ({ signal }) => cockpitMeRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof cockpitMeRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CockpitMeRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof cockpitMeRetrieve>>
>;
export type CockpitMeRetrieveQueryError = unknown;

export function useCockpitMeRetrieve<
  TData = Awaited<ReturnType<typeof cockpitMeRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof cockpitMeRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getCockpitMeRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const cockpitMePartialUpdate = (
  patchedMeRequestRequest?: PatchedMeRequestRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<MeResponse>({
    url: `/cockpit/v1.0/me/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchedMeRequestRequest,
    signal,
  });
};

export const getCockpitMePartialUpdateMutationKey = () =>
  ['cockpitMePartialUpdate'] as const;

export const getCockpitMePartialUpdateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cockpitMePartialUpdate>>,
    TError,
    CockpitMePartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof cockpitMePartialUpdate>>,
  TError,
  CockpitMePartialUpdateMutationVariables,
  TContext
> => {
  const mutationKey = getCockpitMePartialUpdateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof cockpitMePartialUpdate>>,
    CockpitMePartialUpdateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return cockpitMePartialUpdate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CockpitMePartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof cockpitMePartialUpdate>>
>;
export type CockpitMePartialUpdateMutationBody =
  | PatchedMeRequestRequest
  | undefined;
export type CockpitMePartialUpdateMutationError = unknown;
export type CockpitMePartialUpdateMutationVariables = {
  data?: PatchedMeRequestRequest;
};

export const useCockpitMePartialUpdate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cockpitMePartialUpdate>>,
    TError,
    CockpitMePartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof cockpitMePartialUpdate>>,
  TError,
  CockpitMePartialUpdateMutationVariables,
  TContext
> => {
  return useMutation(getCockpitMePartialUpdateMutationOptions(options));
};

export const mobileDeviceCreate = (
  employeeMobileDeviceRequestRequest: EmployeeMobileDeviceRequestRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/cockpit/v1.0/mobile/device/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: employeeMobileDeviceRequestRequest,
    signal,
  });
};

export const getMobileDeviceCreateMutationKey = () =>
  ['mobileDeviceCreate'] as const;

export const getMobileDeviceCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof mobileDeviceCreate>>,
    TError,
    MobileDeviceCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof mobileDeviceCreate>>,
  TError,
  MobileDeviceCreateMutationVariables,
  TContext
> => {
  const mutationKey = getMobileDeviceCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof mobileDeviceCreate>>,
    MobileDeviceCreateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return mobileDeviceCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type MobileDeviceCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof mobileDeviceCreate>>
>;
export type MobileDeviceCreateMutationBody = EmployeeMobileDeviceRequestRequest;
export type MobileDeviceCreateMutationError = unknown;
export type MobileDeviceCreateMutationVariables = {
  data: EmployeeMobileDeviceRequestRequest;
};

export const useMobileDeviceCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof mobileDeviceCreate>>,
    TError,
    MobileDeviceCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof mobileDeviceCreate>>,
  TError,
  MobileDeviceCreateMutationVariables,
  TContext
> => {
  return useMutation(getMobileDeviceCreateMutationOptions(options));
};

export const mobileLoginMetadataRetrieve = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<MobileLoginMetadataResponse>({
    url: `/cockpit/v1.0/mobile/login-metadata/`,
    method: 'GET',
    signal,
  });
};

export const getMobileLoginMetadataRetrieveQueryKey = () => {
  return [`/cockpit/v1.0/mobile/login-metadata/`] as const;
};

export const getMobileLoginMetadataRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof mobileLoginMetadataRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof mobileLoginMetadataRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getMobileLoginMetadataRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof mobileLoginMetadataRetrieve>>
  > = ({ signal }) => mobileLoginMetadataRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof mobileLoginMetadataRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type MobileLoginMetadataRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof mobileLoginMetadataRetrieve>>
>;
export type MobileLoginMetadataRetrieveQueryError = unknown;

export function useMobileLoginMetadataRetrieve<
  TData = Awaited<ReturnType<typeof mobileLoginMetadataRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof mobileLoginMetadataRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getMobileLoginMetadataRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const modularBenefitsRetrieve = (
  benefitPk: number,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<EnrollableBenefitDetailResponse>({
    url: `/cockpit/v1.0/modular-benefits/${benefitPk}/`,
    method: 'GET',
    signal,
  });
};

export const getModularBenefitsRetrieveQueryKey = (benefitPk: number) => {
  return [`/cockpit/v1.0/modular-benefits/${benefitPk}/`] as const;
};

export const getModularBenefitsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof modularBenefitsRetrieve>>,
  TError = unknown,
>(
  benefitPk: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof modularBenefitsRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getModularBenefitsRetrieveQueryKey(benefitPk);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof modularBenefitsRetrieve>>
  > = ({ signal }) => modularBenefitsRetrieve(benefitPk, signal);

  return {
    queryKey,
    queryFn,
    enabled: benefitPk !== null && benefitPk !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof modularBenefitsRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ModularBenefitsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof modularBenefitsRetrieve>>
>;
export type ModularBenefitsRetrieveQueryError = unknown;

export function useModularBenefitsRetrieve<
  TData = Awaited<ReturnType<typeof modularBenefitsRetrieve>>,
  TError = unknown,
>(
  benefitPk: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof modularBenefitsRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getModularBenefitsRetrieveQueryOptions(
    benefitPk,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * The body expects a JSON containing the user inputs in this shape:
 *  {"<modular_benefit_field_key>": <user_input_value>,…}
 *
 * The endpoint will return validation errors if any of the input values
 * do not conform with the spec of that mod. ben. field.
 *
 * The endpoint will return 404 if there's no enrolment for the given benefit_pk
 * and employee.
 *
 * The endpoint will return a 400 if any of the conditional triggers configured
 * for the mod. ben. cannot be evaluated due to an unparsable formula or due to
 * invalid user inputs.
 */
export const modularBenefitsApprovalsCreate = (
  benefitPk: number,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/cockpit/v1.0/modular-benefits/${benefitPk}/approvals/`,
    method: 'POST',
    signal,
  });
};

export const getModularBenefitsApprovalsCreateMutationKey = () =>
  ['modularBenefitsApprovalsCreate'] as const;

export const getModularBenefitsApprovalsCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof modularBenefitsApprovalsCreate>>,
    TError,
    ModularBenefitsApprovalsCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof modularBenefitsApprovalsCreate>>,
  TError,
  ModularBenefitsApprovalsCreateMutationVariables,
  TContext
> => {
  const mutationKey = getModularBenefitsApprovalsCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof modularBenefitsApprovalsCreate>>,
    ModularBenefitsApprovalsCreateMutationVariables
  > = (props) => {
    const { benefitPk } = props ?? {};

    return modularBenefitsApprovalsCreate(benefitPk);
  };

  return { mutationFn, ...mutationOptions };
};

export type ModularBenefitsApprovalsCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof modularBenefitsApprovalsCreate>>
>;

export type ModularBenefitsApprovalsCreateMutationError = unknown;
export type ModularBenefitsApprovalsCreateMutationVariables = {
  benefitPk: number;
};

export const useModularBenefitsApprovalsCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof modularBenefitsApprovalsCreate>>,
    TError,
    ModularBenefitsApprovalsCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof modularBenefitsApprovalsCreate>>,
  TError,
  ModularBenefitsApprovalsCreateMutationVariables,
  TContext
> => {
  return useMutation(getModularBenefitsApprovalsCreateMutationOptions(options));
};

export const modularBenefitsCalculatedValueFieldRecalculateCreate = (
  benefitPk: number,
  fieldPk: number,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/cockpit/v1.0/modular-benefits/${benefitPk}/calculated-value-field/${fieldPk}/recalculate/`,
    method: 'POST',
    signal,
  });
};

export const getModularBenefitsCalculatedValueFieldRecalculateCreateMutationKey =
  () => ['modularBenefitsCalculatedValueFieldRecalculateCreate'] as const;

export const getModularBenefitsCalculatedValueFieldRecalculateCreateMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof modularBenefitsCalculatedValueFieldRecalculateCreate>
      >,
      TError,
      ModularBenefitsCalculatedValueFieldRecalculateCreateMutationVariables,
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof modularBenefitsCalculatedValueFieldRecalculateCreate>
    >,
    TError,
    ModularBenefitsCalculatedValueFieldRecalculateCreateMutationVariables,
    TContext
  > => {
    const mutationKey =
      getModularBenefitsCalculatedValueFieldRecalculateCreateMutationKey();
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof modularBenefitsCalculatedValueFieldRecalculateCreate>
      >,
      ModularBenefitsCalculatedValueFieldRecalculateCreateMutationVariables
    > = (props) => {
      const { benefitPk, fieldPk } = props ?? {};

      return modularBenefitsCalculatedValueFieldRecalculateCreate(
        benefitPk,
        fieldPk
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ModularBenefitsCalculatedValueFieldRecalculateCreateMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof modularBenefitsCalculatedValueFieldRecalculateCreate>
    >
  >;

export type ModularBenefitsCalculatedValueFieldRecalculateCreateMutationError =
  unknown;
export type ModularBenefitsCalculatedValueFieldRecalculateCreateMutationVariables =
  { benefitPk: number; fieldPk: number };

export const useModularBenefitsCalculatedValueFieldRecalculateCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<typeof modularBenefitsCalculatedValueFieldRecalculateCreate>
    >,
    TError,
    ModularBenefitsCalculatedValueFieldRecalculateCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<typeof modularBenefitsCalculatedValueFieldRecalculateCreate>
  >,
  TError,
  ModularBenefitsCalculatedValueFieldRecalculateCreateMutationVariables,
  TContext
> => {
  return useMutation(
    getModularBenefitsCalculatedValueFieldRecalculateCreateMutationOptions(
      options
    )
  );
};

export const modularBenefitsDocumentSigningPrepareCreate = (
  benefitPk: number,
  prepareSigningRequestRequest: PrepareSigningRequestRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<PrepareSigningResponse>({
    url: `/cockpit/v1.0/modular-benefits/${benefitPk}/document-signing/prepare/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: prepareSigningRequestRequest,
    signal,
  });
};

export const getModularBenefitsDocumentSigningPrepareCreateMutationKey = () =>
  ['modularBenefitsDocumentSigningPrepareCreate'] as const;

export const getModularBenefitsDocumentSigningPrepareCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof modularBenefitsDocumentSigningPrepareCreate>>,
    TError,
    ModularBenefitsDocumentSigningPrepareCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof modularBenefitsDocumentSigningPrepareCreate>>,
  TError,
  ModularBenefitsDocumentSigningPrepareCreateMutationVariables,
  TContext
> => {
  const mutationKey =
    getModularBenefitsDocumentSigningPrepareCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof modularBenefitsDocumentSigningPrepareCreate>>,
    ModularBenefitsDocumentSigningPrepareCreateMutationVariables
  > = (props) => {
    const { benefitPk, data } = props ?? {};

    return modularBenefitsDocumentSigningPrepareCreate(benefitPk, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ModularBenefitsDocumentSigningPrepareCreateMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof modularBenefitsDocumentSigningPrepareCreate>>
  >;
export type ModularBenefitsDocumentSigningPrepareCreateMutationBody =
  PrepareSigningRequestRequest;
export type ModularBenefitsDocumentSigningPrepareCreateMutationError = unknown;
export type ModularBenefitsDocumentSigningPrepareCreateMutationVariables = {
  benefitPk: number;
  data: PrepareSigningRequestRequest;
};

export const useModularBenefitsDocumentSigningPrepareCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof modularBenefitsDocumentSigningPrepareCreate>>,
    TError,
    ModularBenefitsDocumentSigningPrepareCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof modularBenefitsDocumentSigningPrepareCreate>>,
  TError,
  ModularBenefitsDocumentSigningPrepareCreateMutationVariables,
  TContext
> => {
  return useMutation(
    getModularBenefitsDocumentSigningPrepareCreateMutationOptions(options)
  );
};

/**
 * This endpoint lets a user cancel their auto-enrolment
 * if it's cancelable.
 */
export const modularBenefitsEnrolmentsCancelAutoEnrolmentPartialUpdate = (
  benefitPk: number,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/cockpit/v1.0/modular-benefits/${benefitPk}/enrolments/cancel-auto-enrolment/`,
    method: 'PATCH',
    signal,
  });
};

export const getModularBenefitsEnrolmentsCancelAutoEnrolmentPartialUpdateMutationKey =
  () => ['modularBenefitsEnrolmentsCancelAutoEnrolmentPartialUpdate'] as const;

export const getModularBenefitsEnrolmentsCancelAutoEnrolmentPartialUpdateMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof modularBenefitsEnrolmentsCancelAutoEnrolmentPartialUpdate
        >
      >,
      TError,
      ModularBenefitsEnrolmentsCancelAutoEnrolmentPartialUpdateMutationVariables,
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof modularBenefitsEnrolmentsCancelAutoEnrolmentPartialUpdate
      >
    >,
    TError,
    ModularBenefitsEnrolmentsCancelAutoEnrolmentPartialUpdateMutationVariables,
    TContext
  > => {
    const mutationKey =
      getModularBenefitsEnrolmentsCancelAutoEnrolmentPartialUpdateMutationKey();
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof modularBenefitsEnrolmentsCancelAutoEnrolmentPartialUpdate
        >
      >,
      ModularBenefitsEnrolmentsCancelAutoEnrolmentPartialUpdateMutationVariables
    > = (props) => {
      const { benefitPk } = props ?? {};

      return modularBenefitsEnrolmentsCancelAutoEnrolmentPartialUpdate(
        benefitPk
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ModularBenefitsEnrolmentsCancelAutoEnrolmentPartialUpdateMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof modularBenefitsEnrolmentsCancelAutoEnrolmentPartialUpdate
      >
    >
  >;

export type ModularBenefitsEnrolmentsCancelAutoEnrolmentPartialUpdateMutationError =
  unknown;
export type ModularBenefitsEnrolmentsCancelAutoEnrolmentPartialUpdateMutationVariables =
  { benefitPk: number };

export const useModularBenefitsEnrolmentsCancelAutoEnrolmentPartialUpdate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        typeof modularBenefitsEnrolmentsCancelAutoEnrolmentPartialUpdate
      >
    >,
    TError,
    ModularBenefitsEnrolmentsCancelAutoEnrolmentPartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<typeof modularBenefitsEnrolmentsCancelAutoEnrolmentPartialUpdate>
  >,
  TError,
  ModularBenefitsEnrolmentsCancelAutoEnrolmentPartialUpdateMutationVariables,
  TContext
> => {
  return useMutation(
    getModularBenefitsEnrolmentsCancelAutoEnrolmentPartialUpdateMutationOptions(
      options
    )
  );
};

/**
 * Cancel a staged BEFORE_ENROLLMENT_END reselection. Tombstones the staged subscription and restores the enrolment to its pre-reselection state. Returns 400 if no staged reselection exists.
 */
export const modularBenefitsEnrolmentsCancelStagedReselectionCreate = (
  benefitPk: number,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/cockpit/v1.0/modular-benefits/${benefitPk}/enrolments/cancel-staged-reselection/`,
    method: 'POST',
    signal,
  });
};

export const getModularBenefitsEnrolmentsCancelStagedReselectionCreateMutationKey =
  () => ['modularBenefitsEnrolmentsCancelStagedReselectionCreate'] as const;

export const getModularBenefitsEnrolmentsCancelStagedReselectionCreateMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof modularBenefitsEnrolmentsCancelStagedReselectionCreate
        >
      >,
      TError,
      ModularBenefitsEnrolmentsCancelStagedReselectionCreateMutationVariables,
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof modularBenefitsEnrolmentsCancelStagedReselectionCreate>
    >,
    TError,
    ModularBenefitsEnrolmentsCancelStagedReselectionCreateMutationVariables,
    TContext
  > => {
    const mutationKey =
      getModularBenefitsEnrolmentsCancelStagedReselectionCreateMutationKey();
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof modularBenefitsEnrolmentsCancelStagedReselectionCreate
        >
      >,
      ModularBenefitsEnrolmentsCancelStagedReselectionCreateMutationVariables
    > = (props) => {
      const { benefitPk } = props ?? {};

      return modularBenefitsEnrolmentsCancelStagedReselectionCreate(benefitPk);
    };

    return { mutationFn, ...mutationOptions };
  };

export type ModularBenefitsEnrolmentsCancelStagedReselectionCreateMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof modularBenefitsEnrolmentsCancelStagedReselectionCreate>
    >
  >;

export type ModularBenefitsEnrolmentsCancelStagedReselectionCreateMutationError =
  unknown;
export type ModularBenefitsEnrolmentsCancelStagedReselectionCreateMutationVariables =
  { benefitPk: number };

export const useModularBenefitsEnrolmentsCancelStagedReselectionCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<typeof modularBenefitsEnrolmentsCancelStagedReselectionCreate>
    >,
    TError,
    ModularBenefitsEnrolmentsCancelStagedReselectionCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<typeof modularBenefitsEnrolmentsCancelStagedReselectionCreate>
  >,
  TError,
  ModularBenefitsEnrolmentsCancelStagedReselectionCreateMutationVariables,
  TContext
> => {
  return useMutation(
    getModularBenefitsEnrolmentsCancelStagedReselectionCreateMutationOptions(
      options
    )
  );
};

/**
 * The body expects a JSON containing the user inputs in this shape:
 *  {"<modular_benefit_field_key>": <user_input_value>,…}
 *
 * The endpoint will return validation errors if any of the input values
 * do not conform with the spec of that mod. ben. field
 */
export const modularBenefitsEnrolmentsEnrollPartialUpdate = (
  benefitPk: number,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/cockpit/v1.0/modular-benefits/${benefitPk}/enrolments/enroll/`,
    method: 'PATCH',
    signal,
  });
};

export const getModularBenefitsEnrolmentsEnrollPartialUpdateMutationKey = () =>
  ['modularBenefitsEnrolmentsEnrollPartialUpdate'] as const;

export const getModularBenefitsEnrolmentsEnrollPartialUpdateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof modularBenefitsEnrolmentsEnrollPartialUpdate>>,
    TError,
    ModularBenefitsEnrolmentsEnrollPartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof modularBenefitsEnrolmentsEnrollPartialUpdate>>,
  TError,
  ModularBenefitsEnrolmentsEnrollPartialUpdateMutationVariables,
  TContext
> => {
  const mutationKey =
    getModularBenefitsEnrolmentsEnrollPartialUpdateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof modularBenefitsEnrolmentsEnrollPartialUpdate>>,
    ModularBenefitsEnrolmentsEnrollPartialUpdateMutationVariables
  > = (props) => {
    const { benefitPk } = props ?? {};

    return modularBenefitsEnrolmentsEnrollPartialUpdate(benefitPk);
  };

  return { mutationFn, ...mutationOptions };
};

export type ModularBenefitsEnrolmentsEnrollPartialUpdateMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof modularBenefitsEnrolmentsEnrollPartialUpdate>>
  >;

export type ModularBenefitsEnrolmentsEnrollPartialUpdateMutationError = unknown;
export type ModularBenefitsEnrolmentsEnrollPartialUpdateMutationVariables = {
  benefitPk: number;
};

export const useModularBenefitsEnrolmentsEnrollPartialUpdate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof modularBenefitsEnrolmentsEnrollPartialUpdate>>,
    TError,
    ModularBenefitsEnrolmentsEnrollPartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof modularBenefitsEnrolmentsEnrollPartialUpdate>>,
  TError,
  ModularBenefitsEnrolmentsEnrollPartialUpdateMutationVariables,
  TContext
> => {
  return useMutation(
    getModularBenefitsEnrolmentsEnrollPartialUpdateMutationOptions(options)
  );
};

/**
 * The endpoint will return 404 if there's no enrolment for the given
 * benefit_pk and employee. The endpoint will return a 400 if the
 * out-out window is closed for the enrolment.
 */
export const modularBenefitsEnrolmentsOptOutPartialUpdate = (
  benefitPk: number,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/cockpit/v1.0/modular-benefits/${benefitPk}/enrolments/opt-out/`,
    method: 'PATCH',
    signal,
  });
};

export const getModularBenefitsEnrolmentsOptOutPartialUpdateMutationKey = () =>
  ['modularBenefitsEnrolmentsOptOutPartialUpdate'] as const;

export const getModularBenefitsEnrolmentsOptOutPartialUpdateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof modularBenefitsEnrolmentsOptOutPartialUpdate>>,
    TError,
    ModularBenefitsEnrolmentsOptOutPartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof modularBenefitsEnrolmentsOptOutPartialUpdate>>,
  TError,
  ModularBenefitsEnrolmentsOptOutPartialUpdateMutationVariables,
  TContext
> => {
  const mutationKey =
    getModularBenefitsEnrolmentsOptOutPartialUpdateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof modularBenefitsEnrolmentsOptOutPartialUpdate>>,
    ModularBenefitsEnrolmentsOptOutPartialUpdateMutationVariables
  > = (props) => {
    const { benefitPk } = props ?? {};

    return modularBenefitsEnrolmentsOptOutPartialUpdate(benefitPk);
  };

  return { mutationFn, ...mutationOptions };
};

export type ModularBenefitsEnrolmentsOptOutPartialUpdateMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof modularBenefitsEnrolmentsOptOutPartialUpdate>>
  >;

export type ModularBenefitsEnrolmentsOptOutPartialUpdateMutationError = unknown;
export type ModularBenefitsEnrolmentsOptOutPartialUpdateMutationVariables = {
  benefitPk: number;
};

export const useModularBenefitsEnrolmentsOptOutPartialUpdate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof modularBenefitsEnrolmentsOptOutPartialUpdate>>,
    TError,
    ModularBenefitsEnrolmentsOptOutPartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof modularBenefitsEnrolmentsOptOutPartialUpdate>>,
  TError,
  ModularBenefitsEnrolmentsOptOutPartialUpdateMutationVariables,
  TContext
> => {
  return useMutation(
    getModularBenefitsEnrolmentsOptOutPartialUpdateMutationOptions(options)
  );
};

/**
 * The request body should be a JSON payload containing the user opt out reason or
 * null, in the form: {"code": "SOME_CODE", "custom_reason": "Some user input"}
 *
 * The endpoint will return 404 if there's no enrolment for the given benefit_pk
 * and employee.
 *
 * The endpoint will return a 400 if the out-out window is closed for the enrolment
 */
export const modularBenefitsEnrolmentsUnenrollPartialUpdate = (
  benefitPk: number,
  patchedModularBenefitUnenrollRequestRequest?: PatchedModularBenefitUnenrollRequestRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/cockpit/v1.0/modular-benefits/${benefitPk}/enrolments/unenroll/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchedModularBenefitUnenrollRequestRequest,
    signal,
  });
};

export const getModularBenefitsEnrolmentsUnenrollPartialUpdateMutationKey =
  () => ['modularBenefitsEnrolmentsUnenrollPartialUpdate'] as const;

export const getModularBenefitsEnrolmentsUnenrollPartialUpdateMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof modularBenefitsEnrolmentsUnenrollPartialUpdate>
      >,
      TError,
      ModularBenefitsEnrolmentsUnenrollPartialUpdateMutationVariables,
      TContext
    >;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof modularBenefitsEnrolmentsUnenrollPartialUpdate>>,
    TError,
    ModularBenefitsEnrolmentsUnenrollPartialUpdateMutationVariables,
    TContext
  > => {
    const mutationKey =
      getModularBenefitsEnrolmentsUnenrollPartialUpdateMutationKey();
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof modularBenefitsEnrolmentsUnenrollPartialUpdate>
      >,
      ModularBenefitsEnrolmentsUnenrollPartialUpdateMutationVariables
    > = (props) => {
      const { benefitPk, data } = props ?? {};

      return modularBenefitsEnrolmentsUnenrollPartialUpdate(benefitPk, data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type ModularBenefitsEnrolmentsUnenrollPartialUpdateMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof modularBenefitsEnrolmentsUnenrollPartialUpdate>>
  >;
export type ModularBenefitsEnrolmentsUnenrollPartialUpdateMutationBody =
  | PatchedModularBenefitUnenrollRequestRequest
  | undefined;
export type ModularBenefitsEnrolmentsUnenrollPartialUpdateMutationError =
  unknown;
export type ModularBenefitsEnrolmentsUnenrollPartialUpdateMutationVariables = {
  benefitPk: number;
  data?: PatchedModularBenefitUnenrollRequestRequest;
};

export const useModularBenefitsEnrolmentsUnenrollPartialUpdate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof modularBenefitsEnrolmentsUnenrollPartialUpdate>>,
    TError,
    ModularBenefitsEnrolmentsUnenrollPartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof modularBenefitsEnrolmentsUnenrollPartialUpdate>>,
  TError,
  ModularBenefitsEnrolmentsUnenrollPartialUpdateMutationVariables,
  TContext
> => {
  return useMutation(
    getModularBenefitsEnrolmentsUnenrollPartialUpdateMutationOptions(options)
  );
};

/**
 * The request body expects a JSON containing the user inputs in this shape:
 * {"<modular_benefit_field_key>": <user_input_value>,…}
 *
 * The endpoint will return validation errors if any of the input values
 * do not conform with the spec of that mod. ben. field.
 *
 * The endpoint will return 404 if there's no enrolment for the given benefit_pk
 * and employee.
 *
 * The endpoint will return a 400 if the config window is closed for the enrolment.
 */
export const modularBenefitsEnrolmentsUpdatePartialUpdate = (
  benefitPk: number,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/cockpit/v1.0/modular-benefits/${benefitPk}/enrolments/update/`,
    method: 'PATCH',
    signal,
  });
};

export const getModularBenefitsEnrolmentsUpdatePartialUpdateMutationKey = () =>
  ['modularBenefitsEnrolmentsUpdatePartialUpdate'] as const;

export const getModularBenefitsEnrolmentsUpdatePartialUpdateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof modularBenefitsEnrolmentsUpdatePartialUpdate>>,
    TError,
    ModularBenefitsEnrolmentsUpdatePartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof modularBenefitsEnrolmentsUpdatePartialUpdate>>,
  TError,
  ModularBenefitsEnrolmentsUpdatePartialUpdateMutationVariables,
  TContext
> => {
  const mutationKey =
    getModularBenefitsEnrolmentsUpdatePartialUpdateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof modularBenefitsEnrolmentsUpdatePartialUpdate>>,
    ModularBenefitsEnrolmentsUpdatePartialUpdateMutationVariables
  > = (props) => {
    const { benefitPk } = props ?? {};

    return modularBenefitsEnrolmentsUpdatePartialUpdate(benefitPk);
  };

  return { mutationFn, ...mutationOptions };
};

export type ModularBenefitsEnrolmentsUpdatePartialUpdateMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof modularBenefitsEnrolmentsUpdatePartialUpdate>>
  >;

export type ModularBenefitsEnrolmentsUpdatePartialUpdateMutationError = unknown;
export type ModularBenefitsEnrolmentsUpdatePartialUpdateMutationVariables = {
  benefitPk: number;
};

export const useModularBenefitsEnrolmentsUpdatePartialUpdate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof modularBenefitsEnrolmentsUpdatePartialUpdate>>,
    TError,
    ModularBenefitsEnrolmentsUpdatePartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof modularBenefitsEnrolmentsUpdatePartialUpdate>>,
  TError,
  ModularBenefitsEnrolmentsUpdatePartialUpdateMutationVariables,
  TContext
> => {
  return useMutation(
    getModularBenefitsEnrolmentsUpdatePartialUpdateMutationOptions(options)
  );
};

export const modularBenefitsFieldsFilesCreate = (
  benefitPk: number,
  fieldPk: number,
  modularBenefitUploadedFileRequestRequest: ModularBenefitUploadedFileRequestRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/cockpit/v1.0/modular-benefits/${benefitPk}/fields/${fieldPk}/files/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: modularBenefitUploadedFileRequestRequest,
    signal,
  });
};

export const getModularBenefitsFieldsFilesCreateMutationKey = () =>
  ['modularBenefitsFieldsFilesCreate'] as const;

export const getModularBenefitsFieldsFilesCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof modularBenefitsFieldsFilesCreate>>,
    TError,
    ModularBenefitsFieldsFilesCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof modularBenefitsFieldsFilesCreate>>,
  TError,
  ModularBenefitsFieldsFilesCreateMutationVariables,
  TContext
> => {
  const mutationKey = getModularBenefitsFieldsFilesCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof modularBenefitsFieldsFilesCreate>>,
    ModularBenefitsFieldsFilesCreateMutationVariables
  > = (props) => {
    const { benefitPk, fieldPk, data } = props ?? {};

    return modularBenefitsFieldsFilesCreate(benefitPk, fieldPk, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ModularBenefitsFieldsFilesCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof modularBenefitsFieldsFilesCreate>>
>;
export type ModularBenefitsFieldsFilesCreateMutationBody =
  ModularBenefitUploadedFileRequestRequest;
export type ModularBenefitsFieldsFilesCreateMutationError = unknown;
export type ModularBenefitsFieldsFilesCreateMutationVariables = {
  benefitPk: number;
  fieldPk: number;
  data: ModularBenefitUploadedFileRequestRequest;
};

export const useModularBenefitsFieldsFilesCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof modularBenefitsFieldsFilesCreate>>,
    TError,
    ModularBenefitsFieldsFilesCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof modularBenefitsFieldsFilesCreate>>,
  TError,
  ModularBenefitsFieldsFilesCreateMutationVariables,
  TContext
> => {
  return useMutation(
    getModularBenefitsFieldsFilesCreateMutationOptions(options)
  );
};

export const modularBenefitsFieldsFilesList = (
  benefitPk: number,
  fieldPk: number,
  fileUuid: string,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<ModularBenefitUploadedFileResponse[]>({
    url: `/cockpit/v1.0/modular-benefits/${benefitPk}/fields/${fieldPk}/files/${fileUuid}/`,
    method: 'GET',
    signal,
  });
};

export const getModularBenefitsFieldsFilesListQueryKey = (
  benefitPk: number,
  fieldPk: number,
  fileUuid: string
) => {
  return [
    `/cockpit/v1.0/modular-benefits/${benefitPk}/fields/${fieldPk}/files/${fileUuid}/`,
  ] as const;
};

export const getModularBenefitsFieldsFilesListQueryOptions = <
  TData = Awaited<ReturnType<typeof modularBenefitsFieldsFilesList>>,
  TError = unknown,
>(
  benefitPk: number,
  fieldPk: number,
  fileUuid: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof modularBenefitsFieldsFilesList>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getModularBenefitsFieldsFilesListQueryKey(benefitPk, fieldPk, fileUuid);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof modularBenefitsFieldsFilesList>>
  > = ({ signal }) =>
    modularBenefitsFieldsFilesList(benefitPk, fieldPk, fileUuid, signal);

  return {
    queryKey,
    queryFn,
    enabled:
      benefitPk !== null &&
      benefitPk !== undefined &&
      fieldPk !== null &&
      fieldPk !== undefined &&
      fileUuid !== null &&
      fileUuid !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof modularBenefitsFieldsFilesList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ModularBenefitsFieldsFilesListQueryResult = NonNullable<
  Awaited<ReturnType<typeof modularBenefitsFieldsFilesList>>
>;
export type ModularBenefitsFieldsFilesListQueryError = unknown;

export function useModularBenefitsFieldsFilesList<
  TData = Awaited<ReturnType<typeof modularBenefitsFieldsFilesList>>,
  TError = unknown,
>(
  benefitPk: number,
  fieldPk: number,
  fileUuid: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof modularBenefitsFieldsFilesList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getModularBenefitsFieldsFilesListQueryOptions(
    benefitPk,
    fieldPk,
    fileUuid,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const modularBenefitsFieldsFilesDestroy = (
  benefitPk: number,
  fieldPk: number,
  fileUuid: string,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/cockpit/v1.0/modular-benefits/${benefitPk}/fields/${fieldPk}/files/${fileUuid}/`,
    method: 'DELETE',
    signal,
  });
};

export const getModularBenefitsFieldsFilesDestroyMutationKey = () =>
  ['modularBenefitsFieldsFilesDestroy'] as const;

export const getModularBenefitsFieldsFilesDestroyMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof modularBenefitsFieldsFilesDestroy>>,
    TError,
    ModularBenefitsFieldsFilesDestroyMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof modularBenefitsFieldsFilesDestroy>>,
  TError,
  ModularBenefitsFieldsFilesDestroyMutationVariables,
  TContext
> => {
  const mutationKey = getModularBenefitsFieldsFilesDestroyMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof modularBenefitsFieldsFilesDestroy>>,
    ModularBenefitsFieldsFilesDestroyMutationVariables
  > = (props) => {
    const { benefitPk, fieldPk, fileUuid } = props ?? {};

    return modularBenefitsFieldsFilesDestroy(benefitPk, fieldPk, fileUuid);
  };

  return { mutationFn, ...mutationOptions };
};

export type ModularBenefitsFieldsFilesDestroyMutationResult = NonNullable<
  Awaited<ReturnType<typeof modularBenefitsFieldsFilesDestroy>>
>;

export type ModularBenefitsFieldsFilesDestroyMutationError = unknown;
export type ModularBenefitsFieldsFilesDestroyMutationVariables = {
  benefitPk: number;
  fieldPk: number;
  fileUuid: string;
};

export const useModularBenefitsFieldsFilesDestroy = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof modularBenefitsFieldsFilesDestroy>>,
    TError,
    ModularBenefitsFieldsFilesDestroyMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof modularBenefitsFieldsFilesDestroy>>,
  TError,
  ModularBenefitsFieldsFilesDestroyMutationVariables,
  TContext
> => {
  return useMutation(
    getModularBenefitsFieldsFilesDestroyMutationOptions(options)
  );
};

export const modularBenefitsMinMaxFormulaFieldRecalculateCreate = (
  benefitPk: number,
  fieldKey: string,
  modularBenefitsMinMaxFormulaFieldRecalculateCreateBody?:
    | ModularBenefitsMinMaxFormulaFieldRecalculateCreateBodyOne
    | ModularBenefitsMinMaxFormulaFieldRecalculateCreateBodyTwo
    | ModularBenefitsMinMaxFormulaFieldRecalculateCreateBodyThree,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<ModularBenefitMinMaxFormulaFieldRecalculateCockpitResponse>(
    {
      url: `/cockpit/v1.0/modular-benefits/${benefitPk}/min-max-formula-field/${fieldKey}/recalculate/`,
      method: 'POST',
      data: modularBenefitsMinMaxFormulaFieldRecalculateCreateBody,
      signal,
    }
  );
};

export const getModularBenefitsMinMaxFormulaFieldRecalculateCreateMutationKey =
  () => ['modularBenefitsMinMaxFormulaFieldRecalculateCreate'] as const;

export const getModularBenefitsMinMaxFormulaFieldRecalculateCreateMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof modularBenefitsMinMaxFormulaFieldRecalculateCreate>
      >,
      TError,
      ModularBenefitsMinMaxFormulaFieldRecalculateCreateMutationVariables,
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof modularBenefitsMinMaxFormulaFieldRecalculateCreate>
    >,
    TError,
    ModularBenefitsMinMaxFormulaFieldRecalculateCreateMutationVariables,
    TContext
  > => {
    const mutationKey =
      getModularBenefitsMinMaxFormulaFieldRecalculateCreateMutationKey();
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof modularBenefitsMinMaxFormulaFieldRecalculateCreate>
      >,
      ModularBenefitsMinMaxFormulaFieldRecalculateCreateMutationVariables
    > = (props) => {
      const { benefitPk, fieldKey, data } = props ?? {};

      return modularBenefitsMinMaxFormulaFieldRecalculateCreate(
        benefitPk,
        fieldKey,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ModularBenefitsMinMaxFormulaFieldRecalculateCreateMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof modularBenefitsMinMaxFormulaFieldRecalculateCreate>
    >
  >;
export type ModularBenefitsMinMaxFormulaFieldRecalculateCreateMutationBody =
  | ModularBenefitsMinMaxFormulaFieldRecalculateCreateBodyOne
  | ModularBenefitsMinMaxFormulaFieldRecalculateCreateBodyTwo
  | ModularBenefitsMinMaxFormulaFieldRecalculateCreateBodyThree
  | undefined;
export type ModularBenefitsMinMaxFormulaFieldRecalculateCreateMutationError =
  unknown;
export type ModularBenefitsMinMaxFormulaFieldRecalculateCreateMutationVariables =
  {
    benefitPk: number;
    fieldKey: string;
    data?:
      | ModularBenefitsMinMaxFormulaFieldRecalculateCreateBodyOne
      | ModularBenefitsMinMaxFormulaFieldRecalculateCreateBodyTwo
      | ModularBenefitsMinMaxFormulaFieldRecalculateCreateBodyThree;
  };

export const useModularBenefitsMinMaxFormulaFieldRecalculateCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<typeof modularBenefitsMinMaxFormulaFieldRecalculateCreate>
    >,
    TError,
    ModularBenefitsMinMaxFormulaFieldRecalculateCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<typeof modularBenefitsMinMaxFormulaFieldRecalculateCreate>
  >,
  TError,
  ModularBenefitsMinMaxFormulaFieldRecalculateCreateMutationVariables,
  TContext
> => {
  return useMutation(
    getModularBenefitsMinMaxFormulaFieldRecalculateCreateMutationOptions(
      options
    )
  );
};

export const modularBenefitsPayrollCyclesList = (
  benefitPk: number,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<ModularBenefitPayrollCycle[]>({
    url: `/cockpit/v1.0/modular-benefits/${benefitPk}/payroll-cycles/`,
    method: 'GET',
    signal,
  });
};

export const getModularBenefitsPayrollCyclesListQueryKey = (
  benefitPk: number
) => {
  return [
    `/cockpit/v1.0/modular-benefits/${benefitPk}/payroll-cycles/`,
  ] as const;
};

export const getModularBenefitsPayrollCyclesListQueryOptions = <
  TData = Awaited<ReturnType<typeof modularBenefitsPayrollCyclesList>>,
  TError = unknown,
>(
  benefitPk: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof modularBenefitsPayrollCyclesList>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getModularBenefitsPayrollCyclesListQueryKey(benefitPk);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof modularBenefitsPayrollCyclesList>>
  > = ({ signal }) => modularBenefitsPayrollCyclesList(benefitPk, signal);

  return {
    queryKey,
    queryFn,
    enabled: benefitPk !== null && benefitPk !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof modularBenefitsPayrollCyclesList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ModularBenefitsPayrollCyclesListQueryResult = NonNullable<
  Awaited<ReturnType<typeof modularBenefitsPayrollCyclesList>>
>;
export type ModularBenefitsPayrollCyclesListQueryError = unknown;

export function useModularBenefitsPayrollCyclesList<
  TData = Awaited<ReturnType<typeof modularBenefitsPayrollCyclesList>>,
  TError = unknown,
>(
  benefitPk: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof modularBenefitsPayrollCyclesList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getModularBenefitsPayrollCyclesListQueryOptions(
    benefitPk,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const modularBenefitsPayrollCyclesRetrieve = (
  benefitPk: number,
  payrollCyclePk: number,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<BenefitPaymentHistoryDetailResponse>({
    url: `/cockpit/v1.0/modular-benefits/${benefitPk}/payroll-cycles/${payrollCyclePk}`,
    method: 'GET',
    signal,
  });
};

export const getModularBenefitsPayrollCyclesRetrieveQueryKey = (
  benefitPk: number,
  payrollCyclePk: number
) => {
  return [
    `/cockpit/v1.0/modular-benefits/${benefitPk}/payroll-cycles/${payrollCyclePk}`,
  ] as const;
};

export const getModularBenefitsPayrollCyclesRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof modularBenefitsPayrollCyclesRetrieve>>,
  TError = unknown,
>(
  benefitPk: number,
  payrollCyclePk: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof modularBenefitsPayrollCyclesRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getModularBenefitsPayrollCyclesRetrieveQueryKey(benefitPk, payrollCyclePk);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof modularBenefitsPayrollCyclesRetrieve>>
  > = ({ signal }) =>
    modularBenefitsPayrollCyclesRetrieve(benefitPk, payrollCyclePk, signal);

  return {
    queryKey,
    queryFn,
    enabled:
      benefitPk !== null &&
      benefitPk !== undefined &&
      payrollCyclePk !== null &&
      payrollCyclePk !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof modularBenefitsPayrollCyclesRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ModularBenefitsPayrollCyclesRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof modularBenefitsPayrollCyclesRetrieve>>
>;
export type ModularBenefitsPayrollCyclesRetrieveQueryError = unknown;

export function useModularBenefitsPayrollCyclesRetrieve<
  TData = Awaited<ReturnType<typeof modularBenefitsPayrollCyclesRetrieve>>,
  TError = unknown,
>(
  benefitPk: number,
  payrollCyclePk: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof modularBenefitsPayrollCyclesRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getModularBenefitsPayrollCyclesRetrieveQueryOptions(
    benefitPk,
    payrollCyclePk,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const modularBenefitsPayrollCyclesCorrectionsRetrieve = (
  benefitPk: number,
  payrollCyclePk: number,
  correctionPk: number,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<BenefitPaymentHistoryCorrectionResponse>({
    url: `/cockpit/v1.0/modular-benefits/${benefitPk}/payroll-cycles/${payrollCyclePk}/corrections/${correctionPk}`,
    method: 'GET',
    signal,
  });
};

export const getModularBenefitsPayrollCyclesCorrectionsRetrieveQueryKey = (
  benefitPk: number,
  payrollCyclePk: number,
  correctionPk: number
) => {
  return [
    `/cockpit/v1.0/modular-benefits/${benefitPk}/payroll-cycles/${payrollCyclePk}/corrections/${correctionPk}`,
  ] as const;
};

export const getModularBenefitsPayrollCyclesCorrectionsRetrieveQueryOptions = <
  TData = Awaited<
    ReturnType<typeof modularBenefitsPayrollCyclesCorrectionsRetrieve>
  >,
  TError = unknown,
>(
  benefitPk: number,
  payrollCyclePk: number,
  correctionPk: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<typeof modularBenefitsPayrollCyclesCorrectionsRetrieve>
      >,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getModularBenefitsPayrollCyclesCorrectionsRetrieveQueryKey(
      benefitPk,
      payrollCyclePk,
      correctionPk
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof modularBenefitsPayrollCyclesCorrectionsRetrieve>>
  > = ({ signal }) =>
    modularBenefitsPayrollCyclesCorrectionsRetrieve(
      benefitPk,
      payrollCyclePk,
      correctionPk,
      signal
    );

  return {
    queryKey,
    queryFn,
    enabled:
      benefitPk !== null &&
      benefitPk !== undefined &&
      payrollCyclePk !== null &&
      payrollCyclePk !== undefined &&
      correctionPk !== null &&
      correctionPk !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof modularBenefitsPayrollCyclesCorrectionsRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ModularBenefitsPayrollCyclesCorrectionsRetrieveQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof modularBenefitsPayrollCyclesCorrectionsRetrieve>>
  >;
export type ModularBenefitsPayrollCyclesCorrectionsRetrieveQueryError = unknown;

export function useModularBenefitsPayrollCyclesCorrectionsRetrieve<
  TData = Awaited<
    ReturnType<typeof modularBenefitsPayrollCyclesCorrectionsRetrieve>
  >,
  TError = unknown,
>(
  benefitPk: number,
  payrollCyclePk: number,
  correctionPk: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<typeof modularBenefitsPayrollCyclesCorrectionsRetrieve>
      >,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getModularBenefitsPayrollCyclesCorrectionsRetrieveQueryOptions(
      benefitPk,
      payrollCyclePk,
      correctionPk,
      options
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const modularBenefitsPensionHolidayEndCreate = (
  benefitPk: number,
  holidayId: number,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/cockpit/v1.0/modular-benefits/${benefitPk}/pension-holiday/${holidayId}/end/`,
    method: 'POST',
    signal,
  });
};

export const getModularBenefitsPensionHolidayEndCreateMutationKey = () =>
  ['modularBenefitsPensionHolidayEndCreate'] as const;

export const getModularBenefitsPensionHolidayEndCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof modularBenefitsPensionHolidayEndCreate>>,
    TError,
    ModularBenefitsPensionHolidayEndCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof modularBenefitsPensionHolidayEndCreate>>,
  TError,
  ModularBenefitsPensionHolidayEndCreateMutationVariables,
  TContext
> => {
  const mutationKey = getModularBenefitsPensionHolidayEndCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof modularBenefitsPensionHolidayEndCreate>>,
    ModularBenefitsPensionHolidayEndCreateMutationVariables
  > = (props) => {
    const { benefitPk, holidayId } = props ?? {};

    return modularBenefitsPensionHolidayEndCreate(benefitPk, holidayId);
  };

  return { mutationFn, ...mutationOptions };
};

export type ModularBenefitsPensionHolidayEndCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof modularBenefitsPensionHolidayEndCreate>>
>;

export type ModularBenefitsPensionHolidayEndCreateMutationError = unknown;
export type ModularBenefitsPensionHolidayEndCreateMutationVariables = {
  benefitPk: number;
  holidayId: number;
};

export const useModularBenefitsPensionHolidayEndCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof modularBenefitsPensionHolidayEndCreate>>,
    TError,
    ModularBenefitsPensionHolidayEndCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof modularBenefitsPensionHolidayEndCreate>>,
  TError,
  ModularBenefitsPensionHolidayEndCreateMutationVariables,
  TContext
> => {
  return useMutation(
    getModularBenefitsPensionHolidayEndCreateMutationOptions(options)
  );
};

/**
 * The body expects a JSON containing the user inputs in this shape:
 *  {"<modular_benefit_field_key>": <user_input_value>,…}
 *
 * The endpoint will return validation errors if any of the input values
 * do not conform with the spec of that mod. ben. field
 */
export const modularBenefitsPriceCreate = (
  benefitPk: number,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<ModularBenefitPriceResponse>({
    url: `/cockpit/v1.0/modular-benefits/${benefitPk}/price/`,
    method: 'POST',
    signal,
  });
};

export const getModularBenefitsPriceCreateMutationKey = () =>
  ['modularBenefitsPriceCreate'] as const;

export const getModularBenefitsPriceCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof modularBenefitsPriceCreate>>,
    TError,
    ModularBenefitsPriceCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof modularBenefitsPriceCreate>>,
  TError,
  ModularBenefitsPriceCreateMutationVariables,
  TContext
> => {
  const mutationKey = getModularBenefitsPriceCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof modularBenefitsPriceCreate>>,
    ModularBenefitsPriceCreateMutationVariables
  > = (props) => {
    const { benefitPk } = props ?? {};

    return modularBenefitsPriceCreate(benefitPk);
  };

  return { mutationFn, ...mutationOptions };
};

export type ModularBenefitsPriceCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof modularBenefitsPriceCreate>>
>;

export type ModularBenefitsPriceCreateMutationError = unknown;
export type ModularBenefitsPriceCreateMutationVariables = { benefitPk: number };

export const useModularBenefitsPriceCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof modularBenefitsPriceCreate>>,
    TError,
    ModularBenefitsPriceCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof modularBenefitsPriceCreate>>,
  TError,
  ModularBenefitsPriceCreateMutationVariables,
  TContext
> => {
  return useMutation(getModularBenefitsPriceCreateMutationOptions(options));
};

export const modularBenefitsSubscriptionsRetrieve = (
  benefitPk: number,
  params?: ModularBenefitsSubscriptionsRetrieveParams,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<ModularBenefitSubscriptionsResponse>({
    url: `/cockpit/v1.0/modular-benefits/${benefitPk}/subscriptions/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getModularBenefitsSubscriptionsRetrieveQueryKey = (
  benefitPk: number,
  params?: ModularBenefitsSubscriptionsRetrieveParams
) => {
  return [
    `/cockpit/v1.0/modular-benefits/${benefitPk}/subscriptions/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getModularBenefitsSubscriptionsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof modularBenefitsSubscriptionsRetrieve>>,
  TError = unknown,
>(
  benefitPk: number,
  params?: ModularBenefitsSubscriptionsRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof modularBenefitsSubscriptionsRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getModularBenefitsSubscriptionsRetrieveQueryKey(benefitPk, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof modularBenefitsSubscriptionsRetrieve>>
  > = ({ signal }) =>
    modularBenefitsSubscriptionsRetrieve(benefitPk, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: benefitPk !== null && benefitPk !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof modularBenefitsSubscriptionsRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ModularBenefitsSubscriptionsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof modularBenefitsSubscriptionsRetrieve>>
>;
export type ModularBenefitsSubscriptionsRetrieveQueryError = unknown;

export function useModularBenefitsSubscriptionsRetrieve<
  TData = Awaited<ReturnType<typeof modularBenefitsSubscriptionsRetrieve>>,
  TError = unknown,
>(
  benefitPk: number,
  params?: ModularBenefitsSubscriptionsRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof modularBenefitsSubscriptionsRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getModularBenefitsSubscriptionsRetrieveQueryOptions(
    benefitPk,
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const modularBenefitsVersionsRetrieve = (
  benefitPk: number,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<ModularBenefitVersionsResponse>({
    url: `/cockpit/v1.0/modular-benefits/${benefitPk}/versions/`,
    method: 'GET',
    signal,
  });
};

export const getModularBenefitsVersionsRetrieveQueryKey = (
  benefitPk: number
) => {
  return [`/cockpit/v1.0/modular-benefits/${benefitPk}/versions/`] as const;
};

export const getModularBenefitsVersionsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof modularBenefitsVersionsRetrieve>>,
  TError = unknown,
>(
  benefitPk: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof modularBenefitsVersionsRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getModularBenefitsVersionsRetrieveQueryKey(benefitPk);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof modularBenefitsVersionsRetrieve>>
  > = ({ signal }) => modularBenefitsVersionsRetrieve(benefitPk, signal);

  return {
    queryKey,
    queryFn,
    enabled: benefitPk !== null && benefitPk !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof modularBenefitsVersionsRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ModularBenefitsVersionsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof modularBenefitsVersionsRetrieve>>
>;
export type ModularBenefitsVersionsRetrieveQueryError = unknown;

export function useModularBenefitsVersionsRetrieve<
  TData = Awaited<ReturnType<typeof modularBenefitsVersionsRetrieve>>,
  TError = unknown,
>(
  benefitPk: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof modularBenefitsVersionsRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getModularBenefitsVersionsRetrieveQueryOptions(
    benefitPk,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const modularBenefitsVersionsRetrieve2 = (
  benefitPk: number,
  benefitVersionPk: number,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<EnrollableBenefitDetailResponse>({
    url: `/cockpit/v1.0/modular-benefits/${benefitPk}/versions/${benefitVersionPk}/`,
    method: 'GET',
    signal,
  });
};

export const getModularBenefitsVersionsRetrieve2QueryKey = (
  benefitPk: number,
  benefitVersionPk: number
) => {
  return [
    `/cockpit/v1.0/modular-benefits/${benefitPk}/versions/${benefitVersionPk}/`,
  ] as const;
};

export const getModularBenefitsVersionsRetrieve2QueryOptions = <
  TData = Awaited<ReturnType<typeof modularBenefitsVersionsRetrieve2>>,
  TError = unknown,
>(
  benefitPk: number,
  benefitVersionPk: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof modularBenefitsVersionsRetrieve2>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getModularBenefitsVersionsRetrieve2QueryKey(benefitPk, benefitVersionPk);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof modularBenefitsVersionsRetrieve2>>
  > = ({ signal }) =>
    modularBenefitsVersionsRetrieve2(benefitPk, benefitVersionPk, signal);

  return {
    queryKey,
    queryFn,
    enabled:
      benefitPk !== null &&
      benefitPk !== undefined &&
      benefitVersionPk !== null &&
      benefitVersionPk !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof modularBenefitsVersionsRetrieve2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ModularBenefitsVersionsRetrieve2QueryResult = NonNullable<
  Awaited<ReturnType<typeof modularBenefitsVersionsRetrieve2>>
>;
export type ModularBenefitsVersionsRetrieve2QueryError = unknown;

export function useModularBenefitsVersionsRetrieve2<
  TData = Awaited<ReturnType<typeof modularBenefitsVersionsRetrieve2>>,
  TError = unknown,
>(
  benefitPk: number,
  benefitVersionPk: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof modularBenefitsVersionsRetrieve2>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getModularBenefitsVersionsRetrieve2QueryOptions(
    benefitPk,
    benefitVersionPk,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Functions the same as ModularBenefitPriceView, however the price
 * is calculated against the versioned benefit, with "now" being considered
 * as the scheduled_renewal_date.
 */
export const modularBenefitsVersionsPriceCreate = (
  benefitPk: number,
  benefitVersionPk: number,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<ModularBenefitPriceResponse>({
    url: `/cockpit/v1.0/modular-benefits/${benefitPk}/versions/${benefitVersionPk}/price/`,
    method: 'POST',
    signal,
  });
};

export const getModularBenefitsVersionsPriceCreateMutationKey = () =>
  ['modularBenefitsVersionsPriceCreate'] as const;

export const getModularBenefitsVersionsPriceCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof modularBenefitsVersionsPriceCreate>>,
    TError,
    ModularBenefitsVersionsPriceCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof modularBenefitsVersionsPriceCreate>>,
  TError,
  ModularBenefitsVersionsPriceCreateMutationVariables,
  TContext
> => {
  const mutationKey = getModularBenefitsVersionsPriceCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof modularBenefitsVersionsPriceCreate>>,
    ModularBenefitsVersionsPriceCreateMutationVariables
  > = (props) => {
    const { benefitPk, benefitVersionPk } = props ?? {};

    return modularBenefitsVersionsPriceCreate(benefitPk, benefitVersionPk);
  };

  return { mutationFn, ...mutationOptions };
};

export type ModularBenefitsVersionsPriceCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof modularBenefitsVersionsPriceCreate>>
>;

export type ModularBenefitsVersionsPriceCreateMutationError = unknown;
export type ModularBenefitsVersionsPriceCreateMutationVariables = {
  benefitPk: number;
  benefitVersionPk: number;
};

export const useModularBenefitsVersionsPriceCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof modularBenefitsVersionsPriceCreate>>,
    TError,
    ModularBenefitsVersionsPriceCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof modularBenefitsVersionsPriceCreate>>,
  TError,
  ModularBenefitsVersionsPriceCreateMutationVariables,
  TContext
> => {
  return useMutation(
    getModularBenefitsVersionsPriceCreateMutationOptions(options)
  );
};

export const notificationsRetrieve = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<void>({
    url: `/cockpit/v1.0/notifications/`,
    method: 'GET',
    signal,
  });
};

export const getNotificationsRetrieveQueryKey = () => {
  return [`/cockpit/v1.0/notifications/`] as const;
};

export const getNotificationsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof notificationsRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof notificationsRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getNotificationsRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof notificationsRetrieve>>
  > = ({ signal }) => notificationsRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof notificationsRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type NotificationsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof notificationsRetrieve>>
>;
export type NotificationsRetrieveQueryError = unknown;

export function useNotificationsRetrieve<
  TData = Awaited<ReturnType<typeof notificationsRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof notificationsRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getNotificationsRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const notificationsReadPartialUpdate = (
  patchedReadNotificationRequestRequest?: PatchedReadNotificationRequestRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<ReadNotificationResponse>({
    url: `/cockpit/v1.0/notifications/read/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchedReadNotificationRequestRequest,
    signal,
  });
};

export const getNotificationsReadPartialUpdateMutationKey = () =>
  ['notificationsReadPartialUpdate'] as const;

export const getNotificationsReadPartialUpdateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof notificationsReadPartialUpdate>>,
    TError,
    NotificationsReadPartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof notificationsReadPartialUpdate>>,
  TError,
  NotificationsReadPartialUpdateMutationVariables,
  TContext
> => {
  const mutationKey = getNotificationsReadPartialUpdateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof notificationsReadPartialUpdate>>,
    NotificationsReadPartialUpdateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return notificationsReadPartialUpdate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type NotificationsReadPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof notificationsReadPartialUpdate>>
>;
export type NotificationsReadPartialUpdateMutationBody =
  | PatchedReadNotificationRequestRequest
  | undefined;
export type NotificationsReadPartialUpdateMutationError = unknown;
export type NotificationsReadPartialUpdateMutationVariables = {
  data?: PatchedReadNotificationRequestRequest;
};

export const useNotificationsReadPartialUpdate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof notificationsReadPartialUpdate>>,
    TError,
    NotificationsReadPartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof notificationsReadPartialUpdate>>,
  TError,
  NotificationsReadPartialUpdateMutationVariables,
  TContext
> => {
  return useMutation(getNotificationsReadPartialUpdateMutationOptions(options));
};

export const onboardingRetrieve = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<OnboardingResponse>({
    url: `/cockpit/v1.0/onboarding/`,
    method: 'GET',
    signal,
  });
};

export const getOnboardingRetrieveQueryKey = () => {
  return [`/cockpit/v1.0/onboarding/`] as const;
};

export const getOnboardingRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof onboardingRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof onboardingRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getOnboardingRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof onboardingRetrieve>>
  > = ({ signal }) => onboardingRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof onboardingRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type OnboardingRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof onboardingRetrieve>>
>;
export type OnboardingRetrieveQueryError = unknown;

export function useOnboardingRetrieve<
  TData = Awaited<ReturnType<typeof onboardingRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof onboardingRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getOnboardingRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const onboardingPartialUpdate = (
  patchedCompleteOnboardingRequestRequest?: PatchedCompleteOnboardingRequestRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/cockpit/v1.0/onboarding/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchedCompleteOnboardingRequestRequest,
    signal,
  });
};

export const getOnboardingPartialUpdateMutationKey = () =>
  ['onboardingPartialUpdate'] as const;

export const getOnboardingPartialUpdateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof onboardingPartialUpdate>>,
    TError,
    OnboardingPartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof onboardingPartialUpdate>>,
  TError,
  OnboardingPartialUpdateMutationVariables,
  TContext
> => {
  const mutationKey = getOnboardingPartialUpdateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof onboardingPartialUpdate>>,
    OnboardingPartialUpdateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return onboardingPartialUpdate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type OnboardingPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof onboardingPartialUpdate>>
>;
export type OnboardingPartialUpdateMutationBody =
  | PatchedCompleteOnboardingRequestRequest
  | undefined;
export type OnboardingPartialUpdateMutationError = unknown;
export type OnboardingPartialUpdateMutationVariables = {
  data?: PatchedCompleteOnboardingRequestRequest;
};

export const useOnboardingPartialUpdate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof onboardingPartialUpdate>>,
    TError,
    OnboardingPartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof onboardingPartialUpdate>>,
  TError,
  OnboardingPartialUpdateMutationVariables,
  TContext
> => {
  return useMutation(getOnboardingPartialUpdateMutationOptions(options));
};

export const onboardingChecklistRetrieve = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<OnboardingChecklistResponse>({
    url: `/cockpit/v1.0/onboarding-checklist/`,
    method: 'GET',
    signal,
  });
};

export const getOnboardingChecklistRetrieveQueryKey = () => {
  return [`/cockpit/v1.0/onboarding-checklist/`] as const;
};

export const getOnboardingChecklistRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof onboardingChecklistRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof onboardingChecklistRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getOnboardingChecklistRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof onboardingChecklistRetrieve>>
  > = ({ signal }) => onboardingChecklistRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof onboardingChecklistRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type OnboardingChecklistRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof onboardingChecklistRetrieve>>
>;
export type OnboardingChecklistRetrieveQueryError = unknown;

export function useOnboardingChecklistRetrieve<
  TData = Awaited<ReturnType<typeof onboardingChecklistRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof onboardingChecklistRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getOnboardingChecklistRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const onboardingChecklistPartialUpdate = (
  patchedOnboardingChecklistRequestRequest?: PatchedOnboardingChecklistRequestRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/cockpit/v1.0/onboarding-checklist/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchedOnboardingChecklistRequestRequest,
    signal,
  });
};

export const getOnboardingChecklistPartialUpdateMutationKey = () =>
  ['onboardingChecklistPartialUpdate'] as const;

export const getOnboardingChecklistPartialUpdateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof onboardingChecklistPartialUpdate>>,
    TError,
    OnboardingChecklistPartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof onboardingChecklistPartialUpdate>>,
  TError,
  OnboardingChecklistPartialUpdateMutationVariables,
  TContext
> => {
  const mutationKey = getOnboardingChecklistPartialUpdateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof onboardingChecklistPartialUpdate>>,
    OnboardingChecklistPartialUpdateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return onboardingChecklistPartialUpdate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type OnboardingChecklistPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof onboardingChecklistPartialUpdate>>
>;
export type OnboardingChecklistPartialUpdateMutationBody =
  | PatchedOnboardingChecklistRequestRequest
  | undefined;
export type OnboardingChecklistPartialUpdateMutationError = unknown;
export type OnboardingChecklistPartialUpdateMutationVariables = {
  data?: PatchedOnboardingChecklistRequestRequest;
};

export const useOnboardingChecklistPartialUpdate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof onboardingChecklistPartialUpdate>>,
    TError,
    OnboardingChecklistPartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof onboardingChecklistPartialUpdate>>,
  TError,
  OnboardingChecklistPartialUpdateMutationVariables,
  TContext
> => {
  return useMutation(
    getOnboardingChecklistPartialUpdateMutationOptions(options)
  );
};

export const onboardingChecklistCompletionsUpdate = (
  itemId: number,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/cockpit/v1.0/onboarding-checklist/completions/${itemId}/`,
    method: 'PUT',
    signal,
  });
};

export const getOnboardingChecklistCompletionsUpdateMutationKey = () =>
  ['onboardingChecklistCompletionsUpdate'] as const;

export const getOnboardingChecklistCompletionsUpdateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof onboardingChecklistCompletionsUpdate>>,
    TError,
    OnboardingChecklistCompletionsUpdateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof onboardingChecklistCompletionsUpdate>>,
  TError,
  OnboardingChecklistCompletionsUpdateMutationVariables,
  TContext
> => {
  const mutationKey = getOnboardingChecklistCompletionsUpdateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof onboardingChecklistCompletionsUpdate>>,
    OnboardingChecklistCompletionsUpdateMutationVariables
  > = (props) => {
    const { itemId } = props ?? {};

    return onboardingChecklistCompletionsUpdate(itemId);
  };

  return { mutationFn, ...mutationOptions };
};

export type OnboardingChecklistCompletionsUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof onboardingChecklistCompletionsUpdate>>
>;

export type OnboardingChecklistCompletionsUpdateMutationError = unknown;
export type OnboardingChecklistCompletionsUpdateMutationVariables = {
  itemId: number;
};

export const useOnboardingChecklistCompletionsUpdate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof onboardingChecklistCompletionsUpdate>>,
    TError,
    OnboardingChecklistCompletionsUpdateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof onboardingChecklistCompletionsUpdate>>,
  TError,
  OnboardingChecklistCompletionsUpdateMutationVariables,
  TContext
> => {
  return useMutation(
    getOnboardingChecklistCompletionsUpdateMutationOptions(options)
  );
};

export const perksatworkAccountRequestCreate = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<void>({
    url: `/cockpit/v1.0/perksatwork-account-request/`,
    method: 'POST',
    signal,
  });
};

export const getPerksatworkAccountRequestCreateMutationKey = () =>
  ['perksatworkAccountRequestCreate'] as const;

export const getPerksatworkAccountRequestCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof perksatworkAccountRequestCreate>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof perksatworkAccountRequestCreate>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = getPerksatworkAccountRequestCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof perksatworkAccountRequestCreate>>,
    void
  > = () => {
    return perksatworkAccountRequestCreate();
  };

  return { mutationFn, ...mutationOptions };
};

export type PerksatworkAccountRequestCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof perksatworkAccountRequestCreate>>
>;

export type PerksatworkAccountRequestCreateMutationError = unknown;

export const usePerksatworkAccountRequestCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof perksatworkAccountRequestCreate>>,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof perksatworkAccountRequestCreate>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPerksatworkAccountRequestCreateMutationOptions(options)
  );
};

export const policiesRetrieve = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<void>({
    url: `/cockpit/v1.0/policies/`,
    method: 'GET',
    signal,
  });
};

export const getPoliciesRetrieveQueryKey = () => {
  return [`/cockpit/v1.0/policies/`] as const;
};

export const getPoliciesRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof policiesRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof policiesRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPoliciesRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof policiesRetrieve>>
  > = ({ signal }) => policiesRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof policiesRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PoliciesRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof policiesRetrieve>>
>;
export type PoliciesRetrieveQueryError = unknown;

export function usePoliciesRetrieve<
  TData = Awaited<ReturnType<typeof policiesRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof policiesRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getPoliciesRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const productsRetrieve = (id: number, signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<ProductResponse>({
    url: `/cockpit/v1.0/products/${id}/`,
    method: 'GET',
    signal,
  });
};

export const getProductsRetrieveQueryKey = (id: number) => {
  return [`/cockpit/v1.0/products/${id}/`] as const;
};

export const getProductsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof productsRetrieve>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof productsRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getProductsRetrieveQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof productsRetrieve>>
  > = ({ signal }) => productsRetrieve(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof productsRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ProductsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof productsRetrieve>>
>;
export type ProductsRetrieveQueryError = unknown;

export function useProductsRetrieve<
  TData = Awaited<ReturnType<typeof productsRetrieve>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof productsRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getProductsRetrieveQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const productsPurchaseCreate = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<PurchaseResponse>({
    url: `/cockpit/v1.0/products/purchase/`,
    method: 'POST',
    signal,
  });
};

export const getProductsPurchaseCreateMutationKey = () =>
  ['productsPurchaseCreate'] as const;

export const getProductsPurchaseCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof productsPurchaseCreate>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof productsPurchaseCreate>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = getProductsPurchaseCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof productsPurchaseCreate>>,
    void
  > = () => {
    return productsPurchaseCreate();
  };

  return { mutationFn, ...mutationOptions };
};

export type ProductsPurchaseCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof productsPurchaseCreate>>
>;

export type ProductsPurchaseCreateMutationError = unknown;

export const useProductsPurchaseCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof productsPurchaseCreate>>,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof productsPurchaseCreate>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getProductsPurchaseCreateMutationOptions(options));
};

export const receiptsExtractCreate = (
  receiptExtractionCreateRequest: ReceiptExtractionCreateRequest,
  signal?: AbortSignal
) => {
  const formData = new FormData();
  formData.append(`file`, receiptExtractionCreateRequest.file);
  if (receiptExtractionCreateRequest.rjsf_config_id !== undefined) {
    formData.append(
      `rjsf_config_id`,
      receiptExtractionCreateRequest.rjsf_config_id
    );
  }
  if (receiptExtractionCreateRequest.rjsf_field_descriptors !== undefined) {
    formData.append(
      `rjsf_field_descriptors`,
      receiptExtractionCreateRequest.rjsf_field_descriptors
    );
  }

  return axiosOrvalCustomInstance<ReceiptDraftStatus>({
    url: `/cockpit/v1.0/receipts/extract/`,
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
    signal,
  });
};

export const getReceiptsExtractCreateMutationKey = () =>
  ['receiptsExtractCreate'] as const;

export const getReceiptsExtractCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof receiptsExtractCreate>>,
    TError,
    ReceiptsExtractCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof receiptsExtractCreate>>,
  TError,
  ReceiptsExtractCreateMutationVariables,
  TContext
> => {
  const mutationKey = getReceiptsExtractCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof receiptsExtractCreate>>,
    ReceiptsExtractCreateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return receiptsExtractCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReceiptsExtractCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof receiptsExtractCreate>>
>;
export type ReceiptsExtractCreateMutationBody = ReceiptExtractionCreateRequest;
export type ReceiptsExtractCreateMutationError = unknown;
export type ReceiptsExtractCreateMutationVariables = {
  data: ReceiptExtractionCreateRequest;
};

export const useReceiptsExtractCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof receiptsExtractCreate>>,
    TError,
    ReceiptsExtractCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof receiptsExtractCreate>>,
  TError,
  ReceiptsExtractCreateMutationVariables,
  TContext
> => {
  return useMutation(getReceiptsExtractCreateMutationOptions(options));
};

export const receiptsExtractRetrieve = (
  draftUuid: string,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<ReceiptDraftStatus>({
    url: `/cockpit/v1.0/receipts/extract/${draftUuid}/`,
    method: 'GET',
    signal,
  });
};

export const getReceiptsExtractRetrieveQueryKey = (draftUuid: string) => {
  return [`/cockpit/v1.0/receipts/extract/${draftUuid}/`] as const;
};

export const getReceiptsExtractRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof receiptsExtractRetrieve>>,
  TError = unknown,
>(
  draftUuid: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof receiptsExtractRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getReceiptsExtractRetrieveQueryKey(draftUuid);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof receiptsExtractRetrieve>>
  > = ({ signal }) => receiptsExtractRetrieve(draftUuid, signal);

  return {
    queryKey,
    queryFn,
    enabled: draftUuid !== null && draftUuid !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof receiptsExtractRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ReceiptsExtractRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof receiptsExtractRetrieve>>
>;
export type ReceiptsExtractRetrieveQueryError = unknown;

export function useReceiptsExtractRetrieve<
  TData = Awaited<ReturnType<typeof receiptsExtractRetrieve>>,
  TError = unknown,
>(
  draftUuid: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof receiptsExtractRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getReceiptsExtractRetrieveQueryOptions(
    draftUuid,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Creates a recognition from the logged-in employee to the recipient.
 */
export const recognitionsCreate = (
  recognitionCreateRequestRequest: RecognitionCreateRequestRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/cockpit/v1.0/recognitions/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: recognitionCreateRequestRequest,
    signal,
  });
};

export const getRecognitionsCreateMutationKey = () =>
  ['recognitionsCreate'] as const;

export const getRecognitionsCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof recognitionsCreate>>,
    TError,
    RecognitionsCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof recognitionsCreate>>,
  TError,
  RecognitionsCreateMutationVariables,
  TContext
> => {
  const mutationKey = getRecognitionsCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof recognitionsCreate>>,
    RecognitionsCreateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return recognitionsCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RecognitionsCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof recognitionsCreate>>
>;
export type RecognitionsCreateMutationBody = RecognitionCreateRequestRequest;
export type RecognitionsCreateMutationError = unknown;
export type RecognitionsCreateMutationVariables = {
  data: RecognitionCreateRequestRequest;
};

export const useRecognitionsCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof recognitionsCreate>>,
    TError,
    RecognitionsCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof recognitionsCreate>>,
  TError,
  RecognitionsCreateMutationVariables,
  TContext
> => {
  return useMutation(getRecognitionsCreateMutationOptions(options));
};

/**
 * Returns a list of all employees eligible for recognition.
 */
export const recognitionsEmployeesRetrieve = (
  params?: RecognitionsEmployeesRetrieveParams,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<RecognitionEmployeesResponse>({
    url: `/cockpit/v1.0/recognitions/employees/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getRecognitionsEmployeesRetrieveQueryKey = (
  params?: RecognitionsEmployeesRetrieveParams
) => {
  return [
    `/cockpit/v1.0/recognitions/employees/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getRecognitionsEmployeesRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof recognitionsEmployeesRetrieve>>,
  TError = unknown,
>(
  params?: RecognitionsEmployeesRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof recognitionsEmployeesRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getRecognitionsEmployeesRetrieveQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof recognitionsEmployeesRetrieve>>
  > = ({ signal }) => recognitionsEmployeesRetrieve(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof recognitionsEmployeesRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type RecognitionsEmployeesRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof recognitionsEmployeesRetrieve>>
>;
export type RecognitionsEmployeesRetrieveQueryError = unknown;

export function useRecognitionsEmployeesRetrieve<
  TData = Awaited<ReturnType<typeof recognitionsEmployeesRetrieve>>,
  TError = unknown,
>(
  params?: RecognitionsEmployeesRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof recognitionsEmployeesRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getRecognitionsEmployeesRetrieveQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Returns an AI-generated recognition message for a given user and occasion.
 * Optionally accepts an input message to use as a base for rewriting.
 */
export const recognitionsSuggestionsCreate = (
  recognitionSuggestionsRequestRequest: RecognitionSuggestionsRequestRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<RecognitionSuggestionsResponse>({
    url: `/cockpit/v1.0/recognitions/suggestions/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: recognitionSuggestionsRequestRequest,
    signal,
  });
};

export const getRecognitionsSuggestionsCreateMutationKey = () =>
  ['recognitionsSuggestionsCreate'] as const;

export const getRecognitionsSuggestionsCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof recognitionsSuggestionsCreate>>,
    TError,
    RecognitionsSuggestionsCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof recognitionsSuggestionsCreate>>,
  TError,
  RecognitionsSuggestionsCreateMutationVariables,
  TContext
> => {
  const mutationKey = getRecognitionsSuggestionsCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof recognitionsSuggestionsCreate>>,
    RecognitionsSuggestionsCreateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return recognitionsSuggestionsCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RecognitionsSuggestionsCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof recognitionsSuggestionsCreate>>
>;
export type RecognitionsSuggestionsCreateMutationBody =
  RecognitionSuggestionsRequestRequest;
export type RecognitionsSuggestionsCreateMutationError = unknown;
export type RecognitionsSuggestionsCreateMutationVariables = {
  data: RecognitionSuggestionsRequestRequest;
};

export const useRecognitionsSuggestionsCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof recognitionsSuggestionsCreate>>,
    TError,
    RecognitionsSuggestionsCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof recognitionsSuggestionsCreate>>,
  TError,
  RecognitionsSuggestionsCreateMutationVariables,
  TContext
> => {
  return useMutation(getRecognitionsSuggestionsCreateMutationOptions(options));
};

export const reimbursementUpdate = (
  reimbursementRequestRequest: ReimbursementRequestRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/cockpit/v1.0/reimbursement/`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: reimbursementRequestRequest,
    signal,
  });
};

export const getReimbursementUpdateMutationKey = () =>
  ['reimbursementUpdate'] as const;

export const getReimbursementUpdateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reimbursementUpdate>>,
    TError,
    ReimbursementUpdateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof reimbursementUpdate>>,
  TError,
  ReimbursementUpdateMutationVariables,
  TContext
> => {
  const mutationKey = getReimbursementUpdateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof reimbursementUpdate>>,
    ReimbursementUpdateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return reimbursementUpdate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReimbursementUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof reimbursementUpdate>>
>;
export type ReimbursementUpdateMutationBody = ReimbursementRequestRequest;
export type ReimbursementUpdateMutationError = unknown;
export type ReimbursementUpdateMutationVariables = {
  data: ReimbursementRequestRequest;
};

export const useReimbursementUpdate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reimbursementUpdate>>,
    TError,
    ReimbursementUpdateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof reimbursementUpdate>>,
  TError,
  ReimbursementUpdateMutationVariables,
  TContext
> => {
  return useMutation(getReimbursementUpdateMutationOptions(options));
};

export const reimbursementDetailRetrieve = (
  reimbursementUuid: string,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<ReimbursementRequestBase>({
    url: `/cockpit/v1.0/reimbursement/${reimbursementUuid}/detail/`,
    method: 'GET',
    signal,
  });
};

export const getReimbursementDetailRetrieveQueryKey = (
  reimbursementUuid: string
) => {
  return [`/cockpit/v1.0/reimbursement/${reimbursementUuid}/detail/`] as const;
};

export const getReimbursementDetailRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof reimbursementDetailRetrieve>>,
  TError = unknown,
>(
  reimbursementUuid: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof reimbursementDetailRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getReimbursementDetailRetrieveQueryKey(reimbursementUuid);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof reimbursementDetailRetrieve>>
  > = ({ signal }) => reimbursementDetailRetrieve(reimbursementUuid, signal);

  return {
    queryKey,
    queryFn,
    enabled: reimbursementUuid !== null && reimbursementUuid !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof reimbursementDetailRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ReimbursementDetailRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof reimbursementDetailRetrieve>>
>;
export type ReimbursementDetailRetrieveQueryError = unknown;

export function useReimbursementDetailRetrieve<
  TData = Awaited<ReturnType<typeof reimbursementDetailRetrieve>>,
  TError = unknown,
>(
  reimbursementUuid: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof reimbursementDetailRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getReimbursementDetailRetrieveQueryOptions(
    reimbursementUuid,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const residencyTypeRetrieve = (
  country: string,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<ResidencyType>({
    url: `/cockpit/v1.0/residency-type/${country}/`,
    method: 'GET',
    signal,
  });
};

export const getResidencyTypeRetrieveQueryKey = (country: string) => {
  return [`/cockpit/v1.0/residency-type/${country}/`] as const;
};

export const getResidencyTypeRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof residencyTypeRetrieve>>,
  TError = unknown,
>(
  country: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof residencyTypeRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getResidencyTypeRetrieveQueryKey(country);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof residencyTypeRetrieve>>
  > = ({ signal }) => residencyTypeRetrieve(country, signal);

  return {
    queryKey,
    queryFn,
    enabled: country !== null && country !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof residencyTypeRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ResidencyTypeRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof residencyTypeRetrieve>>
>;
export type ResidencyTypeRetrieveQueryError = unknown;

export function useResidencyTypeRetrieve<
  TData = Awaited<ReturnType<typeof residencyTypeRetrieve>>,
  TError = unknown,
>(
  country: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof residencyTypeRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getResidencyTypeRetrieveQueryOptions(country, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const cockpitRewardsRetrieve = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<RewardResponse>({
    url: `/cockpit/v1.0/rewards/`,
    method: 'GET',
    signal,
  });
};

export const getCockpitRewardsRetrieveQueryKey = () => {
  return [`/cockpit/v1.0/rewards/`] as const;
};

export const getCockpitRewardsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof cockpitRewardsRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof cockpitRewardsRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getCockpitRewardsRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof cockpitRewardsRetrieve>>
  > = ({ signal }) => cockpitRewardsRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof cockpitRewardsRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CockpitRewardsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof cockpitRewardsRetrieve>>
>;
export type CockpitRewardsRetrieveQueryError = unknown;

export function useCockpitRewardsRetrieve<
  TData = Awaited<ReturnType<typeof cockpitRewardsRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof cockpitRewardsRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getCockpitRewardsRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Returns a paginated list of all rewards budgets available to a given employee,
 * including current balance and reward limits.
 */
export const rewardsSpendingBalancesRetrieve = (
  params?: RewardsSpendingBalancesRetrieveParams,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<RewardsSpendingBalanceListResponse>({
    url: `/cockpit/v1.0/rewards-spending-balances/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getRewardsSpendingBalancesRetrieveQueryKey = (
  params?: RewardsSpendingBalancesRetrieveParams
) => {
  return [
    `/cockpit/v1.0/rewards-spending-balances/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getRewardsSpendingBalancesRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof rewardsSpendingBalancesRetrieve>>,
  TError = unknown,
>(
  params?: RewardsSpendingBalancesRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof rewardsSpendingBalancesRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getRewardsSpendingBalancesRetrieveQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof rewardsSpendingBalancesRetrieve>>
  > = ({ signal }) => rewardsSpendingBalancesRetrieve(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof rewardsSpendingBalancesRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type RewardsSpendingBalancesRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof rewardsSpendingBalancesRetrieve>>
>;
export type RewardsSpendingBalancesRetrieveQueryError = unknown;

export function useRewardsSpendingBalancesRetrieve<
  TData = Awaited<ReturnType<typeof rewardsSpendingBalancesRetrieve>>,
  TError = unknown,
>(
  params?: RewardsSpendingBalancesRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof rewardsSpendingBalancesRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getRewardsSpendingBalancesRetrieveQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Returns all transactions for a specific employee's rewards spending balance.
 */
export const rewardsSpendingBalancesTransactionsRetrieve = (
  rewardsSpendingBalanceId: number,
  params?: RewardsSpendingBalancesTransactionsRetrieveParams,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<RewardsTransactionsResponse>({
    url: `/cockpit/v1.0/rewards-spending-balances/${rewardsSpendingBalanceId}/transactions/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getRewardsSpendingBalancesTransactionsRetrieveQueryKey = (
  rewardsSpendingBalanceId: number,
  params?: RewardsSpendingBalancesTransactionsRetrieveParams
) => {
  return [
    `/cockpit/v1.0/rewards-spending-balances/${rewardsSpendingBalanceId}/transactions/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getRewardsSpendingBalancesTransactionsRetrieveQueryOptions = <
  TData = Awaited<
    ReturnType<typeof rewardsSpendingBalancesTransactionsRetrieve>
  >,
  TError = unknown,
>(
  rewardsSpendingBalanceId: number,
  params?: RewardsSpendingBalancesTransactionsRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof rewardsSpendingBalancesTransactionsRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getRewardsSpendingBalancesTransactionsRetrieveQueryKey(
      rewardsSpendingBalanceId,
      params
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof rewardsSpendingBalancesTransactionsRetrieve>>
  > = ({ signal }) =>
    rewardsSpendingBalancesTransactionsRetrieve(
      rewardsSpendingBalanceId,
      params,
      signal
    );

  return {
    queryKey,
    queryFn,
    enabled:
      rewardsSpendingBalanceId !== null &&
      rewardsSpendingBalanceId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof rewardsSpendingBalancesTransactionsRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type RewardsSpendingBalancesTransactionsRetrieveQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof rewardsSpendingBalancesTransactionsRetrieve>>
  >;
export type RewardsSpendingBalancesTransactionsRetrieveQueryError = unknown;

export function useRewardsSpendingBalancesTransactionsRetrieve<
  TData = Awaited<
    ReturnType<typeof rewardsSpendingBalancesTransactionsRetrieve>
  >,
  TError = unknown,
>(
  rewardsSpendingBalanceId: number,
  params?: RewardsSpendingBalancesTransactionsRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof rewardsSpendingBalancesTransactionsRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getRewardsSpendingBalancesTransactionsRetrieveQueryOptions(
      rewardsSpendingBalanceId,
      params,
      options
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const rewardsRetrieve2 = (rewardId: number, signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<RewardResponse>({
    url: `/cockpit/v1.0/rewards/${rewardId}/`,
    method: 'GET',
    signal,
  });
};

export const getRewardsRetrieve2QueryKey = (rewardId: number) => {
  return [`/cockpit/v1.0/rewards/${rewardId}/`] as const;
};

export const getRewardsRetrieve2QueryOptions = <
  TData = Awaited<ReturnType<typeof rewardsRetrieve2>>,
  TError = unknown,
>(
  rewardId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof rewardsRetrieve2>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getRewardsRetrieve2QueryKey(rewardId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof rewardsRetrieve2>>
  > = ({ signal }) => rewardsRetrieve2(rewardId, signal);

  return {
    queryKey,
    queryFn,
    enabled: rewardId !== null && rewardId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof rewardsRetrieve2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type RewardsRetrieve2QueryResult = NonNullable<
  Awaited<ReturnType<typeof rewardsRetrieve2>>
>;
export type RewardsRetrieve2QueryError = unknown;

export function useRewardsRetrieve2<
  TData = Awaited<ReturnType<typeof rewardsRetrieve2>>,
  TError = unknown,
>(
  rewardId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof rewardsRetrieve2>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getRewardsRetrieve2QueryOptions(rewardId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const salaryDeductionsRetrieve = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<SalaryDeductionsResponse>({
    url: `/cockpit/v1.0/salary-deductions/`,
    method: 'GET',
    signal,
  });
};

export const getSalaryDeductionsRetrieveQueryKey = () => {
  return [`/cockpit/v1.0/salary-deductions/`] as const;
};

export const getSalaryDeductionsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof salaryDeductionsRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof salaryDeductionsRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getSalaryDeductionsRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof salaryDeductionsRetrieve>>
  > = ({ signal }) => salaryDeductionsRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof salaryDeductionsRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SalaryDeductionsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof salaryDeductionsRetrieve>>
>;
export type SalaryDeductionsRetrieveQueryError = unknown;

export function useSalaryDeductionsRetrieve<
  TData = Awaited<ReturnType<typeof salaryDeductionsRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof salaryDeductionsRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSalaryDeductionsRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const scaAuthorizeCreate = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<ScaAuthorizeResponse>({
    url: `/cockpit/v1.0/sca/authorize/`,
    method: 'POST',
    signal,
  });
};

export const getScaAuthorizeCreateMutationKey = () =>
  ['scaAuthorizeCreate'] as const;

export const getScaAuthorizeCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scaAuthorizeCreate>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof scaAuthorizeCreate>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = getScaAuthorizeCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof scaAuthorizeCreate>>,
    void
  > = () => {
    return scaAuthorizeCreate();
  };

  return { mutationFn, ...mutationOptions };
};

export type ScaAuthorizeCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof scaAuthorizeCreate>>
>;

export type ScaAuthorizeCreateMutationError = unknown;

export const useScaAuthorizeCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scaAuthorizeCreate>>,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof scaAuthorizeCreate>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getScaAuthorizeCreateMutationOptions(options));
};

export const setWeavrPasswordCreate = (
  weavrPasswordRequestRequest: WeavrPasswordRequestRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/cockpit/v1.0/set-weavr-password/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: weavrPasswordRequestRequest,
    signal,
  });
};

export const getSetWeavrPasswordCreateMutationKey = () =>
  ['setWeavrPasswordCreate'] as const;

export const getSetWeavrPasswordCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setWeavrPasswordCreate>>,
    TError,
    SetWeavrPasswordCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setWeavrPasswordCreate>>,
  TError,
  SetWeavrPasswordCreateMutationVariables,
  TContext
> => {
  const mutationKey = getSetWeavrPasswordCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setWeavrPasswordCreate>>,
    SetWeavrPasswordCreateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return setWeavrPasswordCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetWeavrPasswordCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof setWeavrPasswordCreate>>
>;
export type SetWeavrPasswordCreateMutationBody = WeavrPasswordRequestRequest;
export type SetWeavrPasswordCreateMutationError = unknown;
export type SetWeavrPasswordCreateMutationVariables = {
  data: WeavrPasswordRequestRequest;
};

export const useSetWeavrPasswordCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setWeavrPasswordCreate>>,
    TError,
    SetWeavrPasswordCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof setWeavrPasswordCreate>>,
  TError,
  SetWeavrPasswordCreateMutationVariables,
  TContext
> => {
  return useMutation(getSetWeavrPasswordCreateMutationOptions(options));
};

export const cockpitTransactionsReceiptsList = (
  transactionId: number,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<Receipt[]>({
    url: `/cockpit/v1.0/transactions/${transactionId}/receipts/`,
    method: 'GET',
    signal,
  });
};

export const getCockpitTransactionsReceiptsListQueryKey = (
  transactionId: number
) => {
  return [`/cockpit/v1.0/transactions/${transactionId}/receipts/`] as const;
};

export const getCockpitTransactionsReceiptsListQueryOptions = <
  TData = Awaited<ReturnType<typeof cockpitTransactionsReceiptsList>>,
  TError = unknown,
>(
  transactionId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof cockpitTransactionsReceiptsList>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getCockpitTransactionsReceiptsListQueryKey(transactionId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof cockpitTransactionsReceiptsList>>
  > = ({ signal }) => cockpitTransactionsReceiptsList(transactionId, signal);

  return {
    queryKey,
    queryFn,
    enabled: transactionId !== null && transactionId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof cockpitTransactionsReceiptsList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CockpitTransactionsReceiptsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof cockpitTransactionsReceiptsList>>
>;
export type CockpitTransactionsReceiptsListQueryError = unknown;

export function useCockpitTransactionsReceiptsList<
  TData = Awaited<ReturnType<typeof cockpitTransactionsReceiptsList>>,
  TError = unknown,
>(
  transactionId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof cockpitTransactionsReceiptsList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getCockpitTransactionsReceiptsListQueryOptions(
    transactionId,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const transactionsCancelRequestPartialUpdate = (
  transactionUuid: string,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/cockpit/v1.0/transactions/${transactionUuid}/cancel-request/`,
    method: 'PATCH',
    signal,
  });
};

export const getTransactionsCancelRequestPartialUpdateMutationKey = () =>
  ['transactionsCancelRequestPartialUpdate'] as const;

export const getTransactionsCancelRequestPartialUpdateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof transactionsCancelRequestPartialUpdate>>,
    TError,
    TransactionsCancelRequestPartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof transactionsCancelRequestPartialUpdate>>,
  TError,
  TransactionsCancelRequestPartialUpdateMutationVariables,
  TContext
> => {
  const mutationKey = getTransactionsCancelRequestPartialUpdateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof transactionsCancelRequestPartialUpdate>>,
    TransactionsCancelRequestPartialUpdateMutationVariables
  > = (props) => {
    const { transactionUuid } = props ?? {};

    return transactionsCancelRequestPartialUpdate(transactionUuid);
  };

  return { mutationFn, ...mutationOptions };
};

export type TransactionsCancelRequestPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof transactionsCancelRequestPartialUpdate>>
>;

export type TransactionsCancelRequestPartialUpdateMutationError = unknown;
export type TransactionsCancelRequestPartialUpdateMutationVariables = {
  transactionUuid: string;
};

export const useTransactionsCancelRequestPartialUpdate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof transactionsCancelRequestPartialUpdate>>,
    TError,
    TransactionsCancelRequestPartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof transactionsCancelRequestPartialUpdate>>,
  TError,
  TransactionsCancelRequestPartialUpdateMutationVariables,
  TContext
> => {
  return useMutation(
    getTransactionsCancelRequestPartialUpdateMutationOptions(options)
  );
};

export const transactionsMissingReceiptsList = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<TransactionResponse[]>({
    url: `/cockpit/v1.0/transactions/missing-receipts/`,
    method: 'GET',
    signal,
  });
};

export const getTransactionsMissingReceiptsListQueryKey = () => {
  return [`/cockpit/v1.0/transactions/missing-receipts/`] as const;
};

export const getTransactionsMissingReceiptsListQueryOptions = <
  TData = Awaited<ReturnType<typeof transactionsMissingReceiptsList>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof transactionsMissingReceiptsList>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getTransactionsMissingReceiptsListQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof transactionsMissingReceiptsList>>
  > = ({ signal }) => transactionsMissingReceiptsList(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof transactionsMissingReceiptsList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type TransactionsMissingReceiptsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof transactionsMissingReceiptsList>>
>;
export type TransactionsMissingReceiptsListQueryError = unknown;

export function useTransactionsMissingReceiptsList<
  TData = Awaited<ReturnType<typeof transactionsMissingReceiptsList>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof transactionsMissingReceiptsList>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getTransactionsMissingReceiptsListQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const cockpitUiConfigRetrieve = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<UiConfigResponse>({
    url: `/cockpit/v1.0/ui-config/`,
    method: 'GET',
    signal,
  });
};

export const getCockpitUiConfigRetrieveQueryKey = () => {
  return [`/cockpit/v1.0/ui-config/`] as const;
};

export const getCockpitUiConfigRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof cockpitUiConfigRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof cockpitUiConfigRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getCockpitUiConfigRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof cockpitUiConfigRetrieve>>
  > = ({ signal }) => cockpitUiConfigRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof cockpitUiConfigRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CockpitUiConfigRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof cockpitUiConfigRetrieve>>
>;
export type CockpitUiConfigRetrieveQueryError = unknown;

export function useCockpitUiConfigRetrieve<
  TData = Awaited<ReturnType<typeof cockpitUiConfigRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof cockpitUiConfigRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getCockpitUiConfigRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const walletsRetrieve = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<void>({
    url: `/cockpit/v1.0/wallets/`,
    method: 'GET',
    signal,
  });
};

export const getWalletsRetrieveQueryKey = () => {
  return [`/cockpit/v1.0/wallets/`] as const;
};

export const getWalletsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof walletsRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof walletsRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getWalletsRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof walletsRetrieve>>> = ({
    signal,
  }) => walletsRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof walletsRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type WalletsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof walletsRetrieve>>
>;
export type WalletsRetrieveQueryError = unknown;

export function useWalletsRetrieve<
  TData = Awaited<ReturnType<typeof walletsRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof walletsRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getWalletsRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const weavrMfaList = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<EmployeeWeavrMFAResponse[]>({
    url: `/cockpit/v1.0/weavr/mfa/`,
    method: 'GET',
    signal,
  });
};

export const getWeavrMfaListQueryKey = () => {
  return [`/cockpit/v1.0/weavr/mfa/`] as const;
};

export const getWeavrMfaListQueryOptions = <
  TData = Awaited<ReturnType<typeof weavrMfaList>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof weavrMfaList>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getWeavrMfaListQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof weavrMfaList>>> = ({
    signal,
  }) => weavrMfaList(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof weavrMfaList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type WeavrMfaListQueryResult = NonNullable<
  Awaited<ReturnType<typeof weavrMfaList>>
>;
export type WeavrMfaListQueryError = unknown;

export function useWeavrMfaList<
  TData = Awaited<ReturnType<typeof weavrMfaList>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof weavrMfaList>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getWeavrMfaListQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const weavrMfaCreate = (
  employeeWeavrMFARequestRequest: EmployeeWeavrMFARequestRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/cockpit/v1.0/weavr/mfa/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: employeeWeavrMFARequestRequest,
    signal,
  });
};

export const getWeavrMfaCreateMutationKey = () => ['weavrMfaCreate'] as const;

export const getWeavrMfaCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof weavrMfaCreate>>,
    TError,
    WeavrMfaCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof weavrMfaCreate>>,
  TError,
  WeavrMfaCreateMutationVariables,
  TContext
> => {
  const mutationKey = getWeavrMfaCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof weavrMfaCreate>>,
    WeavrMfaCreateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return weavrMfaCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type WeavrMfaCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof weavrMfaCreate>>
>;
export type WeavrMfaCreateMutationBody = EmployeeWeavrMFARequestRequest;
export type WeavrMfaCreateMutationError = unknown;
export type WeavrMfaCreateMutationVariables = {
  data: EmployeeWeavrMFARequestRequest;
};

export const useWeavrMfaCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof weavrMfaCreate>>,
    TError,
    WeavrMfaCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof weavrMfaCreate>>,
  TError,
  WeavrMfaCreateMutationVariables,
  TContext
> => {
  return useMutation(getWeavrMfaCreateMutationOptions(options));
};

export const weavrMfaPartialUpdate = (
  patchedVerifyMobileVerificationCodeRequestRequest?: PatchedVerifyMobileVerificationCodeRequestRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/cockpit/v1.0/weavr/mfa/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchedVerifyMobileVerificationCodeRequestRequest,
    signal,
  });
};

export const getWeavrMfaPartialUpdateMutationKey = () =>
  ['weavrMfaPartialUpdate'] as const;

export const getWeavrMfaPartialUpdateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof weavrMfaPartialUpdate>>,
    TError,
    WeavrMfaPartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof weavrMfaPartialUpdate>>,
  TError,
  WeavrMfaPartialUpdateMutationVariables,
  TContext
> => {
  const mutationKey = getWeavrMfaPartialUpdateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof weavrMfaPartialUpdate>>,
    WeavrMfaPartialUpdateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return weavrMfaPartialUpdate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type WeavrMfaPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof weavrMfaPartialUpdate>>
>;
export type WeavrMfaPartialUpdateMutationBody =
  | PatchedVerifyMobileVerificationCodeRequestRequest
  | undefined;
export type WeavrMfaPartialUpdateMutationError = unknown;
export type WeavrMfaPartialUpdateMutationVariables = {
  data?: PatchedVerifyMobileVerificationCodeRequestRequest;
};

export const useWeavrMfaPartialUpdate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof weavrMfaPartialUpdate>>,
    TError,
    WeavrMfaPartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof weavrMfaPartialUpdate>>,
  TError,
  WeavrMfaPartialUpdateMutationVariables,
  TContext
> => {
  return useMutation(getWeavrMfaPartialUpdateMutationOptions(options));
};

export const weavrStepUpCreate = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<void>({
    url: `/cockpit/v1.0/weavr/step-up/`,
    method: 'POST',
    signal,
  });
};

export const getWeavrStepUpCreateMutationKey = () =>
  ['weavrStepUpCreate'] as const;

export const getWeavrStepUpCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof weavrStepUpCreate>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof weavrStepUpCreate>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = getWeavrStepUpCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof weavrStepUpCreate>>,
    void
  > = () => {
    return weavrStepUpCreate();
  };

  return { mutationFn, ...mutationOptions };
};

export type WeavrStepUpCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof weavrStepUpCreate>>
>;

export type WeavrStepUpCreateMutationError = unknown;

export const useWeavrStepUpCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof weavrStepUpCreate>>,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof weavrStepUpCreate>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getWeavrStepUpCreateMutationOptions(options));
};

export const weavrStepUpVerifyCreate = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<void>({
    url: `/cockpit/v1.0/weavr/step-up/verify/`,
    method: 'POST',
    signal,
  });
};

export const getWeavrStepUpVerifyCreateMutationKey = () =>
  ['weavrStepUpVerifyCreate'] as const;

export const getWeavrStepUpVerifyCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof weavrStepUpVerifyCreate>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof weavrStepUpVerifyCreate>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = getWeavrStepUpVerifyCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof weavrStepUpVerifyCreate>>,
    void
  > = () => {
    return weavrStepUpVerifyCreate();
  };

  return { mutationFn, ...mutationOptions };
};

export type WeavrStepUpVerifyCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof weavrStepUpVerifyCreate>>
>;

export type WeavrStepUpVerifyCreateMutationError = unknown;

export const useWeavrStepUpVerifyCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof weavrStepUpVerifyCreate>>,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof weavrStepUpVerifyCreate>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getWeavrStepUpVerifyCreateMutationOptions(options));
};

export const benefitDelaysList = (
  params?: BenefitDelaysListParams,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<PaginatedBenefitDelayList>({
    url: `/columbia/v1.0/benefit-delays/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getBenefitDelaysListQueryKey = (
  params?: BenefitDelaysListParams
) => {
  return [
    `/columbia/v1.0/benefit-delays/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getBenefitDelaysListQueryOptions = <
  TData = Awaited<ReturnType<typeof benefitDelaysList>>,
  TError = unknown,
>(
  params?: BenefitDelaysListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof benefitDelaysList>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getBenefitDelaysListQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof benefitDelaysList>>
  > = ({ signal }) => benefitDelaysList(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof benefitDelaysList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type BenefitDelaysListQueryResult = NonNullable<
  Awaited<ReturnType<typeof benefitDelaysList>>
>;
export type BenefitDelaysListQueryError = unknown;

export function useBenefitDelaysList<
  TData = Awaited<ReturnType<typeof benefitDelaysList>>,
  TError = unknown,
>(
  params?: BenefitDelaysListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof benefitDelaysList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getBenefitDelaysListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const benefitDocumentsList = (
  params?: BenefitDocumentsListParams,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<PaginatedBenefitDocumentCreateRequestList>({
    url: `/columbia/v1.0/benefit-documents/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getBenefitDocumentsListQueryKey = (
  params?: BenefitDocumentsListParams
) => {
  return [
    `/columbia/v1.0/benefit-documents/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getBenefitDocumentsListQueryOptions = <
  TData = Awaited<ReturnType<typeof benefitDocumentsList>>,
  TError = unknown,
>(
  params?: BenefitDocumentsListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof benefitDocumentsList>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getBenefitDocumentsListQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof benefitDocumentsList>>
  > = ({ signal }) => benefitDocumentsList(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof benefitDocumentsList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type BenefitDocumentsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof benefitDocumentsList>>
>;
export type BenefitDocumentsListQueryError = unknown;

export function useBenefitDocumentsList<
  TData = Awaited<ReturnType<typeof benefitDocumentsList>>,
  TError = unknown,
>(
  params?: BenefitDocumentsListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof benefitDocumentsList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getBenefitDocumentsListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const benefitDocumentsCreate = (
  benefitDocumentCreateRequestRequest: BenefitDocumentCreateRequestRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<BenefitDocumentCreateRequest>({
    url: `/columbia/v1.0/benefit-documents/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: benefitDocumentCreateRequestRequest,
    signal,
  });
};

export const getBenefitDocumentsCreateMutationKey = () =>
  ['benefitDocumentsCreate'] as const;

export const getBenefitDocumentsCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof benefitDocumentsCreate>>,
    TError,
    BenefitDocumentsCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof benefitDocumentsCreate>>,
  TError,
  BenefitDocumentsCreateMutationVariables,
  TContext
> => {
  const mutationKey = getBenefitDocumentsCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof benefitDocumentsCreate>>,
    BenefitDocumentsCreateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return benefitDocumentsCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type BenefitDocumentsCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof benefitDocumentsCreate>>
>;
export type BenefitDocumentsCreateMutationBody =
  BenefitDocumentCreateRequestRequest;
export type BenefitDocumentsCreateMutationError = unknown;
export type BenefitDocumentsCreateMutationVariables = {
  data: BenefitDocumentCreateRequestRequest;
};

export const useBenefitDocumentsCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof benefitDocumentsCreate>>,
    TError,
    BenefitDocumentsCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof benefitDocumentsCreate>>,
  TError,
  BenefitDocumentsCreateMutationVariables,
  TContext
> => {
  return useMutation(getBenefitDocumentsCreateMutationOptions(options));
};

export const benefitDocumentsPartialUpdate = (
  benefitDocumentPk: number,
  patchedBenefitDocumentUpdateRequestRequest?: PatchedBenefitDocumentUpdateRequestRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<BenefitDocumentUpdateRequest>({
    url: `/columbia/v1.0/benefit-documents/${benefitDocumentPk}/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchedBenefitDocumentUpdateRequestRequest,
    signal,
  });
};

export const getBenefitDocumentsPartialUpdateMutationKey = () =>
  ['benefitDocumentsPartialUpdate'] as const;

export const getBenefitDocumentsPartialUpdateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof benefitDocumentsPartialUpdate>>,
    TError,
    BenefitDocumentsPartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof benefitDocumentsPartialUpdate>>,
  TError,
  BenefitDocumentsPartialUpdateMutationVariables,
  TContext
> => {
  const mutationKey = getBenefitDocumentsPartialUpdateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof benefitDocumentsPartialUpdate>>,
    BenefitDocumentsPartialUpdateMutationVariables
  > = (props) => {
    const { benefitDocumentPk, data } = props ?? {};

    return benefitDocumentsPartialUpdate(benefitDocumentPk, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type BenefitDocumentsPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof benefitDocumentsPartialUpdate>>
>;
export type BenefitDocumentsPartialUpdateMutationBody =
  | PatchedBenefitDocumentUpdateRequestRequest
  | undefined;
export type BenefitDocumentsPartialUpdateMutationError = unknown;
export type BenefitDocumentsPartialUpdateMutationVariables = {
  benefitDocumentPk: number;
  data?: PatchedBenefitDocumentUpdateRequestRequest;
};

export const useBenefitDocumentsPartialUpdate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof benefitDocumentsPartialUpdate>>,
    TError,
    BenefitDocumentsPartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof benefitDocumentsPartialUpdate>>,
  TError,
  BenefitDocumentsPartialUpdateMutationVariables,
  TContext
> => {
  return useMutation(getBenefitDocumentsPartialUpdateMutationOptions(options));
};

export const benefitHeroImageList = (
  params?: BenefitHeroImageListParams,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<PaginatedBenefitHeroImageList>({
    url: `/columbia/v1.0/benefit-hero-image/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getBenefitHeroImageListQueryKey = (
  params?: BenefitHeroImageListParams
) => {
  return [
    `/columbia/v1.0/benefit-hero-image/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getBenefitHeroImageListQueryOptions = <
  TData = Awaited<ReturnType<typeof benefitHeroImageList>>,
  TError = unknown,
>(
  params?: BenefitHeroImageListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof benefitHeroImageList>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getBenefitHeroImageListQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof benefitHeroImageList>>
  > = ({ signal }) => benefitHeroImageList(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof benefitHeroImageList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type BenefitHeroImageListQueryResult = NonNullable<
  Awaited<ReturnType<typeof benefitHeroImageList>>
>;
export type BenefitHeroImageListQueryError = unknown;

export function useBenefitHeroImageList<
  TData = Awaited<ReturnType<typeof benefitHeroImageList>>,
  TError = unknown,
>(
  params?: BenefitHeroImageListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof benefitHeroImageList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getBenefitHeroImageListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const benefitHeroImageCreate = (
  benefitHeroImageRequest: BenefitHeroImageRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<BenefitHeroImage>({
    url: `/columbia/v1.0/benefit-hero-image/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: benefitHeroImageRequest,
    signal,
  });
};

export const getBenefitHeroImageCreateMutationKey = () =>
  ['benefitHeroImageCreate'] as const;

export const getBenefitHeroImageCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof benefitHeroImageCreate>>,
    TError,
    BenefitHeroImageCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof benefitHeroImageCreate>>,
  TError,
  BenefitHeroImageCreateMutationVariables,
  TContext
> => {
  const mutationKey = getBenefitHeroImageCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof benefitHeroImageCreate>>,
    BenefitHeroImageCreateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return benefitHeroImageCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type BenefitHeroImageCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof benefitHeroImageCreate>>
>;
export type BenefitHeroImageCreateMutationBody = BenefitHeroImageRequest;
export type BenefitHeroImageCreateMutationError = unknown;
export type BenefitHeroImageCreateMutationVariables = {
  data: BenefitHeroImageRequest;
};

export const useBenefitHeroImageCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof benefitHeroImageCreate>>,
    TError,
    BenefitHeroImageCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof benefitHeroImageCreate>>,
  TError,
  BenefitHeroImageCreateMutationVariables,
  TContext
> => {
  return useMutation(getBenefitHeroImageCreateMutationOptions(options));
};

export const benefitImageList = (
  params?: BenefitImageListParams,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<PaginatedBenefitImageList>({
    url: `/columbia/v1.0/benefit-image/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getBenefitImageListQueryKey = (
  params?: BenefitImageListParams
) => {
  return [
    `/columbia/v1.0/benefit-image/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getBenefitImageListQueryOptions = <
  TData = Awaited<ReturnType<typeof benefitImageList>>,
  TError = unknown,
>(
  params?: BenefitImageListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof benefitImageList>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getBenefitImageListQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof benefitImageList>>
  > = ({ signal }) => benefitImageList(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof benefitImageList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type BenefitImageListQueryResult = NonNullable<
  Awaited<ReturnType<typeof benefitImageList>>
>;
export type BenefitImageListQueryError = unknown;

export function useBenefitImageList<
  TData = Awaited<ReturnType<typeof benefitImageList>>,
  TError = unknown,
>(
  params?: BenefitImageListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof benefitImageList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getBenefitImageListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const benefitImageCreate = (
  benefitImageRequest: BenefitImageRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<BenefitImage>({
    url: `/columbia/v1.0/benefit-image/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: benefitImageRequest,
    signal,
  });
};

export const getBenefitImageCreateMutationKey = () =>
  ['benefitImageCreate'] as const;

export const getBenefitImageCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof benefitImageCreate>>,
    TError,
    BenefitImageCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof benefitImageCreate>>,
  TError,
  BenefitImageCreateMutationVariables,
  TContext
> => {
  const mutationKey = getBenefitImageCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof benefitImageCreate>>,
    BenefitImageCreateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return benefitImageCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type BenefitImageCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof benefitImageCreate>>
>;
export type BenefitImageCreateMutationBody = BenefitImageRequest;
export type BenefitImageCreateMutationError = unknown;
export type BenefitImageCreateMutationVariables = { data: BenefitImageRequest };

export const useBenefitImageCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof benefitImageCreate>>,
    TError,
    BenefitImageCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof benefitImageCreate>>,
  TError,
  BenefitImageCreateMutationVariables,
  TContext
> => {
  return useMutation(getBenefitImageCreateMutationOptions(options));
};

export const benefitManagersList = (
  params?: BenefitManagersListParams,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<PaginatedBenefitManagerList>({
    url: `/columbia/v1.0/benefit-managers/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getBenefitManagersListQueryKey = (
  params?: BenefitManagersListParams
) => {
  return [
    `/columbia/v1.0/benefit-managers/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getBenefitManagersListQueryOptions = <
  TData = Awaited<ReturnType<typeof benefitManagersList>>,
  TError = unknown,
>(
  params?: BenefitManagersListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof benefitManagersList>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getBenefitManagersListQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof benefitManagersList>>
  > = ({ signal }) => benefitManagersList(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof benefitManagersList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type BenefitManagersListQueryResult = NonNullable<
  Awaited<ReturnType<typeof benefitManagersList>>
>;
export type BenefitManagersListQueryError = unknown;

export function useBenefitManagersList<
  TData = Awaited<ReturnType<typeof benefitManagersList>>,
  TError = unknown,
>(
  params?: BenefitManagersListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof benefitManagersList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getBenefitManagersListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const benefitManagersCreate = (
  benefitManagerRequest: BenefitManagerRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<BenefitManager>({
    url: `/columbia/v1.0/benefit-managers/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: benefitManagerRequest,
    signal,
  });
};

export const getBenefitManagersCreateMutationKey = () =>
  ['benefitManagersCreate'] as const;

export const getBenefitManagersCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof benefitManagersCreate>>,
    TError,
    BenefitManagersCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof benefitManagersCreate>>,
  TError,
  BenefitManagersCreateMutationVariables,
  TContext
> => {
  const mutationKey = getBenefitManagersCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof benefitManagersCreate>>,
    BenefitManagersCreateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return benefitManagersCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type BenefitManagersCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof benefitManagersCreate>>
>;
export type BenefitManagersCreateMutationBody = BenefitManagerRequest;
export type BenefitManagersCreateMutationError = unknown;
export type BenefitManagersCreateMutationVariables = {
  data: BenefitManagerRequest;
};

export const useBenefitManagersCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof benefitManagersCreate>>,
    TError,
    BenefitManagersCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof benefitManagersCreate>>,
  TError,
  BenefitManagersCreateMutationVariables,
  TContext
> => {
  return useMutation(getBenefitManagersCreateMutationOptions(options));
};

export const benefitProductTypesList = (
  params?: BenefitProductTypesListParams,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<PaginatedBenefitProductTypeList>({
    url: `/columbia/v1.0/benefit-product-types/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getBenefitProductTypesListQueryKey = (
  params?: BenefitProductTypesListParams
) => {
  return [
    `/columbia/v1.0/benefit-product-types/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getBenefitProductTypesListQueryOptions = <
  TData = Awaited<ReturnType<typeof benefitProductTypesList>>,
  TError = unknown,
>(
  params?: BenefitProductTypesListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof benefitProductTypesList>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getBenefitProductTypesListQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof benefitProductTypesList>>
  > = ({ signal }) => benefitProductTypesList(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof benefitProductTypesList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type BenefitProductTypesListQueryResult = NonNullable<
  Awaited<ReturnType<typeof benefitProductTypesList>>
>;
export type BenefitProductTypesListQueryError = unknown;

export function useBenefitProductTypesList<
  TData = Awaited<ReturnType<typeof benefitProductTypesList>>,
  TError = unknown,
>(
  params?: BenefitProductTypesListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof benefitProductTypesList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getBenefitProductTypesListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const benefitProductTypesCreate = (
  benefitProductTypeRequest: BenefitProductTypeRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<BenefitProductType>({
    url: `/columbia/v1.0/benefit-product-types/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: benefitProductTypeRequest,
    signal,
  });
};

export const getBenefitProductTypesCreateMutationKey = () =>
  ['benefitProductTypesCreate'] as const;

export const getBenefitProductTypesCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof benefitProductTypesCreate>>,
    TError,
    BenefitProductTypesCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof benefitProductTypesCreate>>,
  TError,
  BenefitProductTypesCreateMutationVariables,
  TContext
> => {
  const mutationKey = getBenefitProductTypesCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof benefitProductTypesCreate>>,
    BenefitProductTypesCreateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return benefitProductTypesCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type BenefitProductTypesCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof benefitProductTypesCreate>>
>;
export type BenefitProductTypesCreateMutationBody = BenefitProductTypeRequest;
export type BenefitProductTypesCreateMutationError = unknown;
export type BenefitProductTypesCreateMutationVariables = {
  data: BenefitProductTypeRequest;
};

export const useBenefitProductTypesCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof benefitProductTypesCreate>>,
    TError,
    BenefitProductTypesCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof benefitProductTypesCreate>>,
  TError,
  BenefitProductTypesCreateMutationVariables,
  TContext
> => {
  return useMutation(getBenefitProductTypesCreateMutationOptions(options));
};

export const benefitProductsList = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<BenefitProduct[]>({
    url: `/columbia/v1.0/benefit-products/`,
    method: 'GET',
    signal,
  });
};

export const getBenefitProductsListQueryKey = () => {
  return [`/columbia/v1.0/benefit-products/`] as const;
};

export const getBenefitProductsListQueryOptions = <
  TData = Awaited<ReturnType<typeof benefitProductsList>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof benefitProductsList>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getBenefitProductsListQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof benefitProductsList>>
  > = ({ signal }) => benefitProductsList(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof benefitProductsList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type BenefitProductsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof benefitProductsList>>
>;
export type BenefitProductsListQueryError = unknown;

export function useBenefitProductsList<
  TData = Awaited<ReturnType<typeof benefitProductsList>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof benefitProductsList>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getBenefitProductsListQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const benefitRequirementsRetrieve = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<void>({
    url: `/columbia/v1.0/benefit-requirements/`,
    method: 'GET',
    signal,
  });
};

export const getBenefitRequirementsRetrieveQueryKey = () => {
  return [`/columbia/v1.0/benefit-requirements/`] as const;
};

export const getBenefitRequirementsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof benefitRequirementsRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof benefitRequirementsRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getBenefitRequirementsRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof benefitRequirementsRetrieve>>
  > = ({ signal }) => benefitRequirementsRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof benefitRequirementsRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type BenefitRequirementsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof benefitRequirementsRetrieve>>
>;
export type BenefitRequirementsRetrieveQueryError = unknown;

export function useBenefitRequirementsRetrieve<
  TData = Awaited<ReturnType<typeof benefitRequirementsRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof benefitRequirementsRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getBenefitRequirementsRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const benefitTypeRetrieve = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<void>({
    url: `/columbia/v1.0/benefit-type/`,
    method: 'GET',
    signal,
  });
};

export const getBenefitTypeRetrieveQueryKey = () => {
  return [`/columbia/v1.0/benefit-type/`] as const;
};

export const getBenefitTypeRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof benefitTypeRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof benefitTypeRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getBenefitTypeRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof benefitTypeRetrieve>>
  > = ({ signal }) => benefitTypeRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof benefitTypeRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type BenefitTypeRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof benefitTypeRetrieve>>
>;
export type BenefitTypeRetrieveQueryError = unknown;

export function useBenefitTypeRetrieve<
  TData = Awaited<ReturnType<typeof benefitTypeRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof benefitTypeRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getBenefitTypeRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const benefitWaiverReasonsGroupsList = (
  params?: BenefitWaiverReasonsGroupsListParams,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<PaginatedOptOutReasonsGroupList>({
    url: `/columbia/v1.0/benefit-waiver-reasons-groups/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getBenefitWaiverReasonsGroupsListQueryKey = (
  params?: BenefitWaiverReasonsGroupsListParams
) => {
  return [
    `/columbia/v1.0/benefit-waiver-reasons-groups/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getBenefitWaiverReasonsGroupsListQueryOptions = <
  TData = Awaited<ReturnType<typeof benefitWaiverReasonsGroupsList>>,
  TError = unknown,
>(
  params?: BenefitWaiverReasonsGroupsListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof benefitWaiverReasonsGroupsList>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getBenefitWaiverReasonsGroupsListQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof benefitWaiverReasonsGroupsList>>
  > = ({ signal }) => benefitWaiverReasonsGroupsList(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof benefitWaiverReasonsGroupsList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type BenefitWaiverReasonsGroupsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof benefitWaiverReasonsGroupsList>>
>;
export type BenefitWaiverReasonsGroupsListQueryError = unknown;

export function useBenefitWaiverReasonsGroupsList<
  TData = Awaited<ReturnType<typeof benefitWaiverReasonsGroupsList>>,
  TError = unknown,
>(
  params?: BenefitWaiverReasonsGroupsListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof benefitWaiverReasonsGroupsList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getBenefitWaiverReasonsGroupsListQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const benefitWaiverReasonsGroupsCreate = (
  optOutReasonsGroupRequest: OptOutReasonsGroupRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<OptOutReasonsGroup>({
    url: `/columbia/v1.0/benefit-waiver-reasons-groups/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: optOutReasonsGroupRequest,
    signal,
  });
};

export const getBenefitWaiverReasonsGroupsCreateMutationKey = () =>
  ['benefitWaiverReasonsGroupsCreate'] as const;

export const getBenefitWaiverReasonsGroupsCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof benefitWaiverReasonsGroupsCreate>>,
    TError,
    BenefitWaiverReasonsGroupsCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof benefitWaiverReasonsGroupsCreate>>,
  TError,
  BenefitWaiverReasonsGroupsCreateMutationVariables,
  TContext
> => {
  const mutationKey = getBenefitWaiverReasonsGroupsCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof benefitWaiverReasonsGroupsCreate>>,
    BenefitWaiverReasonsGroupsCreateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return benefitWaiverReasonsGroupsCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type BenefitWaiverReasonsGroupsCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof benefitWaiverReasonsGroupsCreate>>
>;
export type BenefitWaiverReasonsGroupsCreateMutationBody =
  OptOutReasonsGroupRequest;
export type BenefitWaiverReasonsGroupsCreateMutationError = unknown;
export type BenefitWaiverReasonsGroupsCreateMutationVariables = {
  data: OptOutReasonsGroupRequest;
};

export const useBenefitWaiverReasonsGroupsCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof benefitWaiverReasonsGroupsCreate>>,
    TError,
    BenefitWaiverReasonsGroupsCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof benefitWaiverReasonsGroupsCreate>>,
  TError,
  BenefitWaiverReasonsGroupsCreateMutationVariables,
  TContext
> => {
  return useMutation(
    getBenefitWaiverReasonsGroupsCreateMutationOptions(options)
  );
};

export const benefitsList = (
  params?: BenefitsListParams,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<PaginatedModularBenefitListResponseList>({
    url: `/columbia/v1.0/benefits/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getBenefitsListQueryKey = (params?: BenefitsListParams) => {
  return [`/columbia/v1.0/benefits/`, ...(params ? [params] : [])] as const;
};

export const getBenefitsListQueryOptions = <
  TData = Awaited<ReturnType<typeof benefitsList>>,
  TError = unknown,
>(
  params?: BenefitsListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof benefitsList>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getBenefitsListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof benefitsList>>> = ({
    signal,
  }) => benefitsList(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof benefitsList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type BenefitsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof benefitsList>>
>;
export type BenefitsListQueryError = unknown;

export function useBenefitsList<
  TData = Awaited<ReturnType<typeof benefitsList>>,
  TError = unknown,
>(
  params?: BenefitsListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof benefitsList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getBenefitsListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const benefitsCreate = (
  modularBenefitListResponseRequest: ModularBenefitListResponseRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<ModularBenefitListResponse>({
    url: `/columbia/v1.0/benefits/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: modularBenefitListResponseRequest,
    signal,
  });
};

export const getBenefitsCreateMutationKey = () => ['benefitsCreate'] as const;

export const getBenefitsCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof benefitsCreate>>,
    TError,
    BenefitsCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof benefitsCreate>>,
  TError,
  BenefitsCreateMutationVariables,
  TContext
> => {
  const mutationKey = getBenefitsCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof benefitsCreate>>,
    BenefitsCreateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return benefitsCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type BenefitsCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof benefitsCreate>>
>;
export type BenefitsCreateMutationBody = ModularBenefitListResponseRequest;
export type BenefitsCreateMutationError = unknown;
export type BenefitsCreateMutationVariables = {
  data: ModularBenefitListResponseRequest;
};

export const useBenefitsCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof benefitsCreate>>,
    TError,
    BenefitsCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof benefitsCreate>>,
  TError,
  BenefitsCreateMutationVariables,
  TContext
> => {
  return useMutation(getBenefitsCreateMutationOptions(options));
};

export const benefitsBrokersList = (
  params?: BenefitsBrokersListParams,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<PaginatedBenefitBrokerList>({
    url: `/columbia/v1.0/benefits/brokers/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getBenefitsBrokersListQueryKey = (
  params?: BenefitsBrokersListParams
) => {
  return [
    `/columbia/v1.0/benefits/brokers/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getBenefitsBrokersListQueryOptions = <
  TData = Awaited<ReturnType<typeof benefitsBrokersList>>,
  TError = unknown,
>(
  params?: BenefitsBrokersListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof benefitsBrokersList>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getBenefitsBrokersListQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof benefitsBrokersList>>
  > = ({ signal }) => benefitsBrokersList(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof benefitsBrokersList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type BenefitsBrokersListQueryResult = NonNullable<
  Awaited<ReturnType<typeof benefitsBrokersList>>
>;
export type BenefitsBrokersListQueryError = unknown;

export function useBenefitsBrokersList<
  TData = Awaited<ReturnType<typeof benefitsBrokersList>>,
  TError = unknown,
>(
  params?: BenefitsBrokersListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof benefitsBrokersList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getBenefitsBrokersListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const benefitsFetchFromAirtableRetrieve = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<void>({
    url: `/columbia/v1.0/benefits/fetch-from-airtable`,
    method: 'GET',
    signal,
  });
};

export const getBenefitsFetchFromAirtableRetrieveQueryKey = () => {
  return [`/columbia/v1.0/benefits/fetch-from-airtable`] as const;
};

export const getBenefitsFetchFromAirtableRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof benefitsFetchFromAirtableRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof benefitsFetchFromAirtableRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getBenefitsFetchFromAirtableRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof benefitsFetchFromAirtableRetrieve>>
  > = ({ signal }) => benefitsFetchFromAirtableRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof benefitsFetchFromAirtableRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type BenefitsFetchFromAirtableRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof benefitsFetchFromAirtableRetrieve>>
>;
export type BenefitsFetchFromAirtableRetrieveQueryError = unknown;

export function useBenefitsFetchFromAirtableRetrieve<
  TData = Awaited<ReturnType<typeof benefitsFetchFromAirtableRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof benefitsFetchFromAirtableRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getBenefitsFetchFromAirtableRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const checkEligibilityRuleQueryCreate = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<void>({
    url: `/columbia/v1.0/check-eligibility-rule-query/`,
    method: 'POST',
    signal,
  });
};

export const getCheckEligibilityRuleQueryCreateMutationKey = () =>
  ['checkEligibilityRuleQueryCreate'] as const;

export const getCheckEligibilityRuleQueryCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof checkEligibilityRuleQueryCreate>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof checkEligibilityRuleQueryCreate>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = getCheckEligibilityRuleQueryCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof checkEligibilityRuleQueryCreate>>,
    void
  > = () => {
    return checkEligibilityRuleQueryCreate();
  };

  return { mutationFn, ...mutationOptions };
};

export type CheckEligibilityRuleQueryCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof checkEligibilityRuleQueryCreate>>
>;

export type CheckEligibilityRuleQueryCreateMutationError = unknown;

export const useCheckEligibilityRuleQueryCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof checkEligibilityRuleQueryCreate>>,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof checkEligibilityRuleQueryCreate>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getCheckEligibilityRuleQueryCreateMutationOptions(options)
  );
};

export const componentKeysList = (
  params?: ComponentKeysListParams,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<PaginatedModularBenefitStepComponentKeyListList>(
    { url: `/columbia/v1.0/component-keys/`, method: 'GET', params, signal }
  );
};

export const getComponentKeysListQueryKey = (
  params?: ComponentKeysListParams
) => {
  return [
    `/columbia/v1.0/component-keys/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getComponentKeysListQueryOptions = <
  TData = Awaited<ReturnType<typeof componentKeysList>>,
  TError = unknown,
>(
  params?: ComponentKeysListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof componentKeysList>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getComponentKeysListQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof componentKeysList>>
  > = ({ signal }) => componentKeysList(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof componentKeysList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ComponentKeysListQueryResult = NonNullable<
  Awaited<ReturnType<typeof componentKeysList>>
>;
export type ComponentKeysListQueryError = unknown;

export function useComponentKeysList<
  TData = Awaited<ReturnType<typeof componentKeysList>>,
  TError = unknown,
>(
  params?: ComponentKeysListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof componentKeysList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getComponentKeysListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const componentKeysCreate = (
  modularBenefitStepComponentKeyListRequest: ModularBenefitStepComponentKeyListRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<ModularBenefitStepComponentKeyList>({
    url: `/columbia/v1.0/component-keys/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: modularBenefitStepComponentKeyListRequest,
    signal,
  });
};

export const getComponentKeysCreateMutationKey = () =>
  ['componentKeysCreate'] as const;

export const getComponentKeysCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof componentKeysCreate>>,
    TError,
    ComponentKeysCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof componentKeysCreate>>,
  TError,
  ComponentKeysCreateMutationVariables,
  TContext
> => {
  const mutationKey = getComponentKeysCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof componentKeysCreate>>,
    ComponentKeysCreateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return componentKeysCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ComponentKeysCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof componentKeysCreate>>
>;
export type ComponentKeysCreateMutationBody =
  ModularBenefitStepComponentKeyListRequest;
export type ComponentKeysCreateMutationError = unknown;
export type ComponentKeysCreateMutationVariables = {
  data: ModularBenefitStepComponentKeyListRequest;
};

export const useComponentKeysCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof componentKeysCreate>>,
    TError,
    ComponentKeysCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof componentKeysCreate>>,
  TError,
  ComponentKeysCreateMutationVariables,
  TContext
> => {
  return useMutation(getComponentKeysCreateMutationOptions(options));
};

export const employersList = (
  params?: EmployersListParams,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<PaginatedEmployerListResponseList>({
    url: `/columbia/v1.0/employers/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getEmployersListQueryKey = (params?: EmployersListParams) => {
  return [`/columbia/v1.0/employers/`, ...(params ? [params] : [])] as const;
};

export const getEmployersListQueryOptions = <
  TData = Awaited<ReturnType<typeof employersList>>,
  TError = unknown,
>(
  params?: EmployersListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof employersList>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getEmployersListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof employersList>>> = ({
    signal,
  }) => employersList(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof employersList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type EmployersListQueryResult = NonNullable<
  Awaited<ReturnType<typeof employersList>>
>;
export type EmployersListQueryError = unknown;

export function useEmployersList<
  TData = Awaited<ReturnType<typeof employersList>>,
  TError = unknown,
>(
  params?: EmployersListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof employersList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getEmployersListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const employersApprovalFlowsRetrieve = (
  employerPk: number,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<ApprovalProcessesListView>({
    url: `/columbia/v1.0/employers/${employerPk}/approval-flows/`,
    method: 'GET',
    signal,
  });
};

export const getEmployersApprovalFlowsRetrieveQueryKey = (
  employerPk: number
) => {
  return [`/columbia/v1.0/employers/${employerPk}/approval-flows/`] as const;
};

export const getEmployersApprovalFlowsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof employersApprovalFlowsRetrieve>>,
  TError = unknown,
>(
  employerPk: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof employersApprovalFlowsRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getEmployersApprovalFlowsRetrieveQueryKey(employerPk);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof employersApprovalFlowsRetrieve>>
  > = ({ signal }) => employersApprovalFlowsRetrieve(employerPk, signal);

  return {
    queryKey,
    queryFn,
    enabled: employerPk !== null && employerPk !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof employersApprovalFlowsRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type EmployersApprovalFlowsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof employersApprovalFlowsRetrieve>>
>;
export type EmployersApprovalFlowsRetrieveQueryError = unknown;

export function useEmployersApprovalFlowsRetrieve<
  TData = Awaited<ReturnType<typeof employersApprovalFlowsRetrieve>>,
  TError = unknown,
>(
  employerPk: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof employersApprovalFlowsRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getEmployersApprovalFlowsRetrieveQueryOptions(
    employerPk,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const employersBenefitCategoriesRetrieve = (
  employerPk: number,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<BenefitCategory>({
    url: `/columbia/v1.0/employers/${employerPk}/benefit-categories/`,
    method: 'GET',
    signal,
  });
};

export const getEmployersBenefitCategoriesRetrieveQueryKey = (
  employerPk: number
) => {
  return [
    `/columbia/v1.0/employers/${employerPk}/benefit-categories/`,
  ] as const;
};

export const getEmployersBenefitCategoriesRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof employersBenefitCategoriesRetrieve>>,
  TError = unknown,
>(
  employerPk: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof employersBenefitCategoriesRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getEmployersBenefitCategoriesRetrieveQueryKey(employerPk);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof employersBenefitCategoriesRetrieve>>
  > = ({ signal }) => employersBenefitCategoriesRetrieve(employerPk, signal);

  return {
    queryKey,
    queryFn,
    enabled: employerPk !== null && employerPk !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof employersBenefitCategoriesRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type EmployersBenefitCategoriesRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof employersBenefitCategoriesRetrieve>>
>;
export type EmployersBenefitCategoriesRetrieveQueryError = unknown;

export function useEmployersBenefitCategoriesRetrieve<
  TData = Awaited<ReturnType<typeof employersBenefitCategoriesRetrieve>>,
  TError = unknown,
>(
  employerPk: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof employersBenefitCategoriesRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getEmployersBenefitCategoriesRetrieveQueryOptions(
    employerPk,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const employersBenefitCategoriesCreate = (
  employerPk: number,
  benefitCategoryRequest: BenefitCategoryRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<BenefitCategory>({
    url: `/columbia/v1.0/employers/${employerPk}/benefit-categories/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: benefitCategoryRequest,
    signal,
  });
};

export const getEmployersBenefitCategoriesCreateMutationKey = () =>
  ['employersBenefitCategoriesCreate'] as const;

export const getEmployersBenefitCategoriesCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof employersBenefitCategoriesCreate>>,
    TError,
    EmployersBenefitCategoriesCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof employersBenefitCategoriesCreate>>,
  TError,
  EmployersBenefitCategoriesCreateMutationVariables,
  TContext
> => {
  const mutationKey = getEmployersBenefitCategoriesCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof employersBenefitCategoriesCreate>>,
    EmployersBenefitCategoriesCreateMutationVariables
  > = (props) => {
    const { employerPk, data } = props ?? {};

    return employersBenefitCategoriesCreate(employerPk, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type EmployersBenefitCategoriesCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof employersBenefitCategoriesCreate>>
>;
export type EmployersBenefitCategoriesCreateMutationBody =
  BenefitCategoryRequest;
export type EmployersBenefitCategoriesCreateMutationError = unknown;
export type EmployersBenefitCategoriesCreateMutationVariables = {
  employerPk: number;
  data: BenefitCategoryRequest;
};

export const useEmployersBenefitCategoriesCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof employersBenefitCategoriesCreate>>,
    TError,
    EmployersBenefitCategoriesCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof employersBenefitCategoriesCreate>>,
  TError,
  EmployersBenefitCategoriesCreateMutationVariables,
  TContext
> => {
  return useMutation(
    getEmployersBenefitCategoriesCreateMutationOptions(options)
  );
};

export const employersProgrammesRetrieve = (
  employerPk: number,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<ProgrammeListResponse>({
    url: `/columbia/v1.0/employers/${employerPk}/programmes/`,
    method: 'GET',
    signal,
  });
};

export const getEmployersProgrammesRetrieveQueryKey = (employerPk: number) => {
  return [`/columbia/v1.0/employers/${employerPk}/programmes/`] as const;
};

export const getEmployersProgrammesRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof employersProgrammesRetrieve>>,
  TError = unknown,
>(
  employerPk: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof employersProgrammesRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getEmployersProgrammesRetrieveQueryKey(employerPk);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof employersProgrammesRetrieve>>
  > = ({ signal }) => employersProgrammesRetrieve(employerPk, signal);

  return {
    queryKey,
    queryFn,
    enabled: employerPk !== null && employerPk !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof employersProgrammesRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type EmployersProgrammesRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof employersProgrammesRetrieve>>
>;
export type EmployersProgrammesRetrieveQueryError = unknown;

export function useEmployersProgrammesRetrieve<
  TData = Awaited<ReturnType<typeof employersProgrammesRetrieve>>,
  TError = unknown,
>(
  employerPk: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof employersProgrammesRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getEmployersProgrammesRetrieveQueryOptions(
    employerPk,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const columbiaLifeEventsRetrieve = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<void>({
    url: `/columbia/v1.0/life-events/`,
    method: 'GET',
    signal,
  });
};

export const getColumbiaLifeEventsRetrieveQueryKey = () => {
  return [`/columbia/v1.0/life-events/`] as const;
};

export const getColumbiaLifeEventsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof columbiaLifeEventsRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof columbiaLifeEventsRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getColumbiaLifeEventsRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof columbiaLifeEventsRetrieve>>
  > = ({ signal }) => columbiaLifeEventsRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof columbiaLifeEventsRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ColumbiaLifeEventsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof columbiaLifeEventsRetrieve>>
>;
export type ColumbiaLifeEventsRetrieveQueryError = unknown;

export function useColumbiaLifeEventsRetrieve<
  TData = Awaited<ReturnType<typeof columbiaLifeEventsRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof columbiaLifeEventsRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getColumbiaLifeEventsRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const optOutReasonsGroupsList = (
  params?: OptOutReasonsGroupsListParams,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<PaginatedOptOutReasonsGroupList>({
    url: `/columbia/v1.0/opt-out-reasons-groups/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getOptOutReasonsGroupsListQueryKey = (
  params?: OptOutReasonsGroupsListParams
) => {
  return [
    `/columbia/v1.0/opt-out-reasons-groups/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getOptOutReasonsGroupsListQueryOptions = <
  TData = Awaited<ReturnType<typeof optOutReasonsGroupsList>>,
  TError = unknown,
>(
  params?: OptOutReasonsGroupsListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof optOutReasonsGroupsList>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getOptOutReasonsGroupsListQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof optOutReasonsGroupsList>>
  > = ({ signal }) => optOutReasonsGroupsList(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof optOutReasonsGroupsList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type OptOutReasonsGroupsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof optOutReasonsGroupsList>>
>;
export type OptOutReasonsGroupsListQueryError = unknown;

export function useOptOutReasonsGroupsList<
  TData = Awaited<ReturnType<typeof optOutReasonsGroupsList>>,
  TError = unknown,
>(
  params?: OptOutReasonsGroupsListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof optOutReasonsGroupsList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getOptOutReasonsGroupsListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const optOutReasonsGroupsCreate = (
  optOutReasonsGroupRequest: OptOutReasonsGroupRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<OptOutReasonsGroup>({
    url: `/columbia/v1.0/opt-out-reasons-groups/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: optOutReasonsGroupRequest,
    signal,
  });
};

export const getOptOutReasonsGroupsCreateMutationKey = () =>
  ['optOutReasonsGroupsCreate'] as const;

export const getOptOutReasonsGroupsCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof optOutReasonsGroupsCreate>>,
    TError,
    OptOutReasonsGroupsCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof optOutReasonsGroupsCreate>>,
  TError,
  OptOutReasonsGroupsCreateMutationVariables,
  TContext
> => {
  const mutationKey = getOptOutReasonsGroupsCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof optOutReasonsGroupsCreate>>,
    OptOutReasonsGroupsCreateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return optOutReasonsGroupsCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type OptOutReasonsGroupsCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof optOutReasonsGroupsCreate>>
>;
export type OptOutReasonsGroupsCreateMutationBody = OptOutReasonsGroupRequest;
export type OptOutReasonsGroupsCreateMutationError = unknown;
export type OptOutReasonsGroupsCreateMutationVariables = {
  data: OptOutReasonsGroupRequest;
};

export const useOptOutReasonsGroupsCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof optOutReasonsGroupsCreate>>,
    TError,
    OptOutReasonsGroupsCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof optOutReasonsGroupsCreate>>,
  TError,
  OptOutReasonsGroupsCreateMutationVariables,
  TContext
> => {
  return useMutation(getOptOutReasonsGroupsCreateMutationOptions(options));
};

export const outboundProvidersList = (
  params?: OutboundProvidersListParams,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<PaginatedOutboundProviderList>({
    url: `/columbia/v1.0/outbound-providers/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getOutboundProvidersListQueryKey = (
  params?: OutboundProvidersListParams
) => {
  return [
    `/columbia/v1.0/outbound-providers/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getOutboundProvidersListQueryOptions = <
  TData = Awaited<ReturnType<typeof outboundProvidersList>>,
  TError = unknown,
>(
  params?: OutboundProvidersListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof outboundProvidersList>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getOutboundProvidersListQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof outboundProvidersList>>
  > = ({ signal }) => outboundProvidersList(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof outboundProvidersList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type OutboundProvidersListQueryResult = NonNullable<
  Awaited<ReturnType<typeof outboundProvidersList>>
>;
export type OutboundProvidersListQueryError = unknown;

export function useOutboundProvidersList<
  TData = Awaited<ReturnType<typeof outboundProvidersList>>,
  TError = unknown,
>(
  params?: OutboundProvidersListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof outboundProvidersList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getOutboundProvidersListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const providersList = (
  params?: ProvidersListParams,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<PaginatedProviderList>({
    url: `/columbia/v1.0/providers/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getProvidersListQueryKey = (params?: ProvidersListParams) => {
  return [`/columbia/v1.0/providers/`, ...(params ? [params] : [])] as const;
};

export const getProvidersListQueryOptions = <
  TData = Awaited<ReturnType<typeof providersList>>,
  TError = unknown,
>(
  params?: ProvidersListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof providersList>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getProvidersListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof providersList>>> = ({
    signal,
  }) => providersList(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof providersList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ProvidersListQueryResult = NonNullable<
  Awaited<ReturnType<typeof providersList>>
>;
export type ProvidersListQueryError = unknown;

export function useProvidersList<
  TData = Awaited<ReturnType<typeof providersList>>,
  TError = unknown,
>(
  params?: ProvidersListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof providersList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getProvidersListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const providersCreate = (
  providerRequest: ProviderRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<Provider>({
    url: `/columbia/v1.0/providers/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: providerRequest,
    signal,
  });
};

export const getProvidersCreateMutationKey = () => ['providersCreate'] as const;

export const getProvidersCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof providersCreate>>,
    TError,
    ProvidersCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof providersCreate>>,
  TError,
  ProvidersCreateMutationVariables,
  TContext
> => {
  const mutationKey = getProvidersCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof providersCreate>>,
    ProvidersCreateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return providersCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ProvidersCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof providersCreate>>
>;
export type ProvidersCreateMutationBody = ProviderRequest;
export type ProvidersCreateMutationError = unknown;
export type ProvidersCreateMutationVariables = { data: ProviderRequest };

export const useProvidersCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof providersCreate>>,
    TError,
    ProvidersCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof providersCreate>>,
  TError,
  ProvidersCreateMutationVariables,
  TContext
> => {
  return useMutation(getProvidersCreateMutationOptions(options));
};

export const statePensionAgeConfigsList = (
  params?: StatePensionAgeConfigsListParams,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<PaginatedStatePensionAgeConfigList>({
    url: `/columbia/v1.0/state-pension-age-configs/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getStatePensionAgeConfigsListQueryKey = (
  params?: StatePensionAgeConfigsListParams
) => {
  return [
    `/columbia/v1.0/state-pension-age-configs/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getStatePensionAgeConfigsListQueryOptions = <
  TData = Awaited<ReturnType<typeof statePensionAgeConfigsList>>,
  TError = unknown,
>(
  params?: StatePensionAgeConfigsListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof statePensionAgeConfigsList>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getStatePensionAgeConfigsListQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof statePensionAgeConfigsList>>
  > = ({ signal }) => statePensionAgeConfigsList(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof statePensionAgeConfigsList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type StatePensionAgeConfigsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof statePensionAgeConfigsList>>
>;
export type StatePensionAgeConfigsListQueryError = unknown;

export function useStatePensionAgeConfigsList<
  TData = Awaited<ReturnType<typeof statePensionAgeConfigsList>>,
  TError = unknown,
>(
  params?: StatePensionAgeConfigsListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof statePensionAgeConfigsList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getStatePensionAgeConfigsListQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const tagsList = (params?: TagsListParams, signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<PaginatedModularBenefitTagList>({
    url: `/columbia/v1.0/tags/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getTagsListQueryKey = (params?: TagsListParams) => {
  return [`/columbia/v1.0/tags/`, ...(params ? [params] : [])] as const;
};

export const getTagsListQueryOptions = <
  TData = Awaited<ReturnType<typeof tagsList>>,
  TError = unknown,
>(
  params?: TagsListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof tagsList>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTagsListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof tagsList>>> = ({
    signal,
  }) => tagsList(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof tagsList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type TagsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof tagsList>>
>;
export type TagsListQueryError = unknown;

export function useTagsList<
  TData = Awaited<ReturnType<typeof tagsList>>,
  TError = unknown,
>(
  params?: TagsListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof tagsList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getTagsListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const tagsCreate = (
  modularBenefitTagRequest: ModularBenefitTagRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<ModularBenefitTag>({
    url: `/columbia/v1.0/tags/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: modularBenefitTagRequest,
    signal,
  });
};

export const getTagsCreateMutationKey = () => ['tagsCreate'] as const;

export const getTagsCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tagsCreate>>,
    TError,
    TagsCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof tagsCreate>>,
  TError,
  TagsCreateMutationVariables,
  TContext
> => {
  const mutationKey = getTagsCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof tagsCreate>>,
    TagsCreateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return tagsCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type TagsCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof tagsCreate>>
>;
export type TagsCreateMutationBody = ModularBenefitTagRequest;
export type TagsCreateMutationError = unknown;
export type TagsCreateMutationVariables = { data: ModularBenefitTagRequest };

export const useTagsCreate = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tagsCreate>>,
    TError,
    TagsCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof tagsCreate>>,
  TError,
  TagsCreateMutationVariables,
  TContext
> => {
  return useMutation(getTagsCreateMutationOptions(options));
};

export const corporatesKybBeneficiariesWatchCreate = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<void>({
    url: `/corporates/kyb/beneficiaries/watch`,
    method: 'POST',
    signal,
  });
};

export const getCorporatesKybBeneficiariesWatchCreateMutationKey = () =>
  ['corporatesKybBeneficiariesWatchCreate'] as const;

export const getCorporatesKybBeneficiariesWatchCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof corporatesKybBeneficiariesWatchCreate>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof corporatesKybBeneficiariesWatchCreate>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = getCorporatesKybBeneficiariesWatchCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof corporatesKybBeneficiariesWatchCreate>>,
    void
  > = () => {
    return corporatesKybBeneficiariesWatchCreate();
  };

  return { mutationFn, ...mutationOptions };
};

export type CorporatesKybBeneficiariesWatchCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof corporatesKybBeneficiariesWatchCreate>>
>;

export type CorporatesKybBeneficiariesWatchCreateMutationError = unknown;

export const useCorporatesKybBeneficiariesWatchCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof corporatesKybBeneficiariesWatchCreate>>,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof corporatesKybBeneficiariesWatchCreate>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getCorporatesKybBeneficiariesWatchCreateMutationOptions(options)
  );
};

export const corporatesKybWatchCreate = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<void>({
    url: `/corporates/kyb/watch`,
    method: 'POST',
    signal,
  });
};

export const getCorporatesKybWatchCreateMutationKey = () =>
  ['corporatesKybWatchCreate'] as const;

export const getCorporatesKybWatchCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof corporatesKybWatchCreate>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof corporatesKybWatchCreate>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = getCorporatesKybWatchCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof corporatesKybWatchCreate>>,
    void
  > = () => {
    return corporatesKybWatchCreate();
  };

  return { mutationFn, ...mutationOptions };
};

export type CorporatesKybWatchCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof corporatesKybWatchCreate>>
>;

export type CorporatesKybWatchCreateMutationError = unknown;

export const useCorporatesKybWatchCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof corporatesKybWatchCreate>>,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof corporatesKybWatchCreate>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getCorporatesKybWatchCreateMutationOptions(options));
};

export const corporatesKycRetrieve = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<unknown>({
    url: `/corporates/kyc`,
    method: 'GET',
    signal,
  });
};

export const getCorporatesKycRetrieveQueryKey = () => {
  return [`/corporates/kyc`] as const;
};

export const getCorporatesKycRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof corporatesKycRetrieve>>,
  TError = void,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof corporatesKycRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCorporatesKycRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof corporatesKycRetrieve>>
  > = ({ signal }) => corporatesKycRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof corporatesKycRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CorporatesKycRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof corporatesKycRetrieve>>
>;
export type CorporatesKycRetrieveQueryError = void;

export function useCorporatesKycRetrieve<
  TData = Awaited<ReturnType<typeof corporatesKycRetrieve>>,
  TError = void,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof corporatesKycRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getCorporatesKycRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const adminEmployerExternalLinksList = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<EmployerExternalLink[]>({
    url: `/ecc/v1.0/admin-employer-external-links/`,
    method: 'GET',
    signal,
  });
};

export const getAdminEmployerExternalLinksListQueryKey = () => {
  return [`/ecc/v1.0/admin-employer-external-links/`] as const;
};

export const getAdminEmployerExternalLinksListQueryOptions = <
  TData = Awaited<ReturnType<typeof adminEmployerExternalLinksList>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof adminEmployerExternalLinksList>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAdminEmployerExternalLinksListQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminEmployerExternalLinksList>>
  > = ({ signal }) => adminEmployerExternalLinksList(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminEmployerExternalLinksList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminEmployerExternalLinksListQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminEmployerExternalLinksList>>
>;
export type AdminEmployerExternalLinksListQueryError = unknown;

export function useAdminEmployerExternalLinksList<
  TData = Awaited<ReturnType<typeof adminEmployerExternalLinksList>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof adminEmployerExternalLinksList>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminEmployerExternalLinksListQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const adminEmployerExternalLinksCreate = (
  employerExternalLinkRequest: EmployerExternalLinkRequest,
  signal?: AbortSignal
) => {
  const formData = new FormData();
  formData.append(`name`, employerExternalLinkRequest.name);
  if (employerExternalLinkRequest.description !== null) {
    formData.append(`description`, employerExternalLinkRequest.description);
  }
  formData.append(`link`, employerExternalLinkRequest.link);
  formData.append(`logo_alt_text`, employerExternalLinkRequest.logo_alt_text);
  if (employerExternalLinkRequest.logo !== undefined) {
    formData.append(`logo`, employerExternalLinkRequest.logo);
  }

  return axiosOrvalCustomInstance<EmployerExternalLink>({
    url: `/ecc/v1.0/admin-employer-external-links/`,
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
    signal,
  });
};

export const getAdminEmployerExternalLinksCreateMutationKey = () =>
  ['adminEmployerExternalLinksCreate'] as const;

export const getAdminEmployerExternalLinksCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminEmployerExternalLinksCreate>>,
    TError,
    AdminEmployerExternalLinksCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminEmployerExternalLinksCreate>>,
  TError,
  AdminEmployerExternalLinksCreateMutationVariables,
  TContext
> => {
  const mutationKey = getAdminEmployerExternalLinksCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminEmployerExternalLinksCreate>>,
    AdminEmployerExternalLinksCreateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return adminEmployerExternalLinksCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminEmployerExternalLinksCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminEmployerExternalLinksCreate>>
>;
export type AdminEmployerExternalLinksCreateMutationBody =
  EmployerExternalLinkRequest;
export type AdminEmployerExternalLinksCreateMutationError = unknown;
export type AdminEmployerExternalLinksCreateMutationVariables = {
  data: EmployerExternalLinkRequest;
};

export const useAdminEmployerExternalLinksCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminEmployerExternalLinksCreate>>,
    TError,
    AdminEmployerExternalLinksCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminEmployerExternalLinksCreate>>,
  TError,
  AdminEmployerExternalLinksCreateMutationVariables,
  TContext
> => {
  return useMutation(
    getAdminEmployerExternalLinksCreateMutationOptions(options)
  );
};

export const adminEmployerExternalLinksUpdate = (
  employerExternalLinkId: number,
  employerExternalLinkRequest: EmployerExternalLinkRequest,
  signal?: AbortSignal
) => {
  const formData = new FormData();
  formData.append(`name`, employerExternalLinkRequest.name);
  if (employerExternalLinkRequest.description !== null) {
    formData.append(`description`, employerExternalLinkRequest.description);
  }
  formData.append(`link`, employerExternalLinkRequest.link);
  formData.append(`logo_alt_text`, employerExternalLinkRequest.logo_alt_text);
  if (employerExternalLinkRequest.logo !== undefined) {
    formData.append(`logo`, employerExternalLinkRequest.logo);
  }

  return axiosOrvalCustomInstance<EmployerExternalLink>({
    url: `/ecc/v1.0/admin-employer-external-links/${employerExternalLinkId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
    signal,
  });
};

export const getAdminEmployerExternalLinksUpdateMutationKey = () =>
  ['adminEmployerExternalLinksUpdate'] as const;

export const getAdminEmployerExternalLinksUpdateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminEmployerExternalLinksUpdate>>,
    TError,
    AdminEmployerExternalLinksUpdateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminEmployerExternalLinksUpdate>>,
  TError,
  AdminEmployerExternalLinksUpdateMutationVariables,
  TContext
> => {
  const mutationKey = getAdminEmployerExternalLinksUpdateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminEmployerExternalLinksUpdate>>,
    AdminEmployerExternalLinksUpdateMutationVariables
  > = (props) => {
    const { employerExternalLinkId, data } = props ?? {};

    return adminEmployerExternalLinksUpdate(employerExternalLinkId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminEmployerExternalLinksUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminEmployerExternalLinksUpdate>>
>;
export type AdminEmployerExternalLinksUpdateMutationBody =
  EmployerExternalLinkRequest;
export type AdminEmployerExternalLinksUpdateMutationError = unknown;
export type AdminEmployerExternalLinksUpdateMutationVariables = {
  employerExternalLinkId: number;
  data: EmployerExternalLinkRequest;
};

export const useAdminEmployerExternalLinksUpdate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminEmployerExternalLinksUpdate>>,
    TError,
    AdminEmployerExternalLinksUpdateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminEmployerExternalLinksUpdate>>,
  TError,
  AdminEmployerExternalLinksUpdateMutationVariables,
  TContext
> => {
  return useMutation(
    getAdminEmployerExternalLinksUpdateMutationOptions(options)
  );
};

export const adminEmployerExternalLinksPartialUpdate = (
  employerExternalLinkId: number,
  patchedEmployerExternalLinkRankRequest?: PatchedEmployerExternalLinkRankRequest,
  signal?: AbortSignal
) => {
  const formData = new FormData();
  if (patchedEmployerExternalLinkRankRequest?.new_index !== undefined) {
    formData.append(
      `new_index`,
      patchedEmployerExternalLinkRankRequest.new_index.toString()
    );
  }

  return axiosOrvalCustomInstance<void>({
    url: `/ecc/v1.0/admin-employer-external-links/${employerExternalLinkId}`,
    method: 'PATCH',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
    signal,
  });
};

export const getAdminEmployerExternalLinksPartialUpdateMutationKey = () =>
  ['adminEmployerExternalLinksPartialUpdate'] as const;

export const getAdminEmployerExternalLinksPartialUpdateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminEmployerExternalLinksPartialUpdate>>,
    TError,
    AdminEmployerExternalLinksPartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminEmployerExternalLinksPartialUpdate>>,
  TError,
  AdminEmployerExternalLinksPartialUpdateMutationVariables,
  TContext
> => {
  const mutationKey = getAdminEmployerExternalLinksPartialUpdateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminEmployerExternalLinksPartialUpdate>>,
    AdminEmployerExternalLinksPartialUpdateMutationVariables
  > = (props) => {
    const { employerExternalLinkId, data } = props ?? {};

    return adminEmployerExternalLinksPartialUpdate(
      employerExternalLinkId,
      data
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminEmployerExternalLinksPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminEmployerExternalLinksPartialUpdate>>
>;
export type AdminEmployerExternalLinksPartialUpdateMutationBody =
  | PatchedEmployerExternalLinkRankRequest
  | undefined;
export type AdminEmployerExternalLinksPartialUpdateMutationError = unknown;
export type AdminEmployerExternalLinksPartialUpdateMutationVariables = {
  employerExternalLinkId: number;
  data?: PatchedEmployerExternalLinkRankRequest;
};

export const useAdminEmployerExternalLinksPartialUpdate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminEmployerExternalLinksPartialUpdate>>,
    TError,
    AdminEmployerExternalLinksPartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminEmployerExternalLinksPartialUpdate>>,
  TError,
  AdminEmployerExternalLinksPartialUpdateMutationVariables,
  TContext
> => {
  return useMutation(
    getAdminEmployerExternalLinksPartialUpdateMutationOptions(options)
  );
};

export const adminEmployerExternalLinksDestroy = (
  employerExternalLinkId: number,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/ecc/v1.0/admin-employer-external-links/${employerExternalLinkId}`,
    method: 'DELETE',
    signal,
  });
};

export const getAdminEmployerExternalLinksDestroyMutationKey = () =>
  ['adminEmployerExternalLinksDestroy'] as const;

export const getAdminEmployerExternalLinksDestroyMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminEmployerExternalLinksDestroy>>,
    TError,
    AdminEmployerExternalLinksDestroyMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminEmployerExternalLinksDestroy>>,
  TError,
  AdminEmployerExternalLinksDestroyMutationVariables,
  TContext
> => {
  const mutationKey = getAdminEmployerExternalLinksDestroyMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminEmployerExternalLinksDestroy>>,
    AdminEmployerExternalLinksDestroyMutationVariables
  > = (props) => {
    const { employerExternalLinkId } = props ?? {};

    return adminEmployerExternalLinksDestroy(employerExternalLinkId);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminEmployerExternalLinksDestroyMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminEmployerExternalLinksDestroy>>
>;

export type AdminEmployerExternalLinksDestroyMutationError = unknown;
export type AdminEmployerExternalLinksDestroyMutationVariables = {
  employerExternalLinkId: number;
};

export const useAdminEmployerExternalLinksDestroy = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminEmployerExternalLinksDestroy>>,
    TError,
    AdminEmployerExternalLinksDestroyMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminEmployerExternalLinksDestroy>>,
  TError,
  AdminEmployerExternalLinksDestroyMutationVariables,
  TContext
> => {
  return useMutation(
    getAdminEmployerExternalLinksDestroyMutationOptions(options)
  );
};

export const allowanceList = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<AllowanceResponse[]>({
    url: `/ecc/v1.0/allowance/`,
    method: 'GET',
    signal,
  });
};

export const getAllowanceListQueryKey = () => {
  return [`/ecc/v1.0/allowance/`] as const;
};

export const getAllowanceListQueryOptions = <
  TData = Awaited<ReturnType<typeof allowanceList>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof allowanceList>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAllowanceListQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof allowanceList>>> = ({
    signal,
  }) => allowanceList(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof allowanceList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AllowanceListQueryResult = NonNullable<
  Awaited<ReturnType<typeof allowanceList>>
>;
export type AllowanceListQueryError = unknown;

export function useAllowanceList<
  TData = Awaited<ReturnType<typeof allowanceList>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof allowanceList>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAllowanceListQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const allowanceRetrieve = (
  allowanceId: number,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<AllowanceResponse>({
    url: `/ecc/v1.0/allowance/${allowanceId}/`,
    method: 'GET',
    signal,
  });
};

export const getAllowanceRetrieveQueryKey = (allowanceId: number) => {
  return [`/ecc/v1.0/allowance/${allowanceId}/`] as const;
};

export const getAllowanceRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof allowanceRetrieve>>,
  TError = unknown,
>(
  allowanceId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof allowanceRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAllowanceRetrieveQueryKey(allowanceId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof allowanceRetrieve>>
  > = ({ signal }) => allowanceRetrieve(allowanceId, signal);

  return {
    queryKey,
    queryFn,
    enabled: allowanceId !== null && allowanceId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof allowanceRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AllowanceRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof allowanceRetrieve>>
>;
export type AllowanceRetrieveQueryError = unknown;

export function useAllowanceRetrieve<
  TData = Awaited<ReturnType<typeof allowanceRetrieve>>,
  TError = unknown,
>(
  allowanceId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof allowanceRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAllowanceRetrieveQueryOptions(allowanceId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const allowanceEmployeeRetrieve = (
  allowanceId: number,
  employeeId: number,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<AllowanceEmployeeRetrieve200>({
    url: `/ecc/v1.0/allowance/${allowanceId}/employee/${employeeId}/`,
    method: 'GET',
    signal,
  });
};

export const getAllowanceEmployeeRetrieveQueryKey = (
  allowanceId: number,
  employeeId: number
) => {
  return [
    `/ecc/v1.0/allowance/${allowanceId}/employee/${employeeId}/`,
  ] as const;
};

export const getAllowanceEmployeeRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof allowanceEmployeeRetrieve>>,
  TError = unknown,
>(
  allowanceId: number,
  employeeId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof allowanceEmployeeRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getAllowanceEmployeeRetrieveQueryKey(allowanceId, employeeId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof allowanceEmployeeRetrieve>>
  > = ({ signal }) =>
    allowanceEmployeeRetrieve(allowanceId, employeeId, signal);

  return {
    queryKey,
    queryFn,
    enabled:
      allowanceId !== null &&
      allowanceId !== undefined &&
      employeeId !== null &&
      employeeId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof allowanceEmployeeRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AllowanceEmployeeRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof allowanceEmployeeRetrieve>>
>;
export type AllowanceEmployeeRetrieveQueryError = unknown;

export function useAllowanceEmployeeRetrieve<
  TData = Awaited<ReturnType<typeof allowanceEmployeeRetrieve>>,
  TError = unknown,
>(
  allowanceId: number,
  employeeId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof allowanceEmployeeRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAllowanceEmployeeRetrieveQueryOptions(
    allowanceId,
    employeeId,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Detail view for ReimbursementRequest and FundRequest
 */
export const approvalRequestsDetailRetrieve = (
  approvalRequestId: string,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<ReimbursementResponse>({
    url: `/ecc/v1.0/approval-requests/${approvalRequestId}/detail/`,
    method: 'GET',
    signal,
  });
};

export const getApprovalRequestsDetailRetrieveQueryKey = (
  approvalRequestId: string
) => {
  return [`/ecc/v1.0/approval-requests/${approvalRequestId}/detail/`] as const;
};

export const getApprovalRequestsDetailRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof approvalRequestsDetailRetrieve>>,
  TError = unknown,
>(
  approvalRequestId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof approvalRequestsDetailRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApprovalRequestsDetailRetrieveQueryKey(approvalRequestId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof approvalRequestsDetailRetrieve>>
  > = ({ signal }) => approvalRequestsDetailRetrieve(approvalRequestId, signal);

  return {
    queryKey,
    queryFn,
    enabled: approvalRequestId !== null && approvalRequestId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof approvalRequestsDetailRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ApprovalRequestsDetailRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof approvalRequestsDetailRetrieve>>
>;
export type ApprovalRequestsDetailRetrieveQueryError = unknown;

export function useApprovalRequestsDetailRetrieve<
  TData = Awaited<ReturnType<typeof approvalRequestsDetailRetrieve>>,
  TError = unknown,
>(
  approvalRequestId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof approvalRequestsDetailRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApprovalRequestsDetailRetrieveQueryOptions(
    approvalRequestId,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const approvalRequestsActionCreate = (
  approvalRequestActionRequest: ApprovalRequestActionRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<ApprovalResponseAction>({
    url: `/ecc/v1.0/approval-requests/action/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: approvalRequestActionRequest,
    signal,
  });
};

export const getApprovalRequestsActionCreateMutationKey = () =>
  ['approvalRequestsActionCreate'] as const;

export const getApprovalRequestsActionCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof approvalRequestsActionCreate>>,
    TError,
    ApprovalRequestsActionCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof approvalRequestsActionCreate>>,
  TError,
  ApprovalRequestsActionCreateMutationVariables,
  TContext
> => {
  const mutationKey = getApprovalRequestsActionCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof approvalRequestsActionCreate>>,
    ApprovalRequestsActionCreateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return approvalRequestsActionCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApprovalRequestsActionCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof approvalRequestsActionCreate>>
>;
export type ApprovalRequestsActionCreateMutationBody =
  ApprovalRequestActionRequest;
export type ApprovalRequestsActionCreateMutationError = unknown;
export type ApprovalRequestsActionCreateMutationVariables = {
  data: ApprovalRequestActionRequest;
};

export const useApprovalRequestsActionCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof approvalRequestsActionCreate>>,
    TError,
    ApprovalRequestsActionCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof approvalRequestsActionCreate>>,
  TError,
  ApprovalRequestsActionCreateMutationVariables,
  TContext
> => {
  return useMutation(getApprovalRequestsActionCreateMutationOptions(options));
};

export const approvalRequestsFundRequestsList = (
  params?: ApprovalRequestsFundRequestsListParams,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<PaginatedApprovalRequestResponseList>({
    url: `/ecc/v1.0/approval-requests/fund-requests`,
    method: 'GET',
    params,
    signal,
  });
};

export const getApprovalRequestsFundRequestsListQueryKey = (
  params?: ApprovalRequestsFundRequestsListParams
) => {
  return [
    `/ecc/v1.0/approval-requests/fund-requests`,
    ...(params ? [params] : []),
  ] as const;
};

export const getApprovalRequestsFundRequestsListQueryOptions = <
  TData = Awaited<ReturnType<typeof approvalRequestsFundRequestsList>>,
  TError = unknown,
>(
  params?: ApprovalRequestsFundRequestsListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof approvalRequestsFundRequestsList>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApprovalRequestsFundRequestsListQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof approvalRequestsFundRequestsList>>
  > = ({ signal }) => approvalRequestsFundRequestsList(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof approvalRequestsFundRequestsList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ApprovalRequestsFundRequestsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof approvalRequestsFundRequestsList>>
>;
export type ApprovalRequestsFundRequestsListQueryError = unknown;

export function useApprovalRequestsFundRequestsList<
  TData = Awaited<ReturnType<typeof approvalRequestsFundRequestsList>>,
  TError = unknown,
>(
  params?: ApprovalRequestsFundRequestsListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof approvalRequestsFundRequestsList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApprovalRequestsFundRequestsListQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const approvalRequestsReimbursementsList = (
  params?: ApprovalRequestsReimbursementsListParams,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<PaginatedApprovalRequestResponseList>({
    url: `/ecc/v1.0/approval-requests/reimbursements`,
    method: 'GET',
    params,
    signal,
  });
};

export const getApprovalRequestsReimbursementsListQueryKey = (
  params?: ApprovalRequestsReimbursementsListParams
) => {
  return [
    `/ecc/v1.0/approval-requests/reimbursements`,
    ...(params ? [params] : []),
  ] as const;
};

export const getApprovalRequestsReimbursementsListQueryOptions = <
  TData = Awaited<ReturnType<typeof approvalRequestsReimbursementsList>>,
  TError = unknown,
>(
  params?: ApprovalRequestsReimbursementsListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof approvalRequestsReimbursementsList>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApprovalRequestsReimbursementsListQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof approvalRequestsReimbursementsList>>
  > = ({ signal }) => approvalRequestsReimbursementsList(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof approvalRequestsReimbursementsList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ApprovalRequestsReimbursementsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof approvalRequestsReimbursementsList>>
>;
export type ApprovalRequestsReimbursementsListQueryError = unknown;

export function useApprovalRequestsReimbursementsList<
  TData = Awaited<ReturnType<typeof approvalRequestsReimbursementsList>>,
  TError = unknown,
>(
  params?: ApprovalRequestsReimbursementsListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof approvalRequestsReimbursementsList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApprovalRequestsReimbursementsListQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const approvalRequestsStepExecutionsList = (
  params?: ApprovalRequestsStepExecutionsListParams,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<PaginatedApprovalRequestStepExecutionResponseList>(
    {
      url: `/ecc/v1.0/approval-requests/step-executions/`,
      method: 'GET',
      params,
      signal,
    }
  );
};

export const getApprovalRequestsStepExecutionsListQueryKey = (
  params?: ApprovalRequestsStepExecutionsListParams
) => {
  return [
    `/ecc/v1.0/approval-requests/step-executions/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getApprovalRequestsStepExecutionsListQueryOptions = <
  TData = Awaited<ReturnType<typeof approvalRequestsStepExecutionsList>>,
  TError = unknown,
>(
  params?: ApprovalRequestsStepExecutionsListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof approvalRequestsStepExecutionsList>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApprovalRequestsStepExecutionsListQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof approvalRequestsStepExecutionsList>>
  > = ({ signal }) => approvalRequestsStepExecutionsList(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof approvalRequestsStepExecutionsList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ApprovalRequestsStepExecutionsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof approvalRequestsStepExecutionsList>>
>;
export type ApprovalRequestsStepExecutionsListQueryError = unknown;

export function useApprovalRequestsStepExecutionsList<
  TData = Awaited<ReturnType<typeof approvalRequestsStepExecutionsList>>,
  TError = unknown,
>(
  params?: ApprovalRequestsStepExecutionsListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof approvalRequestsStepExecutionsList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApprovalRequestsStepExecutionsListQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Action approval step executions. Supports both individual and bulk operations.
 */
export const approvalRequestsStepExecutionsPartialUpdate = (
  approvalActionRequest: ApprovalActionRequest[],
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<ApprovalRequestsActionResponse>({
    url: `/ecc/v1.0/approval-requests/step-executions/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: approvalActionRequest,
    signal,
  });
};

export const getApprovalRequestsStepExecutionsPartialUpdateMutationKey = () =>
  ['approvalRequestsStepExecutionsPartialUpdate'] as const;

export const getApprovalRequestsStepExecutionsPartialUpdateMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof approvalRequestsStepExecutionsPartialUpdate>>,
    TError,
    ApprovalRequestsStepExecutionsPartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof approvalRequestsStepExecutionsPartialUpdate>>,
  TError,
  ApprovalRequestsStepExecutionsPartialUpdateMutationVariables,
  TContext
> => {
  const mutationKey =
    getApprovalRequestsStepExecutionsPartialUpdateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof approvalRequestsStepExecutionsPartialUpdate>>,
    ApprovalRequestsStepExecutionsPartialUpdateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return approvalRequestsStepExecutionsPartialUpdate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApprovalRequestsStepExecutionsPartialUpdateMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof approvalRequestsStepExecutionsPartialUpdate>>
  >;
export type ApprovalRequestsStepExecutionsPartialUpdateMutationBody =
  ApprovalActionRequest[];
export type ApprovalRequestsStepExecutionsPartialUpdateMutationError = void;
export type ApprovalRequestsStepExecutionsPartialUpdateMutationVariables = {
  data: ApprovalActionRequest[];
};

export const useApprovalRequestsStepExecutionsPartialUpdate = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof approvalRequestsStepExecutionsPartialUpdate>>,
    TError,
    ApprovalRequestsStepExecutionsPartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof approvalRequestsStepExecutionsPartialUpdate>>,
  TError,
  ApprovalRequestsStepExecutionsPartialUpdateMutationVariables,
  TContext
> => {
  return useMutation(
    getApprovalRequestsStepExecutionsPartialUpdateMutationOptions(options)
  );
};

export const availableCurrenciesRetrieve = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<AvailableCurrencies>({
    url: `/ecc/v1.0/available-currencies/`,
    method: 'GET',
    signal,
  });
};

export const getAvailableCurrenciesRetrieveQueryKey = () => {
  return [`/ecc/v1.0/available-currencies/`] as const;
};

export const getAvailableCurrenciesRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof availableCurrenciesRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof availableCurrenciesRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAvailableCurrenciesRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof availableCurrenciesRetrieve>>
  > = ({ signal }) => availableCurrenciesRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof availableCurrenciesRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AvailableCurrenciesRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof availableCurrenciesRetrieve>>
>;
export type AvailableCurrenciesRetrieveQueryError = unknown;

export function useAvailableCurrenciesRetrieve<
  TData = Awaited<ReturnType<typeof availableCurrenciesRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof availableCurrenciesRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAvailableCurrenciesRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const benefitsEnrolmentsRetrieve = (
  benefitId: number,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/ecc/v1.0/benefits/${benefitId}/enrolments/`,
    method: 'GET',
    signal,
  });
};

export const getBenefitsEnrolmentsRetrieveQueryKey = (benefitId: number) => {
  return [`/ecc/v1.0/benefits/${benefitId}/enrolments/`] as const;
};

export const getBenefitsEnrolmentsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof benefitsEnrolmentsRetrieve>>,
  TError = unknown,
>(
  benefitId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof benefitsEnrolmentsRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getBenefitsEnrolmentsRetrieveQueryKey(benefitId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof benefitsEnrolmentsRetrieve>>
  > = ({ signal }) => benefitsEnrolmentsRetrieve(benefitId, signal);

  return {
    queryKey,
    queryFn,
    enabled: benefitId !== null && benefitId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof benefitsEnrolmentsRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type BenefitsEnrolmentsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof benefitsEnrolmentsRetrieve>>
>;
export type BenefitsEnrolmentsRetrieveQueryError = unknown;

export function useBenefitsEnrolmentsRetrieve<
  TData = Awaited<ReturnType<typeof benefitsEnrolmentsRetrieve>>,
  TError = unknown,
>(
  benefitId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof benefitsEnrolmentsRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getBenefitsEnrolmentsRetrieveQueryOptions(
    benefitId,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const benefitsBrokersRetrieve = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<BenefitBrokerResponse>({
    url: `/ecc/v1.0/benefits/brokers/`,
    method: 'GET',
    signal,
  });
};

export const getBenefitsBrokersRetrieveQueryKey = () => {
  return [`/ecc/v1.0/benefits/brokers/`] as const;
};

export const getBenefitsBrokersRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof benefitsBrokersRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof benefitsBrokersRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getBenefitsBrokersRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof benefitsBrokersRetrieve>>
  > = ({ signal }) => benefitsBrokersRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof benefitsBrokersRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type BenefitsBrokersRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof benefitsBrokersRetrieve>>
>;
export type BenefitsBrokersRetrieveQueryError = unknown;

export function useBenefitsBrokersRetrieve<
  TData = Awaited<ReturnType<typeof benefitsBrokersRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof benefitsBrokersRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getBenefitsBrokersRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const benefitsEnrollmentsHistoryFiltersRetrieve = (
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<BenefitEnrolmentHistoryFilterResponse>({
    url: `/ecc/v1.0/benefits/enrollments/history/filters`,
    method: 'GET',
    signal,
  });
};

export const getBenefitsEnrollmentsHistoryFiltersRetrieveQueryKey = () => {
  return [`/ecc/v1.0/benefits/enrollments/history/filters`] as const;
};

export const getBenefitsEnrollmentsHistoryFiltersRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof benefitsEnrollmentsHistoryFiltersRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof benefitsEnrollmentsHistoryFiltersRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getBenefitsEnrollmentsHistoryFiltersRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof benefitsEnrollmentsHistoryFiltersRetrieve>>
  > = ({ signal }) => benefitsEnrollmentsHistoryFiltersRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof benefitsEnrollmentsHistoryFiltersRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type BenefitsEnrollmentsHistoryFiltersRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof benefitsEnrollmentsHistoryFiltersRetrieve>>
>;
export type BenefitsEnrollmentsHistoryFiltersRetrieveQueryError = unknown;

export function useBenefitsEnrollmentsHistoryFiltersRetrieve<
  TData = Awaited<ReturnType<typeof benefitsEnrollmentsHistoryFiltersRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof benefitsEnrollmentsHistoryFiltersRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getBenefitsEnrollmentsHistoryFiltersRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const benefitsEnrollmentsWindowsCreate = (
  enrolmentWindowChangeRequest: EnrolmentWindowChangeRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<EnrolmentWindowChange>({
    url: `/ecc/v1.0/benefits/enrollments/windows/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: enrolmentWindowChangeRequest,
    signal,
  });
};

export const getBenefitsEnrollmentsWindowsCreateMutationKey = () =>
  ['benefitsEnrollmentsWindowsCreate'] as const;

export const getBenefitsEnrollmentsWindowsCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof benefitsEnrollmentsWindowsCreate>>,
    TError,
    BenefitsEnrollmentsWindowsCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof benefitsEnrollmentsWindowsCreate>>,
  TError,
  BenefitsEnrollmentsWindowsCreateMutationVariables,
  TContext
> => {
  const mutationKey = getBenefitsEnrollmentsWindowsCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof benefitsEnrollmentsWindowsCreate>>,
    BenefitsEnrollmentsWindowsCreateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return benefitsEnrollmentsWindowsCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type BenefitsEnrollmentsWindowsCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof benefitsEnrollmentsWindowsCreate>>
>;
export type BenefitsEnrollmentsWindowsCreateMutationBody =
  EnrolmentWindowChangeRequest;
export type BenefitsEnrollmentsWindowsCreateMutationError = unknown;
export type BenefitsEnrollmentsWindowsCreateMutationVariables = {
  data: EnrolmentWindowChangeRequest;
};

export const useBenefitsEnrollmentsWindowsCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof benefitsEnrollmentsWindowsCreate>>,
    TError,
    BenefitsEnrollmentsWindowsCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof benefitsEnrollmentsWindowsCreate>>,
  TError,
  BenefitsEnrollmentsWindowsCreateMutationVariables,
  TContext
> => {
  return useMutation(
    getBenefitsEnrollmentsWindowsCreateMutationOptions(options)
  );
};

/**
 * Shared enrolment fetching and view-level permission check for enrolment views.
 */
export const benefitsEnrolmentsDetailRetrieve = (
  enrolmentId: number,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<BenefitEnrolmentDetailResponse>({
    url: `/ecc/v1.0/benefits/enrolments/${enrolmentId}/detail/`,
    method: 'GET',
    signal,
  });
};

export const getBenefitsEnrolmentsDetailRetrieveQueryKey = (
  enrolmentId: number
) => {
  return [`/ecc/v1.0/benefits/enrolments/${enrolmentId}/detail/`] as const;
};

export const getBenefitsEnrolmentsDetailRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof benefitsEnrolmentsDetailRetrieve>>,
  TError = unknown,
>(
  enrolmentId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof benefitsEnrolmentsDetailRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getBenefitsEnrolmentsDetailRetrieveQueryKey(enrolmentId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof benefitsEnrolmentsDetailRetrieve>>
  > = ({ signal }) => benefitsEnrolmentsDetailRetrieve(enrolmentId, signal);

  return {
    queryKey,
    queryFn,
    enabled: enrolmentId !== null && enrolmentId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof benefitsEnrolmentsDetailRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type BenefitsEnrolmentsDetailRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof benefitsEnrolmentsDetailRetrieve>>
>;
export type BenefitsEnrolmentsDetailRetrieveQueryError = unknown;

export function useBenefitsEnrolmentsDetailRetrieve<
  TData = Awaited<ReturnType<typeof benefitsEnrolmentsDetailRetrieve>>,
  TError = unknown,
>(
  enrolmentId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof benefitsEnrolmentsDetailRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getBenefitsEnrolmentsDetailRetrieveQueryOptions(
    enrolmentId,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Shared enrolment fetching and view-level permission check for enrolment views.
 */
export const benefitsEnrolmentsDocumentSigningClaimCreate = (
  enrolmentId: number,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<ClaimSigningStepResponse>({
    url: `/ecc/v1.0/benefits/enrolments/${enrolmentId}/document-signing/claim/`,
    method: 'POST',
    signal,
  });
};

export const getBenefitsEnrolmentsDocumentSigningClaimCreateMutationKey = () =>
  ['benefitsEnrolmentsDocumentSigningClaimCreate'] as const;

export const getBenefitsEnrolmentsDocumentSigningClaimCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof benefitsEnrolmentsDocumentSigningClaimCreate>>,
    TError,
    BenefitsEnrolmentsDocumentSigningClaimCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof benefitsEnrolmentsDocumentSigningClaimCreate>>,
  TError,
  BenefitsEnrolmentsDocumentSigningClaimCreateMutationVariables,
  TContext
> => {
  const mutationKey =
    getBenefitsEnrolmentsDocumentSigningClaimCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof benefitsEnrolmentsDocumentSigningClaimCreate>>,
    BenefitsEnrolmentsDocumentSigningClaimCreateMutationVariables
  > = (props) => {
    const { enrolmentId } = props ?? {};

    return benefitsEnrolmentsDocumentSigningClaimCreate(enrolmentId);
  };

  return { mutationFn, ...mutationOptions };
};

export type BenefitsEnrolmentsDocumentSigningClaimCreateMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof benefitsEnrolmentsDocumentSigningClaimCreate>>
  >;

export type BenefitsEnrolmentsDocumentSigningClaimCreateMutationError = unknown;
export type BenefitsEnrolmentsDocumentSigningClaimCreateMutationVariables = {
  enrolmentId: number;
};

export const useBenefitsEnrolmentsDocumentSigningClaimCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof benefitsEnrolmentsDocumentSigningClaimCreate>>,
    TError,
    BenefitsEnrolmentsDocumentSigningClaimCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof benefitsEnrolmentsDocumentSigningClaimCreate>>,
  TError,
  BenefitsEnrolmentsDocumentSigningClaimCreateMutationVariables,
  TContext
> => {
  return useMutation(
    getBenefitsEnrolmentsDocumentSigningClaimCreateMutationOptions(options)
  );
};

export const benefitsEnrolmentsPriceCreate = (
  enrolmentId: number,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<ModularBenefitPriceResponse>({
    url: `/ecc/v1.0/benefits/enrolments/${enrolmentId}/price/`,
    method: 'POST',
    signal,
  });
};

export const getBenefitsEnrolmentsPriceCreateMutationKey = () =>
  ['benefitsEnrolmentsPriceCreate'] as const;

export const getBenefitsEnrolmentsPriceCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof benefitsEnrolmentsPriceCreate>>,
    TError,
    BenefitsEnrolmentsPriceCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof benefitsEnrolmentsPriceCreate>>,
  TError,
  BenefitsEnrolmentsPriceCreateMutationVariables,
  TContext
> => {
  const mutationKey = getBenefitsEnrolmentsPriceCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof benefitsEnrolmentsPriceCreate>>,
    BenefitsEnrolmentsPriceCreateMutationVariables
  > = (props) => {
    const { enrolmentId } = props ?? {};

    return benefitsEnrolmentsPriceCreate(enrolmentId);
  };

  return { mutationFn, ...mutationOptions };
};

export type BenefitsEnrolmentsPriceCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof benefitsEnrolmentsPriceCreate>>
>;

export type BenefitsEnrolmentsPriceCreateMutationError = unknown;
export type BenefitsEnrolmentsPriceCreateMutationVariables = {
  enrolmentId: number;
};

export const useBenefitsEnrolmentsPriceCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof benefitsEnrolmentsPriceCreate>>,
    TError,
    BenefitsEnrolmentsPriceCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof benefitsEnrolmentsPriceCreate>>,
  TError,
  BenefitsEnrolmentsPriceCreateMutationVariables,
  TContext
> => {
  return useMutation(getBenefitsEnrolmentsPriceCreateMutationOptions(options));
};

export const benefitsEnrolmentsCreate = (
  enrolmentPk: number,
  enrolmentUpdateRequestRequest?: EnrolmentUpdateRequestRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/ecc/v1.0/benefits/enrolments/${enrolmentPk}/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: enrolmentUpdateRequestRequest,
    signal,
  });
};

export const getBenefitsEnrolmentsCreateMutationKey = () =>
  ['benefitsEnrolmentsCreate'] as const;

export const getBenefitsEnrolmentsCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof benefitsEnrolmentsCreate>>,
    TError,
    BenefitsEnrolmentsCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof benefitsEnrolmentsCreate>>,
  TError,
  BenefitsEnrolmentsCreateMutationVariables,
  TContext
> => {
  const mutationKey = getBenefitsEnrolmentsCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof benefitsEnrolmentsCreate>>,
    BenefitsEnrolmentsCreateMutationVariables
  > = (props) => {
    const { enrolmentPk, data } = props ?? {};

    return benefitsEnrolmentsCreate(enrolmentPk, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type BenefitsEnrolmentsCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof benefitsEnrolmentsCreate>>
>;
export type BenefitsEnrolmentsCreateMutationBody =
  | EnrolmentUpdateRequestRequest
  | undefined;
export type BenefitsEnrolmentsCreateMutationError = unknown;
export type BenefitsEnrolmentsCreateMutationVariables = {
  enrolmentPk: number;
  data?: EnrolmentUpdateRequestRequest;
};

export const useBenefitsEnrolmentsCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof benefitsEnrolmentsCreate>>,
    TError,
    BenefitsEnrolmentsCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof benefitsEnrolmentsCreate>>,
  TError,
  BenefitsEnrolmentsCreateMutationVariables,
  TContext
> => {
  return useMutation(getBenefitsEnrolmentsCreateMutationOptions(options));
};

export const benefitsEnrolmentsPartialUpdate = (
  enrolmentPk: number,
  patchedEnrolmentUpdateRequestRequest?: PatchedEnrolmentUpdateRequestRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/ecc/v1.0/benefits/enrolments/${enrolmentPk}/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchedEnrolmentUpdateRequestRequest,
    signal,
  });
};

export const getBenefitsEnrolmentsPartialUpdateMutationKey = () =>
  ['benefitsEnrolmentsPartialUpdate'] as const;

export const getBenefitsEnrolmentsPartialUpdateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof benefitsEnrolmentsPartialUpdate>>,
    TError,
    BenefitsEnrolmentsPartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof benefitsEnrolmentsPartialUpdate>>,
  TError,
  BenefitsEnrolmentsPartialUpdateMutationVariables,
  TContext
> => {
  const mutationKey = getBenefitsEnrolmentsPartialUpdateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof benefitsEnrolmentsPartialUpdate>>,
    BenefitsEnrolmentsPartialUpdateMutationVariables
  > = (props) => {
    const { enrolmentPk, data } = props ?? {};

    return benefitsEnrolmentsPartialUpdate(enrolmentPk, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type BenefitsEnrolmentsPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof benefitsEnrolmentsPartialUpdate>>
>;
export type BenefitsEnrolmentsPartialUpdateMutationBody =
  | PatchedEnrolmentUpdateRequestRequest
  | undefined;
export type BenefitsEnrolmentsPartialUpdateMutationError = unknown;
export type BenefitsEnrolmentsPartialUpdateMutationVariables = {
  enrolmentPk: number;
  data?: PatchedEnrolmentUpdateRequestRequest;
};

export const useBenefitsEnrolmentsPartialUpdate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof benefitsEnrolmentsPartialUpdate>>,
    TError,
    BenefitsEnrolmentsPartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof benefitsEnrolmentsPartialUpdate>>,
  TError,
  BenefitsEnrolmentsPartialUpdateMutationVariables,
  TContext
> => {
  return useMutation(
    getBenefitsEnrolmentsPartialUpdateMutationOptions(options)
  );
};

export const benefitsEnrolmentsCalculatedValueFieldRecalculateCreate = (
  enrolmentPk: number,
  fieldPk: number,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/ecc/v1.0/benefits/enrolments/${enrolmentPk}/calculated-value-field/${fieldPk}/recalculate/`,
    method: 'POST',
    signal,
  });
};

export const getBenefitsEnrolmentsCalculatedValueFieldRecalculateCreateMutationKey =
  () => ['benefitsEnrolmentsCalculatedValueFieldRecalculateCreate'] as const;

export const getBenefitsEnrolmentsCalculatedValueFieldRecalculateCreateMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof benefitsEnrolmentsCalculatedValueFieldRecalculateCreate
        >
      >,
      TError,
      BenefitsEnrolmentsCalculatedValueFieldRecalculateCreateMutationVariables,
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof benefitsEnrolmentsCalculatedValueFieldRecalculateCreate>
    >,
    TError,
    BenefitsEnrolmentsCalculatedValueFieldRecalculateCreateMutationVariables,
    TContext
  > => {
    const mutationKey =
      getBenefitsEnrolmentsCalculatedValueFieldRecalculateCreateMutationKey();
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof benefitsEnrolmentsCalculatedValueFieldRecalculateCreate
        >
      >,
      BenefitsEnrolmentsCalculatedValueFieldRecalculateCreateMutationVariables
    > = (props) => {
      const { enrolmentPk, fieldPk } = props ?? {};

      return benefitsEnrolmentsCalculatedValueFieldRecalculateCreate(
        enrolmentPk,
        fieldPk
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type BenefitsEnrolmentsCalculatedValueFieldRecalculateCreateMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof benefitsEnrolmentsCalculatedValueFieldRecalculateCreate>
    >
  >;

export type BenefitsEnrolmentsCalculatedValueFieldRecalculateCreateMutationError =
  unknown;
export type BenefitsEnrolmentsCalculatedValueFieldRecalculateCreateMutationVariables =
  { enrolmentPk: number; fieldPk: number };

export const useBenefitsEnrolmentsCalculatedValueFieldRecalculateCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<typeof benefitsEnrolmentsCalculatedValueFieldRecalculateCreate>
    >,
    TError,
    BenefitsEnrolmentsCalculatedValueFieldRecalculateCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<typeof benefitsEnrolmentsCalculatedValueFieldRecalculateCreate>
  >,
  TError,
  BenefitsEnrolmentsCalculatedValueFieldRecalculateCreateMutationVariables,
  TContext
> => {
  return useMutation(
    getBenefitsEnrolmentsCalculatedValueFieldRecalculateCreateMutationOptions(
      options
    )
  );
};

/**
 * List uploaded files for an enrolment field.
 */
export const benefitsEnrolmentsFieldsFilesList = (
  enrolmentPk: number,
  fieldPk: number,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<ModularBenefitUploadedFileResponse[]>({
    url: `/ecc/v1.0/benefits/enrolments/${enrolmentPk}/fields/${fieldPk}/files/`,
    method: 'GET',
    signal,
  });
};

export const getBenefitsEnrolmentsFieldsFilesListQueryKey = (
  enrolmentPk: number,
  fieldPk: number
) => {
  return [
    `/ecc/v1.0/benefits/enrolments/${enrolmentPk}/fields/${fieldPk}/files/`,
  ] as const;
};

export const getBenefitsEnrolmentsFieldsFilesListQueryOptions = <
  TData = Awaited<ReturnType<typeof benefitsEnrolmentsFieldsFilesList>>,
  TError = unknown,
>(
  enrolmentPk: number,
  fieldPk: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof benefitsEnrolmentsFieldsFilesList>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getBenefitsEnrolmentsFieldsFilesListQueryKey(enrolmentPk, fieldPk);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof benefitsEnrolmentsFieldsFilesList>>
  > = ({ signal }) =>
    benefitsEnrolmentsFieldsFilesList(enrolmentPk, fieldPk, signal);

  return {
    queryKey,
    queryFn,
    enabled:
      enrolmentPk !== null &&
      enrolmentPk !== undefined &&
      fieldPk !== null &&
      fieldPk !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof benefitsEnrolmentsFieldsFilesList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type BenefitsEnrolmentsFieldsFilesListQueryResult = NonNullable<
  Awaited<ReturnType<typeof benefitsEnrolmentsFieldsFilesList>>
>;
export type BenefitsEnrolmentsFieldsFilesListQueryError = unknown;

export function useBenefitsEnrolmentsFieldsFilesList<
  TData = Awaited<ReturnType<typeof benefitsEnrolmentsFieldsFilesList>>,
  TError = unknown,
>(
  enrolmentPk: number,
  fieldPk: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof benefitsEnrolmentsFieldsFilesList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getBenefitsEnrolmentsFieldsFilesListQueryOptions(
    enrolmentPk,
    fieldPk,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Upload a file for an enrolment field on behalf of an employee.
 */
export const benefitsEnrolmentsFieldsFilesCreate = (
  enrolmentPk: number,
  fieldPk: number,
  modularBenefitUploadedFileRequestRequest: ModularBenefitUploadedFileRequestRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<ModularBenefitUploadedFileResponse>({
    url: `/ecc/v1.0/benefits/enrolments/${enrolmentPk}/fields/${fieldPk}/files/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: modularBenefitUploadedFileRequestRequest,
    signal,
  });
};

export const getBenefitsEnrolmentsFieldsFilesCreateMutationKey = () =>
  ['benefitsEnrolmentsFieldsFilesCreate'] as const;

export const getBenefitsEnrolmentsFieldsFilesCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof benefitsEnrolmentsFieldsFilesCreate>>,
    TError,
    BenefitsEnrolmentsFieldsFilesCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof benefitsEnrolmentsFieldsFilesCreate>>,
  TError,
  BenefitsEnrolmentsFieldsFilesCreateMutationVariables,
  TContext
> => {
  const mutationKey = getBenefitsEnrolmentsFieldsFilesCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof benefitsEnrolmentsFieldsFilesCreate>>,
    BenefitsEnrolmentsFieldsFilesCreateMutationVariables
  > = (props) => {
    const { enrolmentPk, fieldPk, data } = props ?? {};

    return benefitsEnrolmentsFieldsFilesCreate(enrolmentPk, fieldPk, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type BenefitsEnrolmentsFieldsFilesCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof benefitsEnrolmentsFieldsFilesCreate>>
>;
export type BenefitsEnrolmentsFieldsFilesCreateMutationBody =
  ModularBenefitUploadedFileRequestRequest;
export type BenefitsEnrolmentsFieldsFilesCreateMutationError = unknown;
export type BenefitsEnrolmentsFieldsFilesCreateMutationVariables = {
  enrolmentPk: number;
  fieldPk: number;
  data: ModularBenefitUploadedFileRequestRequest;
};

export const useBenefitsEnrolmentsFieldsFilesCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof benefitsEnrolmentsFieldsFilesCreate>>,
    TError,
    BenefitsEnrolmentsFieldsFilesCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof benefitsEnrolmentsFieldsFilesCreate>>,
  TError,
  BenefitsEnrolmentsFieldsFilesCreateMutationVariables,
  TContext
> => {
  return useMutation(
    getBenefitsEnrolmentsFieldsFilesCreateMutationOptions(options)
  );
};

/**
 * Retrieve a single uploaded file.
 */
export const benefitsEnrolmentsFieldsFilesRetrieve = (
  enrolmentPk: number,
  fieldPk: number,
  fileUuid: string,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<ModularBenefitUploadedFileResponse>({
    url: `/ecc/v1.0/benefits/enrolments/${enrolmentPk}/fields/${fieldPk}/files/${fileUuid}/`,
    method: 'GET',
    signal,
  });
};

export const getBenefitsEnrolmentsFieldsFilesRetrieveQueryKey = (
  enrolmentPk: number,
  fieldPk: number,
  fileUuid: string
) => {
  return [
    `/ecc/v1.0/benefits/enrolments/${enrolmentPk}/fields/${fieldPk}/files/${fileUuid}/`,
  ] as const;
};

export const getBenefitsEnrolmentsFieldsFilesRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof benefitsEnrolmentsFieldsFilesRetrieve>>,
  TError = unknown,
>(
  enrolmentPk: number,
  fieldPk: number,
  fileUuid: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof benefitsEnrolmentsFieldsFilesRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getBenefitsEnrolmentsFieldsFilesRetrieveQueryKey(
      enrolmentPk,
      fieldPk,
      fileUuid
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof benefitsEnrolmentsFieldsFilesRetrieve>>
  > = ({ signal }) =>
    benefitsEnrolmentsFieldsFilesRetrieve(
      enrolmentPk,
      fieldPk,
      fileUuid,
      signal
    );

  return {
    queryKey,
    queryFn,
    enabled:
      enrolmentPk !== null &&
      enrolmentPk !== undefined &&
      fieldPk !== null &&
      fieldPk !== undefined &&
      fileUuid !== null &&
      fileUuid !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof benefitsEnrolmentsFieldsFilesRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type BenefitsEnrolmentsFieldsFilesRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof benefitsEnrolmentsFieldsFilesRetrieve>>
>;
export type BenefitsEnrolmentsFieldsFilesRetrieveQueryError = unknown;

export function useBenefitsEnrolmentsFieldsFilesRetrieve<
  TData = Awaited<ReturnType<typeof benefitsEnrolmentsFieldsFilesRetrieve>>,
  TError = unknown,
>(
  enrolmentPk: number,
  fieldPk: number,
  fileUuid: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof benefitsEnrolmentsFieldsFilesRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getBenefitsEnrolmentsFieldsFilesRetrieveQueryOptions(
    enrolmentPk,
    fieldPk,
    fileUuid,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Delete an uploaded file for an enrolment.
 */
export const benefitsEnrolmentsFieldsFilesDestroy = (
  enrolmentPk: number,
  fieldPk: number,
  fileUuid: string,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/ecc/v1.0/benefits/enrolments/${enrolmentPk}/fields/${fieldPk}/files/${fileUuid}/`,
    method: 'DELETE',
    signal,
  });
};

export const getBenefitsEnrolmentsFieldsFilesDestroyMutationKey = () =>
  ['benefitsEnrolmentsFieldsFilesDestroy'] as const;

export const getBenefitsEnrolmentsFieldsFilesDestroyMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof benefitsEnrolmentsFieldsFilesDestroy>>,
    TError,
    BenefitsEnrolmentsFieldsFilesDestroyMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof benefitsEnrolmentsFieldsFilesDestroy>>,
  TError,
  BenefitsEnrolmentsFieldsFilesDestroyMutationVariables,
  TContext
> => {
  const mutationKey = getBenefitsEnrolmentsFieldsFilesDestroyMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof benefitsEnrolmentsFieldsFilesDestroy>>,
    BenefitsEnrolmentsFieldsFilesDestroyMutationVariables
  > = (props) => {
    const { enrolmentPk, fieldPk, fileUuid } = props ?? {};

    return benefitsEnrolmentsFieldsFilesDestroy(enrolmentPk, fieldPk, fileUuid);
  };

  return { mutationFn, ...mutationOptions };
};

export type BenefitsEnrolmentsFieldsFilesDestroyMutationResult = NonNullable<
  Awaited<ReturnType<typeof benefitsEnrolmentsFieldsFilesDestroy>>
>;

export type BenefitsEnrolmentsFieldsFilesDestroyMutationError = unknown;
export type BenefitsEnrolmentsFieldsFilesDestroyMutationVariables = {
  enrolmentPk: number;
  fieldPk: number;
  fileUuid: string;
};

export const useBenefitsEnrolmentsFieldsFilesDestroy = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof benefitsEnrolmentsFieldsFilesDestroy>>,
    TError,
    BenefitsEnrolmentsFieldsFilesDestroyMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof benefitsEnrolmentsFieldsFilesDestroy>>,
  TError,
  BenefitsEnrolmentsFieldsFilesDestroyMutationVariables,
  TContext
> => {
  return useMutation(
    getBenefitsEnrolmentsFieldsFilesDestroyMutationOptions(options)
  );
};

export const benefitsEnrolmentsMinMaxFormulaFieldRecalculateCreate = (
  enrolmentPk: number,
  fieldKey: string,
  benefitsEnrolmentsMinMaxFormulaFieldRecalculateCreateBody?:
    | BenefitsEnrolmentsMinMaxFormulaFieldRecalculateCreateBodyOne
    | BenefitsEnrolmentsMinMaxFormulaFieldRecalculateCreateBodyTwo
    | BenefitsEnrolmentsMinMaxFormulaFieldRecalculateCreateBodyThree,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<ModularBenefitMinMaxFormulaFieldRecalculateHoustonResponse>(
    {
      url: `/ecc/v1.0/benefits/enrolments/${enrolmentPk}/min-max-formula-field/${fieldKey}/recalculate/`,
      method: 'POST',
      data: benefitsEnrolmentsMinMaxFormulaFieldRecalculateCreateBody,
      signal,
    }
  );
};

export const getBenefitsEnrolmentsMinMaxFormulaFieldRecalculateCreateMutationKey =
  () => ['benefitsEnrolmentsMinMaxFormulaFieldRecalculateCreate'] as const;

export const getBenefitsEnrolmentsMinMaxFormulaFieldRecalculateCreateMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof benefitsEnrolmentsMinMaxFormulaFieldRecalculateCreate>
      >,
      TError,
      BenefitsEnrolmentsMinMaxFormulaFieldRecalculateCreateMutationVariables,
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof benefitsEnrolmentsMinMaxFormulaFieldRecalculateCreate>
    >,
    TError,
    BenefitsEnrolmentsMinMaxFormulaFieldRecalculateCreateMutationVariables,
    TContext
  > => {
    const mutationKey =
      getBenefitsEnrolmentsMinMaxFormulaFieldRecalculateCreateMutationKey();
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof benefitsEnrolmentsMinMaxFormulaFieldRecalculateCreate>
      >,
      BenefitsEnrolmentsMinMaxFormulaFieldRecalculateCreateMutationVariables
    > = (props) => {
      const { enrolmentPk, fieldKey, data } = props ?? {};

      return benefitsEnrolmentsMinMaxFormulaFieldRecalculateCreate(
        enrolmentPk,
        fieldKey,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type BenefitsEnrolmentsMinMaxFormulaFieldRecalculateCreateMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof benefitsEnrolmentsMinMaxFormulaFieldRecalculateCreate>
    >
  >;
export type BenefitsEnrolmentsMinMaxFormulaFieldRecalculateCreateMutationBody =
  | BenefitsEnrolmentsMinMaxFormulaFieldRecalculateCreateBodyOne
  | BenefitsEnrolmentsMinMaxFormulaFieldRecalculateCreateBodyTwo
  | BenefitsEnrolmentsMinMaxFormulaFieldRecalculateCreateBodyThree
  | undefined;
export type BenefitsEnrolmentsMinMaxFormulaFieldRecalculateCreateMutationError =
  unknown;
export type BenefitsEnrolmentsMinMaxFormulaFieldRecalculateCreateMutationVariables =
  {
    enrolmentPk: number;
    fieldKey: string;
    data?:
      | BenefitsEnrolmentsMinMaxFormulaFieldRecalculateCreateBodyOne
      | BenefitsEnrolmentsMinMaxFormulaFieldRecalculateCreateBodyTwo
      | BenefitsEnrolmentsMinMaxFormulaFieldRecalculateCreateBodyThree;
  };

export const useBenefitsEnrolmentsMinMaxFormulaFieldRecalculateCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<typeof benefitsEnrolmentsMinMaxFormulaFieldRecalculateCreate>
    >,
    TError,
    BenefitsEnrolmentsMinMaxFormulaFieldRecalculateCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<typeof benefitsEnrolmentsMinMaxFormulaFieldRecalculateCreate>
  >,
  TError,
  BenefitsEnrolmentsMinMaxFormulaFieldRecalculateCreateMutationVariables,
  TContext
> => {
  return useMutation(
    getBenefitsEnrolmentsMinMaxFormulaFieldRecalculateCreateMutationOptions(
      options
    )
  );
};

export const benefitsEnrolmentsPensionHolidayEndCreate = (
  enrolmentPk: number,
  holidayId: number,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/ecc/v1.0/benefits/enrolments/${enrolmentPk}/pension-holiday/${holidayId}/end/`,
    method: 'POST',
    signal,
  });
};

export const getBenefitsEnrolmentsPensionHolidayEndCreateMutationKey = () =>
  ['benefitsEnrolmentsPensionHolidayEndCreate'] as const;

export const getBenefitsEnrolmentsPensionHolidayEndCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof benefitsEnrolmentsPensionHolidayEndCreate>>,
    TError,
    BenefitsEnrolmentsPensionHolidayEndCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof benefitsEnrolmentsPensionHolidayEndCreate>>,
  TError,
  BenefitsEnrolmentsPensionHolidayEndCreateMutationVariables,
  TContext
> => {
  const mutationKey = getBenefitsEnrolmentsPensionHolidayEndCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof benefitsEnrolmentsPensionHolidayEndCreate>>,
    BenefitsEnrolmentsPensionHolidayEndCreateMutationVariables
  > = (props) => {
    const { enrolmentPk, holidayId } = props ?? {};

    return benefitsEnrolmentsPensionHolidayEndCreate(enrolmentPk, holidayId);
  };

  return { mutationFn, ...mutationOptions };
};

export type BenefitsEnrolmentsPensionHolidayEndCreateMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof benefitsEnrolmentsPensionHolidayEndCreate>>
  >;

export type BenefitsEnrolmentsPensionHolidayEndCreateMutationError = unknown;
export type BenefitsEnrolmentsPensionHolidayEndCreateMutationVariables = {
  enrolmentPk: number;
  holidayId: number;
};

export const useBenefitsEnrolmentsPensionHolidayEndCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof benefitsEnrolmentsPensionHolidayEndCreate>>,
    TError,
    BenefitsEnrolmentsPensionHolidayEndCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof benefitsEnrolmentsPensionHolidayEndCreate>>,
  TError,
  BenefitsEnrolmentsPensionHolidayEndCreateMutationVariables,
  TContext
> => {
  return useMutation(
    getBenefitsEnrolmentsPensionHolidayEndCreateMutationOptions(options)
  );
};

export const benefitsEnrolmentsOptOutCreate = (
  benefitOptOutRequestRequest: BenefitOptOutRequestRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/ecc/v1.0/benefits/enrolments/opt-out/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: benefitOptOutRequestRequest,
    signal,
  });
};

export const getBenefitsEnrolmentsOptOutCreateMutationKey = () =>
  ['benefitsEnrolmentsOptOutCreate'] as const;

export const getBenefitsEnrolmentsOptOutCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof benefitsEnrolmentsOptOutCreate>>,
    TError,
    BenefitsEnrolmentsOptOutCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof benefitsEnrolmentsOptOutCreate>>,
  TError,
  BenefitsEnrolmentsOptOutCreateMutationVariables,
  TContext
> => {
  const mutationKey = getBenefitsEnrolmentsOptOutCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof benefitsEnrolmentsOptOutCreate>>,
    BenefitsEnrolmentsOptOutCreateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return benefitsEnrolmentsOptOutCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type BenefitsEnrolmentsOptOutCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof benefitsEnrolmentsOptOutCreate>>
>;
export type BenefitsEnrolmentsOptOutCreateMutationBody =
  BenefitOptOutRequestRequest;
export type BenefitsEnrolmentsOptOutCreateMutationError = unknown;
export type BenefitsEnrolmentsOptOutCreateMutationVariables = {
  data: BenefitOptOutRequestRequest;
};

export const useBenefitsEnrolmentsOptOutCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof benefitsEnrolmentsOptOutCreate>>,
    TError,
    BenefitsEnrolmentsOptOutCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof benefitsEnrolmentsOptOutCreate>>,
  TError,
  BenefitsEnrolmentsOptOutCreateMutationVariables,
  TContext
> => {
  return useMutation(getBenefitsEnrolmentsOptOutCreateMutationOptions(options));
};

export const benefitsProvidersRetrieve = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<ProviderResponse>({
    url: `/ecc/v1.0/benefits/providers/`,
    method: 'GET',
    signal,
  });
};

export const getBenefitsProvidersRetrieveQueryKey = () => {
  return [`/ecc/v1.0/benefits/providers/`] as const;
};

export const getBenefitsProvidersRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof benefitsProvidersRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof benefitsProvidersRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getBenefitsProvidersRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof benefitsProvidersRetrieve>>
  > = ({ signal }) => benefitsProvidersRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof benefitsProvidersRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type BenefitsProvidersRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof benefitsProvidersRetrieve>>
>;
export type BenefitsProvidersRetrieveQueryError = unknown;

export function useBenefitsProvidersRetrieve<
  TData = Awaited<ReturnType<typeof benefitsProvidersRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof benefitsProvidersRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getBenefitsProvidersRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const budgetsRetrieve = (
  params?: BudgetsRetrieveParams,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<BudgetsResponse>({
    url: `/ecc/v1.0/budgets/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getBudgetsRetrieveQueryKey = (params?: BudgetsRetrieveParams) => {
  return [`/ecc/v1.0/budgets/`, ...(params ? [params] : [])] as const;
};

export const getBudgetsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof budgetsRetrieve>>,
  TError = unknown,
>(
  params?: BudgetsRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof budgetsRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getBudgetsRetrieveQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof budgetsRetrieve>>> = ({
    signal,
  }) => budgetsRetrieve(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof budgetsRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type BudgetsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof budgetsRetrieve>>
>;
export type BudgetsRetrieveQueryError = unknown;

export function useBudgetsRetrieve<
  TData = Awaited<ReturnType<typeof budgetsRetrieve>>,
  TError = unknown,
>(
  params?: BudgetsRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof budgetsRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getBudgetsRetrieveQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const budgetsCreate = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<void>({
    url: `/ecc/v1.0/budgets/`,
    method: 'POST',
    signal,
  });
};

export const getBudgetsCreateMutationKey = () => ['budgetsCreate'] as const;

export const getBudgetsCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof budgetsCreate>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof budgetsCreate>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = getBudgetsCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof budgetsCreate>>,
    void
  > = () => {
    return budgetsCreate();
  };

  return { mutationFn, ...mutationOptions };
};

export type BudgetsCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof budgetsCreate>>
>;

export type BudgetsCreateMutationError = unknown;

export const useBudgetsCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof budgetsCreate>>,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof budgetsCreate>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getBudgetsCreateMutationOptions(options));
};

export const budgetsRetrieve2 = (id: number, signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<BudgetDetailResponse>({
    url: `/ecc/v1.0/budgets/${id}/`,
    method: 'GET',
    signal,
  });
};

export const getBudgetsRetrieve2QueryKey = (id: number) => {
  return [`/ecc/v1.0/budgets/${id}/`] as const;
};

export const getBudgetsRetrieve2QueryOptions = <
  TData = Awaited<ReturnType<typeof budgetsRetrieve2>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof budgetsRetrieve2>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getBudgetsRetrieve2QueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof budgetsRetrieve2>>
  > = ({ signal }) => budgetsRetrieve2(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof budgetsRetrieve2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type BudgetsRetrieve2QueryResult = NonNullable<
  Awaited<ReturnType<typeof budgetsRetrieve2>>
>;
export type BudgetsRetrieve2QueryError = unknown;

export function useBudgetsRetrieve2<
  TData = Awaited<ReturnType<typeof budgetsRetrieve2>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof budgetsRetrieve2>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getBudgetsRetrieve2QueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const budgetsPartialUpdate = (
  id: number,
  patchedBudgetUpdateRequestRequest?: PatchedBudgetUpdateRequestRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<BudgetDetailResponse>({
    url: `/ecc/v1.0/budgets/${id}/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchedBudgetUpdateRequestRequest,
    signal,
  });
};

export const getBudgetsPartialUpdateMutationKey = () =>
  ['budgetsPartialUpdate'] as const;

export const getBudgetsPartialUpdateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof budgetsPartialUpdate>>,
    TError,
    BudgetsPartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof budgetsPartialUpdate>>,
  TError,
  BudgetsPartialUpdateMutationVariables,
  TContext
> => {
  const mutationKey = getBudgetsPartialUpdateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof budgetsPartialUpdate>>,
    BudgetsPartialUpdateMutationVariables
  > = (props) => {
    const { id, data } = props ?? {};

    return budgetsPartialUpdate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type BudgetsPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof budgetsPartialUpdate>>
>;
export type BudgetsPartialUpdateMutationBody =
  | PatchedBudgetUpdateRequestRequest
  | undefined;
export type BudgetsPartialUpdateMutationError = unknown;
export type BudgetsPartialUpdateMutationVariables = {
  id: number;
  data?: PatchedBudgetUpdateRequestRequest;
};

export const useBudgetsPartialUpdate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof budgetsPartialUpdate>>,
    TError,
    BudgetsPartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof budgetsPartialUpdate>>,
  TError,
  BudgetsPartialUpdateMutationVariables,
  TContext
> => {
  return useMutation(getBudgetsPartialUpdateMutationOptions(options));
};

export const budgetsMembersList = (
  id: number,
  params?: BudgetsMembersListParams,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<BudgetMemberResponse[]>({
    url: `/ecc/v1.0/budgets/${id}/members/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getBudgetsMembersListQueryKey = (
  id: number,
  params?: BudgetsMembersListParams
) => {
  return [
    `/ecc/v1.0/budgets/${id}/members/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getBudgetsMembersListQueryOptions = <
  TData = Awaited<ReturnType<typeof budgetsMembersList>>,
  TError = unknown,
>(
  id: number,
  params?: BudgetsMembersListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof budgetsMembersList>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getBudgetsMembersListQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof budgetsMembersList>>
  > = ({ signal }) => budgetsMembersList(id, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof budgetsMembersList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type BudgetsMembersListQueryResult = NonNullable<
  Awaited<ReturnType<typeof budgetsMembersList>>
>;
export type BudgetsMembersListQueryError = unknown;

export function useBudgetsMembersList<
  TData = Awaited<ReturnType<typeof budgetsMembersList>>,
  TError = unknown,
>(
  id: number,
  params?: BudgetsMembersListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof budgetsMembersList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getBudgetsMembersListQueryOptions(id, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const budgetsMembersCreate = (id: number, signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<void>({
    url: `/ecc/v1.0/budgets/${id}/members/`,
    method: 'POST',
    signal,
  });
};

export const getBudgetsMembersCreateMutationKey = () =>
  ['budgetsMembersCreate'] as const;

export const getBudgetsMembersCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof budgetsMembersCreate>>,
    TError,
    BudgetsMembersCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof budgetsMembersCreate>>,
  TError,
  BudgetsMembersCreateMutationVariables,
  TContext
> => {
  const mutationKey = getBudgetsMembersCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof budgetsMembersCreate>>,
    BudgetsMembersCreateMutationVariables
  > = (props) => {
    const { id } = props ?? {};

    return budgetsMembersCreate(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type BudgetsMembersCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof budgetsMembersCreate>>
>;

export type BudgetsMembersCreateMutationError = unknown;
export type BudgetsMembersCreateMutationVariables = { id: number };

export const useBudgetsMembersCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof budgetsMembersCreate>>,
    TError,
    BudgetsMembersCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof budgetsMembersCreate>>,
  TError,
  BudgetsMembersCreateMutationVariables,
  TContext
> => {
  return useMutation(getBudgetsMembersCreateMutationOptions(options));
};

export const budgetsTopupCreate = (
  id: number,
  budgetTopupRequestRequest: BudgetTopupRequestRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<BudgetTopupRequest>({
    url: `/ecc/v1.0/budgets/${id}/topup/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: budgetTopupRequestRequest,
    signal,
  });
};

export const getBudgetsTopupCreateMutationKey = () =>
  ['budgetsTopupCreate'] as const;

export const getBudgetsTopupCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof budgetsTopupCreate>>,
    TError,
    BudgetsTopupCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof budgetsTopupCreate>>,
  TError,
  BudgetsTopupCreateMutationVariables,
  TContext
> => {
  const mutationKey = getBudgetsTopupCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof budgetsTopupCreate>>,
    BudgetsTopupCreateMutationVariables
  > = (props) => {
    const { id, data } = props ?? {};

    return budgetsTopupCreate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type BudgetsTopupCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof budgetsTopupCreate>>
>;
export type BudgetsTopupCreateMutationBody = BudgetTopupRequestRequest;
export type BudgetsTopupCreateMutationError = unknown;
export type BudgetsTopupCreateMutationVariables = {
  id: number;
  data: BudgetTopupRequestRequest;
};

export const useBudgetsTopupCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof budgetsTopupCreate>>,
    TError,
    BudgetsTopupCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof budgetsTopupCreate>>,
  TError,
  BudgetsTopupCreateMutationVariables,
  TContext
> => {
  return useMutation(getBudgetsTopupCreateMutationOptions(options));
};

export const budgetsEmployeesRetrieve = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<BudgetEmployeeResponse>({
    url: `/ecc/v1.0/budgets/employees/`,
    method: 'GET',
    signal,
  });
};

export const getBudgetsEmployeesRetrieveQueryKey = () => {
  return [`/ecc/v1.0/budgets/employees/`] as const;
};

export const getBudgetsEmployeesRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof budgetsEmployeesRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof budgetsEmployeesRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getBudgetsEmployeesRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof budgetsEmployeesRetrieve>>
  > = ({ signal }) => budgetsEmployeesRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof budgetsEmployeesRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type BudgetsEmployeesRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof budgetsEmployeesRetrieve>>
>;
export type BudgetsEmployeesRetrieveQueryError = unknown;

export function useBudgetsEmployeesRetrieve<
  TData = Awaited<ReturnType<typeof budgetsEmployeesRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof budgetsEmployeesRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getBudgetsEmployeesRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const changeEmployerRetrieve = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<EmployerResponse>({
    url: `/ecc/v1.0/change_employer/`,
    method: 'GET',
    signal,
  });
};

export const getChangeEmployerRetrieveQueryKey = () => {
  return [`/ecc/v1.0/change_employer/`] as const;
};

export const getChangeEmployerRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof changeEmployerRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof changeEmployerRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getChangeEmployerRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof changeEmployerRetrieve>>
  > = ({ signal }) => changeEmployerRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof changeEmployerRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ChangeEmployerRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof changeEmployerRetrieve>>
>;
export type ChangeEmployerRetrieveQueryError = unknown;

export function useChangeEmployerRetrieve<
  TData = Awaited<ReturnType<typeof changeEmployerRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof changeEmployerRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getChangeEmployerRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const changeEmployerPartialUpdate = (
  patchedEmployerChangeRequestRequest?: PatchedEmployerChangeRequestRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/ecc/v1.0/change_employer/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchedEmployerChangeRequestRequest,
    signal,
  });
};

export const getChangeEmployerPartialUpdateMutationKey = () =>
  ['changeEmployerPartialUpdate'] as const;

export const getChangeEmployerPartialUpdateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changeEmployerPartialUpdate>>,
    TError,
    ChangeEmployerPartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof changeEmployerPartialUpdate>>,
  TError,
  ChangeEmployerPartialUpdateMutationVariables,
  TContext
> => {
  const mutationKey = getChangeEmployerPartialUpdateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof changeEmployerPartialUpdate>>,
    ChangeEmployerPartialUpdateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return changeEmployerPartialUpdate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChangeEmployerPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof changeEmployerPartialUpdate>>
>;
export type ChangeEmployerPartialUpdateMutationBody =
  | PatchedEmployerChangeRequestRequest
  | undefined;
export type ChangeEmployerPartialUpdateMutationError = unknown;
export type ChangeEmployerPartialUpdateMutationVariables = {
  data?: PatchedEmployerChangeRequestRequest;
};

export const useChangeEmployerPartialUpdate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changeEmployerPartialUpdate>>,
    TError,
    ChangeEmployerPartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof changeEmployerPartialUpdate>>,
  TError,
  ChangeEmployerPartialUpdateMutationVariables,
  TContext
> => {
  return useMutation(getChangeEmployerPartialUpdateMutationOptions(options));
};

/**
 * A viewset for listing and retrieving benefit notifications for all enrolments to a
 * given benefit.
 */
export const changesList = (
  params?: ChangesListParams,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<PaginatedAdminEnrolmentChangeListResponseList>(
    { url: `/ecc/v1.0/changes/`, method: 'GET', params, signal }
  );
};

export const getChangesListQueryKey = (params?: ChangesListParams) => {
  return [`/ecc/v1.0/changes/`, ...(params ? [params] : [])] as const;
};

export const getChangesListQueryOptions = <
  TData = Awaited<ReturnType<typeof changesList>>,
  TError = unknown,
>(
  params?: ChangesListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof changesList>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getChangesListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof changesList>>> = ({
    signal,
  }) => changesList(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof changesList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ChangesListQueryResult = NonNullable<
  Awaited<ReturnType<typeof changesList>>
>;
export type ChangesListQueryError = unknown;

export function useChangesList<
  TData = Awaited<ReturnType<typeof changesList>>,
  TError = unknown,
>(
  params?: ChangesListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof changesList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getChangesListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * A viewset for listing and retrieving benefit notifications for all enrolments to a
 * given benefit.
 */
export const changesRetrieve = (id: string, signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<AdminEnrolmentChangeDetailResponse>({
    url: `/ecc/v1.0/changes/${id}/`,
    method: 'GET',
    signal,
  });
};

export const getChangesRetrieveQueryKey = (id: string) => {
  return [`/ecc/v1.0/changes/${id}/`] as const;
};

export const getChangesRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof changesRetrieve>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof changesRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getChangesRetrieveQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof changesRetrieve>>> = ({
    signal,
  }) => changesRetrieve(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof changesRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ChangesRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof changesRetrieve>>
>;
export type ChangesRetrieveQueryError = unknown;

export function useChangesRetrieve<
  TData = Awaited<ReturnType<typeof changesRetrieve>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof changesRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getChangesRetrieveQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * An admin list view to retrieve all benefit notifications for a given user enrolment.
 * The messages returned are tailored to being viewed by an admin.
 */
export const changesEnrolmentsList = (
  enrolmentPk: number,
  params?: ChangesEnrolmentsListParams,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<PaginatedEnrolmentChangeResponseList>({
    url: `/ecc/v1.0/changes/enrolments/${enrolmentPk}/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getChangesEnrolmentsListQueryKey = (
  enrolmentPk: number,
  params?: ChangesEnrolmentsListParams
) => {
  return [
    `/ecc/v1.0/changes/enrolments/${enrolmentPk}/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getChangesEnrolmentsListQueryOptions = <
  TData = Awaited<ReturnType<typeof changesEnrolmentsList>>,
  TError = unknown,
>(
  enrolmentPk: number,
  params?: ChangesEnrolmentsListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof changesEnrolmentsList>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getChangesEnrolmentsListQueryKey(enrolmentPk, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof changesEnrolmentsList>>
  > = ({ signal }) => changesEnrolmentsList(enrolmentPk, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: enrolmentPk !== null && enrolmentPk !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof changesEnrolmentsList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ChangesEnrolmentsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof changesEnrolmentsList>>
>;
export type ChangesEnrolmentsListQueryError = unknown;

export function useChangesEnrolmentsList<
  TData = Awaited<ReturnType<typeof changesEnrolmentsList>>,
  TError = unknown,
>(
  enrolmentPk: number,
  params?: ChangesEnrolmentsListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof changesEnrolmentsList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getChangesEnrolmentsListQueryOptions(
    enrolmentPk,
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const chatChatsRetrieve = (
  params?: ChatChatsRetrieveParams,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<EccChatListPaginatedResponse>({
    url: `/ecc/v1.0/chat/chats/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getChatChatsRetrieveQueryKey = (
  params?: ChatChatsRetrieveParams
) => {
  return [`/ecc/v1.0/chat/chats/`, ...(params ? [params] : [])] as const;
};

export const getChatChatsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof chatChatsRetrieve>>,
  TError = unknown,
>(
  params?: ChatChatsRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof chatChatsRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getChatChatsRetrieveQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof chatChatsRetrieve>>
  > = ({ signal }) => chatChatsRetrieve(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof chatChatsRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ChatChatsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof chatChatsRetrieve>>
>;
export type ChatChatsRetrieveQueryError = unknown;

export function useChatChatsRetrieve<
  TData = Awaited<ReturnType<typeof chatChatsRetrieve>>,
  TError = unknown,
>(
  params?: ChatChatsRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof chatChatsRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getChatChatsRetrieveQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const chatChatsCreate = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<EccChatCreateResponse>({
    url: `/ecc/v1.0/chat/chats/`,
    method: 'POST',
    signal,
  });
};

export const getChatChatsCreateMutationKey = () => ['chatChatsCreate'] as const;

export const getChatChatsCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof chatChatsCreate>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof chatChatsCreate>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = getChatChatsCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof chatChatsCreate>>,
    void
  > = () => {
    return chatChatsCreate();
  };

  return { mutationFn, ...mutationOptions };
};

export type ChatChatsCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof chatChatsCreate>>
>;

export type ChatChatsCreateMutationError = unknown;

export const useChatChatsCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof chatChatsCreate>>,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof chatChatsCreate>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getChatChatsCreateMutationOptions(options));
};

export const chatChatsRetrieve2 = (chatId: string, signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<EccChatDetail>({
    url: `/ecc/v1.0/chat/chats/${chatId}/`,
    method: 'GET',
    signal,
  });
};

export const getChatChatsRetrieve2QueryKey = (chatId: string) => {
  return [`/ecc/v1.0/chat/chats/${chatId}/`] as const;
};

export const getChatChatsRetrieve2QueryOptions = <
  TData = Awaited<ReturnType<typeof chatChatsRetrieve2>>,
  TError = unknown,
>(
  chatId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof chatChatsRetrieve2>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getChatChatsRetrieve2QueryKey(chatId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof chatChatsRetrieve2>>
  > = ({ signal }) => chatChatsRetrieve2(chatId, signal);

  return {
    queryKey,
    queryFn,
    enabled: chatId !== null && chatId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof chatChatsRetrieve2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ChatChatsRetrieve2QueryResult = NonNullable<
  Awaited<ReturnType<typeof chatChatsRetrieve2>>
>;
export type ChatChatsRetrieve2QueryError = unknown;

export function useChatChatsRetrieve2<
  TData = Awaited<ReturnType<typeof chatChatsRetrieve2>>,
  TError = unknown,
>(
  chatId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof chatChatsRetrieve2>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getChatChatsRetrieve2QueryOptions(chatId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const chatChatsHandoffCreate = (
  chatId: string,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<EccHandoffResponse>({
    url: `/ecc/v1.0/chat/chats/${chatId}/handoff/`,
    method: 'POST',
    signal,
  });
};

export const getChatChatsHandoffCreateMutationKey = () =>
  ['chatChatsHandoffCreate'] as const;

export const getChatChatsHandoffCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof chatChatsHandoffCreate>>,
    TError,
    ChatChatsHandoffCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof chatChatsHandoffCreate>>,
  TError,
  ChatChatsHandoffCreateMutationVariables,
  TContext
> => {
  const mutationKey = getChatChatsHandoffCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof chatChatsHandoffCreate>>,
    ChatChatsHandoffCreateMutationVariables
  > = (props) => {
    const { chatId } = props ?? {};

    return chatChatsHandoffCreate(chatId);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChatChatsHandoffCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof chatChatsHandoffCreate>>
>;

export type ChatChatsHandoffCreateMutationError = unknown;
export type ChatChatsHandoffCreateMutationVariables = { chatId: string };

export const useChatChatsHandoffCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof chatChatsHandoffCreate>>,
    TError,
    ChatChatsHandoffCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof chatChatsHandoffCreate>>,
  TError,
  ChatChatsHandoffCreateMutationVariables,
  TContext
> => {
  return useMutation(getChatChatsHandoffCreateMutationOptions(options));
};

export const chatChatsTurnsCreate = (
  chatId: string,
  eccSubmitTurnRequestRequest: EccSubmitTurnRequestRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<EccSubmitTurnResponse>({
    url: `/ecc/v1.0/chat/chats/${chatId}/turns/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: eccSubmitTurnRequestRequest,
    signal,
  });
};

export const getChatChatsTurnsCreateMutationKey = () =>
  ['chatChatsTurnsCreate'] as const;

export const getChatChatsTurnsCreateMutationOptions = <
  TError = EccSubmitTurnConflict,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof chatChatsTurnsCreate>>,
    TError,
    ChatChatsTurnsCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof chatChatsTurnsCreate>>,
  TError,
  ChatChatsTurnsCreateMutationVariables,
  TContext
> => {
  const mutationKey = getChatChatsTurnsCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof chatChatsTurnsCreate>>,
    ChatChatsTurnsCreateMutationVariables
  > = (props) => {
    const { chatId, data } = props ?? {};

    return chatChatsTurnsCreate(chatId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChatChatsTurnsCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof chatChatsTurnsCreate>>
>;
export type ChatChatsTurnsCreateMutationBody = EccSubmitTurnRequestRequest;
export type ChatChatsTurnsCreateMutationError = EccSubmitTurnConflict;
export type ChatChatsTurnsCreateMutationVariables = {
  chatId: string;
  data: EccSubmitTurnRequestRequest;
};

export const useChatChatsTurnsCreate = <
  TError = EccSubmitTurnConflict,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof chatChatsTurnsCreate>>,
    TError,
    ChatChatsTurnsCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof chatChatsTurnsCreate>>,
  TError,
  ChatChatsTurnsCreateMutationVariables,
  TContext
> => {
  return useMutation(getChatChatsTurnsCreateMutationOptions(options));
};

export const chatChatsTurnsRetrieve = (
  chatId: string,
  turnId: string,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<EccPollTurnResponse>({
    url: `/ecc/v1.0/chat/chats/${chatId}/turns/${turnId}/`,
    method: 'GET',
    signal,
  });
};

export const getChatChatsTurnsRetrieveQueryKey = (
  chatId: string,
  turnId: string
) => {
  return [`/ecc/v1.0/chat/chats/${chatId}/turns/${turnId}/`] as const;
};

export const getChatChatsTurnsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof chatChatsTurnsRetrieve>>,
  TError = unknown,
>(
  chatId: string,
  turnId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof chatChatsTurnsRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getChatChatsTurnsRetrieveQueryKey(chatId, turnId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof chatChatsTurnsRetrieve>>
  > = ({ signal }) => chatChatsTurnsRetrieve(chatId, turnId, signal);

  return {
    queryKey,
    queryFn,
    enabled:
      chatId !== null &&
      chatId !== undefined &&
      turnId !== null &&
      turnId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof chatChatsTurnsRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ChatChatsTurnsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof chatChatsTurnsRetrieve>>
>;
export type ChatChatsTurnsRetrieveQueryError = unknown;

export function useChatChatsTurnsRetrieve<
  TData = Awaited<ReturnType<typeof chatChatsTurnsRetrieve>>,
  TError = unknown,
>(
  chatId: string,
  turnId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof chatChatsTurnsRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getChatChatsTurnsRetrieveQueryOptions(
    chatId,
    turnId,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Best-effort cancel of a queued ECC chat turn. Returns 202 even when the turn is already terminal. In-flight turns are left untouched by Temporal's cancel contract.
 */
export const chatChatsTurnsCancelCreate = (
  chatId: string,
  turnId: string,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/ecc/v1.0/chat/chats/${chatId}/turns/${turnId}/cancel/`,
    method: 'POST',
    signal,
  });
};

export const getChatChatsTurnsCancelCreateMutationKey = () =>
  ['chatChatsTurnsCancelCreate'] as const;

export const getChatChatsTurnsCancelCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof chatChatsTurnsCancelCreate>>,
    TError,
    ChatChatsTurnsCancelCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof chatChatsTurnsCancelCreate>>,
  TError,
  ChatChatsTurnsCancelCreateMutationVariables,
  TContext
> => {
  const mutationKey = getChatChatsTurnsCancelCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof chatChatsTurnsCancelCreate>>,
    ChatChatsTurnsCancelCreateMutationVariables
  > = (props) => {
    const { chatId, turnId } = props ?? {};

    return chatChatsTurnsCancelCreate(chatId, turnId);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChatChatsTurnsCancelCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof chatChatsTurnsCancelCreate>>
>;

export type ChatChatsTurnsCancelCreateMutationError = unknown;
export type ChatChatsTurnsCancelCreateMutationVariables = {
  chatId: string;
  turnId: string;
};

export const useChatChatsTurnsCancelCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof chatChatsTurnsCancelCreate>>,
    TError,
    ChatChatsTurnsCancelCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof chatChatsTurnsCancelCreate>>,
  TError,
  ChatChatsTurnsCancelCreateMutationVariables,
  TContext
> => {
  return useMutation(getChatChatsTurnsCancelCreateMutationOptions(options));
};

export const chatSuggestionsRetrieve = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<EccSuggestionsResponse>({
    url: `/ecc/v1.0/chat/suggestions/`,
    method: 'GET',
    signal,
  });
};

export const getChatSuggestionsRetrieveQueryKey = () => {
  return [`/ecc/v1.0/chat/suggestions/`] as const;
};

export const getChatSuggestionsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof chatSuggestionsRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof chatSuggestionsRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getChatSuggestionsRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof chatSuggestionsRetrieve>>
  > = ({ signal }) => chatSuggestionsRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof chatSuggestionsRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ChatSuggestionsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof chatSuggestionsRetrieve>>
>;
export type ChatSuggestionsRetrieveQueryError = unknown;

export function useChatSuggestionsRetrieve<
  TData = Awaited<ReturnType<typeof chatSuggestionsRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof chatSuggestionsRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getChatSuggestionsRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const corporateCreateCreate = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<void>({
    url: `/ecc/v1.0/corporate/create/`,
    method: 'POST',
    signal,
  });
};

export const getCorporateCreateCreateMutationKey = () =>
  ['corporateCreateCreate'] as const;

export const getCorporateCreateCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof corporateCreateCreate>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof corporateCreateCreate>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = getCorporateCreateCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof corporateCreateCreate>>,
    void
  > = () => {
    return corporateCreateCreate();
  };

  return { mutationFn, ...mutationOptions };
};

export type CorporateCreateCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof corporateCreateCreate>>
>;

export type CorporateCreateCreateMutationError = unknown;

export const useCorporateCreateCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof corporateCreateCreate>>,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof corporateCreateCreate>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getCorporateCreateCreateMutationOptions(options));
};

export const corporateKybCreate = (
  corporateKYBRequestRequest?: CorporateKYBRequestRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<CorporateKYBResponse>({
    url: `/ecc/v1.0/corporate/kyb/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: corporateKYBRequestRequest,
    signal,
  });
};

export const getCorporateKybCreateMutationKey = () =>
  ['corporateKybCreate'] as const;

export const getCorporateKybCreateMutationOptions = <
  TError = AirwallexAccountCreateErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof corporateKybCreate>>,
    TError,
    CorporateKybCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof corporateKybCreate>>,
  TError,
  CorporateKybCreateMutationVariables,
  TContext
> => {
  const mutationKey = getCorporateKybCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof corporateKybCreate>>,
    CorporateKybCreateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return corporateKybCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CorporateKybCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof corporateKybCreate>>
>;
export type CorporateKybCreateMutationBody =
  | CorporateKYBRequestRequest
  | undefined;
export type CorporateKybCreateMutationError =
  AirwallexAccountCreateErrorResponse;
export type CorporateKybCreateMutationVariables = {
  data?: CorporateKYBRequestRequest;
};

export const useCorporateKybCreate = <
  TError = AirwallexAccountCreateErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof corporateKybCreate>>,
    TError,
    CorporateKybCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof corporateKybCreate>>,
  TError,
  CorporateKybCreateMutationVariables,
  TContext
> => {
  return useMutation(getCorporateKybCreateMutationOptions(options));
};

export const corporateLoginCreate = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<void>({
    url: `/ecc/v1.0/corporate/login/`,
    method: 'POST',
    signal,
  });
};

export const getCorporateLoginCreateMutationKey = () =>
  ['corporateLoginCreate'] as const;

export const getCorporateLoginCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof corporateLoginCreate>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof corporateLoginCreate>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = getCorporateLoginCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof corporateLoginCreate>>,
    void
  > = () => {
    return corporateLoginCreate();
  };

  return { mutationFn, ...mutationOptions };
};

export type CorporateLoginCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof corporateLoginCreate>>
>;

export type CorporateLoginCreateMutationError = unknown;

export const useCorporateLoginCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof corporateLoginCreate>>,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof corporateLoginCreate>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getCorporateLoginCreateMutationOptions(options));
};

export const corporateManagedAccountRetrieve = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<ManagedAccount>({
    url: `/ecc/v1.0/corporate/managed-account/`,
    method: 'GET',
    signal,
  });
};

export const getCorporateManagedAccountRetrieveQueryKey = () => {
  return [`/ecc/v1.0/corporate/managed-account/`] as const;
};

export const getCorporateManagedAccountRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof corporateManagedAccountRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof corporateManagedAccountRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getCorporateManagedAccountRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof corporateManagedAccountRetrieve>>
  > = ({ signal }) => corporateManagedAccountRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof corporateManagedAccountRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CorporateManagedAccountRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof corporateManagedAccountRetrieve>>
>;
export type CorporateManagedAccountRetrieveQueryError = unknown;

export function useCorporateManagedAccountRetrieve<
  TData = Awaited<ReturnType<typeof corporateManagedAccountRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof corporateManagedAccountRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getCorporateManagedAccountRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const corporateManagedAccountCreate = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<void>({
    url: `/ecc/v1.0/corporate/managed-account/`,
    method: 'POST',
    signal,
  });
};

export const getCorporateManagedAccountCreateMutationKey = () =>
  ['corporateManagedAccountCreate'] as const;

export const getCorporateManagedAccountCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof corporateManagedAccountCreate>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof corporateManagedAccountCreate>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = getCorporateManagedAccountCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof corporateManagedAccountCreate>>,
    void
  > = () => {
    return corporateManagedAccountCreate();
  };

  return { mutationFn, ...mutationOptions };
};

export type CorporateManagedAccountCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof corporateManagedAccountCreate>>
>;

export type CorporateManagedAccountCreateMutationError = unknown;

export const useCorporateManagedAccountCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof corporateManagedAccountCreate>>,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof corporateManagedAccountCreate>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getCorporateManagedAccountCreateMutationOptions(options));
};

export const corporateManagedAccountBalancesRetrieve = (
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<ManagedAccountBalances>({
    url: `/ecc/v1.0/corporate/managed-account/balances/`,
    method: 'GET',
    signal,
  });
};

export const getCorporateManagedAccountBalancesRetrieveQueryKey = () => {
  return [`/ecc/v1.0/corporate/managed-account/balances/`] as const;
};

export const getCorporateManagedAccountBalancesRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof corporateManagedAccountBalancesRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof corporateManagedAccountBalancesRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getCorporateManagedAccountBalancesRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof corporateManagedAccountBalancesRetrieve>>
  > = ({ signal }) => corporateManagedAccountBalancesRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof corporateManagedAccountBalancesRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CorporateManagedAccountBalancesRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof corporateManagedAccountBalancesRetrieve>>
>;
export type CorporateManagedAccountBalancesRetrieveQueryError = unknown;

export function useCorporateManagedAccountBalancesRetrieve<
  TData = Awaited<ReturnType<typeof corporateManagedAccountBalancesRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof corporateManagedAccountBalancesRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getCorporateManagedAccountBalancesRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const corporateSendEmailVerificationCodeCreate = (
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/ecc/v1.0/corporate/send_email_verification_code/`,
    method: 'POST',
    signal,
  });
};

export const getCorporateSendEmailVerificationCodeCreateMutationKey = () =>
  ['corporateSendEmailVerificationCodeCreate'] as const;

export const getCorporateSendEmailVerificationCodeCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof corporateSendEmailVerificationCodeCreate>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof corporateSendEmailVerificationCodeCreate>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = getCorporateSendEmailVerificationCodeCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof corporateSendEmailVerificationCodeCreate>>,
    void
  > = () => {
    return corporateSendEmailVerificationCodeCreate();
  };

  return { mutationFn, ...mutationOptions };
};

export type CorporateSendEmailVerificationCodeCreateMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof corporateSendEmailVerificationCodeCreate>>
  >;

export type CorporateSendEmailVerificationCodeCreateMutationError = unknown;

export const useCorporateSendEmailVerificationCodeCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof corporateSendEmailVerificationCodeCreate>>,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof corporateSendEmailVerificationCodeCreate>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getCorporateSendEmailVerificationCodeCreateMutationOptions(options)
  );
};

export const corporateSendMobileVerificationCodeCreate = (
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/ecc/v1.0/corporate/send_mobile_verification_code/`,
    method: 'POST',
    signal,
  });
};

export const getCorporateSendMobileVerificationCodeCreateMutationKey = () =>
  ['corporateSendMobileVerificationCodeCreate'] as const;

export const getCorporateSendMobileVerificationCodeCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof corporateSendMobileVerificationCodeCreate>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof corporateSendMobileVerificationCodeCreate>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = getCorporateSendMobileVerificationCodeCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof corporateSendMobileVerificationCodeCreate>>,
    void
  > = () => {
    return corporateSendMobileVerificationCodeCreate();
  };

  return { mutationFn, ...mutationOptions };
};

export type CorporateSendMobileVerificationCodeCreateMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof corporateSendMobileVerificationCodeCreate>>
  >;

export type CorporateSendMobileVerificationCodeCreateMutationError = unknown;

export const useCorporateSendMobileVerificationCodeCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof corporateSendMobileVerificationCodeCreate>>,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof corporateSendMobileVerificationCodeCreate>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getCorporateSendMobileVerificationCodeCreateMutationOptions(options)
  );
};

export const corporateSetPasswordCreate = (
  weavrPasswordRequestRequest: WeavrPasswordRequestRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/ecc/v1.0/corporate/set-password/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: weavrPasswordRequestRequest,
    signal,
  });
};

export const getCorporateSetPasswordCreateMutationKey = () =>
  ['corporateSetPasswordCreate'] as const;

export const getCorporateSetPasswordCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof corporateSetPasswordCreate>>,
    TError,
    CorporateSetPasswordCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof corporateSetPasswordCreate>>,
  TError,
  CorporateSetPasswordCreateMutationVariables,
  TContext
> => {
  const mutationKey = getCorporateSetPasswordCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof corporateSetPasswordCreate>>,
    CorporateSetPasswordCreateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return corporateSetPasswordCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CorporateSetPasswordCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof corporateSetPasswordCreate>>
>;
export type CorporateSetPasswordCreateMutationBody =
  WeavrPasswordRequestRequest;
export type CorporateSetPasswordCreateMutationError = unknown;
export type CorporateSetPasswordCreateMutationVariables = {
  data: WeavrPasswordRequestRequest;
};

export const useCorporateSetPasswordCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof corporateSetPasswordCreate>>,
    TError,
    CorporateSetPasswordCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof corporateSetPasswordCreate>>,
  TError,
  CorporateSetPasswordCreateMutationVariables,
  TContext
> => {
  return useMutation(getCorporateSetPasswordCreateMutationOptions(options));
};

export const corporateVerifyEmailVerificationCodeCreate = (
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/ecc/v1.0/corporate/verify_email_verification_code/`,
    method: 'POST',
    signal,
  });
};

export const getCorporateVerifyEmailVerificationCodeCreateMutationKey = () =>
  ['corporateVerifyEmailVerificationCodeCreate'] as const;

export const getCorporateVerifyEmailVerificationCodeCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof corporateVerifyEmailVerificationCodeCreate>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof corporateVerifyEmailVerificationCodeCreate>>,
  TError,
  void,
  TContext
> => {
  const mutationKey =
    getCorporateVerifyEmailVerificationCodeCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof corporateVerifyEmailVerificationCodeCreate>>,
    void
  > = () => {
    return corporateVerifyEmailVerificationCodeCreate();
  };

  return { mutationFn, ...mutationOptions };
};

export type CorporateVerifyEmailVerificationCodeCreateMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof corporateVerifyEmailVerificationCodeCreate>>
  >;

export type CorporateVerifyEmailVerificationCodeCreateMutationError = unknown;

export const useCorporateVerifyEmailVerificationCodeCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof corporateVerifyEmailVerificationCodeCreate>>,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof corporateVerifyEmailVerificationCodeCreate>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getCorporateVerifyEmailVerificationCodeCreateMutationOptions(options)
  );
};

export const corporateVerifyMobileVerificationCodeCreate = (
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/ecc/v1.0/corporate/verify_mobile_verification_code/`,
    method: 'POST',
    signal,
  });
};

export const getCorporateVerifyMobileVerificationCodeCreateMutationKey = () =>
  ['corporateVerifyMobileVerificationCodeCreate'] as const;

export const getCorporateVerifyMobileVerificationCodeCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof corporateVerifyMobileVerificationCodeCreate>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof corporateVerifyMobileVerificationCodeCreate>>,
  TError,
  void,
  TContext
> => {
  const mutationKey =
    getCorporateVerifyMobileVerificationCodeCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof corporateVerifyMobileVerificationCodeCreate>>,
    void
  > = () => {
    return corporateVerifyMobileVerificationCodeCreate();
  };

  return { mutationFn, ...mutationOptions };
};

export type CorporateVerifyMobileVerificationCodeCreateMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof corporateVerifyMobileVerificationCodeCreate>>
  >;

export type CorporateVerifyMobileVerificationCodeCreateMutationError = unknown;

export const useCorporateVerifyMobileVerificationCodeCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof corporateVerifyMobileVerificationCodeCreate>>,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof corporateVerifyMobileVerificationCodeCreate>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getCorporateVerifyMobileVerificationCodeCreateMutationOptions(options)
  );
};

export const eccEmployeeAndDependentsRetrieve = (
  employeeId: number,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<EmployeeDependent>({
    url: `/ecc/v1.0/employee-and-dependents/${employeeId}/`,
    method: 'GET',
    signal,
  });
};

export const getEccEmployeeAndDependentsRetrieveQueryKey = (
  employeeId: number
) => {
  return [`/ecc/v1.0/employee-and-dependents/${employeeId}/`] as const;
};

export const getEccEmployeeAndDependentsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof eccEmployeeAndDependentsRetrieve>>,
  TError = unknown,
>(
  employeeId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof eccEmployeeAndDependentsRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getEccEmployeeAndDependentsRetrieveQueryKey(employeeId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof eccEmployeeAndDependentsRetrieve>>
  > = ({ signal }) => eccEmployeeAndDependentsRetrieve(employeeId, signal);

  return {
    queryKey,
    queryFn,
    enabled: employeeId !== null && employeeId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof eccEmployeeAndDependentsRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type EccEmployeeAndDependentsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof eccEmployeeAndDependentsRetrieve>>
>;
export type EccEmployeeAndDependentsRetrieveQueryError = unknown;

export function useEccEmployeeAndDependentsRetrieve<
  TData = Awaited<ReturnType<typeof eccEmployeeAndDependentsRetrieve>>,
  TError = unknown,
>(
  employeeId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof eccEmployeeAndDependentsRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getEccEmployeeAndDependentsRetrieveQueryOptions(
    employeeId,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const employeeFiltersRetrieve = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<void>({
    url: `/ecc/v1.0/employee-filters/`,
    method: 'GET',
    signal,
  });
};

export const getEmployeeFiltersRetrieveQueryKey = () => {
  return [`/ecc/v1.0/employee-filters/`] as const;
};

export const getEmployeeFiltersRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof employeeFiltersRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof employeeFiltersRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getEmployeeFiltersRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof employeeFiltersRetrieve>>
  > = ({ signal }) => employeeFiltersRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof employeeFiltersRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type EmployeeFiltersRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof employeeFiltersRetrieve>>
>;
export type EmployeeFiltersRetrieveQueryError = unknown;

export function useEmployeeFiltersRetrieve<
  TData = Awaited<ReturnType<typeof employeeFiltersRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof employeeFiltersRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getEmployeeFiltersRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const employeeSegmentsList = (
  params?: EmployeeSegmentsListParams,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<PaginatedEmployeeSegmentListList>({
    url: `/ecc/v1.0/employee-segments/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getEmployeeSegmentsListQueryKey = (
  params?: EmployeeSegmentsListParams
) => {
  return [`/ecc/v1.0/employee-segments/`, ...(params ? [params] : [])] as const;
};

export const getEmployeeSegmentsListQueryOptions = <
  TData = Awaited<ReturnType<typeof employeeSegmentsList>>,
  TError = unknown,
>(
  params?: EmployeeSegmentsListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof employeeSegmentsList>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getEmployeeSegmentsListQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof employeeSegmentsList>>
  > = ({ signal }) => employeeSegmentsList(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof employeeSegmentsList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type EmployeeSegmentsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof employeeSegmentsList>>
>;
export type EmployeeSegmentsListQueryError = unknown;

export function useEmployeeSegmentsList<
  TData = Awaited<ReturnType<typeof employeeSegmentsList>>,
  TError = unknown,
>(
  params?: EmployeeSegmentsListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof employeeSegmentsList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getEmployeeSegmentsListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const employeeSegmentsCreate = (
  employeeSegmentCreateRequestRequest: EmployeeSegmentCreateRequestRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<EmployeeSegmentList>({
    url: `/ecc/v1.0/employee-segments/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: employeeSegmentCreateRequestRequest,
    signal,
  });
};

export const getEmployeeSegmentsCreateMutationKey = () =>
  ['employeeSegmentsCreate'] as const;

export const getEmployeeSegmentsCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof employeeSegmentsCreate>>,
    TError,
    EmployeeSegmentsCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof employeeSegmentsCreate>>,
  TError,
  EmployeeSegmentsCreateMutationVariables,
  TContext
> => {
  const mutationKey = getEmployeeSegmentsCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof employeeSegmentsCreate>>,
    EmployeeSegmentsCreateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return employeeSegmentsCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type EmployeeSegmentsCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof employeeSegmentsCreate>>
>;
export type EmployeeSegmentsCreateMutationBody =
  EmployeeSegmentCreateRequestRequest;
export type EmployeeSegmentsCreateMutationError = unknown;
export type EmployeeSegmentsCreateMutationVariables = {
  data: EmployeeSegmentCreateRequestRequest;
};

export const useEmployeeSegmentsCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof employeeSegmentsCreate>>,
    TError,
    EmployeeSegmentsCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof employeeSegmentsCreate>>,
  TError,
  EmployeeSegmentsCreateMutationVariables,
  TContext
> => {
  return useMutation(getEmployeeSegmentsCreateMutationOptions(options));
};

export const employeeSegmentsEmployeesCreate = (
  employeeSegmentQueryRequestRequest: EmployeeSegmentQueryRequestRequest,
  params?: EmployeeSegmentsEmployeesCreateParams,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<PaginatedEmployeeSegmentEmployeeList>({
    url: `/ecc/v1.0/employee-segments/employees/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: employeeSegmentQueryRequestRequest,
    params,
    signal,
  });
};

export const getEmployeeSegmentsEmployeesCreateMutationKey = () =>
  ['employeeSegmentsEmployeesCreate'] as const;

export const getEmployeeSegmentsEmployeesCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof employeeSegmentsEmployeesCreate>>,
    TError,
    EmployeeSegmentsEmployeesCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof employeeSegmentsEmployeesCreate>>,
  TError,
  EmployeeSegmentsEmployeesCreateMutationVariables,
  TContext
> => {
  const mutationKey = getEmployeeSegmentsEmployeesCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof employeeSegmentsEmployeesCreate>>,
    EmployeeSegmentsEmployeesCreateMutationVariables
  > = (props) => {
    const { data, params } = props ?? {};

    return employeeSegmentsEmployeesCreate(data, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type EmployeeSegmentsEmployeesCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof employeeSegmentsEmployeesCreate>>
>;
export type EmployeeSegmentsEmployeesCreateMutationBody =
  EmployeeSegmentQueryRequestRequest;
export type EmployeeSegmentsEmployeesCreateMutationError = unknown;
export type EmployeeSegmentsEmployeesCreateMutationVariables = {
  data: EmployeeSegmentQueryRequestRequest;
  params?: EmployeeSegmentsEmployeesCreateParams;
};

export const useEmployeeSegmentsEmployeesCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof employeeSegmentsEmployeesCreate>>,
    TError,
    EmployeeSegmentsEmployeesCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof employeeSegmentsEmployeesCreate>>,
  TError,
  EmployeeSegmentsEmployeesCreateMutationVariables,
  TContext
> => {
  return useMutation(
    getEmployeeSegmentsEmployeesCreateMutationOptions(options)
  );
};

export const employeeSegmentsQueryBuilderRetrieve = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<QueryBuilderSchemaResponse>({
    url: `/ecc/v1.0/employee-segments/query-builder/`,
    method: 'GET',
    signal,
  });
};

export const getEmployeeSegmentsQueryBuilderRetrieveQueryKey = () => {
  return [`/ecc/v1.0/employee-segments/query-builder/`] as const;
};

export const getEmployeeSegmentsQueryBuilderRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof employeeSegmentsQueryBuilderRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof employeeSegmentsQueryBuilderRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getEmployeeSegmentsQueryBuilderRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof employeeSegmentsQueryBuilderRetrieve>>
  > = ({ signal }) => employeeSegmentsQueryBuilderRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof employeeSegmentsQueryBuilderRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type EmployeeSegmentsQueryBuilderRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof employeeSegmentsQueryBuilderRetrieve>>
>;
export type EmployeeSegmentsQueryBuilderRetrieveQueryError = unknown;

export function useEmployeeSegmentsQueryBuilderRetrieve<
  TData = Awaited<ReturnType<typeof employeeSegmentsQueryBuilderRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof employeeSegmentsQueryBuilderRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getEmployeeSegmentsQueryBuilderRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const employeesList = (
  params?: EmployeesListParams,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<EmployeeMinimalDetailsResponse[]>({
    url: `/ecc/v1.0/employees/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getEmployeesListQueryKey = (params?: EmployeesListParams) => {
  return [`/ecc/v1.0/employees/`, ...(params ? [params] : [])] as const;
};

export const getEmployeesListQueryOptions = <
  TData = Awaited<ReturnType<typeof employeesList>>,
  TError = unknown,
>(
  params?: EmployeesListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof employeesList>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getEmployeesListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof employeesList>>> = ({
    signal,
  }) => employeesList(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof employeesList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type EmployeesListQueryResult = NonNullable<
  Awaited<ReturnType<typeof employeesList>>
>;
export type EmployeesListQueryError = unknown;

export function useEmployeesList<
  TData = Awaited<ReturnType<typeof employeesList>>,
  TError = unknown,
>(
  params?: EmployeesListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof employeesList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getEmployeesListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const employeesCreate = (
  employeeRequestRequest: EmployeeRequestRequest[],
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/ecc/v1.0/employees/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: employeeRequestRequest,
    signal,
  });
};

export const getEmployeesCreateMutationKey = () => ['employeesCreate'] as const;

export const getEmployeesCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof employeesCreate>>,
    TError,
    EmployeesCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof employeesCreate>>,
  TError,
  EmployeesCreateMutationVariables,
  TContext
> => {
  const mutationKey = getEmployeesCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof employeesCreate>>,
    EmployeesCreateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return employeesCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type EmployeesCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof employeesCreate>>
>;
export type EmployeesCreateMutationBody = EmployeeRequestRequest[];
export type EmployeesCreateMutationError = unknown;
export type EmployeesCreateMutationVariables = {
  data: EmployeeRequestRequest[];
};

export const useEmployeesCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof employeesCreate>>,
    TError,
    EmployeesCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof employeesCreate>>,
  TError,
  EmployeesCreateMutationVariables,
  TContext
> => {
  return useMutation(getEmployeesCreateMutationOptions(options));
};

export const employeesPartialUpdate = (
  patchedEmployeePatchRequestRequest?: PatchedEmployeePatchRequestRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/ecc/v1.0/employees/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchedEmployeePatchRequestRequest,
    signal,
  });
};

export const getEmployeesPartialUpdateMutationKey = () =>
  ['employeesPartialUpdate'] as const;

export const getEmployeesPartialUpdateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof employeesPartialUpdate>>,
    TError,
    EmployeesPartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof employeesPartialUpdate>>,
  TError,
  EmployeesPartialUpdateMutationVariables,
  TContext
> => {
  const mutationKey = getEmployeesPartialUpdateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof employeesPartialUpdate>>,
    EmployeesPartialUpdateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return employeesPartialUpdate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type EmployeesPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof employeesPartialUpdate>>
>;
export type EmployeesPartialUpdateMutationBody =
  | PatchedEmployeePatchRequestRequest
  | undefined;
export type EmployeesPartialUpdateMutationError = unknown;
export type EmployeesPartialUpdateMutationVariables = {
  data?: PatchedEmployeePatchRequestRequest;
};

export const useEmployeesPartialUpdate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof employeesPartialUpdate>>,
    TError,
    EmployeesPartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof employeesPartialUpdate>>,
  TError,
  EmployeesPartialUpdateMutationVariables,
  TContext
> => {
  return useMutation(getEmployeesPartialUpdateMutationOptions(options));
};

export const employeesProfileRetrieve = (
  employeeId: number,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<EmployeeInfoResponse>({
    url: `/ecc/v1.0/employees/${employeeId}/profile/`,
    method: 'GET',
    signal,
  });
};

export const getEmployeesProfileRetrieveQueryKey = (employeeId: number) => {
  return [`/ecc/v1.0/employees/${employeeId}/profile/`] as const;
};

export const getEmployeesProfileRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof employeesProfileRetrieve>>,
  TError = unknown,
>(
  employeeId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof employeesProfileRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getEmployeesProfileRetrieveQueryKey(employeeId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof employeesProfileRetrieve>>
  > = ({ signal }) => employeesProfileRetrieve(employeeId, signal);

  return {
    queryKey,
    queryFn,
    enabled: employeeId !== null && employeeId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof employeesProfileRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type EmployeesProfileRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof employeesProfileRetrieve>>
>;
export type EmployeesProfileRetrieveQueryError = unknown;

export function useEmployeesProfileRetrieve<
  TData = Awaited<ReturnType<typeof employeesProfileRetrieve>>,
  TError = unknown,
>(
  employeeId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof employeesProfileRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getEmployeesProfileRetrieveQueryOptions(
    employeeId,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const employeesProfilePartialUpdate = (
  employeeId: number,
  patchedEmployeeInfoRequestRequest?: PatchedEmployeeInfoRequestRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/ecc/v1.0/employees/${employeeId}/profile/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchedEmployeeInfoRequestRequest,
    signal,
  });
};

export const getEmployeesProfilePartialUpdateMutationKey = () =>
  ['employeesProfilePartialUpdate'] as const;

export const getEmployeesProfilePartialUpdateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof employeesProfilePartialUpdate>>,
    TError,
    EmployeesProfilePartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof employeesProfilePartialUpdate>>,
  TError,
  EmployeesProfilePartialUpdateMutationVariables,
  TContext
> => {
  const mutationKey = getEmployeesProfilePartialUpdateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof employeesProfilePartialUpdate>>,
    EmployeesProfilePartialUpdateMutationVariables
  > = (props) => {
    const { employeeId, data } = props ?? {};

    return employeesProfilePartialUpdate(employeeId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type EmployeesProfilePartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof employeesProfilePartialUpdate>>
>;
export type EmployeesProfilePartialUpdateMutationBody =
  | PatchedEmployeeInfoRequestRequest
  | undefined;
export type EmployeesProfilePartialUpdateMutationError = unknown;
export type EmployeesProfilePartialUpdateMutationVariables = {
  employeeId: number;
  data?: PatchedEmployeeInfoRequestRequest;
};

export const useEmployeesProfilePartialUpdate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof employeesProfilePartialUpdate>>,
    TError,
    EmployeesProfilePartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof employeesProfilePartialUpdate>>,
  TError,
  EmployeesProfilePartialUpdateMutationVariables,
  TContext
> => {
  return useMutation(getEmployeesProfilePartialUpdateMutationOptions(options));
};

export const employeesRolesPartialUpdate = (
  employeeId: number,
  patchedEmployeeRolesUpdateRequest?: PatchedEmployeeRolesUpdateRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/ecc/v1.0/employees/${employeeId}/roles/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchedEmployeeRolesUpdateRequest,
    signal,
  });
};

export const getEmployeesRolesPartialUpdateMutationKey = () =>
  ['employeesRolesPartialUpdate'] as const;

export const getEmployeesRolesPartialUpdateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof employeesRolesPartialUpdate>>,
    TError,
    EmployeesRolesPartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof employeesRolesPartialUpdate>>,
  TError,
  EmployeesRolesPartialUpdateMutationVariables,
  TContext
> => {
  const mutationKey = getEmployeesRolesPartialUpdateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof employeesRolesPartialUpdate>>,
    EmployeesRolesPartialUpdateMutationVariables
  > = (props) => {
    const { employeeId, data } = props ?? {};

    return employeesRolesPartialUpdate(employeeId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type EmployeesRolesPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof employeesRolesPartialUpdate>>
>;
export type EmployeesRolesPartialUpdateMutationBody =
  | PatchedEmployeeRolesUpdateRequest
  | undefined;
export type EmployeesRolesPartialUpdateMutationError = unknown;
export type EmployeesRolesPartialUpdateMutationVariables = {
  employeeId: number;
  data?: PatchedEmployeeRolesUpdateRequest;
};

export const useEmployeesRolesPartialUpdate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof employeesRolesPartialUpdate>>,
    TError,
    EmployeesRolesPartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof employeesRolesPartialUpdate>>,
  TError,
  EmployeesRolesPartialUpdateMutationVariables,
  TContext
> => {
  return useMutation(getEmployeesRolesPartialUpdateMutationOptions(options));
};

export const employeesSalaryRetrieve = (
  employeeId: number,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<EmployeeSalaryResponse>({
    url: `/ecc/v1.0/employees/${employeeId}/salary/`,
    method: 'GET',
    signal,
  });
};

export const getEmployeesSalaryRetrieveQueryKey = (employeeId: number) => {
  return [`/ecc/v1.0/employees/${employeeId}/salary/`] as const;
};

export const getEmployeesSalaryRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof employeesSalaryRetrieve>>,
  TError = unknown,
>(
  employeeId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof employeesSalaryRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getEmployeesSalaryRetrieveQueryKey(employeeId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof employeesSalaryRetrieve>>
  > = ({ signal }) => employeesSalaryRetrieve(employeeId, signal);

  return {
    queryKey,
    queryFn,
    enabled: employeeId !== null && employeeId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof employeesSalaryRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type EmployeesSalaryRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof employeesSalaryRetrieve>>
>;
export type EmployeesSalaryRetrieveQueryError = unknown;

export function useEmployeesSalaryRetrieve<
  TData = Awaited<ReturnType<typeof employeesSalaryRetrieve>>,
  TError = unknown,
>(
  employeeId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof employeesSalaryRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getEmployeesSalaryRetrieveQueryOptions(
    employeeId,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const employeesSalaryUpdate = (
  employeeId: number,
  employeeSalaryRequest?: EmployeeSalaryRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<EmployeeSalaryResponse>({
    url: `/ecc/v1.0/employees/${employeeId}/salary/`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: employeeSalaryRequest,
    signal,
  });
};

export const getEmployeesSalaryUpdateMutationKey = () =>
  ['employeesSalaryUpdate'] as const;

export const getEmployeesSalaryUpdateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof employeesSalaryUpdate>>,
    TError,
    EmployeesSalaryUpdateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof employeesSalaryUpdate>>,
  TError,
  EmployeesSalaryUpdateMutationVariables,
  TContext
> => {
  const mutationKey = getEmployeesSalaryUpdateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof employeesSalaryUpdate>>,
    EmployeesSalaryUpdateMutationVariables
  > = (props) => {
    const { employeeId, data } = props ?? {};

    return employeesSalaryUpdate(employeeId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type EmployeesSalaryUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof employeesSalaryUpdate>>
>;
export type EmployeesSalaryUpdateMutationBody =
  | EmployeeSalaryRequest
  | undefined;
export type EmployeesSalaryUpdateMutationError = unknown;
export type EmployeesSalaryUpdateMutationVariables = {
  employeeId: number;
  data?: EmployeeSalaryRequest;
};

export const useEmployeesSalaryUpdate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof employeesSalaryUpdate>>,
    TError,
    EmployeesSalaryUpdateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof employeesSalaryUpdate>>,
  TError,
  EmployeesSalaryUpdateMutationVariables,
  TContext
> => {
  return useMutation(getEmployeesSalaryUpdateMutationOptions(options));
};

export const employeesBatchUpdateCreate = (
  employeeUpdateRequestRequest: EmployeeUpdateRequestRequest[],
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/ecc/v1.0/employees/batch-update`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: employeeUpdateRequestRequest,
    signal,
  });
};

export const getEmployeesBatchUpdateCreateMutationKey = () =>
  ['employeesBatchUpdateCreate'] as const;

export const getEmployeesBatchUpdateCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof employeesBatchUpdateCreate>>,
    TError,
    EmployeesBatchUpdateCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof employeesBatchUpdateCreate>>,
  TError,
  EmployeesBatchUpdateCreateMutationVariables,
  TContext
> => {
  const mutationKey = getEmployeesBatchUpdateCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof employeesBatchUpdateCreate>>,
    EmployeesBatchUpdateCreateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return employeesBatchUpdateCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type EmployeesBatchUpdateCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof employeesBatchUpdateCreate>>
>;
export type EmployeesBatchUpdateCreateMutationBody =
  EmployeeUpdateRequestRequest[];
export type EmployeesBatchUpdateCreateMutationError = unknown;
export type EmployeesBatchUpdateCreateMutationVariables = {
  data: EmployeeUpdateRequestRequest[];
};

export const useEmployeesBatchUpdateCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof employeesBatchUpdateCreate>>,
    TError,
    EmployeesBatchUpdateCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof employeesBatchUpdateCreate>>,
  TError,
  EmployeesBatchUpdateCreateMutationVariables,
  TContext
> => {
  return useMutation(getEmployeesBatchUpdateCreateMutationOptions(options));
};

export const employeesDepartmentsRetrieve = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<void>({
    url: `/ecc/v1.0/employees/departments/`,
    method: 'GET',
    signal,
  });
};

export const getEmployeesDepartmentsRetrieveQueryKey = () => {
  return [`/ecc/v1.0/employees/departments/`] as const;
};

export const getEmployeesDepartmentsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof employeesDepartmentsRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof employeesDepartmentsRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getEmployeesDepartmentsRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof employeesDepartmentsRetrieve>>
  > = ({ signal }) => employeesDepartmentsRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof employeesDepartmentsRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type EmployeesDepartmentsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof employeesDepartmentsRetrieve>>
>;
export type EmployeesDepartmentsRetrieveQueryError = unknown;

export function useEmployeesDepartmentsRetrieve<
  TData = Awaited<ReturnType<typeof employeesDepartmentsRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof employeesDepartmentsRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getEmployeesDepartmentsRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const employeesOfficeLocationsRetrieve = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<void>({
    url: `/ecc/v1.0/employees/office-locations/`,
    method: 'GET',
    signal,
  });
};

export const getEmployeesOfficeLocationsRetrieveQueryKey = () => {
  return [`/ecc/v1.0/employees/office-locations/`] as const;
};

export const getEmployeesOfficeLocationsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof employeesOfficeLocationsRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof employeesOfficeLocationsRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getEmployeesOfficeLocationsRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof employeesOfficeLocationsRetrieve>>
  > = ({ signal }) => employeesOfficeLocationsRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof employeesOfficeLocationsRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type EmployeesOfficeLocationsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof employeesOfficeLocationsRetrieve>>
>;
export type EmployeesOfficeLocationsRetrieveQueryError = unknown;

export function useEmployeesOfficeLocationsRetrieve<
  TData = Awaited<ReturnType<typeof employeesOfficeLocationsRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof employeesOfficeLocationsRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getEmployeesOfficeLocationsRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const employeesResendInviteEmailCreate = (
  resendInviteEmailRequestRequest: ResendInviteEmailRequestRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/ecc/v1.0/employees/resend-invite-email/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: resendInviteEmailRequestRequest,
    signal,
  });
};

export const getEmployeesResendInviteEmailCreateMutationKey = () =>
  ['employeesResendInviteEmailCreate'] as const;

export const getEmployeesResendInviteEmailCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof employeesResendInviteEmailCreate>>,
    TError,
    EmployeesResendInviteEmailCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof employeesResendInviteEmailCreate>>,
  TError,
  EmployeesResendInviteEmailCreateMutationVariables,
  TContext
> => {
  const mutationKey = getEmployeesResendInviteEmailCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof employeesResendInviteEmailCreate>>,
    EmployeesResendInviteEmailCreateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return employeesResendInviteEmailCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type EmployeesResendInviteEmailCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof employeesResendInviteEmailCreate>>
>;
export type EmployeesResendInviteEmailCreateMutationBody =
  ResendInviteEmailRequestRequest;
export type EmployeesResendInviteEmailCreateMutationError = unknown;
export type EmployeesResendInviteEmailCreateMutationVariables = {
  data: ResendInviteEmailRequestRequest;
};

export const useEmployeesResendInviteEmailCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof employeesResendInviteEmailCreate>>,
    TError,
    EmployeesResendInviteEmailCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof employeesResendInviteEmailCreate>>,
  TError,
  EmployeesResendInviteEmailCreateMutationVariables,
  TContext
> => {
  return useMutation(
    getEmployeesResendInviteEmailCreateMutationOptions(options)
  );
};

export const employeesResidencyTypesRetrieve = (
  country: string,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/ecc/v1.0/employees/residency-types/${country}/`,
    method: 'GET',
    signal,
  });
};

export const getEmployeesResidencyTypesRetrieveQueryKey = (country: string) => {
  return [`/ecc/v1.0/employees/residency-types/${country}/`] as const;
};

export const getEmployeesResidencyTypesRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof employeesResidencyTypesRetrieve>>,
  TError = unknown,
>(
  country: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof employeesResidencyTypesRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getEmployeesResidencyTypesRetrieveQueryKey(country);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof employeesResidencyTypesRetrieve>>
  > = ({ signal }) => employeesResidencyTypesRetrieve(country, signal);

  return {
    queryKey,
    queryFn,
    enabled: country !== null && country !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof employeesResidencyTypesRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type EmployeesResidencyTypesRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof employeesResidencyTypesRetrieve>>
>;
export type EmployeesResidencyTypesRetrieveQueryError = unknown;

export function useEmployeesResidencyTypesRetrieve<
  TData = Awaited<ReturnType<typeof employeesResidencyTypesRetrieve>>,
  TError = unknown,
>(
  country: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof employeesResidencyTypesRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getEmployeesResidencyTypesRetrieveQueryOptions(
    country,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const employeesTagsRetrieve = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<string[]>({
    url: `/ecc/v1.0/employees/tags/`,
    method: 'GET',
    signal,
  });
};

export const getEmployeesTagsRetrieveQueryKey = () => {
  return [`/ecc/v1.0/employees/tags/`] as const;
};

export const getEmployeesTagsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof employeesTagsRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof employeesTagsRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getEmployeesTagsRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof employeesTagsRetrieve>>
  > = ({ signal }) => employeesTagsRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof employeesTagsRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type EmployeesTagsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof employeesTagsRetrieve>>
>;
export type EmployeesTagsRetrieveQueryError = unknown;

export function useEmployeesTagsRetrieve<
  TData = Awaited<ReturnType<typeof employeesTagsRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof employeesTagsRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getEmployeesTagsRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const employeesUpdateTemplateRetrieve = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<void>({
    url: `/ecc/v1.0/employees/update-template/`,
    method: 'GET',
    signal,
  });
};

export const getEmployeesUpdateTemplateRetrieveQueryKey = () => {
  return [`/ecc/v1.0/employees/update-template/`] as const;
};

export const getEmployeesUpdateTemplateRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof employeesUpdateTemplateRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof employeesUpdateTemplateRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getEmployeesUpdateTemplateRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof employeesUpdateTemplateRetrieve>>
  > = ({ signal }) => employeesUpdateTemplateRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof employeesUpdateTemplateRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type EmployeesUpdateTemplateRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof employeesUpdateTemplateRetrieve>>
>;
export type EmployeesUpdateTemplateRetrieveQueryError = unknown;

export function useEmployeesUpdateTemplateRetrieve<
  TData = Awaited<ReturnType<typeof employeesUpdateTemplateRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof employeesUpdateTemplateRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getEmployeesUpdateTemplateRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const employerIntegrationsList = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<IntegrationResponse[]>({
    url: `/ecc/v1.0/employer/integrations/`,
    method: 'GET',
    signal,
  });
};

export const getEmployerIntegrationsListQueryKey = () => {
  return [`/ecc/v1.0/employer/integrations/`] as const;
};

export const getEmployerIntegrationsListQueryOptions = <
  TData = Awaited<ReturnType<typeof employerIntegrationsList>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof employerIntegrationsList>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getEmployerIntegrationsListQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof employerIntegrationsList>>
  > = ({ signal }) => employerIntegrationsList(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof employerIntegrationsList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type EmployerIntegrationsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof employerIntegrationsList>>
>;
export type EmployerIntegrationsListQueryError = unknown;

export function useEmployerIntegrationsList<
  TData = Awaited<ReturnType<typeof employerIntegrationsList>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof employerIntegrationsList>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getEmployerIntegrationsListQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const employerIntegrationsCreate = (
  contentType: string,
  objectId: string,
  action: 'DISABLE' | 'ENABLE' | 'RELINK' | 'REMOVE',
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<IntegrationActionResponse>({
    url: `/ecc/v1.0/employer/integrations/${contentType}/${objectId}/${action}/`,
    method: 'POST',
    signal,
  });
};

export const getEmployerIntegrationsCreateMutationKey = () =>
  ['employerIntegrationsCreate'] as const;

export const getEmployerIntegrationsCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof employerIntegrationsCreate>>,
    TError,
    EmployerIntegrationsCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof employerIntegrationsCreate>>,
  TError,
  EmployerIntegrationsCreateMutationVariables,
  TContext
> => {
  const mutationKey = getEmployerIntegrationsCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof employerIntegrationsCreate>>,
    EmployerIntegrationsCreateMutationVariables
  > = (props) => {
    const { contentType, objectId, action } = props ?? {};

    return employerIntegrationsCreate(contentType, objectId, action);
  };

  return { mutationFn, ...mutationOptions };
};

export type EmployerIntegrationsCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof employerIntegrationsCreate>>
>;

export type EmployerIntegrationsCreateMutationError = unknown;
export type EmployerIntegrationsCreateMutationVariables = {
  contentType: string;
  objectId: string;
  action: 'DISABLE' | 'ENABLE' | 'RELINK' | 'REMOVE';
};

export const useEmployerIntegrationsCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof employerIntegrationsCreate>>,
    TError,
    EmployerIntegrationsCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof employerIntegrationsCreate>>,
  TError,
  EmployerIntegrationsCreateMutationVariables,
  TContext
> => {
  return useMutation(getEmployerIntegrationsCreateMutationOptions(options));
};

export const employerIntegrationsKomboConnectCreate = (
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/ecc/v1.0/employer/integrations/kombo-connect/`,
    method: 'POST',
    signal,
  });
};

export const getEmployerIntegrationsKomboConnectCreateMutationKey = () =>
  ['employerIntegrationsKomboConnectCreate'] as const;

export const getEmployerIntegrationsKomboConnectCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof employerIntegrationsKomboConnectCreate>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof employerIntegrationsKomboConnectCreate>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = getEmployerIntegrationsKomboConnectCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof employerIntegrationsKomboConnectCreate>>,
    void
  > = () => {
    return employerIntegrationsKomboConnectCreate();
  };

  return { mutationFn, ...mutationOptions };
};

export type EmployerIntegrationsKomboConnectCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof employerIntegrationsKomboConnectCreate>>
>;

export type EmployerIntegrationsKomboConnectCreateMutationError = unknown;

export const useEmployerIntegrationsKomboConnectCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof employerIntegrationsKomboConnectCreate>>,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof employerIntegrationsKomboConnectCreate>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getEmployerIntegrationsKomboConnectCreateMutationOptions(options)
  );
};

export const employerIntegrationsKomboConnectPartialUpdate = (
  patchedKomboSetupActivateRequestRequest?: PatchedKomboSetupActivateRequestRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/ecc/v1.0/employer/integrations/kombo-connect/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchedKomboSetupActivateRequestRequest,
    signal,
  });
};

export const getEmployerIntegrationsKomboConnectPartialUpdateMutationKey = () =>
  ['employerIntegrationsKomboConnectPartialUpdate'] as const;

export const getEmployerIntegrationsKomboConnectPartialUpdateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof employerIntegrationsKomboConnectPartialUpdate>>,
    TError,
    EmployerIntegrationsKomboConnectPartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof employerIntegrationsKomboConnectPartialUpdate>>,
  TError,
  EmployerIntegrationsKomboConnectPartialUpdateMutationVariables,
  TContext
> => {
  const mutationKey =
    getEmployerIntegrationsKomboConnectPartialUpdateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof employerIntegrationsKomboConnectPartialUpdate>>,
    EmployerIntegrationsKomboConnectPartialUpdateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return employerIntegrationsKomboConnectPartialUpdate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type EmployerIntegrationsKomboConnectPartialUpdateMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof employerIntegrationsKomboConnectPartialUpdate>>
  >;
export type EmployerIntegrationsKomboConnectPartialUpdateMutationBody =
  | PatchedKomboSetupActivateRequestRequest
  | undefined;
export type EmployerIntegrationsKomboConnectPartialUpdateMutationError =
  unknown;
export type EmployerIntegrationsKomboConnectPartialUpdateMutationVariables = {
  data?: PatchedKomboSetupActivateRequestRequest;
};

export const useEmployerIntegrationsKomboConnectPartialUpdate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof employerIntegrationsKomboConnectPartialUpdate>>,
    TError,
    EmployerIntegrationsKomboConnectPartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof employerIntegrationsKomboConnectPartialUpdate>>,
  TError,
  EmployerIntegrationsKomboConnectPartialUpdateMutationVariables,
  TContext
> => {
  return useMutation(
    getEmployerIntegrationsKomboConnectPartialUpdateMutationOptions(options)
  );
};

export const employerMissingRequirementsCsvReportRetrieve = (
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/ecc/v1.0/employer/missing-requirements-csv-report/`,
    method: 'GET',
    signal,
  });
};

export const getEmployerMissingRequirementsCsvReportRetrieveQueryKey = () => {
  return [`/ecc/v1.0/employer/missing-requirements-csv-report/`] as const;
};

export const getEmployerMissingRequirementsCsvReportRetrieveQueryOptions = <
  TData = Awaited<
    ReturnType<typeof employerMissingRequirementsCsvReportRetrieve>
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof employerMissingRequirementsCsvReportRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getEmployerMissingRequirementsCsvReportRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof employerMissingRequirementsCsvReportRetrieve>>
  > = ({ signal }) => employerMissingRequirementsCsvReportRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof employerMissingRequirementsCsvReportRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type EmployerMissingRequirementsCsvReportRetrieveQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof employerMissingRequirementsCsvReportRetrieve>>
  >;
export type EmployerMissingRequirementsCsvReportRetrieveQueryError = unknown;

export function useEmployerMissingRequirementsCsvReportRetrieve<
  TData = Awaited<
    ReturnType<typeof employerMissingRequirementsCsvReportRetrieve>
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof employerMissingRequirementsCsvReportRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getEmployerMissingRequirementsCsvReportRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const filteredEmployeesCreate = (
  filteredEmployeesRequestRequest?: FilteredEmployeesRequestRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<FilteredEmployeesResponse>({
    url: `/ecc/v1.0/filtered-employees/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: filteredEmployeesRequestRequest,
    signal,
  });
};

export const getFilteredEmployeesCreateMutationKey = () =>
  ['filteredEmployeesCreate'] as const;

export const getFilteredEmployeesCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof filteredEmployeesCreate>>,
    TError,
    FilteredEmployeesCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof filteredEmployeesCreate>>,
  TError,
  FilteredEmployeesCreateMutationVariables,
  TContext
> => {
  const mutationKey = getFilteredEmployeesCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof filteredEmployeesCreate>>,
    FilteredEmployeesCreateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return filteredEmployeesCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type FilteredEmployeesCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof filteredEmployeesCreate>>
>;
export type FilteredEmployeesCreateMutationBody =
  | FilteredEmployeesRequestRequest
  | undefined;
export type FilteredEmployeesCreateMutationError = unknown;
export type FilteredEmployeesCreateMutationVariables = {
  data?: FilteredEmployeesRequestRequest;
};

export const useFilteredEmployeesCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof filteredEmployeesCreate>>,
    TError,
    FilteredEmployeesCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof filteredEmployeesCreate>>,
  TError,
  FilteredEmployeesCreateMutationVariables,
  TContext
> => {
  return useMutation(getFilteredEmployeesCreateMutationOptions(options));
};

/**
 * Returns a paginated list of all recognitions with the status SENT or FAILED
 * for the given employer. The list can be sorted, searched and filtered.
 */
export const filteredRecognitionsHistoryCreate = (
  eccRecognitionsListRequestRequest?: EccRecognitionsListRequestRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<RecognitionsListResponse>({
    url: `/ecc/v1.0/filtered-recognitions-history/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: eccRecognitionsListRequestRequest,
    signal,
  });
};

export const getFilteredRecognitionsHistoryCreateMutationKey = () =>
  ['filteredRecognitionsHistoryCreate'] as const;

export const getFilteredRecognitionsHistoryCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof filteredRecognitionsHistoryCreate>>,
    TError,
    FilteredRecognitionsHistoryCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof filteredRecognitionsHistoryCreate>>,
  TError,
  FilteredRecognitionsHistoryCreateMutationVariables,
  TContext
> => {
  const mutationKey = getFilteredRecognitionsHistoryCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof filteredRecognitionsHistoryCreate>>,
    FilteredRecognitionsHistoryCreateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return filteredRecognitionsHistoryCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type FilteredRecognitionsHistoryCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof filteredRecognitionsHistoryCreate>>
>;
export type FilteredRecognitionsHistoryCreateMutationBody =
  | EccRecognitionsListRequestRequest
  | undefined;
export type FilteredRecognitionsHistoryCreateMutationError = unknown;
export type FilteredRecognitionsHistoryCreateMutationVariables = {
  data?: EccRecognitionsListRequestRequest;
};

export const useFilteredRecognitionsHistoryCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof filteredRecognitionsHistoryCreate>>,
    TError,
    FilteredRecognitionsHistoryCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof filteredRecognitionsHistoryCreate>>,
  TError,
  FilteredRecognitionsHistoryCreateMutationVariables,
  TContext
> => {
  return useMutation(
    getFilteredRecognitionsHistoryCreateMutationOptions(options)
  );
};

export const homepageLayoutEditorRetrieve = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<EccHomepageLayoutResponse>({
    url: `/ecc/v1.0/homepage/layout-editor/`,
    method: 'GET',
    signal,
  });
};

export const getHomepageLayoutEditorRetrieveQueryKey = () => {
  return [`/ecc/v1.0/homepage/layout-editor/`] as const;
};

export const getHomepageLayoutEditorRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof homepageLayoutEditorRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof homepageLayoutEditorRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getHomepageLayoutEditorRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof homepageLayoutEditorRetrieve>>
  > = ({ signal }) => homepageLayoutEditorRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof homepageLayoutEditorRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HomepageLayoutEditorRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof homepageLayoutEditorRetrieve>>
>;
export type HomepageLayoutEditorRetrieveQueryError = unknown;

export function useHomepageLayoutEditorRetrieve<
  TData = Awaited<ReturnType<typeof homepageLayoutEditorRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof homepageLayoutEditorRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHomepageLayoutEditorRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const homepageLayoutEditorUpdate = (
  eccHomepageLayoutRequestRequest: EccHomepageLayoutRequestRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<EccHomepageLayoutResponse>({
    url: `/ecc/v1.0/homepage/layout-editor/`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: eccHomepageLayoutRequestRequest,
    signal,
  });
};

export const getHomepageLayoutEditorUpdateMutationKey = () =>
  ['homepageLayoutEditorUpdate'] as const;

export const getHomepageLayoutEditorUpdateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof homepageLayoutEditorUpdate>>,
    TError,
    HomepageLayoutEditorUpdateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof homepageLayoutEditorUpdate>>,
  TError,
  HomepageLayoutEditorUpdateMutationVariables,
  TContext
> => {
  const mutationKey = getHomepageLayoutEditorUpdateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof homepageLayoutEditorUpdate>>,
    HomepageLayoutEditorUpdateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return homepageLayoutEditorUpdate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type HomepageLayoutEditorUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof homepageLayoutEditorUpdate>>
>;
export type HomepageLayoutEditorUpdateMutationBody =
  EccHomepageLayoutRequestRequest;
export type HomepageLayoutEditorUpdateMutationError = unknown;
export type HomepageLayoutEditorUpdateMutationVariables = {
  data: EccHomepageLayoutRequestRequest;
};

export const useHomepageLayoutEditorUpdate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof homepageLayoutEditorUpdate>>,
    TError,
    HomepageLayoutEditorUpdateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof homepageLayoutEditorUpdate>>,
  TError,
  HomepageLayoutEditorUpdateMutationVariables,
  TContext
> => {
  return useMutation(getHomepageLayoutEditorUpdateMutationOptions(options));
};

export const homepageRegistryRetrieve = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<HomepageRegistryResponse>({
    url: `/ecc/v1.0/homepage/registry/`,
    method: 'GET',
    signal,
  });
};

export const getHomepageRegistryRetrieveQueryKey = () => {
  return [`/ecc/v1.0/homepage/registry/`] as const;
};

export const getHomepageRegistryRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof homepageRegistryRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof homepageRegistryRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getHomepageRegistryRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof homepageRegistryRetrieve>>
  > = ({ signal }) => homepageRegistryRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof homepageRegistryRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HomepageRegistryRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof homepageRegistryRetrieve>>
>;
export type HomepageRegistryRetrieveQueryError = unknown;

export function useHomepageRegistryRetrieve<
  TData = Awaited<ReturnType<typeof homepageRegistryRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof homepageRegistryRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHomepageRegistryRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const invoicesRetrieve = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<InvoiceResponse>({
    url: `/ecc/v1.0/invoices/`,
    method: 'GET',
    signal,
  });
};

export const getInvoicesRetrieveQueryKey = () => {
  return [`/ecc/v1.0/invoices/`] as const;
};

export const getInvoicesRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof invoicesRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof invoicesRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getInvoicesRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof invoicesRetrieve>>
  > = ({ signal }) => invoicesRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof invoicesRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type InvoicesRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof invoicesRetrieve>>
>;
export type InvoicesRetrieveQueryError = unknown;

export function useInvoicesRetrieve<
  TData = Awaited<ReturnType<typeof invoicesRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof invoicesRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getInvoicesRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const invoicesPayCreate = (invoiceId: number, signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<void>({
    url: `/ecc/v1.0/invoices/${invoiceId}/pay/`,
    method: 'POST',
    signal,
  });
};

export const getInvoicesPayCreateMutationKey = () =>
  ['invoicesPayCreate'] as const;

export const getInvoicesPayCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof invoicesPayCreate>>,
    TError,
    InvoicesPayCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof invoicesPayCreate>>,
  TError,
  InvoicesPayCreateMutationVariables,
  TContext
> => {
  const mutationKey = getInvoicesPayCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof invoicesPayCreate>>,
    InvoicesPayCreateMutationVariables
  > = (props) => {
    const { invoiceId } = props ?? {};

    return invoicesPayCreate(invoiceId);
  };

  return { mutationFn, ...mutationOptions };
};

export type InvoicesPayCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof invoicesPayCreate>>
>;

export type InvoicesPayCreateMutationError = unknown;
export type InvoicesPayCreateMutationVariables = { invoiceId: number };

export const useInvoicesPayCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof invoicesPayCreate>>,
    TError,
    InvoicesPayCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof invoicesPayCreate>>,
  TError,
  InvoicesPayCreateMutationVariables,
  TContext
> => {
  return useMutation(getInvoicesPayCreateMutationOptions(options));
};

export const lifeEventsList = (
  params?: LifeEventsListParams,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<PaginatedLifeEventResponseList>({
    url: `/ecc/v1.0/life-events/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getLifeEventsListQueryKey = (params?: LifeEventsListParams) => {
  return [`/ecc/v1.0/life-events/`, ...(params ? [params] : [])] as const;
};

export const getLifeEventsListQueryOptions = <
  TData = Awaited<ReturnType<typeof lifeEventsList>>,
  TError = unknown,
>(
  params?: LifeEventsListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof lifeEventsList>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getLifeEventsListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof lifeEventsList>>> = ({
    signal,
  }) => lifeEventsList(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof lifeEventsList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type LifeEventsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof lifeEventsList>>
>;
export type LifeEventsListQueryError = unknown;

export function useLifeEventsList<
  TData = Awaited<ReturnType<typeof lifeEventsList>>,
  TError = unknown,
>(
  params?: LifeEventsListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof lifeEventsList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getLifeEventsListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const eccLifeEventsRetrieve = (
  lifeEventId: number,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<LifeEventResponseDetail>({
    url: `/ecc/v1.0/life-events/${lifeEventId}/`,
    method: 'GET',
    signal,
  });
};

export const getEccLifeEventsRetrieveQueryKey = (lifeEventId: number) => {
  return [`/ecc/v1.0/life-events/${lifeEventId}/`] as const;
};

export const getEccLifeEventsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof eccLifeEventsRetrieve>>,
  TError = unknown,
>(
  lifeEventId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof eccLifeEventsRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getEccLifeEventsRetrieveQueryKey(lifeEventId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof eccLifeEventsRetrieve>>
  > = ({ signal }) => eccLifeEventsRetrieve(lifeEventId, signal);

  return {
    queryKey,
    queryFn,
    enabled: lifeEventId !== null && lifeEventId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof eccLifeEventsRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type EccLifeEventsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof eccLifeEventsRetrieve>>
>;
export type EccLifeEventsRetrieveQueryError = unknown;

export function useEccLifeEventsRetrieve<
  TData = Awaited<ReturnType<typeof eccLifeEventsRetrieve>>,
  TError = unknown,
>(
  lifeEventId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof eccLifeEventsRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getEccLifeEventsRetrieveQueryOptions(
    lifeEventId,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const lifeEventsReviewCreate = (
  lifeEventId: number,
  lifeEventReviewRequestRequest: LifeEventReviewRequestRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/ecc/v1.0/life-events/${lifeEventId}/review/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: lifeEventReviewRequestRequest,
    signal,
  });
};

export const getLifeEventsReviewCreateMutationKey = () =>
  ['lifeEventsReviewCreate'] as const;

export const getLifeEventsReviewCreateMutationOptions = <
  TError = LifeEventReviewErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof lifeEventsReviewCreate>>,
    TError,
    LifeEventsReviewCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof lifeEventsReviewCreate>>,
  TError,
  LifeEventsReviewCreateMutationVariables,
  TContext
> => {
  const mutationKey = getLifeEventsReviewCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof lifeEventsReviewCreate>>,
    LifeEventsReviewCreateMutationVariables
  > = (props) => {
    const { lifeEventId, data } = props ?? {};

    return lifeEventsReviewCreate(lifeEventId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type LifeEventsReviewCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof lifeEventsReviewCreate>>
>;
export type LifeEventsReviewCreateMutationBody = LifeEventReviewRequestRequest;
export type LifeEventsReviewCreateMutationError = LifeEventReviewErrorResponse;
export type LifeEventsReviewCreateMutationVariables = {
  lifeEventId: number;
  data: LifeEventReviewRequestRequest;
};

export const useLifeEventsReviewCreate = <
  TError = LifeEventReviewErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof lifeEventsReviewCreate>>,
    TError,
    LifeEventsReviewCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof lifeEventsReviewCreate>>,
  TError,
  LifeEventsReviewCreateMutationVariables,
  TContext
> => {
  return useMutation(getLifeEventsReviewCreateMutationOptions(options));
};

export const managedCardsEmployeeList = (
  managedCardExternalId: string,
  employeeId: number,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<ManagedCardsTransactionResponse[]>({
    url: `/ecc/v1.0/managed-cards/${managedCardExternalId}/employee/${employeeId}/`,
    method: 'GET',
    signal,
  });
};

export const getManagedCardsEmployeeListQueryKey = (
  managedCardExternalId: string,
  employeeId: number
) => {
  return [
    `/ecc/v1.0/managed-cards/${managedCardExternalId}/employee/${employeeId}/`,
  ] as const;
};

export const getManagedCardsEmployeeListQueryOptions = <
  TData = Awaited<ReturnType<typeof managedCardsEmployeeList>>,
  TError = unknown,
>(
  managedCardExternalId: string,
  employeeId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof managedCardsEmployeeList>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getManagedCardsEmployeeListQueryKey(managedCardExternalId, employeeId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof managedCardsEmployeeList>>
  > = ({ signal }) =>
    managedCardsEmployeeList(managedCardExternalId, employeeId, signal);

  return {
    queryKey,
    queryFn,
    enabled:
      managedCardExternalId !== null &&
      managedCardExternalId !== undefined &&
      employeeId !== null &&
      employeeId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof managedCardsEmployeeList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ManagedCardsEmployeeListQueryResult = NonNullable<
  Awaited<ReturnType<typeof managedCardsEmployeeList>>
>;
export type ManagedCardsEmployeeListQueryError = unknown;

export function useManagedCardsEmployeeList<
  TData = Awaited<ReturnType<typeof managedCardsEmployeeList>>,
  TError = unknown,
>(
  managedCardExternalId: string,
  employeeId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof managedCardsEmployeeList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getManagedCardsEmployeeListQueryOptions(
    managedCardExternalId,
    employeeId,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const managedCardsCategoriesEmployeesRetrieve = (
  categoryName: string,
  categoryId: number,
  params?: ManagedCardsCategoriesEmployeesRetrieveParams,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<TopupEmployeesResponse>({
    url: `/ecc/v1.0/managed-cards/categories/${categoryName}/${categoryId}/employees/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getManagedCardsCategoriesEmployeesRetrieveQueryKey = (
  categoryName: string,
  categoryId: number,
  params?: ManagedCardsCategoriesEmployeesRetrieveParams
) => {
  return [
    `/ecc/v1.0/managed-cards/categories/${categoryName}/${categoryId}/employees/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getManagedCardsCategoriesEmployeesRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof managedCardsCategoriesEmployeesRetrieve>>,
  TError = unknown,
>(
  categoryName: string,
  categoryId: number,
  params?: ManagedCardsCategoriesEmployeesRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof managedCardsCategoriesEmployeesRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getManagedCardsCategoriesEmployeesRetrieveQueryKey(
      categoryName,
      categoryId,
      params
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof managedCardsCategoriesEmployeesRetrieve>>
  > = ({ signal }) =>
    managedCardsCategoriesEmployeesRetrieve(
      categoryName,
      categoryId,
      params,
      signal
    );

  return {
    queryKey,
    queryFn,
    enabled:
      categoryName !== null &&
      categoryName !== undefined &&
      categoryId !== null &&
      categoryId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof managedCardsCategoriesEmployeesRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ManagedCardsCategoriesEmployeesRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof managedCardsCategoriesEmployeesRetrieve>>
>;
export type ManagedCardsCategoriesEmployeesRetrieveQueryError = unknown;

export function useManagedCardsCategoriesEmployeesRetrieve<
  TData = Awaited<ReturnType<typeof managedCardsCategoriesEmployeesRetrieve>>,
  TError = unknown,
>(
  categoryName: string,
  categoryId: number,
  params?: ManagedCardsCategoriesEmployeesRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof managedCardsCategoriesEmployeesRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getManagedCardsCategoriesEmployeesRetrieveQueryOptions(
    categoryName,
    categoryId,
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const managedCardsCategoriesTopupsList = (
  categoryName: string,
  categoryId: number,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<CardTopUpResponse[]>({
    url: `/ecc/v1.0/managed-cards/categories/${categoryName}/${categoryId}/topups/`,
    method: 'GET',
    signal,
  });
};

export const getManagedCardsCategoriesTopupsListQueryKey = (
  categoryName: string,
  categoryId: number
) => {
  return [
    `/ecc/v1.0/managed-cards/categories/${categoryName}/${categoryId}/topups/`,
  ] as const;
};

export const getManagedCardsCategoriesTopupsListQueryOptions = <
  TData = Awaited<ReturnType<typeof managedCardsCategoriesTopupsList>>,
  TError = unknown,
>(
  categoryName: string,
  categoryId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof managedCardsCategoriesTopupsList>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getManagedCardsCategoriesTopupsListQueryKey(categoryName, categoryId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof managedCardsCategoriesTopupsList>>
  > = ({ signal }) =>
    managedCardsCategoriesTopupsList(categoryName, categoryId, signal);

  return {
    queryKey,
    queryFn,
    enabled:
      categoryName !== null &&
      categoryName !== undefined &&
      categoryId !== null &&
      categoryId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof managedCardsCategoriesTopupsList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ManagedCardsCategoriesTopupsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof managedCardsCategoriesTopupsList>>
>;
export type ManagedCardsCategoriesTopupsListQueryError = unknown;

export function useManagedCardsCategoriesTopupsList<
  TData = Awaited<ReturnType<typeof managedCardsCategoriesTopupsList>>,
  TError = unknown,
>(
  categoryName: string,
  categoryId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof managedCardsCategoriesTopupsList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getManagedCardsCategoriesTopupsListQueryOptions(
    categoryName,
    categoryId,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const managedCardsCategoriesTopupsCreate = (
  categoryName: string,
  categoryId: number,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<CardTopUpRequest>({
    url: `/ecc/v1.0/managed-cards/categories/${categoryName}/${categoryId}/topups/`,
    method: 'POST',
    signal,
  });
};

export const getManagedCardsCategoriesTopupsCreateMutationKey = () =>
  ['managedCardsCategoriesTopupsCreate'] as const;

export const getManagedCardsCategoriesTopupsCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof managedCardsCategoriesTopupsCreate>>,
    TError,
    ManagedCardsCategoriesTopupsCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof managedCardsCategoriesTopupsCreate>>,
  TError,
  ManagedCardsCategoriesTopupsCreateMutationVariables,
  TContext
> => {
  const mutationKey = getManagedCardsCategoriesTopupsCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof managedCardsCategoriesTopupsCreate>>,
    ManagedCardsCategoriesTopupsCreateMutationVariables
  > = (props) => {
    const { categoryName, categoryId } = props ?? {};

    return managedCardsCategoriesTopupsCreate(categoryName, categoryId);
  };

  return { mutationFn, ...mutationOptions };
};

export type ManagedCardsCategoriesTopupsCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof managedCardsCategoriesTopupsCreate>>
>;

export type ManagedCardsCategoriesTopupsCreateMutationError = unknown;
export type ManagedCardsCategoriesTopupsCreateMutationVariables = {
  categoryName: string;
  categoryId: number;
};

export const useManagedCardsCategoriesTopupsCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof managedCardsCategoriesTopupsCreate>>,
    TError,
    ManagedCardsCategoriesTopupsCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof managedCardsCategoriesTopupsCreate>>,
  TError,
  ManagedCardsCategoriesTopupsCreateMutationVariables,
  TContext
> => {
  return useMutation(
    getManagedCardsCategoriesTopupsCreateMutationOptions(options)
  );
};

export const eccMeRetrieve = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<Me>({
    url: `/ecc/v1.0/me/`,
    method: 'GET',
    signal,
  });
};

export const getEccMeRetrieveQueryKey = () => {
  return [`/ecc/v1.0/me/`] as const;
};

export const getEccMeRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof eccMeRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof eccMeRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getEccMeRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof eccMeRetrieve>>> = ({
    signal,
  }) => eccMeRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof eccMeRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type EccMeRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof eccMeRetrieve>>
>;
export type EccMeRetrieveQueryError = unknown;

export function useEccMeRetrieve<
  TData = Awaited<ReturnType<typeof eccMeRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof eccMeRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getEccMeRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const eccMePartialUpdate = (
  patchedMeRequestRequest?: PatchedMeRequestRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<Me>({
    url: `/ecc/v1.0/me/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchedMeRequestRequest,
    signal,
  });
};

export const getEccMePartialUpdateMutationKey = () =>
  ['eccMePartialUpdate'] as const;

export const getEccMePartialUpdateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof eccMePartialUpdate>>,
    TError,
    EccMePartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof eccMePartialUpdate>>,
  TError,
  EccMePartialUpdateMutationVariables,
  TContext
> => {
  const mutationKey = getEccMePartialUpdateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof eccMePartialUpdate>>,
    EccMePartialUpdateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return eccMePartialUpdate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type EccMePartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof eccMePartialUpdate>>
>;
export type EccMePartialUpdateMutationBody =
  | PatchedMeRequestRequest
  | undefined;
export type EccMePartialUpdateMutationError = unknown;
export type EccMePartialUpdateMutationVariables = {
  data?: PatchedMeRequestRequest;
};

export const useEccMePartialUpdate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof eccMePartialUpdate>>,
    TError,
    EccMePartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof eccMePartialUpdate>>,
  TError,
  EccMePartialUpdateMutationVariables,
  TContext
> => {
  return useMutation(getEccMePartialUpdateMutationOptions(options));
};

export const metabaseRetrieve = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<Metabase>({
    url: `/ecc/v1.0/metabase/`,
    method: 'GET',
    signal,
  });
};

export const getMetabaseRetrieveQueryKey = () => {
  return [`/ecc/v1.0/metabase/`] as const;
};

export const getMetabaseRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof metabaseRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof metabaseRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getMetabaseRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof metabaseRetrieve>>
  > = ({ signal }) => metabaseRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof metabaseRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type MetabaseRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof metabaseRetrieve>>
>;
export type MetabaseRetrieveQueryError = unknown;

export function useMetabaseRetrieve<
  TData = Awaited<ReturnType<typeof metabaseRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof metabaseRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getMetabaseRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const payrollInstructionConfigsList = (
  params?: PayrollInstructionConfigsListParams,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<PaginatedPayrollInstructionConfigList>({
    url: `/ecc/v1.0/payroll-instruction-configs/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getPayrollInstructionConfigsListQueryKey = (
  params?: PayrollInstructionConfigsListParams
) => {
  return [
    `/ecc/v1.0/payroll-instruction-configs/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getPayrollInstructionConfigsListQueryOptions = <
  TData = Awaited<ReturnType<typeof payrollInstructionConfigsList>>,
  TError = unknown,
>(
  params?: PayrollInstructionConfigsListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof payrollInstructionConfigsList>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getPayrollInstructionConfigsListQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof payrollInstructionConfigsList>>
  > = ({ signal }) => payrollInstructionConfigsList(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof payrollInstructionConfigsList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PayrollInstructionConfigsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof payrollInstructionConfigsList>>
>;
export type PayrollInstructionConfigsListQueryError = unknown;

export function usePayrollInstructionConfigsList<
  TData = Awaited<ReturnType<typeof payrollInstructionConfigsList>>,
  TError = unknown,
>(
  params?: PayrollInstructionConfigsListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof payrollInstructionConfigsList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getPayrollInstructionConfigsListQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const payrollInstructionConfigsCreate = (
  payrollInstructionConfigCreateRequest: PayrollInstructionConfigCreateRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<PayrollInstructionConfig>({
    url: `/ecc/v1.0/payroll-instruction-configs/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: payrollInstructionConfigCreateRequest,
    signal,
  });
};

export const getPayrollInstructionConfigsCreateMutationKey = () =>
  ['payrollInstructionConfigsCreate'] as const;

export const getPayrollInstructionConfigsCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof payrollInstructionConfigsCreate>>,
    TError,
    PayrollInstructionConfigsCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof payrollInstructionConfigsCreate>>,
  TError,
  PayrollInstructionConfigsCreateMutationVariables,
  TContext
> => {
  const mutationKey = getPayrollInstructionConfigsCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof payrollInstructionConfigsCreate>>,
    PayrollInstructionConfigsCreateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return payrollInstructionConfigsCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PayrollInstructionConfigsCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof payrollInstructionConfigsCreate>>
>;
export type PayrollInstructionConfigsCreateMutationBody =
  PayrollInstructionConfigCreateRequest;
export type PayrollInstructionConfigsCreateMutationError = unknown;
export type PayrollInstructionConfigsCreateMutationVariables = {
  data: PayrollInstructionConfigCreateRequest;
};

export const usePayrollInstructionConfigsCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof payrollInstructionConfigsCreate>>,
    TError,
    PayrollInstructionConfigsCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof payrollInstructionConfigsCreate>>,
  TError,
  PayrollInstructionConfigsCreateMutationVariables,
  TContext
> => {
  return useMutation(
    getPayrollInstructionConfigsCreateMutationOptions(options)
  );
};

export const payrollInstructionConfigsRetrieve = (
  configId: number,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<PayrollInstructionConfig>({
    url: `/ecc/v1.0/payroll-instruction-configs/${configId}/`,
    method: 'GET',
    signal,
  });
};

export const getPayrollInstructionConfigsRetrieveQueryKey = (
  configId: number
) => {
  return [`/ecc/v1.0/payroll-instruction-configs/${configId}/`] as const;
};

export const getPayrollInstructionConfigsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof payrollInstructionConfigsRetrieve>>,
  TError = unknown,
>(
  configId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof payrollInstructionConfigsRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getPayrollInstructionConfigsRetrieveQueryKey(configId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof payrollInstructionConfigsRetrieve>>
  > = ({ signal }) => payrollInstructionConfigsRetrieve(configId, signal);

  return {
    queryKey,
    queryFn,
    enabled: configId !== null && configId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof payrollInstructionConfigsRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PayrollInstructionConfigsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof payrollInstructionConfigsRetrieve>>
>;
export type PayrollInstructionConfigsRetrieveQueryError = unknown;

export function usePayrollInstructionConfigsRetrieve<
  TData = Awaited<ReturnType<typeof payrollInstructionConfigsRetrieve>>,
  TError = unknown,
>(
  configId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof payrollInstructionConfigsRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getPayrollInstructionConfigsRetrieveQueryOptions(
    configId,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const payrollInstructionConfigsPartialUpdate = (
  configId: number,
  patchedPayrollInstructionConfigCreateRequest?: PatchedPayrollInstructionConfigCreateRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<PayrollInstructionConfig>({
    url: `/ecc/v1.0/payroll-instruction-configs/${configId}/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchedPayrollInstructionConfigCreateRequest,
    signal,
  });
};

export const getPayrollInstructionConfigsPartialUpdateMutationKey = () =>
  ['payrollInstructionConfigsPartialUpdate'] as const;

export const getPayrollInstructionConfigsPartialUpdateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof payrollInstructionConfigsPartialUpdate>>,
    TError,
    PayrollInstructionConfigsPartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof payrollInstructionConfigsPartialUpdate>>,
  TError,
  PayrollInstructionConfigsPartialUpdateMutationVariables,
  TContext
> => {
  const mutationKey = getPayrollInstructionConfigsPartialUpdateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof payrollInstructionConfigsPartialUpdate>>,
    PayrollInstructionConfigsPartialUpdateMutationVariables
  > = (props) => {
    const { configId, data } = props ?? {};

    return payrollInstructionConfigsPartialUpdate(configId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PayrollInstructionConfigsPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof payrollInstructionConfigsPartialUpdate>>
>;
export type PayrollInstructionConfigsPartialUpdateMutationBody =
  | PatchedPayrollInstructionConfigCreateRequest
  | undefined;
export type PayrollInstructionConfigsPartialUpdateMutationError = unknown;
export type PayrollInstructionConfigsPartialUpdateMutationVariables = {
  configId: number;
  data?: PatchedPayrollInstructionConfigCreateRequest;
};

export const usePayrollInstructionConfigsPartialUpdate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof payrollInstructionConfigsPartialUpdate>>,
    TError,
    PayrollInstructionConfigsPartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof payrollInstructionConfigsPartialUpdate>>,
  TError,
  PayrollInstructionConfigsPartialUpdateMutationVariables,
  TContext
> => {
  return useMutation(
    getPayrollInstructionConfigsPartialUpdateMutationOptions(options)
  );
};

export const payrollInstructionConfigsDestroy = (
  configId: number,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/ecc/v1.0/payroll-instruction-configs/${configId}/`,
    method: 'DELETE',
    signal,
  });
};

export const getPayrollInstructionConfigsDestroyMutationKey = () =>
  ['payrollInstructionConfigsDestroy'] as const;

export const getPayrollInstructionConfigsDestroyMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof payrollInstructionConfigsDestroy>>,
    TError,
    PayrollInstructionConfigsDestroyMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof payrollInstructionConfigsDestroy>>,
  TError,
  PayrollInstructionConfigsDestroyMutationVariables,
  TContext
> => {
  const mutationKey = getPayrollInstructionConfigsDestroyMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof payrollInstructionConfigsDestroy>>,
    PayrollInstructionConfigsDestroyMutationVariables
  > = (props) => {
    const { configId } = props ?? {};

    return payrollInstructionConfigsDestroy(configId);
  };

  return { mutationFn, ...mutationOptions };
};

export type PayrollInstructionConfigsDestroyMutationResult = NonNullable<
  Awaited<ReturnType<typeof payrollInstructionConfigsDestroy>>
>;

export type PayrollInstructionConfigsDestroyMutationError = unknown;
export type PayrollInstructionConfigsDestroyMutationVariables = {
  configId: number;
};

export const usePayrollInstructionConfigsDestroy = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof payrollInstructionConfigsDestroy>>,
    TError,
    PayrollInstructionConfigsDestroyMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof payrollInstructionConfigsDestroy>>,
  TError,
  PayrollInstructionConfigsDestroyMutationVariables,
  TContext
> => {
  return useMutation(
    getPayrollInstructionConfigsDestroyMutationOptions(options)
  );
};

export const payrollInstructionConfigsDuplicateCreate = (
  configId: number,
  payrollInstructionConfigDuplicateRequest?: PayrollInstructionConfigDuplicateRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<PayrollInstructionConfig>({
    url: `/ecc/v1.0/payroll-instruction-configs/${configId}/duplicate/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: payrollInstructionConfigDuplicateRequest,
    signal,
  });
};

export const getPayrollInstructionConfigsDuplicateCreateMutationKey = () =>
  ['payrollInstructionConfigsDuplicateCreate'] as const;

export const getPayrollInstructionConfigsDuplicateCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof payrollInstructionConfigsDuplicateCreate>>,
    TError,
    PayrollInstructionConfigsDuplicateCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof payrollInstructionConfigsDuplicateCreate>>,
  TError,
  PayrollInstructionConfigsDuplicateCreateMutationVariables,
  TContext
> => {
  const mutationKey = getPayrollInstructionConfigsDuplicateCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof payrollInstructionConfigsDuplicateCreate>>,
    PayrollInstructionConfigsDuplicateCreateMutationVariables
  > = (props) => {
    const { configId, data } = props ?? {};

    return payrollInstructionConfigsDuplicateCreate(configId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PayrollInstructionConfigsDuplicateCreateMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof payrollInstructionConfigsDuplicateCreate>>
  >;
export type PayrollInstructionConfigsDuplicateCreateMutationBody =
  | PayrollInstructionConfigDuplicateRequest
  | undefined;
export type PayrollInstructionConfigsDuplicateCreateMutationError = unknown;
export type PayrollInstructionConfigsDuplicateCreateMutationVariables = {
  configId: number;
  data?: PayrollInstructionConfigDuplicateRequest;
};

export const usePayrollInstructionConfigsDuplicateCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof payrollInstructionConfigsDuplicateCreate>>,
    TError,
    PayrollInstructionConfigsDuplicateCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof payrollInstructionConfigsDuplicateCreate>>,
  TError,
  PayrollInstructionConfigsDuplicateCreateMutationVariables,
  TContext
> => {
  return useMutation(
    getPayrollInstructionConfigsDuplicateCreateMutationOptions(options)
  );
};

export const payrollInstructionSchemasList = (
  params?: PayrollInstructionSchemasListParams,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<PaginatedPayrollInstructionOutputSchemaList>({
    url: `/ecc/v1.0/payroll-instruction-schemas/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getPayrollInstructionSchemasListQueryKey = (
  params?: PayrollInstructionSchemasListParams
) => {
  return [
    `/ecc/v1.0/payroll-instruction-schemas/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getPayrollInstructionSchemasListQueryOptions = <
  TData = Awaited<ReturnType<typeof payrollInstructionSchemasList>>,
  TError = unknown,
>(
  params?: PayrollInstructionSchemasListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof payrollInstructionSchemasList>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getPayrollInstructionSchemasListQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof payrollInstructionSchemasList>>
  > = ({ signal }) => payrollInstructionSchemasList(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof payrollInstructionSchemasList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PayrollInstructionSchemasListQueryResult = NonNullable<
  Awaited<ReturnType<typeof payrollInstructionSchemasList>>
>;
export type PayrollInstructionSchemasListQueryError = unknown;

export function usePayrollInstructionSchemasList<
  TData = Awaited<ReturnType<typeof payrollInstructionSchemasList>>,
  TError = unknown,
>(
  params?: PayrollInstructionSchemasListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof payrollInstructionSchemasList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getPayrollInstructionSchemasListQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const payrollInstructionSchemasCreate = (
  payrollInstructionOutputSchemaRequest: PayrollInstructionOutputSchemaRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<PayrollInstructionOutputSchema>({
    url: `/ecc/v1.0/payroll-instruction-schemas/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: payrollInstructionOutputSchemaRequest,
    signal,
  });
};

export const getPayrollInstructionSchemasCreateMutationKey = () =>
  ['payrollInstructionSchemasCreate'] as const;

export const getPayrollInstructionSchemasCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof payrollInstructionSchemasCreate>>,
    TError,
    PayrollInstructionSchemasCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof payrollInstructionSchemasCreate>>,
  TError,
  PayrollInstructionSchemasCreateMutationVariables,
  TContext
> => {
  const mutationKey = getPayrollInstructionSchemasCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof payrollInstructionSchemasCreate>>,
    PayrollInstructionSchemasCreateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return payrollInstructionSchemasCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PayrollInstructionSchemasCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof payrollInstructionSchemasCreate>>
>;
export type PayrollInstructionSchemasCreateMutationBody =
  PayrollInstructionOutputSchemaRequest;
export type PayrollInstructionSchemasCreateMutationError = unknown;
export type PayrollInstructionSchemasCreateMutationVariables = {
  data: PayrollInstructionOutputSchemaRequest;
};

export const usePayrollInstructionSchemasCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof payrollInstructionSchemasCreate>>,
    TError,
    PayrollInstructionSchemasCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof payrollInstructionSchemasCreate>>,
  TError,
  PayrollInstructionSchemasCreateMutationVariables,
  TContext
> => {
  return useMutation(
    getPayrollInstructionSchemasCreateMutationOptions(options)
  );
};

export const payrollInstructionSchemasRetrieve = (
  schemaId: number,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<PayrollInstructionOutputSchema>({
    url: `/ecc/v1.0/payroll-instruction-schemas/${schemaId}/`,
    method: 'GET',
    signal,
  });
};

export const getPayrollInstructionSchemasRetrieveQueryKey = (
  schemaId: number
) => {
  return [`/ecc/v1.0/payroll-instruction-schemas/${schemaId}/`] as const;
};

export const getPayrollInstructionSchemasRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof payrollInstructionSchemasRetrieve>>,
  TError = unknown,
>(
  schemaId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof payrollInstructionSchemasRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getPayrollInstructionSchemasRetrieveQueryKey(schemaId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof payrollInstructionSchemasRetrieve>>
  > = ({ signal }) => payrollInstructionSchemasRetrieve(schemaId, signal);

  return {
    queryKey,
    queryFn,
    enabled: schemaId !== null && schemaId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof payrollInstructionSchemasRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PayrollInstructionSchemasRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof payrollInstructionSchemasRetrieve>>
>;
export type PayrollInstructionSchemasRetrieveQueryError = unknown;

export function usePayrollInstructionSchemasRetrieve<
  TData = Awaited<ReturnType<typeof payrollInstructionSchemasRetrieve>>,
  TError = unknown,
>(
  schemaId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof payrollInstructionSchemasRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getPayrollInstructionSchemasRetrieveQueryOptions(
    schemaId,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const payrollInstructionSchemasUpdate = (
  schemaId: number,
  payrollInstructionOutputSchemaUpdateRequest: PayrollInstructionOutputSchemaUpdateRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<PayrollInstructionOutputSchema>({
    url: `/ecc/v1.0/payroll-instruction-schemas/${schemaId}/`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: payrollInstructionOutputSchemaUpdateRequest,
    signal,
  });
};

export const getPayrollInstructionSchemasUpdateMutationKey = () =>
  ['payrollInstructionSchemasUpdate'] as const;

export const getPayrollInstructionSchemasUpdateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof payrollInstructionSchemasUpdate>>,
    TError,
    PayrollInstructionSchemasUpdateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof payrollInstructionSchemasUpdate>>,
  TError,
  PayrollInstructionSchemasUpdateMutationVariables,
  TContext
> => {
  const mutationKey = getPayrollInstructionSchemasUpdateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof payrollInstructionSchemasUpdate>>,
    PayrollInstructionSchemasUpdateMutationVariables
  > = (props) => {
    const { schemaId, data } = props ?? {};

    return payrollInstructionSchemasUpdate(schemaId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PayrollInstructionSchemasUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof payrollInstructionSchemasUpdate>>
>;
export type PayrollInstructionSchemasUpdateMutationBody =
  PayrollInstructionOutputSchemaUpdateRequest;
export type PayrollInstructionSchemasUpdateMutationError = unknown;
export type PayrollInstructionSchemasUpdateMutationVariables = {
  schemaId: number;
  data: PayrollInstructionOutputSchemaUpdateRequest;
};

export const usePayrollInstructionSchemasUpdate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof payrollInstructionSchemasUpdate>>,
    TError,
    PayrollInstructionSchemasUpdateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof payrollInstructionSchemasUpdate>>,
  TError,
  PayrollInstructionSchemasUpdateMutationVariables,
  TContext
> => {
  return useMutation(
    getPayrollInstructionSchemasUpdateMutationOptions(options)
  );
};

export const payrollInstructionSchemasDestroy = (
  schemaId: number,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/ecc/v1.0/payroll-instruction-schemas/${schemaId}/`,
    method: 'DELETE',
    signal,
  });
};

export const getPayrollInstructionSchemasDestroyMutationKey = () =>
  ['payrollInstructionSchemasDestroy'] as const;

export const getPayrollInstructionSchemasDestroyMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof payrollInstructionSchemasDestroy>>,
    TError,
    PayrollInstructionSchemasDestroyMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof payrollInstructionSchemasDestroy>>,
  TError,
  PayrollInstructionSchemasDestroyMutationVariables,
  TContext
> => {
  const mutationKey = getPayrollInstructionSchemasDestroyMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof payrollInstructionSchemasDestroy>>,
    PayrollInstructionSchemasDestroyMutationVariables
  > = (props) => {
    const { schemaId } = props ?? {};

    return payrollInstructionSchemasDestroy(schemaId);
  };

  return { mutationFn, ...mutationOptions };
};

export type PayrollInstructionSchemasDestroyMutationResult = NonNullable<
  Awaited<ReturnType<typeof payrollInstructionSchemasDestroy>>
>;

export type PayrollInstructionSchemasDestroyMutationError = unknown;
export type PayrollInstructionSchemasDestroyMutationVariables = {
  schemaId: number;
};

export const usePayrollInstructionSchemasDestroy = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof payrollInstructionSchemasDestroy>>,
    TError,
    PayrollInstructionSchemasDestroyMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof payrollInstructionSchemasDestroy>>,
  TError,
  PayrollInstructionSchemasDestroyMutationVariables,
  TContext
> => {
  return useMutation(
    getPayrollInstructionSchemasDestroyMutationOptions(options)
  );
};

export const payrollInstructionSchemasCyclesList = (
  schemaId: number,
  params?: PayrollInstructionSchemasCyclesListParams,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<PaginatedPayrollInstructionSchemaCycleList>({
    url: `/ecc/v1.0/payroll-instruction-schemas/${schemaId}/cycles/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getPayrollInstructionSchemasCyclesListQueryKey = (
  schemaId: number,
  params?: PayrollInstructionSchemasCyclesListParams
) => {
  return [
    `/ecc/v1.0/payroll-instruction-schemas/${schemaId}/cycles/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getPayrollInstructionSchemasCyclesListQueryOptions = <
  TData = Awaited<ReturnType<typeof payrollInstructionSchemasCyclesList>>,
  TError = unknown,
>(
  schemaId: number,
  params?: PayrollInstructionSchemasCyclesListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof payrollInstructionSchemasCyclesList>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getPayrollInstructionSchemasCyclesListQueryKey(schemaId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof payrollInstructionSchemasCyclesList>>
  > = ({ signal }) =>
    payrollInstructionSchemasCyclesList(schemaId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: schemaId !== null && schemaId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof payrollInstructionSchemasCyclesList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PayrollInstructionSchemasCyclesListQueryResult = NonNullable<
  Awaited<ReturnType<typeof payrollInstructionSchemasCyclesList>>
>;
export type PayrollInstructionSchemasCyclesListQueryError = unknown;

export function usePayrollInstructionSchemasCyclesList<
  TData = Awaited<ReturnType<typeof payrollInstructionSchemasCyclesList>>,
  TError = unknown,
>(
  schemaId: number,
  params?: PayrollInstructionSchemasCyclesListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof payrollInstructionSchemasCyclesList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getPayrollInstructionSchemasCyclesListQueryOptions(
    schemaId,
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const payrollInstructionSchemasCyclesRetrieve = (
  schemaId: number,
  cycleId: number,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<PayrollInstructionReportDetail>({
    url: `/ecc/v1.0/payroll-instruction-schemas/${schemaId}/cycles/${cycleId}/`,
    method: 'GET',
    signal,
  });
};

export const getPayrollInstructionSchemasCyclesRetrieveQueryKey = (
  schemaId: number,
  cycleId: number
) => {
  return [
    `/ecc/v1.0/payroll-instruction-schemas/${schemaId}/cycles/${cycleId}/`,
  ] as const;
};

export const getPayrollInstructionSchemasCyclesRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof payrollInstructionSchemasCyclesRetrieve>>,
  TError = unknown,
>(
  schemaId: number,
  cycleId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof payrollInstructionSchemasCyclesRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getPayrollInstructionSchemasCyclesRetrieveQueryKey(schemaId, cycleId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof payrollInstructionSchemasCyclesRetrieve>>
  > = ({ signal }) =>
    payrollInstructionSchemasCyclesRetrieve(schemaId, cycleId, signal);

  return {
    queryKey,
    queryFn,
    enabled:
      schemaId !== null &&
      schemaId !== undefined &&
      cycleId !== null &&
      cycleId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof payrollInstructionSchemasCyclesRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PayrollInstructionSchemasCyclesRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof payrollInstructionSchemasCyclesRetrieve>>
>;
export type PayrollInstructionSchemasCyclesRetrieveQueryError = unknown;

export function usePayrollInstructionSchemasCyclesRetrieve<
  TData = Awaited<ReturnType<typeof payrollInstructionSchemasCyclesRetrieve>>,
  TError = unknown,
>(
  schemaId: number,
  cycleId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof payrollInstructionSchemasCyclesRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getPayrollInstructionSchemasCyclesRetrieveQueryOptions(
    schemaId,
    cycleId,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const payrollInstructionSchemasCyclesRowsList = (
  schemaId: number,
  cycleId: number,
  params?: PayrollInstructionSchemasCyclesRowsListParams,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<PayrollInstructionReportRowsResponse>({
    url: `/ecc/v1.0/payroll-instruction-schemas/${schemaId}/cycles/${cycleId}/rows/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getPayrollInstructionSchemasCyclesRowsListQueryKey = (
  schemaId: number,
  cycleId: number,
  params?: PayrollInstructionSchemasCyclesRowsListParams
) => {
  return [
    `/ecc/v1.0/payroll-instruction-schemas/${schemaId}/cycles/${cycleId}/rows/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getPayrollInstructionSchemasCyclesRowsListQueryOptions = <
  TData = Awaited<ReturnType<typeof payrollInstructionSchemasCyclesRowsList>>,
  TError = unknown,
>(
  schemaId: number,
  cycleId: number,
  params?: PayrollInstructionSchemasCyclesRowsListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof payrollInstructionSchemasCyclesRowsList>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getPayrollInstructionSchemasCyclesRowsListQueryKey(
      schemaId,
      cycleId,
      params
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof payrollInstructionSchemasCyclesRowsList>>
  > = ({ signal }) =>
    payrollInstructionSchemasCyclesRowsList(schemaId, cycleId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled:
      schemaId !== null &&
      schemaId !== undefined &&
      cycleId !== null &&
      cycleId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof payrollInstructionSchemasCyclesRowsList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PayrollInstructionSchemasCyclesRowsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof payrollInstructionSchemasCyclesRowsList>>
>;
export type PayrollInstructionSchemasCyclesRowsListQueryError = unknown;

export function usePayrollInstructionSchemasCyclesRowsList<
  TData = Awaited<ReturnType<typeof payrollInstructionSchemasCyclesRowsList>>,
  TError = unknown,
>(
  schemaId: number,
  cycleId: number,
  params?: PayrollInstructionSchemasCyclesRowsListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof payrollInstructionSchemasCyclesRowsList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getPayrollInstructionSchemasCyclesRowsListQueryOptions(
    schemaId,
    cycleId,
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const payrollInstructionSchemasTestCasesList = (
  schemaId: number,
  params?: PayrollInstructionSchemasTestCasesListParams,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<PaginatedTestCaseListList>({
    url: `/ecc/v1.0/payroll-instruction-schemas/${schemaId}/test-cases/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getPayrollInstructionSchemasTestCasesListQueryKey = (
  schemaId: number,
  params?: PayrollInstructionSchemasTestCasesListParams
) => {
  return [
    `/ecc/v1.0/payroll-instruction-schemas/${schemaId}/test-cases/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getPayrollInstructionSchemasTestCasesListQueryOptions = <
  TData = Awaited<ReturnType<typeof payrollInstructionSchemasTestCasesList>>,
  TError = unknown,
>(
  schemaId: number,
  params?: PayrollInstructionSchemasTestCasesListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof payrollInstructionSchemasTestCasesList>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getPayrollInstructionSchemasTestCasesListQueryKey(schemaId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof payrollInstructionSchemasTestCasesList>>
  > = ({ signal }) =>
    payrollInstructionSchemasTestCasesList(schemaId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: schemaId !== null && schemaId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof payrollInstructionSchemasTestCasesList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PayrollInstructionSchemasTestCasesListQueryResult = NonNullable<
  Awaited<ReturnType<typeof payrollInstructionSchemasTestCasesList>>
>;
export type PayrollInstructionSchemasTestCasesListQueryError = unknown;

export function usePayrollInstructionSchemasTestCasesList<
  TData = Awaited<ReturnType<typeof payrollInstructionSchemasTestCasesList>>,
  TError = unknown,
>(
  schemaId: number,
  params?: PayrollInstructionSchemasTestCasesListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof payrollInstructionSchemasTestCasesList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getPayrollInstructionSchemasTestCasesListQueryOptions(
    schemaId,
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const payrollInstructionSchemasTestCasesCreate = (
  schemaId: number,
  testCaseCreateRequest: TestCaseCreateRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<TestCaseDetail>({
    url: `/ecc/v1.0/payroll-instruction-schemas/${schemaId}/test-cases/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: testCaseCreateRequest,
    signal,
  });
};

export const getPayrollInstructionSchemasTestCasesCreateMutationKey = () =>
  ['payrollInstructionSchemasTestCasesCreate'] as const;

export const getPayrollInstructionSchemasTestCasesCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof payrollInstructionSchemasTestCasesCreate>>,
    TError,
    PayrollInstructionSchemasTestCasesCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof payrollInstructionSchemasTestCasesCreate>>,
  TError,
  PayrollInstructionSchemasTestCasesCreateMutationVariables,
  TContext
> => {
  const mutationKey = getPayrollInstructionSchemasTestCasesCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof payrollInstructionSchemasTestCasesCreate>>,
    PayrollInstructionSchemasTestCasesCreateMutationVariables
  > = (props) => {
    const { schemaId, data } = props ?? {};

    return payrollInstructionSchemasTestCasesCreate(schemaId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PayrollInstructionSchemasTestCasesCreateMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof payrollInstructionSchemasTestCasesCreate>>
  >;
export type PayrollInstructionSchemasTestCasesCreateMutationBody =
  TestCaseCreateRequest;
export type PayrollInstructionSchemasTestCasesCreateMutationError = unknown;
export type PayrollInstructionSchemasTestCasesCreateMutationVariables = {
  schemaId: number;
  data: TestCaseCreateRequest;
};

export const usePayrollInstructionSchemasTestCasesCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof payrollInstructionSchemasTestCasesCreate>>,
    TError,
    PayrollInstructionSchemasTestCasesCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof payrollInstructionSchemasTestCasesCreate>>,
  TError,
  PayrollInstructionSchemasTestCasesCreateMutationVariables,
  TContext
> => {
  return useMutation(
    getPayrollInstructionSchemasTestCasesCreateMutationOptions(options)
  );
};

export const payrollInstructionSchemasTestCasesRetrieve = (
  schemaId: number,
  caseId: number,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<TestCaseDetail>({
    url: `/ecc/v1.0/payroll-instruction-schemas/${schemaId}/test-cases/${caseId}/`,
    method: 'GET',
    signal,
  });
};

export const getPayrollInstructionSchemasTestCasesRetrieveQueryKey = (
  schemaId: number,
  caseId: number
) => {
  return [
    `/ecc/v1.0/payroll-instruction-schemas/${schemaId}/test-cases/${caseId}/`,
  ] as const;
};

export const getPayrollInstructionSchemasTestCasesRetrieveQueryOptions = <
  TData = Awaited<
    ReturnType<typeof payrollInstructionSchemasTestCasesRetrieve>
  >,
  TError = unknown,
>(
  schemaId: number,
  caseId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof payrollInstructionSchemasTestCasesRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getPayrollInstructionSchemasTestCasesRetrieveQueryKey(schemaId, caseId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof payrollInstructionSchemasTestCasesRetrieve>>
  > = ({ signal }) =>
    payrollInstructionSchemasTestCasesRetrieve(schemaId, caseId, signal);

  return {
    queryKey,
    queryFn,
    enabled:
      schemaId !== null &&
      schemaId !== undefined &&
      caseId !== null &&
      caseId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof payrollInstructionSchemasTestCasesRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PayrollInstructionSchemasTestCasesRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof payrollInstructionSchemasTestCasesRetrieve>>
>;
export type PayrollInstructionSchemasTestCasesRetrieveQueryError = unknown;

export function usePayrollInstructionSchemasTestCasesRetrieve<
  TData = Awaited<
    ReturnType<typeof payrollInstructionSchemasTestCasesRetrieve>
  >,
  TError = unknown,
>(
  schemaId: number,
  caseId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof payrollInstructionSchemasTestCasesRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getPayrollInstructionSchemasTestCasesRetrieveQueryOptions(
      schemaId,
      caseId,
      options
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const payrollInstructionSchemasTestCasesPartialUpdate = (
  schemaId: number,
  caseId: number,
  patchedTestCaseUpdateRequest?: PatchedTestCaseUpdateRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<TestCaseDetail>({
    url: `/ecc/v1.0/payroll-instruction-schemas/${schemaId}/test-cases/${caseId}/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchedTestCaseUpdateRequest,
    signal,
  });
};

export const getPayrollInstructionSchemasTestCasesPartialUpdateMutationKey =
  () => ['payrollInstructionSchemasTestCasesPartialUpdate'] as const;

export const getPayrollInstructionSchemasTestCasesPartialUpdateMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof payrollInstructionSchemasTestCasesPartialUpdate>
      >,
      TError,
      PayrollInstructionSchemasTestCasesPartialUpdateMutationVariables,
      TContext
    >;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof payrollInstructionSchemasTestCasesPartialUpdate>>,
    TError,
    PayrollInstructionSchemasTestCasesPartialUpdateMutationVariables,
    TContext
  > => {
    const mutationKey =
      getPayrollInstructionSchemasTestCasesPartialUpdateMutationKey();
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof payrollInstructionSchemasTestCasesPartialUpdate>
      >,
      PayrollInstructionSchemasTestCasesPartialUpdateMutationVariables
    > = (props) => {
      const { schemaId, caseId, data } = props ?? {};

      return payrollInstructionSchemasTestCasesPartialUpdate(
        schemaId,
        caseId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PayrollInstructionSchemasTestCasesPartialUpdateMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof payrollInstructionSchemasTestCasesPartialUpdate>>
  >;
export type PayrollInstructionSchemasTestCasesPartialUpdateMutationBody =
  | PatchedTestCaseUpdateRequest
  | undefined;
export type PayrollInstructionSchemasTestCasesPartialUpdateMutationError =
  unknown;
export type PayrollInstructionSchemasTestCasesPartialUpdateMutationVariables = {
  schemaId: number;
  caseId: number;
  data?: PatchedTestCaseUpdateRequest;
};

export const usePayrollInstructionSchemasTestCasesPartialUpdate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof payrollInstructionSchemasTestCasesPartialUpdate>>,
    TError,
    PayrollInstructionSchemasTestCasesPartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof payrollInstructionSchemasTestCasesPartialUpdate>>,
  TError,
  PayrollInstructionSchemasTestCasesPartialUpdateMutationVariables,
  TContext
> => {
  return useMutation(
    getPayrollInstructionSchemasTestCasesPartialUpdateMutationOptions(options)
  );
};

export const payrollInstructionSchemasTestCasesDestroy = (
  schemaId: number,
  caseId: number,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/ecc/v1.0/payroll-instruction-schemas/${schemaId}/test-cases/${caseId}/`,
    method: 'DELETE',
    signal,
  });
};

export const getPayrollInstructionSchemasTestCasesDestroyMutationKey = () =>
  ['payrollInstructionSchemasTestCasesDestroy'] as const;

export const getPayrollInstructionSchemasTestCasesDestroyMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof payrollInstructionSchemasTestCasesDestroy>>,
    TError,
    PayrollInstructionSchemasTestCasesDestroyMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof payrollInstructionSchemasTestCasesDestroy>>,
  TError,
  PayrollInstructionSchemasTestCasesDestroyMutationVariables,
  TContext
> => {
  const mutationKey = getPayrollInstructionSchemasTestCasesDestroyMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof payrollInstructionSchemasTestCasesDestroy>>,
    PayrollInstructionSchemasTestCasesDestroyMutationVariables
  > = (props) => {
    const { schemaId, caseId } = props ?? {};

    return payrollInstructionSchemasTestCasesDestroy(schemaId, caseId);
  };

  return { mutationFn, ...mutationOptions };
};

export type PayrollInstructionSchemasTestCasesDestroyMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof payrollInstructionSchemasTestCasesDestroy>>
  >;

export type PayrollInstructionSchemasTestCasesDestroyMutationError = unknown;
export type PayrollInstructionSchemasTestCasesDestroyMutationVariables = {
  schemaId: number;
  caseId: number;
};

export const usePayrollInstructionSchemasTestCasesDestroy = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof payrollInstructionSchemasTestCasesDestroy>>,
    TError,
    PayrollInstructionSchemasTestCasesDestroyMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof payrollInstructionSchemasTestCasesDestroy>>,
  TError,
  PayrollInstructionSchemasTestCasesDestroyMutationVariables,
  TContext
> => {
  return useMutation(
    getPayrollInstructionSchemasTestCasesDestroyMutationOptions(options)
  );
};

export const payrollInstructionSchemasTestCasesDuplicateCreate = (
  schemaId: number,
  caseId: number,
  testCaseDuplicateRequest?: TestCaseDuplicateRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<TestCaseDetail>({
    url: `/ecc/v1.0/payroll-instruction-schemas/${schemaId}/test-cases/${caseId}/duplicate/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: testCaseDuplicateRequest,
    signal,
  });
};

export const getPayrollInstructionSchemasTestCasesDuplicateCreateMutationKey =
  () => ['payrollInstructionSchemasTestCasesDuplicateCreate'] as const;

export const getPayrollInstructionSchemasTestCasesDuplicateCreateMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof payrollInstructionSchemasTestCasesDuplicateCreate>
      >,
      TError,
      PayrollInstructionSchemasTestCasesDuplicateCreateMutationVariables,
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof payrollInstructionSchemasTestCasesDuplicateCreate>
    >,
    TError,
    PayrollInstructionSchemasTestCasesDuplicateCreateMutationVariables,
    TContext
  > => {
    const mutationKey =
      getPayrollInstructionSchemasTestCasesDuplicateCreateMutationKey();
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof payrollInstructionSchemasTestCasesDuplicateCreate>
      >,
      PayrollInstructionSchemasTestCasesDuplicateCreateMutationVariables
    > = (props) => {
      const { schemaId, caseId, data } = props ?? {};

      return payrollInstructionSchemasTestCasesDuplicateCreate(
        schemaId,
        caseId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PayrollInstructionSchemasTestCasesDuplicateCreateMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof payrollInstructionSchemasTestCasesDuplicateCreate>
    >
  >;
export type PayrollInstructionSchemasTestCasesDuplicateCreateMutationBody =
  | TestCaseDuplicateRequest
  | undefined;
export type PayrollInstructionSchemasTestCasesDuplicateCreateMutationError =
  unknown;
export type PayrollInstructionSchemasTestCasesDuplicateCreateMutationVariables =
  { schemaId: number; caseId: number; data?: TestCaseDuplicateRequest };

export const usePayrollInstructionSchemasTestCasesDuplicateCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<typeof payrollInstructionSchemasTestCasesDuplicateCreate>
    >,
    TError,
    PayrollInstructionSchemasTestCasesDuplicateCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof payrollInstructionSchemasTestCasesDuplicateCreate>>,
  TError,
  PayrollInstructionSchemasTestCasesDuplicateCreateMutationVariables,
  TContext
> => {
  return useMutation(
    getPayrollInstructionSchemasTestCasesDuplicateCreateMutationOptions(options)
  );
};

/**
 * Synchronously re-run a single test case from its stored snapshot.
 */
export const payrollInstructionSchemasTestCasesRunCreate2 = (
  schemaId: number,
  caseId: number,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<TestCaseDetail>({
    url: `/ecc/v1.0/payroll-instruction-schemas/${schemaId}/test-cases/${caseId}/run/`,
    method: 'POST',
    signal,
  });
};

export const getPayrollInstructionSchemasTestCasesRunCreate2MutationKey = () =>
  ['payrollInstructionSchemasTestCasesRunCreate2'] as const;

export const getPayrollInstructionSchemasTestCasesRunCreate2MutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof payrollInstructionSchemasTestCasesRunCreate2>>,
    TError,
    PayrollInstructionSchemasTestCasesRunCreate2MutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof payrollInstructionSchemasTestCasesRunCreate2>>,
  TError,
  PayrollInstructionSchemasTestCasesRunCreate2MutationVariables,
  TContext
> => {
  const mutationKey =
    getPayrollInstructionSchemasTestCasesRunCreate2MutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof payrollInstructionSchemasTestCasesRunCreate2>>,
    PayrollInstructionSchemasTestCasesRunCreate2MutationVariables
  > = (props) => {
    const { schemaId, caseId } = props ?? {};

    return payrollInstructionSchemasTestCasesRunCreate2(schemaId, caseId);
  };

  return { mutationFn, ...mutationOptions };
};

export type PayrollInstructionSchemasTestCasesRunCreate2MutationResult =
  NonNullable<
    Awaited<ReturnType<typeof payrollInstructionSchemasTestCasesRunCreate2>>
  >;

export type PayrollInstructionSchemasTestCasesRunCreate2MutationError = unknown;
export type PayrollInstructionSchemasTestCasesRunCreate2MutationVariables = {
  schemaId: number;
  caseId: number;
};

export const usePayrollInstructionSchemasTestCasesRunCreate2 = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof payrollInstructionSchemasTestCasesRunCreate2>>,
    TError,
    PayrollInstructionSchemasTestCasesRunCreate2MutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof payrollInstructionSchemasTestCasesRunCreate2>>,
  TError,
  PayrollInstructionSchemasTestCasesRunCreate2MutationVariables,
  TContext
> => {
  return useMutation(
    getPayrollInstructionSchemasTestCasesRunCreate2MutationOptions(options)
  );
};

/**
 * Asynchronously re-run all test cases for the schema. Returns 202 when the task is dispatched, 200 when the schema has no test cases.
 */
export const payrollInstructionSchemasTestCasesRunCreate = (
  schemaId: number,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/ecc/v1.0/payroll-instruction-schemas/${schemaId}/test-cases/run/`,
    method: 'POST',
    signal,
  });
};

export const getPayrollInstructionSchemasTestCasesRunCreateMutationKey = () =>
  ['payrollInstructionSchemasTestCasesRunCreate'] as const;

export const getPayrollInstructionSchemasTestCasesRunCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof payrollInstructionSchemasTestCasesRunCreate>>,
    TError,
    PayrollInstructionSchemasTestCasesRunCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof payrollInstructionSchemasTestCasesRunCreate>>,
  TError,
  PayrollInstructionSchemasTestCasesRunCreateMutationVariables,
  TContext
> => {
  const mutationKey =
    getPayrollInstructionSchemasTestCasesRunCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof payrollInstructionSchemasTestCasesRunCreate>>,
    PayrollInstructionSchemasTestCasesRunCreateMutationVariables
  > = (props) => {
    const { schemaId } = props ?? {};

    return payrollInstructionSchemasTestCasesRunCreate(schemaId);
  };

  return { mutationFn, ...mutationOptions };
};

export type PayrollInstructionSchemasTestCasesRunCreateMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof payrollInstructionSchemasTestCasesRunCreate>>
  >;

export type PayrollInstructionSchemasTestCasesRunCreateMutationError = unknown;
export type PayrollInstructionSchemasTestCasesRunCreateMutationVariables = {
  schemaId: number;
};

export const usePayrollInstructionSchemasTestCasesRunCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof payrollInstructionSchemasTestCasesRunCreate>>,
    TError,
    PayrollInstructionSchemasTestCasesRunCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof payrollInstructionSchemasTestCasesRunCreate>>,
  TError,
  PayrollInstructionSchemasTestCasesRunCreateMutationVariables,
  TContext
> => {
  return useMutation(
    getPayrollInstructionSchemasTestCasesRunCreateMutationOptions(options)
  );
};

/**
 * Create a placeholder output schema from an uploaded payroll spec file.
 */
export const payrollInstructionSchemasGenerateCreate = (
  payrollInstructionOutputSchemaGenerateRequestRequest: PayrollInstructionOutputSchemaGenerateRequestRequest,
  signal?: AbortSignal
) => {
  const formData = new FormData();
  formData.append(
    `name`,
    payrollInstructionOutputSchemaGenerateRequestRequest.name
  );
  if (
    payrollInstructionOutputSchemaGenerateRequestRequest.description !==
    undefined
  ) {
    formData.append(
      `description`,
      payrollInstructionOutputSchemaGenerateRequestRequest.description
    );
  }
  if (
    payrollInstructionOutputSchemaGenerateRequestRequest.files !== undefined
  ) {
    payrollInstructionOutputSchemaGenerateRequestRequest.files.forEach(
      (value) => formData.append(`files`, value)
    );
  }

  return axiosOrvalCustomInstance<PayrollInstructionOutputSchemaGenerateResponse>(
    {
      url: `/ecc/v1.0/payroll-instruction-schemas/generate/`,
      method: 'POST',
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData,
      signal,
    }
  );
};

export const getPayrollInstructionSchemasGenerateCreateMutationKey = () =>
  ['payrollInstructionSchemasGenerateCreate'] as const;

export const getPayrollInstructionSchemasGenerateCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof payrollInstructionSchemasGenerateCreate>>,
    TError,
    PayrollInstructionSchemasGenerateCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof payrollInstructionSchemasGenerateCreate>>,
  TError,
  PayrollInstructionSchemasGenerateCreateMutationVariables,
  TContext
> => {
  const mutationKey = getPayrollInstructionSchemasGenerateCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof payrollInstructionSchemasGenerateCreate>>,
    PayrollInstructionSchemasGenerateCreateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return payrollInstructionSchemasGenerateCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PayrollInstructionSchemasGenerateCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof payrollInstructionSchemasGenerateCreate>>
>;
export type PayrollInstructionSchemasGenerateCreateMutationBody =
  PayrollInstructionOutputSchemaGenerateRequestRequest;
export type PayrollInstructionSchemasGenerateCreateMutationError = unknown;
export type PayrollInstructionSchemasGenerateCreateMutationVariables = {
  data: PayrollInstructionOutputSchemaGenerateRequestRequest;
};

export const usePayrollInstructionSchemasGenerateCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof payrollInstructionSchemasGenerateCreate>>,
    TError,
    PayrollInstructionSchemasGenerateCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof payrollInstructionSchemasGenerateCreate>>,
  TError,
  PayrollInstructionSchemasGenerateCreateMutationVariables,
  TContext
> => {
  return useMutation(
    getPayrollInstructionSchemasGenerateCreateMutationOptions(options)
  );
};

export const payrollConfigurationsList = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<PayrollConfigOption[]>({
    url: `/ecc/v1.0/payroll/configurations/`,
    method: 'GET',
    signal,
  });
};

export const getPayrollConfigurationsListQueryKey = () => {
  return [`/ecc/v1.0/payroll/configurations/`] as const;
};

export const getPayrollConfigurationsListQueryOptions = <
  TData = Awaited<ReturnType<typeof payrollConfigurationsList>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof payrollConfigurationsList>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getPayrollConfigurationsListQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof payrollConfigurationsList>>
  > = ({ signal }) => payrollConfigurationsList(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof payrollConfigurationsList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PayrollConfigurationsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof payrollConfigurationsList>>
>;
export type PayrollConfigurationsListQueryError = unknown;

export function usePayrollConfigurationsList<
  TData = Awaited<ReturnType<typeof payrollConfigurationsList>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof payrollConfigurationsList>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getPayrollConfigurationsListQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const payrollCyclesList = (
  params?: PayrollCyclesListParams,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<PaginatedPayrollCycleList>({
    url: `/ecc/v1.0/payroll/cycles/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getPayrollCyclesListQueryKey = (
  params?: PayrollCyclesListParams
) => {
  return [`/ecc/v1.0/payroll/cycles/`, ...(params ? [params] : [])] as const;
};

export const getPayrollCyclesListQueryOptions = <
  TData = Awaited<ReturnType<typeof payrollCyclesList>>,
  TError = unknown,
>(
  params?: PayrollCyclesListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof payrollCyclesList>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getPayrollCyclesListQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof payrollCyclesList>>
  > = ({ signal }) => payrollCyclesList(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof payrollCyclesList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PayrollCyclesListQueryResult = NonNullable<
  Awaited<ReturnType<typeof payrollCyclesList>>
>;
export type PayrollCyclesListQueryError = unknown;

export function usePayrollCyclesList<
  TData = Awaited<ReturnType<typeof payrollCyclesList>>,
  TError = unknown,
>(
  params?: PayrollCyclesListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof payrollCyclesList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getPayrollCyclesListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const programmesEnrollmentListList = (
  programmeId: number,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<ProgrammeEnrollmentResponse[]>({
    url: `/ecc/v1.0/programmes/${programmeId}/enrollment-list/`,
    method: 'GET',
    signal,
  });
};

export const getProgrammesEnrollmentListListQueryKey = (
  programmeId: number
) => {
  return [`/ecc/v1.0/programmes/${programmeId}/enrollment-list/`] as const;
};

export const getProgrammesEnrollmentListListQueryOptions = <
  TData = Awaited<ReturnType<typeof programmesEnrollmentListList>>,
  TError = unknown,
>(
  programmeId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof programmesEnrollmentListList>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getProgrammesEnrollmentListListQueryKey(programmeId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof programmesEnrollmentListList>>
  > = ({ signal }) => programmesEnrollmentListList(programmeId, signal);

  return {
    queryKey,
    queryFn,
    enabled: programmeId !== null && programmeId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof programmesEnrollmentListList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ProgrammesEnrollmentListListQueryResult = NonNullable<
  Awaited<ReturnType<typeof programmesEnrollmentListList>>
>;
export type ProgrammesEnrollmentListListQueryError = unknown;

export function useProgrammesEnrollmentListList<
  TData = Awaited<ReturnType<typeof programmesEnrollmentListList>>,
  TError = unknown,
>(
  programmeId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof programmesEnrollmentListList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getProgrammesEnrollmentListListQueryOptions(
    programmeId,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const programmesEnrollmentPricePreviewCreate = (
  programmeCostPreviewRequestRequest: ProgrammeCostPreviewRequestRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<ProgrammeCostResponse>({
    url: `/ecc/v1.0/programmes/enrollment-price-preview/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: programmeCostPreviewRequestRequest,
    signal,
  });
};

export const getProgrammesEnrollmentPricePreviewCreateMutationKey = () =>
  ['programmesEnrollmentPricePreviewCreate'] as const;

export const getProgrammesEnrollmentPricePreviewCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof programmesEnrollmentPricePreviewCreate>>,
    TError,
    ProgrammesEnrollmentPricePreviewCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof programmesEnrollmentPricePreviewCreate>>,
  TError,
  ProgrammesEnrollmentPricePreviewCreateMutationVariables,
  TContext
> => {
  const mutationKey = getProgrammesEnrollmentPricePreviewCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof programmesEnrollmentPricePreviewCreate>>,
    ProgrammesEnrollmentPricePreviewCreateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return programmesEnrollmentPricePreviewCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ProgrammesEnrollmentPricePreviewCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof programmesEnrollmentPricePreviewCreate>>
>;
export type ProgrammesEnrollmentPricePreviewCreateMutationBody =
  ProgrammeCostPreviewRequestRequest;
export type ProgrammesEnrollmentPricePreviewCreateMutationError = unknown;
export type ProgrammesEnrollmentPricePreviewCreateMutationVariables = {
  data: ProgrammeCostPreviewRequestRequest;
};

export const useProgrammesEnrollmentPricePreviewCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof programmesEnrollmentPricePreviewCreate>>,
    TError,
    ProgrammesEnrollmentPricePreviewCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof programmesEnrollmentPricePreviewCreate>>,
  TError,
  ProgrammesEnrollmentPricePreviewCreateMutationVariables,
  TContext
> => {
  return useMutation(
    getProgrammesEnrollmentPricePreviewCreateMutationOptions(options)
  );
};

export const programmesEnrollmentUpdateCreate = (
  programmeEnrollmentRequestRequest: ProgrammeEnrollmentRequestRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/ecc/v1.0/programmes/enrollment-update/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: programmeEnrollmentRequestRequest,
    signal,
  });
};

export const getProgrammesEnrollmentUpdateCreateMutationKey = () =>
  ['programmesEnrollmentUpdateCreate'] as const;

export const getProgrammesEnrollmentUpdateCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof programmesEnrollmentUpdateCreate>>,
    TError,
    ProgrammesEnrollmentUpdateCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof programmesEnrollmentUpdateCreate>>,
  TError,
  ProgrammesEnrollmentUpdateCreateMutationVariables,
  TContext
> => {
  const mutationKey = getProgrammesEnrollmentUpdateCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof programmesEnrollmentUpdateCreate>>,
    ProgrammesEnrollmentUpdateCreateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return programmesEnrollmentUpdateCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ProgrammesEnrollmentUpdateCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof programmesEnrollmentUpdateCreate>>
>;
export type ProgrammesEnrollmentUpdateCreateMutationBody =
  ProgrammeEnrollmentRequestRequest;
export type ProgrammesEnrollmentUpdateCreateMutationError = unknown;
export type ProgrammesEnrollmentUpdateCreateMutationVariables = {
  data: ProgrammeEnrollmentRequestRequest;
};

export const useProgrammesEnrollmentUpdateCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof programmesEnrollmentUpdateCreate>>,
    TError,
    ProgrammesEnrollmentUpdateCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof programmesEnrollmentUpdateCreate>>,
  TError,
  ProgrammesEnrollmentUpdateCreateMutationVariables,
  TContext
> => {
  return useMutation(
    getProgrammesEnrollmentUpdateCreateMutationOptions(options)
  );
};

export const programmesEnrolmentRetrieve = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<ProgrammeBulkEnrolmentResponse>({
    url: `/ecc/v1.0/programmes/enrolment/`,
    method: 'GET',
    signal,
  });
};

export const getProgrammesEnrolmentRetrieveQueryKey = () => {
  return [`/ecc/v1.0/programmes/enrolment/`] as const;
};

export const getProgrammesEnrolmentRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof programmesEnrolmentRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof programmesEnrolmentRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getProgrammesEnrolmentRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof programmesEnrolmentRetrieve>>
  > = ({ signal }) => programmesEnrolmentRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof programmesEnrolmentRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ProgrammesEnrolmentRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof programmesEnrolmentRetrieve>>
>;
export type ProgrammesEnrolmentRetrieveQueryError = unknown;

export function useProgrammesEnrolmentRetrieve<
  TData = Awaited<ReturnType<typeof programmesEnrolmentRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof programmesEnrolmentRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getProgrammesEnrolmentRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const programmesEnrolmentUpdate = (
  programmeBulkEnrolmentRequestRequest: ProgrammeBulkEnrolmentRequestRequest[],
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/ecc/v1.0/programmes/enrolment/`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: programmeBulkEnrolmentRequestRequest,
    signal,
  });
};

export const getProgrammesEnrolmentUpdateMutationKey = () =>
  ['programmesEnrolmentUpdate'] as const;

export const getProgrammesEnrolmentUpdateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof programmesEnrolmentUpdate>>,
    TError,
    ProgrammesEnrolmentUpdateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof programmesEnrolmentUpdate>>,
  TError,
  ProgrammesEnrolmentUpdateMutationVariables,
  TContext
> => {
  const mutationKey = getProgrammesEnrolmentUpdateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof programmesEnrolmentUpdate>>,
    ProgrammesEnrolmentUpdateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return programmesEnrolmentUpdate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ProgrammesEnrolmentUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof programmesEnrolmentUpdate>>
>;
export type ProgrammesEnrolmentUpdateMutationBody =
  ProgrammeBulkEnrolmentRequestRequest[];
export type ProgrammesEnrolmentUpdateMutationError = unknown;
export type ProgrammesEnrolmentUpdateMutationVariables = {
  data: ProgrammeBulkEnrolmentRequestRequest[];
};

export const useProgrammesEnrolmentUpdate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof programmesEnrolmentUpdate>>,
    TError,
    ProgrammesEnrolmentUpdateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof programmesEnrolmentUpdate>>,
  TError,
  ProgrammesEnrolmentUpdateMutationVariables,
  TContext
> => {
  return useMutation(getProgrammesEnrolmentUpdateMutationOptions(options));
};

export const reportsAirwallexList = (
  params?: ReportsAirwallexListParams,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<PaginatedAirwallexFinancialReportListItemList>(
    { url: `/ecc/v1.0/reports/airwallex/`, method: 'GET', params, signal }
  );
};

export const getReportsAirwallexListQueryKey = (
  params?: ReportsAirwallexListParams
) => {
  return [`/ecc/v1.0/reports/airwallex/`, ...(params ? [params] : [])] as const;
};

export const getReportsAirwallexListQueryOptions = <
  TData = Awaited<ReturnType<typeof reportsAirwallexList>>,
  TError = unknown,
>(
  params?: ReportsAirwallexListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof reportsAirwallexList>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getReportsAirwallexListQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof reportsAirwallexList>>
  > = ({ signal }) => reportsAirwallexList(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof reportsAirwallexList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ReportsAirwallexListQueryResult = NonNullable<
  Awaited<ReturnType<typeof reportsAirwallexList>>
>;
export type ReportsAirwallexListQueryError = unknown;

export function useReportsAirwallexList<
  TData = Awaited<ReturnType<typeof reportsAirwallexList>>,
  TError = unknown,
>(
  params?: ReportsAirwallexListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof reportsAirwallexList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getReportsAirwallexListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const reportsAirwallexDownloadRetrieve = (
  id: number,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<AirwallexFinancialReportDownloadResponse>({
    url: `/ecc/v1.0/reports/airwallex/${id}/download/`,
    method: 'GET',
    signal,
  });
};

export const getReportsAirwallexDownloadRetrieveQueryKey = (id: number) => {
  return [`/ecc/v1.0/reports/airwallex/${id}/download/`] as const;
};

export const getReportsAirwallexDownloadRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof reportsAirwallexDownloadRetrieve>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof reportsAirwallexDownloadRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getReportsAirwallexDownloadRetrieveQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof reportsAirwallexDownloadRetrieve>>
  > = ({ signal }) => reportsAirwallexDownloadRetrieve(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof reportsAirwallexDownloadRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ReportsAirwallexDownloadRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof reportsAirwallexDownloadRetrieve>>
>;
export type ReportsAirwallexDownloadRetrieveQueryError = unknown;

export function useReportsAirwallexDownloadRetrieve<
  TData = Awaited<ReturnType<typeof reportsAirwallexDownloadRetrieve>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof reportsAirwallexDownloadRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getReportsAirwallexDownloadRetrieveQueryOptions(
    id,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const reportsAirwallexGenerateCreate = (
  airwallexFinancialReportGenerateRequestRequest: AirwallexFinancialReportGenerateRequestRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<AirwallexFinancialReportGenerateResponse>({
    url: `/ecc/v1.0/reports/airwallex/generate/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: airwallexFinancialReportGenerateRequestRequest,
    signal,
  });
};

export const getReportsAirwallexGenerateCreateMutationKey = () =>
  ['reportsAirwallexGenerateCreate'] as const;

export const getReportsAirwallexGenerateCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reportsAirwallexGenerateCreate>>,
    TError,
    ReportsAirwallexGenerateCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof reportsAirwallexGenerateCreate>>,
  TError,
  ReportsAirwallexGenerateCreateMutationVariables,
  TContext
> => {
  const mutationKey = getReportsAirwallexGenerateCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof reportsAirwallexGenerateCreate>>,
    ReportsAirwallexGenerateCreateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return reportsAirwallexGenerateCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReportsAirwallexGenerateCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof reportsAirwallexGenerateCreate>>
>;
export type ReportsAirwallexGenerateCreateMutationBody =
  AirwallexFinancialReportGenerateRequestRequest;
export type ReportsAirwallexGenerateCreateMutationError = unknown;
export type ReportsAirwallexGenerateCreateMutationVariables = {
  data: AirwallexFinancialReportGenerateRequestRequest;
};

export const useReportsAirwallexGenerateCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reportsAirwallexGenerateCreate>>,
    TError,
    ReportsAirwallexGenerateCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof reportsAirwallexGenerateCreate>>,
  TError,
  ReportsAirwallexGenerateCreateMutationVariables,
  TContext
> => {
  return useMutation(getReportsAirwallexGenerateCreateMutationOptions(options));
};

export const reportsAutoEnrolmentAssessmentExportRetrieve = (
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<AutoEnrolmentAssessmentReportExportResponse>({
    url: `/ecc/v1.0/reports/auto-enrolment-assessment/export/`,
    method: 'GET',
    signal,
  });
};

export const getReportsAutoEnrolmentAssessmentExportRetrieveQueryKey = () => {
  return [`/ecc/v1.0/reports/auto-enrolment-assessment/export/`] as const;
};

export const getReportsAutoEnrolmentAssessmentExportRetrieveQueryOptions = <
  TData = Awaited<
    ReturnType<typeof reportsAutoEnrolmentAssessmentExportRetrieve>
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof reportsAutoEnrolmentAssessmentExportRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getReportsAutoEnrolmentAssessmentExportRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof reportsAutoEnrolmentAssessmentExportRetrieve>>
  > = ({ signal }) => reportsAutoEnrolmentAssessmentExportRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof reportsAutoEnrolmentAssessmentExportRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ReportsAutoEnrolmentAssessmentExportRetrieveQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof reportsAutoEnrolmentAssessmentExportRetrieve>>
  >;
export type ReportsAutoEnrolmentAssessmentExportRetrieveQueryError = unknown;

export function useReportsAutoEnrolmentAssessmentExportRetrieve<
  TData = Awaited<
    ReturnType<typeof reportsAutoEnrolmentAssessmentExportRetrieve>
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof reportsAutoEnrolmentAssessmentExportRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getReportsAutoEnrolmentAssessmentExportRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const reportsAutoEnrolmentAssessmentGenerateCreate = (
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<AutoEnrolmentAssessmentReportGenerateResponse>(
    {
      url: `/ecc/v1.0/reports/auto-enrolment-assessment/generate/`,
      method: 'POST',
      signal,
    }
  );
};

export const getReportsAutoEnrolmentAssessmentGenerateCreateMutationKey = () =>
  ['reportsAutoEnrolmentAssessmentGenerateCreate'] as const;

export const getReportsAutoEnrolmentAssessmentGenerateCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reportsAutoEnrolmentAssessmentGenerateCreate>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof reportsAutoEnrolmentAssessmentGenerateCreate>>,
  TError,
  void,
  TContext
> => {
  const mutationKey =
    getReportsAutoEnrolmentAssessmentGenerateCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof reportsAutoEnrolmentAssessmentGenerateCreate>>,
    void
  > = () => {
    return reportsAutoEnrolmentAssessmentGenerateCreate();
  };

  return { mutationFn, ...mutationOptions };
};

export type ReportsAutoEnrolmentAssessmentGenerateCreateMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof reportsAutoEnrolmentAssessmentGenerateCreate>>
  >;

export type ReportsAutoEnrolmentAssessmentGenerateCreateMutationError = unknown;

export const useReportsAutoEnrolmentAssessmentGenerateCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reportsAutoEnrolmentAssessmentGenerateCreate>>,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof reportsAutoEnrolmentAssessmentGenerateCreate>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getReportsAutoEnrolmentAssessmentGenerateCreateMutationOptions(options)
  );
};

export const reportsContributionHolidaysExportRetrieve = (
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<ContributionHolidaysExportResponse>({
    url: `/ecc/v1.0/reports/contribution-holidays/export/`,
    method: 'GET',
    signal,
  });
};

export const getReportsContributionHolidaysExportRetrieveQueryKey = () => {
  return [`/ecc/v1.0/reports/contribution-holidays/export/`] as const;
};

export const getReportsContributionHolidaysExportRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof reportsContributionHolidaysExportRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof reportsContributionHolidaysExportRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getReportsContributionHolidaysExportRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof reportsContributionHolidaysExportRetrieve>>
  > = ({ signal }) => reportsContributionHolidaysExportRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof reportsContributionHolidaysExportRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ReportsContributionHolidaysExportRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof reportsContributionHolidaysExportRetrieve>>
>;
export type ReportsContributionHolidaysExportRetrieveQueryError = unknown;

export function useReportsContributionHolidaysExportRetrieve<
  TData = Awaited<ReturnType<typeof reportsContributionHolidaysExportRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof reportsContributionHolidaysExportRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getReportsContributionHolidaysExportRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const reportsContributionHolidaysGenerateCreate = (
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<ContributionHolidaysGenerateResponse>({
    url: `/ecc/v1.0/reports/contribution-holidays/generate/`,
    method: 'POST',
    signal,
  });
};

export const getReportsContributionHolidaysGenerateCreateMutationKey = () =>
  ['reportsContributionHolidaysGenerateCreate'] as const;

export const getReportsContributionHolidaysGenerateCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reportsContributionHolidaysGenerateCreate>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof reportsContributionHolidaysGenerateCreate>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = getReportsContributionHolidaysGenerateCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof reportsContributionHolidaysGenerateCreate>>,
    void
  > = () => {
    return reportsContributionHolidaysGenerateCreate();
  };

  return { mutationFn, ...mutationOptions };
};

export type ReportsContributionHolidaysGenerateCreateMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof reportsContributionHolidaysGenerateCreate>>
  >;

export type ReportsContributionHolidaysGenerateCreateMutationError = unknown;

export const useReportsContributionHolidaysGenerateCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reportsContributionHolidaysGenerateCreate>>,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof reportsContributionHolidaysGenerateCreate>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getReportsContributionHolidaysGenerateCreateMutationOptions(options)
  );
};

export const reportsDocumentSigningExportRetrieve = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<DocumentSigningExportResponse>({
    url: `/ecc/v1.0/reports/document-signing/export/`,
    method: 'GET',
    signal,
  });
};

export const getReportsDocumentSigningExportRetrieveQueryKey = () => {
  return [`/ecc/v1.0/reports/document-signing/export/`] as const;
};

export const getReportsDocumentSigningExportRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof reportsDocumentSigningExportRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof reportsDocumentSigningExportRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getReportsDocumentSigningExportRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof reportsDocumentSigningExportRetrieve>>
  > = ({ signal }) => reportsDocumentSigningExportRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof reportsDocumentSigningExportRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ReportsDocumentSigningExportRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof reportsDocumentSigningExportRetrieve>>
>;
export type ReportsDocumentSigningExportRetrieveQueryError = unknown;

export function useReportsDocumentSigningExportRetrieve<
  TData = Awaited<ReturnType<typeof reportsDocumentSigningExportRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof reportsDocumentSigningExportRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getReportsDocumentSigningExportRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const reportsDocumentSigningGenerateCreate = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<DocumentSigningGenerateResponse>({
    url: `/ecc/v1.0/reports/document-signing/generate/`,
    method: 'POST',
    signal,
  });
};

export const getReportsDocumentSigningGenerateCreateMutationKey = () =>
  ['reportsDocumentSigningGenerateCreate'] as const;

export const getReportsDocumentSigningGenerateCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reportsDocumentSigningGenerateCreate>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof reportsDocumentSigningGenerateCreate>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = getReportsDocumentSigningGenerateCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof reportsDocumentSigningGenerateCreate>>,
    void
  > = () => {
    return reportsDocumentSigningGenerateCreate();
  };

  return { mutationFn, ...mutationOptions };
};

export type ReportsDocumentSigningGenerateCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof reportsDocumentSigningGenerateCreate>>
>;

export type ReportsDocumentSigningGenerateCreateMutationError = unknown;

export const useReportsDocumentSigningGenerateCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reportsDocumentSigningGenerateCreate>>,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof reportsDocumentSigningGenerateCreate>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getReportsDocumentSigningGenerateCreateMutationOptions(options)
  );
};

export const reportsNmwCheckList = (
  params?: ReportsNmwCheckListParams,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<NmwCheckReportResponse>({
    url: `/ecc/v1.0/reports/nmw-check/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getReportsNmwCheckListQueryKey = (
  params?: ReportsNmwCheckListParams
) => {
  return [`/ecc/v1.0/reports/nmw-check/`, ...(params ? [params] : [])] as const;
};

export const getReportsNmwCheckListQueryOptions = <
  TData = Awaited<ReturnType<typeof reportsNmwCheckList>>,
  TError = unknown,
>(
  params?: ReportsNmwCheckListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof reportsNmwCheckList>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getReportsNmwCheckListQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof reportsNmwCheckList>>
  > = ({ signal }) => reportsNmwCheckList(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof reportsNmwCheckList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ReportsNmwCheckListQueryResult = NonNullable<
  Awaited<ReturnType<typeof reportsNmwCheckList>>
>;
export type ReportsNmwCheckListQueryError = unknown;

export function useReportsNmwCheckList<
  TData = Awaited<ReturnType<typeof reportsNmwCheckList>>,
  TError = unknown,
>(
  params?: ReportsNmwCheckListParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof reportsNmwCheckList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getReportsNmwCheckListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const reportsNmwCheckExportRetrieve = (
  params: ReportsNmwCheckExportRetrieveParams,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<NmwCheckExportResponse>({
    url: `/ecc/v1.0/reports/nmw-check/export/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getReportsNmwCheckExportRetrieveQueryKey = (
  params?: ReportsNmwCheckExportRetrieveParams
) => {
  return [
    `/ecc/v1.0/reports/nmw-check/export/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getReportsNmwCheckExportRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof reportsNmwCheckExportRetrieve>>,
  TError = unknown,
>(
  params: ReportsNmwCheckExportRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof reportsNmwCheckExportRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getReportsNmwCheckExportRetrieveQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof reportsNmwCheckExportRetrieve>>
  > = ({ signal }) => reportsNmwCheckExportRetrieve(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof reportsNmwCheckExportRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ReportsNmwCheckExportRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof reportsNmwCheckExportRetrieve>>
>;
export type ReportsNmwCheckExportRetrieveQueryError = unknown;

export function useReportsNmwCheckExportRetrieve<
  TData = Awaited<ReturnType<typeof reportsNmwCheckExportRetrieve>>,
  TError = unknown,
>(
  params: ReportsNmwCheckExportRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof reportsNmwCheckExportRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getReportsNmwCheckExportRetrieveQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const reportsNmwCheckFiltersRetrieve = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<NmwCheckFilterOptionsResponse>({
    url: `/ecc/v1.0/reports/nmw-check/filters/`,
    method: 'GET',
    signal,
  });
};

export const getReportsNmwCheckFiltersRetrieveQueryKey = () => {
  return [`/ecc/v1.0/reports/nmw-check/filters/`] as const;
};

export const getReportsNmwCheckFiltersRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof reportsNmwCheckFiltersRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof reportsNmwCheckFiltersRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getReportsNmwCheckFiltersRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof reportsNmwCheckFiltersRetrieve>>
  > = ({ signal }) => reportsNmwCheckFiltersRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof reportsNmwCheckFiltersRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ReportsNmwCheckFiltersRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof reportsNmwCheckFiltersRetrieve>>
>;
export type ReportsNmwCheckFiltersRetrieveQueryError = unknown;

export function useReportsNmwCheckFiltersRetrieve<
  TData = Awaited<ReturnType<typeof reportsNmwCheckFiltersRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof reportsNmwCheckFiltersRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getReportsNmwCheckFiltersRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const reportsNmwCheckGenerateCreate = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<NmwCheckGenerateResponse>({
    url: `/ecc/v1.0/reports/nmw-check/generate/`,
    method: 'POST',
    signal,
  });
};

export const getReportsNmwCheckGenerateCreateMutationKey = () =>
  ['reportsNmwCheckGenerateCreate'] as const;

export const getReportsNmwCheckGenerateCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reportsNmwCheckGenerateCreate>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof reportsNmwCheckGenerateCreate>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = getReportsNmwCheckGenerateCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof reportsNmwCheckGenerateCreate>>,
    void
  > = () => {
    return reportsNmwCheckGenerateCreate();
  };

  return { mutationFn, ...mutationOptions };
};

export type ReportsNmwCheckGenerateCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof reportsNmwCheckGenerateCreate>>
>;

export type ReportsNmwCheckGenerateCreateMutationError = unknown;

export const useReportsNmwCheckGenerateCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reportsNmwCheckGenerateCreate>>,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof reportsNmwCheckGenerateCreate>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getReportsNmwCheckGenerateCreateMutationOptions(options));
};

export const reportsPayrollExportRetrieve = (
  params: ReportsPayrollExportRetrieveParams,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<PayrollReportExportResponse>({
    url: `/ecc/v1.0/reports/payroll/export/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getReportsPayrollExportRetrieveQueryKey = (
  params?: ReportsPayrollExportRetrieveParams
) => {
  return [
    `/ecc/v1.0/reports/payroll/export/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getReportsPayrollExportRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof reportsPayrollExportRetrieve>>,
  TError = unknown,
>(
  params: ReportsPayrollExportRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof reportsPayrollExportRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getReportsPayrollExportRetrieveQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof reportsPayrollExportRetrieve>>
  > = ({ signal }) => reportsPayrollExportRetrieve(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof reportsPayrollExportRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ReportsPayrollExportRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof reportsPayrollExportRetrieve>>
>;
export type ReportsPayrollExportRetrieveQueryError = unknown;

export function useReportsPayrollExportRetrieve<
  TData = Awaited<ReturnType<typeof reportsPayrollExportRetrieve>>,
  TError = unknown,
>(
  params: ReportsPayrollExportRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof reportsPayrollExportRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getReportsPayrollExportRetrieveQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const rewardCreate = (
  rewardResponseRequest: RewardResponseRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<RewardResponse>({
    url: `/ecc/v1.0/reward/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: rewardResponseRequest,
    signal,
  });
};

export const getRewardCreateMutationKey = () => ['rewardCreate'] as const;

export const getRewardCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rewardCreate>>,
    TError,
    RewardCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof rewardCreate>>,
  TError,
  RewardCreateMutationVariables,
  TContext
> => {
  const mutationKey = getRewardCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof rewardCreate>>,
    RewardCreateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return rewardCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RewardCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof rewardCreate>>
>;
export type RewardCreateMutationBody = RewardResponseRequest;
export type RewardCreateMutationError = unknown;
export type RewardCreateMutationVariables = { data: RewardResponseRequest };

export const useRewardCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rewardCreate>>,
    TError,
    RewardCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof rewardCreate>>,
  TError,
  RewardCreateMutationVariables,
  TContext
> => {
  return useMutation(getRewardCreateMutationOptions(options));
};

export const eccRewardsRetrieve = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<RewardsListResponse>({
    url: `/ecc/v1.0/rewards/`,
    method: 'GET',
    signal,
  });
};

export const getEccRewardsRetrieveQueryKey = () => {
  return [`/ecc/v1.0/rewards/`] as const;
};

export const getEccRewardsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof eccRewardsRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof eccRewardsRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getEccRewardsRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof eccRewardsRetrieve>>
  > = ({ signal }) => eccRewardsRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof eccRewardsRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type EccRewardsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof eccRewardsRetrieve>>
>;
export type EccRewardsRetrieveQueryError = unknown;

export function useEccRewardsRetrieve<
  TData = Awaited<ReturnType<typeof eccRewardsRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof eccRewardsRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getEccRewardsRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const eccTransactionsReceiptsList = (
  transactionId: number,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<Receipt[]>({
    url: `/ecc/v1.0/transactions/${transactionId}/receipts/`,
    method: 'GET',
    signal,
  });
};

export const getEccTransactionsReceiptsListQueryKey = (
  transactionId: number
) => {
  return [`/ecc/v1.0/transactions/${transactionId}/receipts/`] as const;
};

export const getEccTransactionsReceiptsListQueryOptions = <
  TData = Awaited<ReturnType<typeof eccTransactionsReceiptsList>>,
  TError = unknown,
>(
  transactionId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof eccTransactionsReceiptsList>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getEccTransactionsReceiptsListQueryKey(transactionId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof eccTransactionsReceiptsList>>
  > = ({ signal }) => eccTransactionsReceiptsList(transactionId, signal);

  return {
    queryKey,
    queryFn,
    enabled: transactionId !== null && transactionId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof eccTransactionsReceiptsList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type EccTransactionsReceiptsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof eccTransactionsReceiptsList>>
>;
export type EccTransactionsReceiptsListQueryError = unknown;

export function useEccTransactionsReceiptsList<
  TData = Awaited<ReturnType<typeof eccTransactionsReceiptsList>>,
  TError = unknown,
>(
  transactionId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof eccTransactionsReceiptsList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getEccTransactionsReceiptsListQueryOptions(
    transactionId,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const eccUiConfigRetrieve = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<EmployerConfiguration>({
    url: `/ecc/v1.0/ui-config/`,
    method: 'GET',
    signal,
  });
};

export const getEccUiConfigRetrieveQueryKey = () => {
  return [`/ecc/v1.0/ui-config/`] as const;
};

export const getEccUiConfigRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof eccUiConfigRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof eccUiConfigRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getEccUiConfigRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof eccUiConfigRetrieve>>
  > = ({ signal }) => eccUiConfigRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof eccUiConfigRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type EccUiConfigRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof eccUiConfigRetrieve>>
>;
export type EccUiConfigRetrieveQueryError = unknown;

export function useEccUiConfigRetrieve<
  TData = Awaited<ReturnType<typeof eccUiConfigRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof eccUiConfigRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getEccUiConfigRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const employeeUrlRetrieve = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<EmployeeUrlResponse>({
    url: `/employee/url`,
    method: 'GET',
    signal,
  });
};

export const getEmployeeUrlRetrieveQueryKey = () => {
  return [`/employee/url`] as const;
};

export const getEmployeeUrlRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof employeeUrlRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof employeeUrlRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getEmployeeUrlRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof employeeUrlRetrieve>>
  > = ({ signal }) => employeeUrlRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof employeeUrlRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type EmployeeUrlRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof employeeUrlRetrieve>>
>;
export type EmployeeUrlRetrieveQueryError = unknown;

export function useEmployeeUrlRetrieve<
  TData = Awaited<ReturnType<typeof employeeUrlRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof employeeUrlRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getEmployeeUrlRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * The flow of media download:
 *     1. User visits the URL file URL (this view)
 *     2. User is redirected to login page via redirect_to_login
 *     3. User logs in with auth0
 *     4. User is redirected back to this view with "?code=..." by auth0
 *     5. User is redirected to the file download page via redirect_to_download_page
 *
 * We're using the same view here for multiple purposes to keep the auth0 callback
 * config simple and have the "canonical" file urls consistent.
 */
export const filesDownloadRetrieve = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<unknown>({
    url: `/files/download/`,
    method: 'GET',
    signal,
  });
};

export const getFilesDownloadRetrieveQueryKey = () => {
  return [`/files/download/`] as const;
};

export const getFilesDownloadRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof filesDownloadRetrieve>>,
  TError = void,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof filesDownloadRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getFilesDownloadRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof filesDownloadRetrieve>>
  > = ({ signal }) => filesDownloadRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof filesDownloadRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type FilesDownloadRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof filesDownloadRetrieve>>
>;
export type FilesDownloadRetrieveQueryError = void;

export function useFilesDownloadRetrieve<
  TData = Awaited<ReturnType<typeof filesDownloadRetrieve>>,
  TError = void,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof filesDownloadRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getFilesDownloadRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * The flow of media download:
 *     1. User visits the URL file URL (this view)
 *     2. User is redirected to login page via redirect_to_login
 *     3. User logs in with auth0
 *     4. User is redirected back to this view with "?code=..." by auth0
 *     5. User is redirected to the file download page via redirect_to_download_page
 *
 * We're using the same view here for multiple purposes to keep the auth0 callback
 * config simple and have the "canonical" file urls consistent.
 */
export const filesDownloadRetrieve2 = (
  employerPk: number,
  downloader: string,
  fileId: string,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<unknown>({
    url: `/files/download/${employerPk}/${downloader}/${fileId}/`,
    method: 'GET',
    signal,
  });
};

export const getFilesDownloadRetrieve2QueryKey = (
  employerPk: number,
  downloader: string,
  fileId: string
) => {
  return [`/files/download/${employerPk}/${downloader}/${fileId}/`] as const;
};

export const getFilesDownloadRetrieve2QueryOptions = <
  TData = Awaited<ReturnType<typeof filesDownloadRetrieve2>>,
  TError = void,
>(
  employerPk: number,
  downloader: string,
  fileId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof filesDownloadRetrieve2>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getFilesDownloadRetrieve2QueryKey(employerPk, downloader, fileId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof filesDownloadRetrieve2>>
  > = ({ signal }) =>
    filesDownloadRetrieve2(employerPk, downloader, fileId, signal);

  return {
    queryKey,
    queryFn,
    enabled:
      employerPk !== null &&
      employerPk !== undefined &&
      downloader !== null &&
      downloader !== undefined &&
      fileId !== null &&
      fileId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof filesDownloadRetrieve2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type FilesDownloadRetrieve2QueryResult = NonNullable<
  Awaited<ReturnType<typeof filesDownloadRetrieve2>>
>;
export type FilesDownloadRetrieve2QueryError = void;

export function useFilesDownloadRetrieve2<
  TData = Awaited<ReturnType<typeof filesDownloadRetrieve2>>,
  TError = void,
>(
  employerPk: number,
  downloader: string,
  fileId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof filesDownloadRetrieve2>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getFilesDownloadRetrieve2QueryOptions(
    employerPk,
    downloader,
    fileId,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const healthRetrieve = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<void>({
    url: `/health/`,
    method: 'GET',
    signal,
  });
};

export const getHealthRetrieveQueryKey = () => {
  return [`/health/`] as const;
};

export const getHealthRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof healthRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof healthRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getHealthRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof healthRetrieve>>> = ({
    signal,
  }) => healthRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof healthRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HealthRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof healthRetrieve>>
>;
export type HealthRetrieveQueryError = unknown;

export function useHealthRetrieve<
  TData = Awaited<ReturnType<typeof healthRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof healthRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHealthRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const impersonationSessionRetrieve = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<ImpersonationSessionResponse | void>({
    url: `/impersonation/session/`,
    method: 'GET',
    signal,
  });
};

export const getImpersonationSessionRetrieveQueryKey = () => {
  return [`/impersonation/session/`] as const;
};

export const getImpersonationSessionRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof impersonationSessionRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof impersonationSessionRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getImpersonationSessionRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof impersonationSessionRetrieve>>
  > = ({ signal }) => impersonationSessionRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof impersonationSessionRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ImpersonationSessionRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof impersonationSessionRetrieve>>
>;
export type ImpersonationSessionRetrieveQueryError = unknown;

export function useImpersonationSessionRetrieve<
  TData = Awaited<ReturnType<typeof impersonationSessionRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof impersonationSessionRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getImpersonationSessionRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const impersonationSessionEndCreate = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<void>({
    url: `/impersonation/session/end/`,
    method: 'POST',
    signal,
  });
};

export const getImpersonationSessionEndCreateMutationKey = () =>
  ['impersonationSessionEndCreate'] as const;

export const getImpersonationSessionEndCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof impersonationSessionEndCreate>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof impersonationSessionEndCreate>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = getImpersonationSessionEndCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof impersonationSessionEndCreate>>,
    void
  > = () => {
    return impersonationSessionEndCreate();
  };

  return { mutationFn, ...mutationOptions };
};

export type ImpersonationSessionEndCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof impersonationSessionEndCreate>>
>;

export type ImpersonationSessionEndCreateMutationError = unknown;

export const useImpersonationSessionEndCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof impersonationSessionEndCreate>>,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof impersonationSessionEndCreate>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getImpersonationSessionEndCreateMutationOptions(options));
};

export const impersonationSessionStartCreate = (
  startImpersonationSessionRequestRequest: StartImpersonationSessionRequestRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<ImpersonationSessionResponse>({
    url: `/impersonation/session/start/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: startImpersonationSessionRequestRequest,
    signal,
  });
};

export const getImpersonationSessionStartCreateMutationKey = () =>
  ['impersonationSessionStartCreate'] as const;

export const getImpersonationSessionStartCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof impersonationSessionStartCreate>>,
    TError,
    ImpersonationSessionStartCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof impersonationSessionStartCreate>>,
  TError,
  ImpersonationSessionStartCreateMutationVariables,
  TContext
> => {
  const mutationKey = getImpersonationSessionStartCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof impersonationSessionStartCreate>>,
    ImpersonationSessionStartCreateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return impersonationSessionStartCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ImpersonationSessionStartCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof impersonationSessionStartCreate>>
>;
export type ImpersonationSessionStartCreateMutationBody =
  StartImpersonationSessionRequestRequest;
export type ImpersonationSessionStartCreateMutationError = unknown;
export type ImpersonationSessionStartCreateMutationVariables = {
  data: StartImpersonationSessionRequestRequest;
};

export const useImpersonationSessionStartCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof impersonationSessionStartCreate>>,
    TError,
    ImpersonationSessionStartCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof impersonationSessionStartCreate>>,
  TError,
  ImpersonationSessionStartCreateMutationVariables,
  TContext
> => {
  return useMutation(
    getImpersonationSessionStartCreateMutationOptions(options)
  );
};

export const inviteConsumeRetrieve = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<unknown>({
    url: `/invite/consume/`,
    method: 'GET',
    signal,
  });
};

export const getInviteConsumeRetrieveQueryKey = () => {
  return [`/invite/consume/`] as const;
};

export const getInviteConsumeRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof inviteConsumeRetrieve>>,
  TError = void,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof inviteConsumeRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getInviteConsumeRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof inviteConsumeRetrieve>>
  > = ({ signal }) => inviteConsumeRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof inviteConsumeRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type InviteConsumeRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof inviteConsumeRetrieve>>
>;
export type InviteConsumeRetrieveQueryError = void;

export function useInviteConsumeRetrieve<
  TData = Awaited<ReturnType<typeof inviteConsumeRetrieve>>,
  TError = void,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof inviteConsumeRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getInviteConsumeRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const managedAccountsDepositsWatchCreate = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<void>({
    url: `/managed_accounts/deposits/watch`,
    method: 'POST',
    signal,
  });
};

export const getManagedAccountsDepositsWatchCreateMutationKey = () =>
  ['managedAccountsDepositsWatchCreate'] as const;

export const getManagedAccountsDepositsWatchCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof managedAccountsDepositsWatchCreate>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof managedAccountsDepositsWatchCreate>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = getManagedAccountsDepositsWatchCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof managedAccountsDepositsWatchCreate>>,
    void
  > = () => {
    return managedAccountsDepositsWatchCreate();
  };

  return { mutationFn, ...mutationOptions };
};

export type ManagedAccountsDepositsWatchCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof managedAccountsDepositsWatchCreate>>
>;

export type ManagedAccountsDepositsWatchCreateMutationError = unknown;

export const useManagedAccountsDepositsWatchCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof managedAccountsDepositsWatchCreate>>,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof managedAccountsDepositsWatchCreate>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getManagedAccountsDepositsWatchCreateMutationOptions(options)
  );
};

export const managedAccountsWatchCreate = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<void>({
    url: `/managed_accounts/watch`,
    method: 'POST',
    signal,
  });
};

export const getManagedAccountsWatchCreateMutationKey = () =>
  ['managedAccountsWatchCreate'] as const;

export const getManagedAccountsWatchCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof managedAccountsWatchCreate>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof managedAccountsWatchCreate>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = getManagedAccountsWatchCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof managedAccountsWatchCreate>>,
    void
  > = () => {
    return managedAccountsWatchCreate();
  };

  return { mutationFn, ...mutationOptions };
};

export type ManagedAccountsWatchCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof managedAccountsWatchCreate>>
>;

export type ManagedAccountsWatchCreateMutationError = unknown;

export const useManagedAccountsWatchCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof managedAccountsWatchCreate>>,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof managedAccountsWatchCreate>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getManagedAccountsWatchCreateMutationOptions(options));
};

export const managedCardsAuthorisationsWatchCreate = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<void>({
    url: `/managed_cards/authorisations/watch`,
    method: 'POST',
    signal,
  });
};

export const getManagedCardsAuthorisationsWatchCreateMutationKey = () =>
  ['managedCardsAuthorisationsWatchCreate'] as const;

export const getManagedCardsAuthorisationsWatchCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof managedCardsAuthorisationsWatchCreate>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof managedCardsAuthorisationsWatchCreate>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = getManagedCardsAuthorisationsWatchCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof managedCardsAuthorisationsWatchCreate>>,
    void
  > = () => {
    return managedCardsAuthorisationsWatchCreate();
  };

  return { mutationFn, ...mutationOptions };
};

export type ManagedCardsAuthorisationsWatchCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof managedCardsAuthorisationsWatchCreate>>
>;

export type ManagedCardsAuthorisationsWatchCreateMutationError = unknown;

export const useManagedCardsAuthorisationsWatchCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof managedCardsAuthorisationsWatchCreate>>,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof managedCardsAuthorisationsWatchCreate>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getManagedCardsAuthorisationsWatchCreateMutationOptions(options)
  );
};

export const managedCardsExpiriesWatchCreate = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<void>({
    url: `/managed_cards/expiries/watch`,
    method: 'POST',
    signal,
  });
};

export const getManagedCardsExpiriesWatchCreateMutationKey = () =>
  ['managedCardsExpiriesWatchCreate'] as const;

export const getManagedCardsExpiriesWatchCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof managedCardsExpiriesWatchCreate>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof managedCardsExpiriesWatchCreate>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = getManagedCardsExpiriesWatchCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof managedCardsExpiriesWatchCreate>>,
    void
  > = () => {
    return managedCardsExpiriesWatchCreate();
  };

  return { mutationFn, ...mutationOptions };
};

export type ManagedCardsExpiriesWatchCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof managedCardsExpiriesWatchCreate>>
>;

export type ManagedCardsExpiriesWatchCreateMutationError = unknown;

export const useManagedCardsExpiriesWatchCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof managedCardsExpiriesWatchCreate>>,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof managedCardsExpiriesWatchCreate>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getManagedCardsExpiriesWatchCreateMutationOptions(options)
  );
};

export const managedCardsSettlementsWatchCreate = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<void>({
    url: `/managed_cards/settlements/watch`,
    method: 'POST',
    signal,
  });
};

export const getManagedCardsSettlementsWatchCreateMutationKey = () =>
  ['managedCardsSettlementsWatchCreate'] as const;

export const getManagedCardsSettlementsWatchCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof managedCardsSettlementsWatchCreate>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof managedCardsSettlementsWatchCreate>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = getManagedCardsSettlementsWatchCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof managedCardsSettlementsWatchCreate>>,
    void
  > = () => {
    return managedCardsSettlementsWatchCreate();
  };

  return { mutationFn, ...mutationOptions };
};

export type ManagedCardsSettlementsWatchCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof managedCardsSettlementsWatchCreate>>
>;

export type ManagedCardsSettlementsWatchCreateMutationError = unknown;

export const useManagedCardsSettlementsWatchCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof managedCardsSettlementsWatchCreate>>,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof managedCardsSettlementsWatchCreate>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getManagedCardsSettlementsWatchCreateMutationOptions(options)
  );
};

export const messagingIntegrationsV10Retrieve = (
  params: MessagingIntegrationsV10RetrieveParams,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<EmployerIntegrationResponse>({
    url: `/messaging_integrations/v1.0/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getMessagingIntegrationsV10RetrieveQueryKey = (
  params?: MessagingIntegrationsV10RetrieveParams
) => {
  return [
    `/messaging_integrations/v1.0/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getMessagingIntegrationsV10RetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof messagingIntegrationsV10Retrieve>>,
  TError = unknown,
>(
  params: MessagingIntegrationsV10RetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof messagingIntegrationsV10Retrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getMessagingIntegrationsV10RetrieveQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof messagingIntegrationsV10Retrieve>>
  > = ({ signal }) => messagingIntegrationsV10Retrieve(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof messagingIntegrationsV10Retrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type MessagingIntegrationsV10RetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof messagingIntegrationsV10Retrieve>>
>;
export type MessagingIntegrationsV10RetrieveQueryError = unknown;

export function useMessagingIntegrationsV10Retrieve<
  TData = Awaited<ReturnType<typeof messagingIntegrationsV10Retrieve>>,
  TError = unknown,
>(
  params: MessagingIntegrationsV10RetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof messagingIntegrationsV10Retrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getMessagingIntegrationsV10RetrieveQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Endpoints used to update MS Teams integration specific settings
 * and disconnect the integration.
 */
export const messagingIntegrationsV10MsTeamsPartialUpdate = (
  patchedMSTeamsUpdateEmployerConfigRequestRequest?: PatchedMSTeamsUpdateEmployerConfigRequestRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/messaging_integrations/v1.0/ms_teams/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchedMSTeamsUpdateEmployerConfigRequestRequest,
    signal,
  });
};

export const getMessagingIntegrationsV10MsTeamsPartialUpdateMutationKey = () =>
  ['messagingIntegrationsV10MsTeamsPartialUpdate'] as const;

export const getMessagingIntegrationsV10MsTeamsPartialUpdateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof messagingIntegrationsV10MsTeamsPartialUpdate>>,
    TError,
    MessagingIntegrationsV10MsTeamsPartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof messagingIntegrationsV10MsTeamsPartialUpdate>>,
  TError,
  MessagingIntegrationsV10MsTeamsPartialUpdateMutationVariables,
  TContext
> => {
  const mutationKey =
    getMessagingIntegrationsV10MsTeamsPartialUpdateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof messagingIntegrationsV10MsTeamsPartialUpdate>>,
    MessagingIntegrationsV10MsTeamsPartialUpdateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return messagingIntegrationsV10MsTeamsPartialUpdate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type MessagingIntegrationsV10MsTeamsPartialUpdateMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof messagingIntegrationsV10MsTeamsPartialUpdate>>
  >;
export type MessagingIntegrationsV10MsTeamsPartialUpdateMutationBody =
  | PatchedMSTeamsUpdateEmployerConfigRequestRequest
  | undefined;
export type MessagingIntegrationsV10MsTeamsPartialUpdateMutationError = unknown;
export type MessagingIntegrationsV10MsTeamsPartialUpdateMutationVariables = {
  data?: PatchedMSTeamsUpdateEmployerConfigRequestRequest;
};

export const useMessagingIntegrationsV10MsTeamsPartialUpdate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof messagingIntegrationsV10MsTeamsPartialUpdate>>,
    TError,
    MessagingIntegrationsV10MsTeamsPartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof messagingIntegrationsV10MsTeamsPartialUpdate>>,
  TError,
  MessagingIntegrationsV10MsTeamsPartialUpdateMutationVariables,
  TContext
> => {
  return useMutation(
    getMessagingIntegrationsV10MsTeamsPartialUpdateMutationOptions(options)
  );
};

/**
 * Endpoints used to update MS Teams integration specific settings
 * and disconnect the integration.
 */
export const messagingIntegrationsV10MsTeamsDestroy = (
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/messaging_integrations/v1.0/ms_teams/`,
    method: 'DELETE',
    signal,
  });
};

export const getMessagingIntegrationsV10MsTeamsDestroyMutationKey = () =>
  ['messagingIntegrationsV10MsTeamsDestroy'] as const;

export const getMessagingIntegrationsV10MsTeamsDestroyMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof messagingIntegrationsV10MsTeamsDestroy>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof messagingIntegrationsV10MsTeamsDestroy>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = getMessagingIntegrationsV10MsTeamsDestroyMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof messagingIntegrationsV10MsTeamsDestroy>>,
    void
  > = () => {
    return messagingIntegrationsV10MsTeamsDestroy();
  };

  return { mutationFn, ...mutationOptions };
};

export type MessagingIntegrationsV10MsTeamsDestroyMutationResult = NonNullable<
  Awaited<ReturnType<typeof messagingIntegrationsV10MsTeamsDestroy>>
>;

export type MessagingIntegrationsV10MsTeamsDestroyMutationError = unknown;

export const useMessagingIntegrationsV10MsTeamsDestroy = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof messagingIntegrationsV10MsTeamsDestroy>>,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof messagingIntegrationsV10MsTeamsDestroy>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getMessagingIntegrationsV10MsTeamsDestroyMutationOptions(options)
  );
};

/**
 * Endpoints required for setting up the MS Teams integration.
 * This allows us to relate Ben data to MS data.
 * (Unlike Slack) Completion of the OAuth flow will not
 * install the Ben app to the user's MS Teams.
 *
 * See (TODO(callt-ben): create doc) for more details.
 */
export const messagingIntegrationsV10MsTeamsAuthRetrieve = (
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<MSTeamsStartAuthResponse>({
    url: `/messaging_integrations/v1.0/ms_teams/auth/`,
    method: 'GET',
    signal,
  });
};

export const getMessagingIntegrationsV10MsTeamsAuthRetrieveQueryKey = () => {
  return [`/messaging_integrations/v1.0/ms_teams/auth/`] as const;
};

export const getMessagingIntegrationsV10MsTeamsAuthRetrieveQueryOptions = <
  TData = Awaited<
    ReturnType<typeof messagingIntegrationsV10MsTeamsAuthRetrieve>
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof messagingIntegrationsV10MsTeamsAuthRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getMessagingIntegrationsV10MsTeamsAuthRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof messagingIntegrationsV10MsTeamsAuthRetrieve>>
  > = ({ signal }) => messagingIntegrationsV10MsTeamsAuthRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof messagingIntegrationsV10MsTeamsAuthRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type MessagingIntegrationsV10MsTeamsAuthRetrieveQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof messagingIntegrationsV10MsTeamsAuthRetrieve>>
  >;
export type MessagingIntegrationsV10MsTeamsAuthRetrieveQueryError = unknown;

export function useMessagingIntegrationsV10MsTeamsAuthRetrieve<
  TData = Awaited<
    ReturnType<typeof messagingIntegrationsV10MsTeamsAuthRetrieve>
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof messagingIntegrationsV10MsTeamsAuthRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getMessagingIntegrationsV10MsTeamsAuthRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Endpoints required for setting up the MS Teams integration.
 * This allows us to relate Ben data to MS data.
 * (Unlike Slack) Completion of the OAuth flow will not
 * install the Ben app to the user's MS Teams.
 *
 * See (TODO(callt-ben): create doc) for more details.
 */
export const messagingIntegrationsV10MsTeamsAuthCreate = (
  mSTeamsCompleteAuthRequestRequest: MSTeamsCompleteAuthRequestRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/messaging_integrations/v1.0/ms_teams/auth/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: mSTeamsCompleteAuthRequestRequest,
    signal,
  });
};

export const getMessagingIntegrationsV10MsTeamsAuthCreateMutationKey = () =>
  ['messagingIntegrationsV10MsTeamsAuthCreate'] as const;

export const getMessagingIntegrationsV10MsTeamsAuthCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof messagingIntegrationsV10MsTeamsAuthCreate>>,
    TError,
    MessagingIntegrationsV10MsTeamsAuthCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof messagingIntegrationsV10MsTeamsAuthCreate>>,
  TError,
  MessagingIntegrationsV10MsTeamsAuthCreateMutationVariables,
  TContext
> => {
  const mutationKey = getMessagingIntegrationsV10MsTeamsAuthCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof messagingIntegrationsV10MsTeamsAuthCreate>>,
    MessagingIntegrationsV10MsTeamsAuthCreateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return messagingIntegrationsV10MsTeamsAuthCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type MessagingIntegrationsV10MsTeamsAuthCreateMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof messagingIntegrationsV10MsTeamsAuthCreate>>
  >;
export type MessagingIntegrationsV10MsTeamsAuthCreateMutationBody =
  MSTeamsCompleteAuthRequestRequest;
export type MessagingIntegrationsV10MsTeamsAuthCreateMutationError = unknown;
export type MessagingIntegrationsV10MsTeamsAuthCreateMutationVariables = {
  data: MSTeamsCompleteAuthRequestRequest;
};

export const useMessagingIntegrationsV10MsTeamsAuthCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof messagingIntegrationsV10MsTeamsAuthCreate>>,
    TError,
    MessagingIntegrationsV10MsTeamsAuthCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof messagingIntegrationsV10MsTeamsAuthCreate>>,
  TError,
  MessagingIntegrationsV10MsTeamsAuthCreateMutationVariables,
  TContext
> => {
  return useMutation(
    getMessagingIntegrationsV10MsTeamsAuthCreateMutationOptions(options)
  );
};

/**
 * Used as part of the MS OAuth flow to redirect
 * the user back to their employer's hostname.
 *
 * See (TODO(callt-ben): create doc) for more details.
 */
export const messagingIntegrationsV10MsTeamsAuthRedirectRetrieve = (
  params: MessagingIntegrationsV10MsTeamsAuthRedirectRetrieveParams,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<unknown>({
    url: `/messaging_integrations/v1.0/ms_teams/auth/redirect/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getMessagingIntegrationsV10MsTeamsAuthRedirectRetrieveQueryKey = (
  params?: MessagingIntegrationsV10MsTeamsAuthRedirectRetrieveParams
) => {
  return [
    `/messaging_integrations/v1.0/ms_teams/auth/redirect/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getMessagingIntegrationsV10MsTeamsAuthRedirectRetrieveQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof messagingIntegrationsV10MsTeamsAuthRedirectRetrieve>
    >,
    TError = void,
  >(
    params: MessagingIntegrationsV10MsTeamsAuthRedirectRetrieveParams,
    options?: {
      query?: UseQueryOptions<
        Awaited<
          ReturnType<typeof messagingIntegrationsV10MsTeamsAuthRedirectRetrieve>
        >,
        TError,
        TData
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getMessagingIntegrationsV10MsTeamsAuthRedirectRetrieveQueryKey(params);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof messagingIntegrationsV10MsTeamsAuthRedirectRetrieve>
      >
    > = ({ signal }) =>
      messagingIntegrationsV10MsTeamsAuthRedirectRetrieve(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof messagingIntegrationsV10MsTeamsAuthRedirectRetrieve>
      >,
      TError,
      TData
    > & { queryKey: QueryKey };
  };

export type MessagingIntegrationsV10MsTeamsAuthRedirectRetrieveQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof messagingIntegrationsV10MsTeamsAuthRedirectRetrieve>
    >
  >;
export type MessagingIntegrationsV10MsTeamsAuthRedirectRetrieveQueryError =
  void;

export function useMessagingIntegrationsV10MsTeamsAuthRedirectRetrieve<
  TData = Awaited<
    ReturnType<typeof messagingIntegrationsV10MsTeamsAuthRedirectRetrieve>
  >,
  TError = void,
>(
  params: MessagingIntegrationsV10MsTeamsAuthRedirectRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<typeof messagingIntegrationsV10MsTeamsAuthRedirectRetrieve>
      >,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getMessagingIntegrationsV10MsTeamsAuthRedirectRetrieveQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Fetch a list of teams related to the employer's MS Teams integration.
 */
export const messagingIntegrationsV10MsTeamsTeamsRetrieve = (
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<MSTeamsTeamsResponse>({
    url: `/messaging_integrations/v1.0/ms_teams/teams/`,
    method: 'GET',
    signal,
  });
};

export const getMessagingIntegrationsV10MsTeamsTeamsRetrieveQueryKey = () => {
  return [`/messaging_integrations/v1.0/ms_teams/teams/`] as const;
};

export const getMessagingIntegrationsV10MsTeamsTeamsRetrieveQueryOptions = <
  TData = Awaited<
    ReturnType<typeof messagingIntegrationsV10MsTeamsTeamsRetrieve>
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof messagingIntegrationsV10MsTeamsTeamsRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getMessagingIntegrationsV10MsTeamsTeamsRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof messagingIntegrationsV10MsTeamsTeamsRetrieve>>
  > = ({ signal }) => messagingIntegrationsV10MsTeamsTeamsRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof messagingIntegrationsV10MsTeamsTeamsRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type MessagingIntegrationsV10MsTeamsTeamsRetrieveQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof messagingIntegrationsV10MsTeamsTeamsRetrieve>>
  >;
export type MessagingIntegrationsV10MsTeamsTeamsRetrieveQueryError = unknown;

export function useMessagingIntegrationsV10MsTeamsTeamsRetrieve<
  TData = Awaited<
    ReturnType<typeof messagingIntegrationsV10MsTeamsTeamsRetrieve>
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof messagingIntegrationsV10MsTeamsTeamsRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getMessagingIntegrationsV10MsTeamsTeamsRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Fetch a list of channels related to the employer's MS Teams integration.
 */
export const messagingIntegrationsV10MsTeamsTeamsChannelsRetrieve = (
  teamId: number,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<MSTeamsChannelsResponse>({
    url: `/messaging_integrations/v1.0/ms_teams/teams/${teamId}/channels/`,
    method: 'GET',
    signal,
  });
};

export const getMessagingIntegrationsV10MsTeamsTeamsChannelsRetrieveQueryKey = (
  teamId: number
) => {
  return [
    `/messaging_integrations/v1.0/ms_teams/teams/${teamId}/channels/`,
  ] as const;
};

export const getMessagingIntegrationsV10MsTeamsTeamsChannelsRetrieveQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof messagingIntegrationsV10MsTeamsTeamsChannelsRetrieve>
    >,
    TError = unknown,
  >(
    teamId: number,
    options?: {
      query?: UseQueryOptions<
        Awaited<
          ReturnType<
            typeof messagingIntegrationsV10MsTeamsTeamsChannelsRetrieve
          >
        >,
        TError,
        TData
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getMessagingIntegrationsV10MsTeamsTeamsChannelsRetrieveQueryKey(teamId);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof messagingIntegrationsV10MsTeamsTeamsChannelsRetrieve>
      >
    > = ({ signal }) =>
      messagingIntegrationsV10MsTeamsTeamsChannelsRetrieve(teamId, signal);

    return {
      queryKey,
      queryFn,
      enabled: teamId !== null && teamId !== undefined,
      ...queryOptions,
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof messagingIntegrationsV10MsTeamsTeamsChannelsRetrieve>
      >,
      TError,
      TData
    > & { queryKey: QueryKey };
  };

export type MessagingIntegrationsV10MsTeamsTeamsChannelsRetrieveQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof messagingIntegrationsV10MsTeamsTeamsChannelsRetrieve>
    >
  >;
export type MessagingIntegrationsV10MsTeamsTeamsChannelsRetrieveQueryError =
  unknown;

export function useMessagingIntegrationsV10MsTeamsTeamsChannelsRetrieve<
  TData = Awaited<
    ReturnType<typeof messagingIntegrationsV10MsTeamsTeamsChannelsRetrieve>
  >,
  TError = unknown,
>(
  teamId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<typeof messagingIntegrationsV10MsTeamsTeamsChannelsRetrieve>
      >,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getMessagingIntegrationsV10MsTeamsTeamsChannelsRetrieveQueryOptions(
      teamId,
      options
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Endpoint for receiving events from MS Teams for
 * our bot to handle.
 *
 * See MSTeamsEventsService for more details.
 */
export const messagingIntegrationsV10MsTeamsWebhooksEventsCreate = (
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/messaging_integrations/v1.0/ms_teams/webhooks/events/`,
    method: 'POST',
    signal,
  });
};

export const getMessagingIntegrationsV10MsTeamsWebhooksEventsCreateMutationKey =
  () => ['messagingIntegrationsV10MsTeamsWebhooksEventsCreate'] as const;

export const getMessagingIntegrationsV10MsTeamsWebhooksEventsCreateMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof messagingIntegrationsV10MsTeamsWebhooksEventsCreate>
      >,
      TError,
      void,
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof messagingIntegrationsV10MsTeamsWebhooksEventsCreate>
    >,
    TError,
    void,
    TContext
  > => {
    const mutationKey =
      getMessagingIntegrationsV10MsTeamsWebhooksEventsCreateMutationKey();
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof messagingIntegrationsV10MsTeamsWebhooksEventsCreate>
      >,
      void
    > = () => {
      return messagingIntegrationsV10MsTeamsWebhooksEventsCreate();
    };

    return { mutationFn, ...mutationOptions };
  };

export type MessagingIntegrationsV10MsTeamsWebhooksEventsCreateMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof messagingIntegrationsV10MsTeamsWebhooksEventsCreate>
    >
  >;

export type MessagingIntegrationsV10MsTeamsWebhooksEventsCreateMutationError =
  unknown;

export const useMessagingIntegrationsV10MsTeamsWebhooksEventsCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<typeof messagingIntegrationsV10MsTeamsWebhooksEventsCreate>
    >,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<typeof messagingIntegrationsV10MsTeamsWebhooksEventsCreate>
  >,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getMessagingIntegrationsV10MsTeamsWebhooksEventsCreateMutationOptions(
      options
    )
  );
};

/**
 * Endpoints used to update Slack integration specific settings
 * and disconnect the integration.
 */
export const messagingIntegrationsV10SlackPartialUpdate = (
  patchedSlackUpdateEmployerConfigRequestRequest?: PatchedSlackUpdateEmployerConfigRequestRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/messaging_integrations/v1.0/slack/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchedSlackUpdateEmployerConfigRequestRequest,
    signal,
  });
};

export const getMessagingIntegrationsV10SlackPartialUpdateMutationKey = () =>
  ['messagingIntegrationsV10SlackPartialUpdate'] as const;

export const getMessagingIntegrationsV10SlackPartialUpdateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof messagingIntegrationsV10SlackPartialUpdate>>,
    TError,
    MessagingIntegrationsV10SlackPartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof messagingIntegrationsV10SlackPartialUpdate>>,
  TError,
  MessagingIntegrationsV10SlackPartialUpdateMutationVariables,
  TContext
> => {
  const mutationKey =
    getMessagingIntegrationsV10SlackPartialUpdateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof messagingIntegrationsV10SlackPartialUpdate>>,
    MessagingIntegrationsV10SlackPartialUpdateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return messagingIntegrationsV10SlackPartialUpdate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type MessagingIntegrationsV10SlackPartialUpdateMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof messagingIntegrationsV10SlackPartialUpdate>>
  >;
export type MessagingIntegrationsV10SlackPartialUpdateMutationBody =
  | PatchedSlackUpdateEmployerConfigRequestRequest
  | undefined;
export type MessagingIntegrationsV10SlackPartialUpdateMutationError = unknown;
export type MessagingIntegrationsV10SlackPartialUpdateMutationVariables = {
  data?: PatchedSlackUpdateEmployerConfigRequestRequest;
};

export const useMessagingIntegrationsV10SlackPartialUpdate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof messagingIntegrationsV10SlackPartialUpdate>>,
    TError,
    MessagingIntegrationsV10SlackPartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof messagingIntegrationsV10SlackPartialUpdate>>,
  TError,
  MessagingIntegrationsV10SlackPartialUpdateMutationVariables,
  TContext
> => {
  return useMutation(
    getMessagingIntegrationsV10SlackPartialUpdateMutationOptions(options)
  );
};

/**
 * Endpoints used to update Slack integration specific settings
 * and disconnect the integration.
 */
export const messagingIntegrationsV10SlackDestroy = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<void>({
    url: `/messaging_integrations/v1.0/slack/`,
    method: 'DELETE',
    signal,
  });
};

export const getMessagingIntegrationsV10SlackDestroyMutationKey = () =>
  ['messagingIntegrationsV10SlackDestroy'] as const;

export const getMessagingIntegrationsV10SlackDestroyMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof messagingIntegrationsV10SlackDestroy>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof messagingIntegrationsV10SlackDestroy>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = getMessagingIntegrationsV10SlackDestroyMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof messagingIntegrationsV10SlackDestroy>>,
    void
  > = () => {
    return messagingIntegrationsV10SlackDestroy();
  };

  return { mutationFn, ...mutationOptions };
};

export type MessagingIntegrationsV10SlackDestroyMutationResult = NonNullable<
  Awaited<ReturnType<typeof messagingIntegrationsV10SlackDestroy>>
>;

export type MessagingIntegrationsV10SlackDestroyMutationError = unknown;

export const useMessagingIntegrationsV10SlackDestroy = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof messagingIntegrationsV10SlackDestroy>>,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof messagingIntegrationsV10SlackDestroy>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getMessagingIntegrationsV10SlackDestroyMutationOptions(options)
  );
};

/**
 * Endpoints required for setting up the Slack integration.
 * This allows us to relate Ben data to Slack data. Completion
 * of the OAuth flow will install the Ben app to the user's
 * Slack.
 *
 * See https://www.notion.so/thanksben/Slack-Auth-and-Setup-Flow-1cec5fff8f8d8097ad2bf1d5ef6aa9b9?pvs=4 for more details.
 */
export const messagingIntegrationsV10SlackAuthRetrieve = (
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<SlackStartAuthResponse>({
    url: `/messaging_integrations/v1.0/slack/auth/`,
    method: 'GET',
    signal,
  });
};

export const getMessagingIntegrationsV10SlackAuthRetrieveQueryKey = () => {
  return [`/messaging_integrations/v1.0/slack/auth/`] as const;
};

export const getMessagingIntegrationsV10SlackAuthRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof messagingIntegrationsV10SlackAuthRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof messagingIntegrationsV10SlackAuthRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getMessagingIntegrationsV10SlackAuthRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof messagingIntegrationsV10SlackAuthRetrieve>>
  > = ({ signal }) => messagingIntegrationsV10SlackAuthRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof messagingIntegrationsV10SlackAuthRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type MessagingIntegrationsV10SlackAuthRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof messagingIntegrationsV10SlackAuthRetrieve>>
>;
export type MessagingIntegrationsV10SlackAuthRetrieveQueryError = unknown;

export function useMessagingIntegrationsV10SlackAuthRetrieve<
  TData = Awaited<ReturnType<typeof messagingIntegrationsV10SlackAuthRetrieve>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof messagingIntegrationsV10SlackAuthRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getMessagingIntegrationsV10SlackAuthRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Endpoints required for setting up the Slack integration.
 * This allows us to relate Ben data to Slack data. Completion
 * of the OAuth flow will install the Ben app to the user's
 * Slack.
 *
 * See https://www.notion.so/thanksben/Slack-Auth-and-Setup-Flow-1cec5fff8f8d8097ad2bf1d5ef6aa9b9?pvs=4 for more details.
 */
export const messagingIntegrationsV10SlackAuthCreate = (
  slackCompleteAuthRequestRequest: SlackCompleteAuthRequestRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<SlackCompleteAuthResponse>({
    url: `/messaging_integrations/v1.0/slack/auth/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: slackCompleteAuthRequestRequest,
    signal,
  });
};

export const getMessagingIntegrationsV10SlackAuthCreateMutationKey = () =>
  ['messagingIntegrationsV10SlackAuthCreate'] as const;

export const getMessagingIntegrationsV10SlackAuthCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof messagingIntegrationsV10SlackAuthCreate>>,
    TError,
    MessagingIntegrationsV10SlackAuthCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof messagingIntegrationsV10SlackAuthCreate>>,
  TError,
  MessagingIntegrationsV10SlackAuthCreateMutationVariables,
  TContext
> => {
  const mutationKey = getMessagingIntegrationsV10SlackAuthCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof messagingIntegrationsV10SlackAuthCreate>>,
    MessagingIntegrationsV10SlackAuthCreateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return messagingIntegrationsV10SlackAuthCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type MessagingIntegrationsV10SlackAuthCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof messagingIntegrationsV10SlackAuthCreate>>
>;
export type MessagingIntegrationsV10SlackAuthCreateMutationBody =
  SlackCompleteAuthRequestRequest;
export type MessagingIntegrationsV10SlackAuthCreateMutationError = unknown;
export type MessagingIntegrationsV10SlackAuthCreateMutationVariables = {
  data: SlackCompleteAuthRequestRequest;
};

export const useMessagingIntegrationsV10SlackAuthCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof messagingIntegrationsV10SlackAuthCreate>>,
    TError,
    MessagingIntegrationsV10SlackAuthCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof messagingIntegrationsV10SlackAuthCreate>>,
  TError,
  MessagingIntegrationsV10SlackAuthCreateMutationVariables,
  TContext
> => {
  return useMutation(
    getMessagingIntegrationsV10SlackAuthCreateMutationOptions(options)
  );
};

/**
 * Used as part of the Slack OAuth flow to redirect
 * the user back to their employer's hostname.
 *
 * See https://www.notion.so/thanksben/Slack-Auth-and-Setup-Flow-1cec5fff8f8d8097ad2bf1d5ef6aa9b9?pvs=4 for more details.
 */
export const messagingIntegrationsV10SlackAuthRedirectRetrieve = (
  params?: MessagingIntegrationsV10SlackAuthRedirectRetrieveParams,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<unknown>({
    url: `/messaging_integrations/v1.0/slack/auth/redirect`,
    method: 'GET',
    params,
    signal,
  });
};

export const getMessagingIntegrationsV10SlackAuthRedirectRetrieveQueryKey = (
  params?: MessagingIntegrationsV10SlackAuthRedirectRetrieveParams
) => {
  return [
    `/messaging_integrations/v1.0/slack/auth/redirect`,
    ...(params ? [params] : []),
  ] as const;
};

export const getMessagingIntegrationsV10SlackAuthRedirectRetrieveQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof messagingIntegrationsV10SlackAuthRedirectRetrieve>
    >,
    TError = void,
  >(
    params?: MessagingIntegrationsV10SlackAuthRedirectRetrieveParams,
    options?: {
      query?: UseQueryOptions<
        Awaited<
          ReturnType<typeof messagingIntegrationsV10SlackAuthRedirectRetrieve>
        >,
        TError,
        TData
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getMessagingIntegrationsV10SlackAuthRedirectRetrieveQueryKey(params);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof messagingIntegrationsV10SlackAuthRedirectRetrieve>
      >
    > = ({ signal }) =>
      messagingIntegrationsV10SlackAuthRedirectRetrieve(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof messagingIntegrationsV10SlackAuthRedirectRetrieve>
      >,
      TError,
      TData
    > & { queryKey: QueryKey };
  };

export type MessagingIntegrationsV10SlackAuthRedirectRetrieveQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof messagingIntegrationsV10SlackAuthRedirectRetrieve>
    >
  >;
export type MessagingIntegrationsV10SlackAuthRedirectRetrieveQueryError = void;

export function useMessagingIntegrationsV10SlackAuthRedirectRetrieve<
  TData = Awaited<
    ReturnType<typeof messagingIntegrationsV10SlackAuthRedirectRetrieve>
  >,
  TError = void,
>(
  params?: MessagingIntegrationsV10SlackAuthRedirectRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<typeof messagingIntegrationsV10SlackAuthRedirectRetrieve>
      >,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getMessagingIntegrationsV10SlackAuthRedirectRetrieveQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Endpoints required for connecting a Slack user's
 * account to a Ben user.
 */
export const messagingIntegrationsV10SlackAuthUsersRetrieve = (
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<SlackStartUsersAuthResponse>({
    url: `/messaging_integrations/v1.0/slack/auth/users/`,
    method: 'GET',
    signal,
  });
};

export const getMessagingIntegrationsV10SlackAuthUsersRetrieveQueryKey = () => {
  return [`/messaging_integrations/v1.0/slack/auth/users/`] as const;
};

export const getMessagingIntegrationsV10SlackAuthUsersRetrieveQueryOptions = <
  TData = Awaited<
    ReturnType<typeof messagingIntegrationsV10SlackAuthUsersRetrieve>
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof messagingIntegrationsV10SlackAuthUsersRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getMessagingIntegrationsV10SlackAuthUsersRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof messagingIntegrationsV10SlackAuthUsersRetrieve>>
  > = ({ signal }) => messagingIntegrationsV10SlackAuthUsersRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof messagingIntegrationsV10SlackAuthUsersRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type MessagingIntegrationsV10SlackAuthUsersRetrieveQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof messagingIntegrationsV10SlackAuthUsersRetrieve>>
  >;
export type MessagingIntegrationsV10SlackAuthUsersRetrieveQueryError = unknown;

export function useMessagingIntegrationsV10SlackAuthUsersRetrieve<
  TData = Awaited<
    ReturnType<typeof messagingIntegrationsV10SlackAuthUsersRetrieve>
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof messagingIntegrationsV10SlackAuthUsersRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getMessagingIntegrationsV10SlackAuthUsersRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Endpoints required for connecting a Slack user's
 * account to a Ben user.
 */
export const messagingIntegrationsV10SlackAuthUsersCreate = (
  slackCompleteUsersAuthRequestRequest: SlackCompleteUsersAuthRequestRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/messaging_integrations/v1.0/slack/auth/users/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: slackCompleteUsersAuthRequestRequest,
    signal,
  });
};

export const getMessagingIntegrationsV10SlackAuthUsersCreateMutationKey = () =>
  ['messagingIntegrationsV10SlackAuthUsersCreate'] as const;

export const getMessagingIntegrationsV10SlackAuthUsersCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof messagingIntegrationsV10SlackAuthUsersCreate>>,
    TError,
    MessagingIntegrationsV10SlackAuthUsersCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof messagingIntegrationsV10SlackAuthUsersCreate>>,
  TError,
  MessagingIntegrationsV10SlackAuthUsersCreateMutationVariables,
  TContext
> => {
  const mutationKey =
    getMessagingIntegrationsV10SlackAuthUsersCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof messagingIntegrationsV10SlackAuthUsersCreate>>,
    MessagingIntegrationsV10SlackAuthUsersCreateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return messagingIntegrationsV10SlackAuthUsersCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type MessagingIntegrationsV10SlackAuthUsersCreateMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof messagingIntegrationsV10SlackAuthUsersCreate>>
  >;
export type MessagingIntegrationsV10SlackAuthUsersCreateMutationBody =
  SlackCompleteUsersAuthRequestRequest;
export type MessagingIntegrationsV10SlackAuthUsersCreateMutationError = unknown;
export type MessagingIntegrationsV10SlackAuthUsersCreateMutationVariables = {
  data: SlackCompleteUsersAuthRequestRequest;
};

export const useMessagingIntegrationsV10SlackAuthUsersCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof messagingIntegrationsV10SlackAuthUsersCreate>>,
    TError,
    MessagingIntegrationsV10SlackAuthUsersCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof messagingIntegrationsV10SlackAuthUsersCreate>>,
  TError,
  MessagingIntegrationsV10SlackAuthUsersCreateMutationVariables,
  TContext
> => {
  return useMutation(
    getMessagingIntegrationsV10SlackAuthUsersCreateMutationOptions(options)
  );
};

/**
 * Used as part of the Slack user OAuth flow to redirect
 * the user back to their employer's hostname.
 */
export const messagingIntegrationsV10SlackAuthUsersRedirectRetrieve = (
  params: MessagingIntegrationsV10SlackAuthUsersRedirectRetrieveParams,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<unknown>({
    url: `/messaging_integrations/v1.0/slack/auth/users/redirect/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getMessagingIntegrationsV10SlackAuthUsersRedirectRetrieveQueryKey =
  (params?: MessagingIntegrationsV10SlackAuthUsersRedirectRetrieveParams) => {
    return [
      `/messaging_integrations/v1.0/slack/auth/users/redirect/`,
      ...(params ? [params] : []),
    ] as const;
  };

export const getMessagingIntegrationsV10SlackAuthUsersRedirectRetrieveQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof messagingIntegrationsV10SlackAuthUsersRedirectRetrieve>
    >,
    TError = void,
  >(
    params: MessagingIntegrationsV10SlackAuthUsersRedirectRetrieveParams,
    options?: {
      query?: UseQueryOptions<
        Awaited<
          ReturnType<
            typeof messagingIntegrationsV10SlackAuthUsersRedirectRetrieve
          >
        >,
        TError,
        TData
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getMessagingIntegrationsV10SlackAuthUsersRedirectRetrieveQueryKey(params);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof messagingIntegrationsV10SlackAuthUsersRedirectRetrieve
        >
      >
    > = ({ signal }) =>
      messagingIntegrationsV10SlackAuthUsersRedirectRetrieve(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof messagingIntegrationsV10SlackAuthUsersRedirectRetrieve
        >
      >,
      TError,
      TData
    > & { queryKey: QueryKey };
  };

export type MessagingIntegrationsV10SlackAuthUsersRedirectRetrieveQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof messagingIntegrationsV10SlackAuthUsersRedirectRetrieve>
    >
  >;
export type MessagingIntegrationsV10SlackAuthUsersRedirectRetrieveQueryError =
  void;

export function useMessagingIntegrationsV10SlackAuthUsersRedirectRetrieve<
  TData = Awaited<
    ReturnType<typeof messagingIntegrationsV10SlackAuthUsersRedirectRetrieve>
  >,
  TError = void,
>(
  params: MessagingIntegrationsV10SlackAuthUsersRedirectRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          typeof messagingIntegrationsV10SlackAuthUsersRedirectRetrieve
        >
      >,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getMessagingIntegrationsV10SlackAuthUsersRedirectRetrieveQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Endpoint for receiving commands from Slack.
 * https://api.slack.com/interactivity/slash-commands
 */
export const messagingIntegrationsV10SlackCommandsCreate = (
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/messaging_integrations/v1.0/slack/commands/`,
    method: 'POST',
    signal,
  });
};

export const getMessagingIntegrationsV10SlackCommandsCreateMutationKey = () =>
  ['messagingIntegrationsV10SlackCommandsCreate'] as const;

export const getMessagingIntegrationsV10SlackCommandsCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof messagingIntegrationsV10SlackCommandsCreate>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof messagingIntegrationsV10SlackCommandsCreate>>,
  TError,
  void,
  TContext
> => {
  const mutationKey =
    getMessagingIntegrationsV10SlackCommandsCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof messagingIntegrationsV10SlackCommandsCreate>>,
    void
  > = () => {
    return messagingIntegrationsV10SlackCommandsCreate();
  };

  return { mutationFn, ...mutationOptions };
};

export type MessagingIntegrationsV10SlackCommandsCreateMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof messagingIntegrationsV10SlackCommandsCreate>>
  >;

export type MessagingIntegrationsV10SlackCommandsCreateMutationError = unknown;

export const useMessagingIntegrationsV10SlackCommandsCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof messagingIntegrationsV10SlackCommandsCreate>>,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof messagingIntegrationsV10SlackCommandsCreate>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getMessagingIntegrationsV10SlackCommandsCreateMutationOptions(options)
  );
};

/**
 * For interactive elements in Slack like a button,
 * Slack will send us an interaction payload. This is required
 * even if we only use the button as a link to a URL.
 *
 * Currently, we do not do anything with the payload. However,
 * we still need to respond with a 200 status code to acknowledge
 * the interaction, otherwise users see a warning within Slack.
 */
export const messagingIntegrationsV10SlackInteractivityCreate = (
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/messaging_integrations/v1.0/slack/interactivity/`,
    method: 'POST',
    signal,
  });
};

export const getMessagingIntegrationsV10SlackInteractivityCreateMutationKey =
  () => ['messagingIntegrationsV10SlackInteractivityCreate'] as const;

export const getMessagingIntegrationsV10SlackInteractivityCreateMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof messagingIntegrationsV10SlackInteractivityCreate>
      >,
      TError,
      void,
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof messagingIntegrationsV10SlackInteractivityCreate>
    >,
    TError,
    void,
    TContext
  > => {
    const mutationKey =
      getMessagingIntegrationsV10SlackInteractivityCreateMutationKey();
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof messagingIntegrationsV10SlackInteractivityCreate>
      >,
      void
    > = () => {
      return messagingIntegrationsV10SlackInteractivityCreate();
    };

    return { mutationFn, ...mutationOptions };
  };

export type MessagingIntegrationsV10SlackInteractivityCreateMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof messagingIntegrationsV10SlackInteractivityCreate>>
  >;

export type MessagingIntegrationsV10SlackInteractivityCreateMutationError =
  unknown;

export const useMessagingIntegrationsV10SlackInteractivityCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<typeof messagingIntegrationsV10SlackInteractivityCreate>
    >,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof messagingIntegrationsV10SlackInteractivityCreate>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getMessagingIntegrationsV10SlackInteractivityCreateMutationOptions(options)
  );
};

/**
 * Endpoint for Slack external multi-select recipients in recognition modal.
 */
export const messagingIntegrationsV10SlackInteractivityOptionsCreate = (
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<SlackExternalMultiSelectOptionsResponse>({
    url: `/messaging_integrations/v1.0/slack/interactivity/options/`,
    method: 'POST',
    signal,
  });
};

export const getMessagingIntegrationsV10SlackInteractivityOptionsCreateMutationKey =
  () => ['messagingIntegrationsV10SlackInteractivityOptionsCreate'] as const;

export const getMessagingIntegrationsV10SlackInteractivityOptionsCreateMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof messagingIntegrationsV10SlackInteractivityOptionsCreate
        >
      >,
      TError,
      void,
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof messagingIntegrationsV10SlackInteractivityOptionsCreate>
    >,
    TError,
    void,
    TContext
  > => {
    const mutationKey =
      getMessagingIntegrationsV10SlackInteractivityOptionsCreateMutationKey();
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof messagingIntegrationsV10SlackInteractivityOptionsCreate
        >
      >,
      void
    > = () => {
      return messagingIntegrationsV10SlackInteractivityOptionsCreate();
    };

    return { mutationFn, ...mutationOptions };
  };

export type MessagingIntegrationsV10SlackInteractivityOptionsCreateMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof messagingIntegrationsV10SlackInteractivityOptionsCreate>
    >
  >;

export type MessagingIntegrationsV10SlackInteractivityOptionsCreateMutationError =
  unknown;

export const useMessagingIntegrationsV10SlackInteractivityOptionsCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<typeof messagingIntegrationsV10SlackInteractivityOptionsCreate>
    >,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<typeof messagingIntegrationsV10SlackInteractivityOptionsCreate>
  >,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getMessagingIntegrationsV10SlackInteractivityOptionsCreateMutationOptions(
      options
    )
  );
};

/**
 * Fetch a list of teams related to the employer's Slack integration.
 */
export const messagingIntegrationsV10SlackTeamsRetrieve = (
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<SlackTeamsResponse>({
    url: `/messaging_integrations/v1.0/slack/teams/`,
    method: 'GET',
    signal,
  });
};

export const getMessagingIntegrationsV10SlackTeamsRetrieveQueryKey = () => {
  return [`/messaging_integrations/v1.0/slack/teams/`] as const;
};

export const getMessagingIntegrationsV10SlackTeamsRetrieveQueryOptions = <
  TData = Awaited<
    ReturnType<typeof messagingIntegrationsV10SlackTeamsRetrieve>
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof messagingIntegrationsV10SlackTeamsRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getMessagingIntegrationsV10SlackTeamsRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof messagingIntegrationsV10SlackTeamsRetrieve>>
  > = ({ signal }) => messagingIntegrationsV10SlackTeamsRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof messagingIntegrationsV10SlackTeamsRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type MessagingIntegrationsV10SlackTeamsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof messagingIntegrationsV10SlackTeamsRetrieve>>
>;
export type MessagingIntegrationsV10SlackTeamsRetrieveQueryError = unknown;

export function useMessagingIntegrationsV10SlackTeamsRetrieve<
  TData = Awaited<
    ReturnType<typeof messagingIntegrationsV10SlackTeamsRetrieve>
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof messagingIntegrationsV10SlackTeamsRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getMessagingIntegrationsV10SlackTeamsRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Fetch a list of channels related to the employer's Slack integration.
 */
export const messagingIntegrationsV10SlackTeamsChannelsRetrieve = (
  teamId: string,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<SlackChannelsResponse>({
    url: `/messaging_integrations/v1.0/slack/teams/${teamId}/channels/`,
    method: 'GET',
    signal,
  });
};

export const getMessagingIntegrationsV10SlackTeamsChannelsRetrieveQueryKey = (
  teamId: string
) => {
  return [
    `/messaging_integrations/v1.0/slack/teams/${teamId}/channels/`,
  ] as const;
};

export const getMessagingIntegrationsV10SlackTeamsChannelsRetrieveQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof messagingIntegrationsV10SlackTeamsChannelsRetrieve>
    >,
    TError = unknown,
  >(
    teamId: string,
    options?: {
      query?: UseQueryOptions<
        Awaited<
          ReturnType<typeof messagingIntegrationsV10SlackTeamsChannelsRetrieve>
        >,
        TError,
        TData
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getMessagingIntegrationsV10SlackTeamsChannelsRetrieveQueryKey(teamId);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof messagingIntegrationsV10SlackTeamsChannelsRetrieve>
      >
    > = ({ signal }) =>
      messagingIntegrationsV10SlackTeamsChannelsRetrieve(teamId, signal);

    return {
      queryKey,
      queryFn,
      enabled: teamId !== null && teamId !== undefined,
      ...queryOptions,
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof messagingIntegrationsV10SlackTeamsChannelsRetrieve>
      >,
      TError,
      TData
    > & { queryKey: QueryKey };
  };

export type MessagingIntegrationsV10SlackTeamsChannelsRetrieveQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof messagingIntegrationsV10SlackTeamsChannelsRetrieve>
    >
  >;
export type MessagingIntegrationsV10SlackTeamsChannelsRetrieveQueryError =
  unknown;

export function useMessagingIntegrationsV10SlackTeamsChannelsRetrieve<
  TData = Awaited<
    ReturnType<typeof messagingIntegrationsV10SlackTeamsChannelsRetrieve>
  >,
  TError = unknown,
>(
  teamId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<typeof messagingIntegrationsV10SlackTeamsChannelsRetrieve>
      >,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getMessagingIntegrationsV10SlackTeamsChannelsRetrieveQueryOptions(
      teamId,
      options
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Determine if the current authenticated user
 * has connected their Slack account to Ben.
 */
export const messagingIntegrationsV10SlackUsersRetrieve = (
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<SlackUsersResponse>({
    url: `/messaging_integrations/v1.0/slack/users/`,
    method: 'GET',
    signal,
  });
};

export const getMessagingIntegrationsV10SlackUsersRetrieveQueryKey = () => {
  return [`/messaging_integrations/v1.0/slack/users/`] as const;
};

export const getMessagingIntegrationsV10SlackUsersRetrieveQueryOptions = <
  TData = Awaited<
    ReturnType<typeof messagingIntegrationsV10SlackUsersRetrieve>
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof messagingIntegrationsV10SlackUsersRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getMessagingIntegrationsV10SlackUsersRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof messagingIntegrationsV10SlackUsersRetrieve>>
  > = ({ signal }) => messagingIntegrationsV10SlackUsersRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof messagingIntegrationsV10SlackUsersRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type MessagingIntegrationsV10SlackUsersRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof messagingIntegrationsV10SlackUsersRetrieve>>
>;
export type MessagingIntegrationsV10SlackUsersRetrieveQueryError = unknown;

export function useMessagingIntegrationsV10SlackUsersRetrieve<
  TData = Awaited<
    ReturnType<typeof messagingIntegrationsV10SlackUsersRetrieve>
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof messagingIntegrationsV10SlackUsersRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getMessagingIntegrationsV10SlackUsersRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Determine if the current authenticated user
 * has connected their Slack account to Ben.
 */
export const messagingIntegrationsV10SlackUsersDestroy = (
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/messaging_integrations/v1.0/slack/users/`,
    method: 'DELETE',
    signal,
  });
};

export const getMessagingIntegrationsV10SlackUsersDestroyMutationKey = () =>
  ['messagingIntegrationsV10SlackUsersDestroy'] as const;

export const getMessagingIntegrationsV10SlackUsersDestroyMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof messagingIntegrationsV10SlackUsersDestroy>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof messagingIntegrationsV10SlackUsersDestroy>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = getMessagingIntegrationsV10SlackUsersDestroyMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof messagingIntegrationsV10SlackUsersDestroy>>,
    void
  > = () => {
    return messagingIntegrationsV10SlackUsersDestroy();
  };

  return { mutationFn, ...mutationOptions };
};

export type MessagingIntegrationsV10SlackUsersDestroyMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof messagingIntegrationsV10SlackUsersDestroy>>
  >;

export type MessagingIntegrationsV10SlackUsersDestroyMutationError = unknown;

export const useMessagingIntegrationsV10SlackUsersDestroy = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof messagingIntegrationsV10SlackUsersDestroy>>,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof messagingIntegrationsV10SlackUsersDestroy>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getMessagingIntegrationsV10SlackUsersDestroyMutationOptions(options)
  );
};

/**
 * Endpoint for receiving events from Slack.
 * https://api.slack.com/apis/events-api
 */
export const messagingIntegrationsV10SlackWebhooksEventsCreate = (
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/messaging_integrations/v1.0/slack/webhooks/events/`,
    method: 'POST',
    signal,
  });
};

export const getMessagingIntegrationsV10SlackWebhooksEventsCreateMutationKey =
  () => ['messagingIntegrationsV10SlackWebhooksEventsCreate'] as const;

export const getMessagingIntegrationsV10SlackWebhooksEventsCreateMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof messagingIntegrationsV10SlackWebhooksEventsCreate>
      >,
      TError,
      void,
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof messagingIntegrationsV10SlackWebhooksEventsCreate>
    >,
    TError,
    void,
    TContext
  > => {
    const mutationKey =
      getMessagingIntegrationsV10SlackWebhooksEventsCreateMutationKey();
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof messagingIntegrationsV10SlackWebhooksEventsCreate>
      >,
      void
    > = () => {
      return messagingIntegrationsV10SlackWebhooksEventsCreate();
    };

    return { mutationFn, ...mutationOptions };
  };

export type MessagingIntegrationsV10SlackWebhooksEventsCreateMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof messagingIntegrationsV10SlackWebhooksEventsCreate>
    >
  >;

export type MessagingIntegrationsV10SlackWebhooksEventsCreateMutationError =
  unknown;

export const useMessagingIntegrationsV10SlackWebhooksEventsCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<typeof messagingIntegrationsV10SlackWebhooksEventsCreate>
    >,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof messagingIntegrationsV10SlackWebhooksEventsCreate>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getMessagingIntegrationsV10SlackWebhooksEventsCreateMutationOptions(options)
  );
};

export const notificationsV10CampaignsRetrieve = (
  params?: NotificationsV10CampaignsRetrieveParams,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<PaginatedCampaignListResponse>({
    url: `/notifications/v1.0/campaigns/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getNotificationsV10CampaignsRetrieveQueryKey = (
  params?: NotificationsV10CampaignsRetrieveParams
) => {
  return [
    `/notifications/v1.0/campaigns/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getNotificationsV10CampaignsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof notificationsV10CampaignsRetrieve>>,
  TError = unknown,
>(
  params?: NotificationsV10CampaignsRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof notificationsV10CampaignsRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getNotificationsV10CampaignsRetrieveQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof notificationsV10CampaignsRetrieve>>
  > = ({ signal }) => notificationsV10CampaignsRetrieve(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof notificationsV10CampaignsRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type NotificationsV10CampaignsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof notificationsV10CampaignsRetrieve>>
>;
export type NotificationsV10CampaignsRetrieveQueryError = unknown;

export function useNotificationsV10CampaignsRetrieve<
  TData = Awaited<ReturnType<typeof notificationsV10CampaignsRetrieve>>,
  TError = unknown,
>(
  params?: NotificationsV10CampaignsRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof notificationsV10CampaignsRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getNotificationsV10CampaignsRetrieveQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const notificationsV10CampaignsCreate = (
  createCampaignRequestRequest: CreateCampaignRequestRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<CampaignDetailResponse>({
    url: `/notifications/v1.0/campaigns/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createCampaignRequestRequest,
    signal,
  });
};

export const getNotificationsV10CampaignsCreateMutationKey = () =>
  ['notificationsV10CampaignsCreate'] as const;

export const getNotificationsV10CampaignsCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof notificationsV10CampaignsCreate>>,
    TError,
    NotificationsV10CampaignsCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof notificationsV10CampaignsCreate>>,
  TError,
  NotificationsV10CampaignsCreateMutationVariables,
  TContext
> => {
  const mutationKey = getNotificationsV10CampaignsCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof notificationsV10CampaignsCreate>>,
    NotificationsV10CampaignsCreateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return notificationsV10CampaignsCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type NotificationsV10CampaignsCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof notificationsV10CampaignsCreate>>
>;
export type NotificationsV10CampaignsCreateMutationBody =
  CreateCampaignRequestRequest;
export type NotificationsV10CampaignsCreateMutationError = unknown;
export type NotificationsV10CampaignsCreateMutationVariables = {
  data: CreateCampaignRequestRequest;
};

export const useNotificationsV10CampaignsCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof notificationsV10CampaignsCreate>>,
    TError,
    NotificationsV10CampaignsCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof notificationsV10CampaignsCreate>>,
  TError,
  NotificationsV10CampaignsCreateMutationVariables,
  TContext
> => {
  return useMutation(
    getNotificationsV10CampaignsCreateMutationOptions(options)
  );
};

export const notificationsV10CampaignsRetrieve2 = (
  campaignId: number,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<CampaignDetailResponse>({
    url: `/notifications/v1.0/campaigns/${campaignId}/`,
    method: 'GET',
    signal,
  });
};

export const getNotificationsV10CampaignsRetrieve2QueryKey = (
  campaignId: number
) => {
  return [`/notifications/v1.0/campaigns/${campaignId}/`] as const;
};

export const getNotificationsV10CampaignsRetrieve2QueryOptions = <
  TData = Awaited<ReturnType<typeof notificationsV10CampaignsRetrieve2>>,
  TError = unknown,
>(
  campaignId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof notificationsV10CampaignsRetrieve2>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getNotificationsV10CampaignsRetrieve2QueryKey(campaignId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof notificationsV10CampaignsRetrieve2>>
  > = ({ signal }) => notificationsV10CampaignsRetrieve2(campaignId, signal);

  return {
    queryKey,
    queryFn,
    enabled: campaignId !== null && campaignId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof notificationsV10CampaignsRetrieve2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type NotificationsV10CampaignsRetrieve2QueryResult = NonNullable<
  Awaited<ReturnType<typeof notificationsV10CampaignsRetrieve2>>
>;
export type NotificationsV10CampaignsRetrieve2QueryError = unknown;

export function useNotificationsV10CampaignsRetrieve2<
  TData = Awaited<ReturnType<typeof notificationsV10CampaignsRetrieve2>>,
  TError = unknown,
>(
  campaignId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof notificationsV10CampaignsRetrieve2>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getNotificationsV10CampaignsRetrieve2QueryOptions(
    campaignId,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const notificationsV10CampaignsPartialUpdate = (
  campaignId: number,
  patchedUpdateCampaignRequestRequest?: PatchedUpdateCampaignRequestRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<CampaignDetailResponse>({
    url: `/notifications/v1.0/campaigns/${campaignId}/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchedUpdateCampaignRequestRequest,
    signal,
  });
};

export const getNotificationsV10CampaignsPartialUpdateMutationKey = () =>
  ['notificationsV10CampaignsPartialUpdate'] as const;

export const getNotificationsV10CampaignsPartialUpdateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof notificationsV10CampaignsPartialUpdate>>,
    TError,
    NotificationsV10CampaignsPartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof notificationsV10CampaignsPartialUpdate>>,
  TError,
  NotificationsV10CampaignsPartialUpdateMutationVariables,
  TContext
> => {
  const mutationKey = getNotificationsV10CampaignsPartialUpdateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof notificationsV10CampaignsPartialUpdate>>,
    NotificationsV10CampaignsPartialUpdateMutationVariables
  > = (props) => {
    const { campaignId, data } = props ?? {};

    return notificationsV10CampaignsPartialUpdate(campaignId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type NotificationsV10CampaignsPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof notificationsV10CampaignsPartialUpdate>>
>;
export type NotificationsV10CampaignsPartialUpdateMutationBody =
  | PatchedUpdateCampaignRequestRequest
  | undefined;
export type NotificationsV10CampaignsPartialUpdateMutationError = unknown;
export type NotificationsV10CampaignsPartialUpdateMutationVariables = {
  campaignId: number;
  data?: PatchedUpdateCampaignRequestRequest;
};

export const useNotificationsV10CampaignsPartialUpdate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof notificationsV10CampaignsPartialUpdate>>,
    TError,
    NotificationsV10CampaignsPartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof notificationsV10CampaignsPartialUpdate>>,
  TError,
  NotificationsV10CampaignsPartialUpdateMutationVariables,
  TContext
> => {
  return useMutation(
    getNotificationsV10CampaignsPartialUpdateMutationOptions(options)
  );
};

export const notificationsV10CampaignsRevertToDraftPartialUpdate = (
  campaignId: number,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<CampaignDetailResponse>({
    url: `/notifications/v1.0/campaigns/${campaignId}/revert_to_draft/`,
    method: 'PATCH',
    signal,
  });
};

export const getNotificationsV10CampaignsRevertToDraftPartialUpdateMutationKey =
  () => ['notificationsV10CampaignsRevertToDraftPartialUpdate'] as const;

export const getNotificationsV10CampaignsRevertToDraftPartialUpdateMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof notificationsV10CampaignsRevertToDraftPartialUpdate>
      >,
      TError,
      NotificationsV10CampaignsRevertToDraftPartialUpdateMutationVariables,
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof notificationsV10CampaignsRevertToDraftPartialUpdate>
    >,
    TError,
    NotificationsV10CampaignsRevertToDraftPartialUpdateMutationVariables,
    TContext
  > => {
    const mutationKey =
      getNotificationsV10CampaignsRevertToDraftPartialUpdateMutationKey();
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof notificationsV10CampaignsRevertToDraftPartialUpdate>
      >,
      NotificationsV10CampaignsRevertToDraftPartialUpdateMutationVariables
    > = (props) => {
      const { campaignId } = props ?? {};

      return notificationsV10CampaignsRevertToDraftPartialUpdate(campaignId);
    };

    return { mutationFn, ...mutationOptions };
  };

export type NotificationsV10CampaignsRevertToDraftPartialUpdateMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof notificationsV10CampaignsRevertToDraftPartialUpdate>
    >
  >;

export type NotificationsV10CampaignsRevertToDraftPartialUpdateMutationError =
  unknown;
export type NotificationsV10CampaignsRevertToDraftPartialUpdateMutationVariables =
  { campaignId: number };

export const useNotificationsV10CampaignsRevertToDraftPartialUpdate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<typeof notificationsV10CampaignsRevertToDraftPartialUpdate>
    >,
    TError,
    NotificationsV10CampaignsRevertToDraftPartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<typeof notificationsV10CampaignsRevertToDraftPartialUpdate>
  >,
  TError,
  NotificationsV10CampaignsRevertToDraftPartialUpdateMutationVariables,
  TContext
> => {
  return useMutation(
    getNotificationsV10CampaignsRevertToDraftPartialUpdateMutationOptions(
      options
    )
  );
};

export const notificationsV10CampaignsSendCreate = (
  campaignId: number,
  sendCampaignRequestRequest?: SendCampaignRequestRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<CampaignDetailResponse>({
    url: `/notifications/v1.0/campaigns/${campaignId}/send/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: sendCampaignRequestRequest,
    signal,
  });
};

export const getNotificationsV10CampaignsSendCreateMutationKey = () =>
  ['notificationsV10CampaignsSendCreate'] as const;

export const getNotificationsV10CampaignsSendCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof notificationsV10CampaignsSendCreate>>,
    TError,
    NotificationsV10CampaignsSendCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof notificationsV10CampaignsSendCreate>>,
  TError,
  NotificationsV10CampaignsSendCreateMutationVariables,
  TContext
> => {
  const mutationKey = getNotificationsV10CampaignsSendCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof notificationsV10CampaignsSendCreate>>,
    NotificationsV10CampaignsSendCreateMutationVariables
  > = (props) => {
    const { campaignId, data } = props ?? {};

    return notificationsV10CampaignsSendCreate(campaignId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type NotificationsV10CampaignsSendCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof notificationsV10CampaignsSendCreate>>
>;
export type NotificationsV10CampaignsSendCreateMutationBody =
  | SendCampaignRequestRequest
  | undefined;
export type NotificationsV10CampaignsSendCreateMutationError = unknown;
export type NotificationsV10CampaignsSendCreateMutationVariables = {
  campaignId: number;
  data?: SendCampaignRequestRequest;
};

export const useNotificationsV10CampaignsSendCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof notificationsV10CampaignsSendCreate>>,
    TError,
    NotificationsV10CampaignsSendCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof notificationsV10CampaignsSendCreate>>,
  TError,
  NotificationsV10CampaignsSendCreateMutationVariables,
  TContext
> => {
  return useMutation(
    getNotificationsV10CampaignsSendCreateMutationOptions(options)
  );
};

export const notificationsV10EmailPreviewCreate = (
  emailPreviewRequestRequest: EmailPreviewRequestRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<EmailPreviewResponse>({
    url: `/notifications/v1.0/email-preview/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: emailPreviewRequestRequest,
    signal,
  });
};

export const getNotificationsV10EmailPreviewCreateMutationKey = () =>
  ['notificationsV10EmailPreviewCreate'] as const;

export const getNotificationsV10EmailPreviewCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof notificationsV10EmailPreviewCreate>>,
    TError,
    NotificationsV10EmailPreviewCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof notificationsV10EmailPreviewCreate>>,
  TError,
  NotificationsV10EmailPreviewCreateMutationVariables,
  TContext
> => {
  const mutationKey = getNotificationsV10EmailPreviewCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof notificationsV10EmailPreviewCreate>>,
    NotificationsV10EmailPreviewCreateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return notificationsV10EmailPreviewCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type NotificationsV10EmailPreviewCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof notificationsV10EmailPreviewCreate>>
>;
export type NotificationsV10EmailPreviewCreateMutationBody =
  EmailPreviewRequestRequest;
export type NotificationsV10EmailPreviewCreateMutationError = unknown;
export type NotificationsV10EmailPreviewCreateMutationVariables = {
  data: EmailPreviewRequestRequest;
};

export const useNotificationsV10EmailPreviewCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof notificationsV10EmailPreviewCreate>>,
    TError,
    NotificationsV10EmailPreviewCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof notificationsV10EmailPreviewCreate>>,
  TError,
  NotificationsV10EmailPreviewCreateMutationVariables,
  TContext
> => {
  return useMutation(
    getNotificationsV10EmailPreviewCreateMutationOptions(options)
  );
};

export const notificationsV10EventsRetrieve = (
  params?: NotificationsV10EventsRetrieveParams,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<Blob>({
    url: `/notifications/v1.0/events/`,
    method: 'GET',
    params,
    responseType: 'blob',
    signal,
  });
};

export const getNotificationsV10EventsRetrieveQueryKey = (
  params?: NotificationsV10EventsRetrieveParams
) => {
  return [`/notifications/v1.0/events/`, ...(params ? [params] : [])] as const;
};

export const getNotificationsV10EventsRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof notificationsV10EventsRetrieve>>,
  TError = unknown,
>(
  params?: NotificationsV10EventsRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof notificationsV10EventsRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getNotificationsV10EventsRetrieveQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof notificationsV10EventsRetrieve>>
  > = ({ signal }) => notificationsV10EventsRetrieve(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof notificationsV10EventsRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type NotificationsV10EventsRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof notificationsV10EventsRetrieve>>
>;
export type NotificationsV10EventsRetrieveQueryError = unknown;

export function useNotificationsV10EventsRetrieve<
  TData = Awaited<ReturnType<typeof notificationsV10EventsRetrieve>>,
  TError = unknown,
>(
  params?: NotificationsV10EventsRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof notificationsV10EventsRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getNotificationsV10EventsRetrieveQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const notificationsV10NotificationDefinitionsRetrieve = (
  params?: NotificationsV10NotificationDefinitionsRetrieveParams,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<NotificationDefinitionsResponse>({
    url: `/notifications/v1.0/notification_definitions/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getNotificationsV10NotificationDefinitionsRetrieveQueryKey = (
  params?: NotificationsV10NotificationDefinitionsRetrieveParams
) => {
  return [
    `/notifications/v1.0/notification_definitions/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getNotificationsV10NotificationDefinitionsRetrieveQueryOptions = <
  TData = Awaited<
    ReturnType<typeof notificationsV10NotificationDefinitionsRetrieve>
  >,
  TError = unknown,
>(
  params?: NotificationsV10NotificationDefinitionsRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<typeof notificationsV10NotificationDefinitionsRetrieve>
      >,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getNotificationsV10NotificationDefinitionsRetrieveQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof notificationsV10NotificationDefinitionsRetrieve>>
  > = ({ signal }) =>
    notificationsV10NotificationDefinitionsRetrieve(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof notificationsV10NotificationDefinitionsRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type NotificationsV10NotificationDefinitionsRetrieveQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof notificationsV10NotificationDefinitionsRetrieve>>
  >;
export type NotificationsV10NotificationDefinitionsRetrieveQueryError = unknown;

export function useNotificationsV10NotificationDefinitionsRetrieve<
  TData = Awaited<
    ReturnType<typeof notificationsV10NotificationDefinitionsRetrieve>
  >,
  TError = unknown,
>(
  params?: NotificationsV10NotificationDefinitionsRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<typeof notificationsV10NotificationDefinitionsRetrieve>
      >,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getNotificationsV10NotificationDefinitionsRetrieveQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const notificationsV10NotificationDefinitionsRetrieve2 = (
  notificationDefinitionId: number,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<NotificationDefinitionDetailResponse>({
    url: `/notifications/v1.0/notification_definitions/${notificationDefinitionId}/`,
    method: 'GET',
    signal,
  });
};

export const getNotificationsV10NotificationDefinitionsRetrieve2QueryKey = (
  notificationDefinitionId: number
) => {
  return [
    `/notifications/v1.0/notification_definitions/${notificationDefinitionId}/`,
  ] as const;
};

export const getNotificationsV10NotificationDefinitionsRetrieve2QueryOptions = <
  TData = Awaited<
    ReturnType<typeof notificationsV10NotificationDefinitionsRetrieve2>
  >,
  TError = unknown,
>(
  notificationDefinitionId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<typeof notificationsV10NotificationDefinitionsRetrieve2>
      >,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getNotificationsV10NotificationDefinitionsRetrieve2QueryKey(
      notificationDefinitionId
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof notificationsV10NotificationDefinitionsRetrieve2>>
  > = ({ signal }) =>
    notificationsV10NotificationDefinitionsRetrieve2(
      notificationDefinitionId,
      signal
    );

  return {
    queryKey,
    queryFn,
    enabled:
      notificationDefinitionId !== null &&
      notificationDefinitionId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<
      ReturnType<typeof notificationsV10NotificationDefinitionsRetrieve2>
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type NotificationsV10NotificationDefinitionsRetrieve2QueryResult =
  NonNullable<
    Awaited<ReturnType<typeof notificationsV10NotificationDefinitionsRetrieve2>>
  >;
export type NotificationsV10NotificationDefinitionsRetrieve2QueryError =
  unknown;

export function useNotificationsV10NotificationDefinitionsRetrieve2<
  TData = Awaited<
    ReturnType<typeof notificationsV10NotificationDefinitionsRetrieve2>
  >,
  TError = unknown,
>(
  notificationDefinitionId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<typeof notificationsV10NotificationDefinitionsRetrieve2>
      >,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getNotificationsV10NotificationDefinitionsRetrieve2QueryOptions(
      notificationDefinitionId,
      options
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const notificationsV10NotificationDefinitionsPartialUpdate = (
  notificationDefinitionId: number,
  patchedNotificationDefinitionUpdateRequestRequest?: PatchedNotificationDefinitionUpdateRequestRequest,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/notifications/v1.0/notification_definitions/${notificationDefinitionId}/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchedNotificationDefinitionUpdateRequestRequest,
    signal,
  });
};

export const getNotificationsV10NotificationDefinitionsPartialUpdateMutationKey =
  () => ['notificationsV10NotificationDefinitionsPartialUpdate'] as const;

export const getNotificationsV10NotificationDefinitionsPartialUpdateMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof notificationsV10NotificationDefinitionsPartialUpdate>
      >,
      TError,
      NotificationsV10NotificationDefinitionsPartialUpdateMutationVariables,
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof notificationsV10NotificationDefinitionsPartialUpdate>
    >,
    TError,
    NotificationsV10NotificationDefinitionsPartialUpdateMutationVariables,
    TContext
  > => {
    const mutationKey =
      getNotificationsV10NotificationDefinitionsPartialUpdateMutationKey();
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof notificationsV10NotificationDefinitionsPartialUpdate>
      >,
      NotificationsV10NotificationDefinitionsPartialUpdateMutationVariables
    > = (props) => {
      const { notificationDefinitionId, data } = props ?? {};

      return notificationsV10NotificationDefinitionsPartialUpdate(
        notificationDefinitionId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type NotificationsV10NotificationDefinitionsPartialUpdateMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof notificationsV10NotificationDefinitionsPartialUpdate>
    >
  >;
export type NotificationsV10NotificationDefinitionsPartialUpdateMutationBody =
  | PatchedNotificationDefinitionUpdateRequestRequest
  | undefined;
export type NotificationsV10NotificationDefinitionsPartialUpdateMutationError =
  unknown;
export type NotificationsV10NotificationDefinitionsPartialUpdateMutationVariables =
  {
    notificationDefinitionId: number;
    data?: PatchedNotificationDefinitionUpdateRequestRequest;
  };

export const useNotificationsV10NotificationDefinitionsPartialUpdate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<typeof notificationsV10NotificationDefinitionsPartialUpdate>
    >,
    TError,
    NotificationsV10NotificationDefinitionsPartialUpdateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<typeof notificationsV10NotificationDefinitionsPartialUpdate>
  >,
  TError,
  NotificationsV10NotificationDefinitionsPartialUpdateMutationVariables,
  TContext
> => {
  return useMutation(
    getNotificationsV10NotificationDefinitionsPartialUpdateMutationOptions(
      options
    )
  );
};

export const notificationsV10NotificationDefinitionsEventsRetrieve = (
  notificationDefinitionId: number,
  params?: NotificationsV10NotificationDefinitionsEventsRetrieveParams,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<NotificationEventsResponse>({
    url: `/notifications/v1.0/notification_definitions/${notificationDefinitionId}/events/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getNotificationsV10NotificationDefinitionsEventsRetrieveQueryKey =
  (
    notificationDefinitionId: number,
    params?: NotificationsV10NotificationDefinitionsEventsRetrieveParams
  ) => {
    return [
      `/notifications/v1.0/notification_definitions/${notificationDefinitionId}/events/`,
      ...(params ? [params] : []),
    ] as const;
  };

export const getNotificationsV10NotificationDefinitionsEventsRetrieveQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof notificationsV10NotificationDefinitionsEventsRetrieve>
    >,
    TError = unknown,
  >(
    notificationDefinitionId: number,
    params?: NotificationsV10NotificationDefinitionsEventsRetrieveParams,
    options?: {
      query?: UseQueryOptions<
        Awaited<
          ReturnType<
            typeof notificationsV10NotificationDefinitionsEventsRetrieve
          >
        >,
        TError,
        TData
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getNotificationsV10NotificationDefinitionsEventsRetrieveQueryKey(
        notificationDefinitionId,
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof notificationsV10NotificationDefinitionsEventsRetrieve>
      >
    > = ({ signal }) =>
      notificationsV10NotificationDefinitionsEventsRetrieve(
        notificationDefinitionId,
        params,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled:
        notificationDefinitionId !== null &&
        notificationDefinitionId !== undefined,
      ...queryOptions,
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof notificationsV10NotificationDefinitionsEventsRetrieve>
      >,
      TError,
      TData
    > & { queryKey: QueryKey };
  };

export type NotificationsV10NotificationDefinitionsEventsRetrieveQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof notificationsV10NotificationDefinitionsEventsRetrieve>
    >
  >;
export type NotificationsV10NotificationDefinitionsEventsRetrieveQueryError =
  unknown;

export function useNotificationsV10NotificationDefinitionsEventsRetrieve<
  TData = Awaited<
    ReturnType<typeof notificationsV10NotificationDefinitionsEventsRetrieve>
  >,
  TError = unknown,
>(
  notificationDefinitionId: number,
  params?: NotificationsV10NotificationDefinitionsEventsRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<typeof notificationsV10NotificationDefinitionsEventsRetrieve>
      >,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getNotificationsV10NotificationDefinitionsEventsRetrieveQueryOptions(
      notificationDefinitionId,
      params,
      options
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const notificationsV10NotificationDefinitionsTemplatesRetrieve = (
  notificationDefinitionId: number,
  params: NotificationsV10NotificationDefinitionsTemplatesRetrieveParams,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<NotificationTemplatePreviewResponse>({
    url: `/notifications/v1.0/notification_definitions/${notificationDefinitionId}/templates/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getNotificationsV10NotificationDefinitionsTemplatesRetrieveQueryKey =
  (
    notificationDefinitionId: number,
    params?: NotificationsV10NotificationDefinitionsTemplatesRetrieveParams
  ) => {
    return [
      `/notifications/v1.0/notification_definitions/${notificationDefinitionId}/templates/`,
      ...(params ? [params] : []),
    ] as const;
  };

export const getNotificationsV10NotificationDefinitionsTemplatesRetrieveQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof notificationsV10NotificationDefinitionsTemplatesRetrieve
      >
    >,
    TError = unknown,
  >(
    notificationDefinitionId: number,
    params: NotificationsV10NotificationDefinitionsTemplatesRetrieveParams,
    options?: {
      query?: UseQueryOptions<
        Awaited<
          ReturnType<
            typeof notificationsV10NotificationDefinitionsTemplatesRetrieve
          >
        >,
        TError,
        TData
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getNotificationsV10NotificationDefinitionsTemplatesRetrieveQueryKey(
        notificationDefinitionId,
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof notificationsV10NotificationDefinitionsTemplatesRetrieve
        >
      >
    > = ({ signal }) =>
      notificationsV10NotificationDefinitionsTemplatesRetrieve(
        notificationDefinitionId,
        params,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled:
        notificationDefinitionId !== null &&
        notificationDefinitionId !== undefined,
      ...queryOptions,
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof notificationsV10NotificationDefinitionsTemplatesRetrieve
        >
      >,
      TError,
      TData
    > & { queryKey: QueryKey };
  };

export type NotificationsV10NotificationDefinitionsTemplatesRetrieveQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof notificationsV10NotificationDefinitionsTemplatesRetrieve
      >
    >
  >;
export type NotificationsV10NotificationDefinitionsTemplatesRetrieveQueryError =
  unknown;

export function useNotificationsV10NotificationDefinitionsTemplatesRetrieve<
  TData = Awaited<
    ReturnType<typeof notificationsV10NotificationDefinitionsTemplatesRetrieve>
  >,
  TError = unknown,
>(
  notificationDefinitionId: number,
  params: NotificationsV10NotificationDefinitionsTemplatesRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          typeof notificationsV10NotificationDefinitionsTemplatesRetrieve
        >
      >,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getNotificationsV10NotificationDefinitionsTemplatesRetrieveQueryOptions(
      notificationDefinitionId,
      params,
      options
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const publicInviteRetrieve = (
  employerUuid: string,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<EmployerOfflineWorkerForm>({
    url: `/public-invite/${employerUuid}/`,
    method: 'GET',
    signal,
  });
};

export const getPublicInviteRetrieveQueryKey = (employerUuid: string) => {
  return [`/public-invite/${employerUuid}/`] as const;
};

export const getPublicInviteRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof publicInviteRetrieve>>,
  TError = unknown,
>(
  employerUuid: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof publicInviteRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getPublicInviteRetrieveQueryKey(employerUuid);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof publicInviteRetrieve>>
  > = ({ signal }) => publicInviteRetrieve(employerUuid, signal);

  return {
    queryKey,
    queryFn,
    enabled: employerUuid !== null && employerUuid !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof publicInviteRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PublicInviteRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof publicInviteRetrieve>>
>;
export type PublicInviteRetrieveQueryError = unknown;

export function usePublicInviteRetrieve<
  TData = Awaited<ReturnType<typeof publicInviteRetrieve>>,
  TError = unknown,
>(
  employerUuid: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof publicInviteRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getPublicInviteRetrieveQueryOptions(
    employerUuid,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const publicInviteCreate = (
  employerUuid: string,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<void>({
    url: `/public-invite/${employerUuid}/`,
    method: 'POST',
    signal,
  });
};

export const getPublicInviteCreateMutationKey = () =>
  ['publicInviteCreate'] as const;

export const getPublicInviteCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof publicInviteCreate>>,
    TError,
    PublicInviteCreateMutationVariables,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof publicInviteCreate>>,
  TError,
  PublicInviteCreateMutationVariables,
  TContext
> => {
  const mutationKey = getPublicInviteCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof publicInviteCreate>>,
    PublicInviteCreateMutationVariables
  > = (props) => {
    const { employerUuid } = props ?? {};

    return publicInviteCreate(employerUuid);
  };

  return { mutationFn, ...mutationOptions };
};

export type PublicInviteCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof publicInviteCreate>>
>;

export type PublicInviteCreateMutationError = unknown;
export type PublicInviteCreateMutationVariables = { employerUuid: string };

export const usePublicInviteCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof publicInviteCreate>>,
    TError,
    PublicInviteCreateMutationVariables,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof publicInviteCreate>>,
  TError,
  PublicInviteCreateMutationVariables,
  TContext
> => {
  return useMutation(getPublicInviteCreateMutationOptions(options));
};

export const setPasswordRetrieve = (
  nonce: string,
  email: string,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<unknown>({
    url: `/set-password/${nonce}/${email}`,
    method: 'GET',
    signal,
  });
};

export const getSetPasswordRetrieveQueryKey = (
  nonce: string,
  email: string
) => {
  return [`/set-password/${nonce}/${email}`] as const;
};

export const getSetPasswordRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof setPasswordRetrieve>>,
  TError = void,
>(
  nonce: string,
  email: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof setPasswordRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getSetPasswordRetrieveQueryKey(nonce, email);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof setPasswordRetrieve>>
  > = ({ signal }) => setPasswordRetrieve(nonce, email, signal);

  return {
    queryKey,
    queryFn,
    enabled:
      nonce !== null &&
      nonce !== undefined &&
      email !== null &&
      email !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof setPasswordRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SetPasswordRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof setPasswordRetrieve>>
>;
export type SetPasswordRetrieveQueryError = void;

export function useSetPasswordRetrieve<
  TData = Awaited<ReturnType<typeof setPasswordRetrieve>>,
  TError = void,
>(
  nonce: string,
  email: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof setPasswordRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSetPasswordRetrieveQueryOptions(
    nonce,
    email,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const verifyRetrieve = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<unknown>({
    url: `/verify`,
    method: 'GET',
    signal,
  });
};

export const getVerifyRetrieveQueryKey = () => {
  return [`/verify`] as const;
};

export const getVerifyRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof verifyRetrieve>>,
  TError = void,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof verifyRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getVerifyRetrieveQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof verifyRetrieve>>> = ({
    signal,
  }) => verifyRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof verifyRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type VerifyRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof verifyRetrieve>>
>;
export type VerifyRetrieveQueryError = void;

export function useVerifyRetrieve<
  TData = Awaited<ReturnType<typeof verifyRetrieve>>,
  TError = void,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof verifyRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getVerifyRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const webhooksAirwallexCreate = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<void>({
    url: `/webhooks/airwallex/`,
    method: 'POST',
    signal,
  });
};

export const getWebhooksAirwallexCreateMutationKey = () =>
  ['webhooksAirwallexCreate'] as const;

export const getWebhooksAirwallexCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof webhooksAirwallexCreate>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof webhooksAirwallexCreate>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = getWebhooksAirwallexCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof webhooksAirwallexCreate>>,
    void
  > = () => {
    return webhooksAirwallexCreate();
  };

  return { mutationFn, ...mutationOptions };
};

export type WebhooksAirwallexCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof webhooksAirwallexCreate>>
>;

export type WebhooksAirwallexCreateMutationError = unknown;

export const useWebhooksAirwallexCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof webhooksAirwallexCreate>>,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof webhooksAirwallexCreate>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getWebhooksAirwallexCreateMutationOptions(options));
};

/**
 * Handle Airwallex webhook events for ACH operations
 */
export const webhooksAirwallexAchCreate = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<void>({
    url: `/webhooks/airwallex/ach/`,
    method: 'POST',
    signal,
  });
};

export const getWebhooksAirwallexAchCreateMutationKey = () =>
  ['webhooksAirwallexAchCreate'] as const;

export const getWebhooksAirwallexAchCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof webhooksAirwallexAchCreate>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof webhooksAirwallexAchCreate>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = getWebhooksAirwallexAchCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof webhooksAirwallexAchCreate>>,
    void
  > = () => {
    return webhooksAirwallexAchCreate();
  };

  return { mutationFn, ...mutationOptions };
};

export type WebhooksAirwallexAchCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof webhooksAirwallexAchCreate>>
>;

export type WebhooksAirwallexAchCreateMutationError = unknown;

export const useWebhooksAirwallexAchCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof webhooksAirwallexAchCreate>>,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof webhooksAirwallexAchCreate>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getWebhooksAirwallexAchCreateMutationOptions(options));
};

export const webhooksKomboCreate = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<void>({
    url: `/webhooks/kombo/`,
    method: 'POST',
    signal,
  });
};

export const getWebhooksKomboCreateMutationKey = () =>
  ['webhooksKomboCreate'] as const;

export const getWebhooksKomboCreateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof webhooksKomboCreate>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof webhooksKomboCreate>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = getWebhooksKomboCreateMutationKey();
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof webhooksKomboCreate>>,
    void
  > = () => {
    return webhooksKomboCreate();
  };

  return { mutationFn, ...mutationOptions };
};

export type WebhooksKomboCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof webhooksKomboCreate>>
>;

export type WebhooksKomboCreateMutationError = unknown;

export const useWebhooksKomboCreate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof webhooksKomboCreate>>,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof webhooksKomboCreate>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getWebhooksKomboCreateMutationOptions(options));
};

export const xeroOauthStartRetrieve = (
  profileUuid: string,
  signal?: AbortSignal
) => {
  return axiosOrvalCustomInstance<unknown>({
    url: `/xero/oauth/${profileUuid}/start/`,
    method: 'GET',
    signal,
  });
};

export const getXeroOauthStartRetrieveQueryKey = (profileUuid: string) => {
  return [`/xero/oauth/${profileUuid}/start/`] as const;
};

export const getXeroOauthStartRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof xeroOauthStartRetrieve>>,
  TError = void,
>(
  profileUuid: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof xeroOauthStartRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getXeroOauthStartRetrieveQueryKey(profileUuid);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof xeroOauthStartRetrieve>>
  > = ({ signal }) => xeroOauthStartRetrieve(profileUuid, signal);

  return {
    queryKey,
    queryFn,
    enabled: profileUuid !== null && profileUuid !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof xeroOauthStartRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type XeroOauthStartRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof xeroOauthStartRetrieve>>
>;
export type XeroOauthStartRetrieveQueryError = void;

export function useXeroOauthStartRetrieve<
  TData = Awaited<ReturnType<typeof xeroOauthStartRetrieve>>,
  TError = void,
>(
  profileUuid: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof xeroOauthStartRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getXeroOauthStartRetrieveQueryOptions(
    profileUuid,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const xeroOauthCallbackRetrieve = (signal?: AbortSignal) => {
  return axiosOrvalCustomInstance<unknown>({
    url: `/xero/oauth/callback/`,
    method: 'GET',
    signal,
  });
};

export const getXeroOauthCallbackRetrieveQueryKey = () => {
  return [`/xero/oauth/callback/`] as const;
};

export const getXeroOauthCallbackRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof xeroOauthCallbackRetrieve>>,
  TError = void,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof xeroOauthCallbackRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getXeroOauthCallbackRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof xeroOauthCallbackRetrieve>>
  > = ({ signal }) => xeroOauthCallbackRetrieve(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof xeroOauthCallbackRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type XeroOauthCallbackRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof xeroOauthCallbackRetrieve>>
>;
export type XeroOauthCallbackRetrieveQueryError = void;

export function useXeroOauthCallbackRetrieve<
  TData = Awaited<ReturnType<typeof xeroOauthCallbackRetrieve>>,
  TError = void,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof xeroOauthCallbackRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getXeroOauthCallbackRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}
